import {
  DEFAULT_OG_CARD_CONFIG,
  DEFAULT_SHARE_FORMAT
} from "./chunk-ITIRBWGP.mjs";
import {
  buildGenerationCoreOutput,
  createGenerationRegistry,
  resolveGenerationContent,
  selectGenerationCandidate
} from "./chunk-LMAPSLSD.mjs";
import {
  CATEGORY_COLORS,
  CATEGORY_LABELS,
  CATEGORY_RECOMMENDATIONS,
  CONTEXT_MULTIPLIERS,
  DRAMA_KEYWORDS,
  DRAMA_THRESHOLDS,
  ISSUE_DESCRIPTIONS,
  SEVERITY_WEIGHTS,
  SHARE_FORMAT_DIMENSIONS,
  computeFallbackWeights,
  getDramaCategory
} from "./chunk-V7UCD2TT.mjs";
import {
  ENTITLEMENTS_MANIFEST,
  getFeatureValue,
  getLimit,
  hasFeatureBoolean
} from "./chunk-UZRKHB62.mjs";
import {
  AcceptTosResultDto,
  AgentExecutionEntryDto,
  AgentExecutionStatusEnum,
  AnalysisDto,
  AnalysisFeedbackSourceEnum,
  AnalysisHistoryEntryDto,
  AnalysisHistoryPageDto,
  AnalysisProviderEnum,
  AnalysisRecordCategoryEnum,
  AnalysisRecordProviderEnum,
  AnalysisRevisionDto,
  AnalysisRevisionStatusEnum,
  AnalysisStatsDto,
  AnonymousQuotaDto,
  CancelSubscriptionResultDto,
  CertificationStatusEnum,
  ClaimAnonymousDataResultDto,
  ClearAnalysisResultDto,
  CommunicationPatternDto,
  ConfirmAnalysisReceiptResultDto,
  ConversationDto,
  ConversationLastMessagePreviewDto,
  ConversationListEntryDto,
  ConversationStatusEnum,
  CreateConversationResultDto,
  CreateSharedLinkResultDto,
  CrisisAssistanceRequestResultDto,
  CrisisAssistanceRespondResultDto,
  CrisisContactMethodEnum,
  CrisisFeedbackSubmitResultDto,
  CrisisUrgencyLevelEnum,
  CrisisUrgencyPreferenceEnum,
  CryptoShreddingInfoDto,
  CustomerPortalSessionResultDto,
  CustomerReferralDto,
  DeleteAnalysisResultDto,
  DeleteUserDataCountsDto,
  DeleteUserDataResultDto,
  DramaAnalysisRequestSchema,
  DramaCategoryEnum,
  E2ESharedLinkFixtureResultDto,
  EntitlementsDto,
  ExplicitSharedResultDto,
  FamilyAcceptResultDto,
  FamilyCancelInviteResultDto,
  FamilyInviteBillingIntervalEnum,
  FamilyInviteDetailsDto,
  FamilyInviteDto,
  FamilyInviteResultDto,
  FamilyInviteStatusEnum,
  FamilyMemberDto,
  FamilyPlanDetailsDto,
  FamilyPlanDto,
  FamilyPlanTierDtoEnum,
  FamilyQuotaDto,
  FamilyRemoveResultDto,
  FeedbackEntryDto,
  FeedbackSubmitResultDto,
  FeedbackTypeEnum,
  GeneratedContentResultDto,
  GetFeedbackResultDto,
  GetMessagesPageDto,
  ListConversationsPageDto,
  MarkMessagesReadResultDto,
  MessageContextEnum,
  MessageContextSchema,
  MessageDto,
  OnboardingStatusDto,
  PartnerCertificationDto,
  PartnerCertificationTypeEnum,
  PartnerDashboardResultDto,
  PartnerFunnelStepDto,
  PartnerTypeEnum,
  PatternArchiveResultDto,
  PatternCreateResultDto,
  PatternDetailDto,
  PatternListDto,
  PatternPublishResultDto,
  PatternStatusDtoEnum,
  PatternTypeDtoEnum,
  PatternUpdateResultDto,
  PracticeTypeEnum,
  PractitionerAcceptResultDto,
  PractitionerConsentListDto,
  PractitionerConsentRecordDto,
  PractitionerConsentRevokeResultDto,
  PractitionerConsentUpdateResultDto,
  PractitionerDashboardDto,
  PractitionerInviteResultDto,
  PractitionerProfileDto,
  PractitionerRemoveResultDto,
  PractitionerStatusEnum,
  PublicSharedAnalysisDto,
  QuotaPolicyDto,
  QuotaRefundResultDto,
  QuotaUsageDto,
  ReferralCodeResultDto,
  ReferralRowDto,
  ReferralStatusEnum,
  RetentionDaysEnum,
  RevokeSharedLinkResultDto,
  RewriteDecisionEnum,
  RewriteEventDto,
  RewriteIssueSeverityEnum,
  SendMessageCompletedDto,
  SendMessagePendingDto,
  SendMessageResultDto,
  SessionPrepPatternItemDto,
  SessionPrepResponseDto,
  SharedAnalysisDto,
  SharedLinkPrivacySettingsDto,
  SubmitConcernResultDto,
  SubscriptionStatusDto,
  SubscriptionStatusEnum,
  SubscriptionTierEnum,
  TierDto,
  TierIdEnum,
  TierSourceEnum,
  UpdateLastActiveResultDto,
  UpdateOnboardingResultDto,
  UpdatePreferencesResultDto,
  UpdateSubscriptionActionEnum,
  UpdateSubscriptionResultDto,
  UserPreferencesDto,
  UserStatsDto,
  UserStatsRowDto,
  VisualLayerEnum,
  getEmailDomain,
  isDefined,
  isFreeEmailProvider,
  isNonEmptyString,
  sanitizeEmail,
  sanitizeInput,
  validateAndSanitizeEmail,
  validateContext,
  validateEmail,
  validateMessage,
  validateScore,
  validateUuid
} from "./chunk-A5WADSRJ.mjs";
import {
  SharedLinkTypeEnum
} from "./chunk-A7RTSNAY.mjs";
import {
  __commonJS,
  __export,
  __require,
  __toESM
} from "./chunk-XGB3TDIC.mjs";

// src/i18n/locales/en/common.json
var require_common = __commonJS({
  "src/i18n/locales/en/common.json"(exports, module) {
    module.exports = {
      app_name: "DramaDetector",
      loading: "Loading...",
      error: "Something went wrong",
      try_again: "Try Again",
      tier_drama_plus: "Drama+",
      tier_dramax: "DramaX",
      error_boundary: {
        title: "Something went wrong",
        description: "We encountered an issue displaying this content."
      },
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      success: "Success",
      share: "Share",
      remove: "Remove",
      send: "Send",
      back: "Back",
      yearly: "Yearly",
      monthly: "Monthly",
      cancelInvite: "Cancel Invite",
      copied: "Copied!",
      free: "Free",
      referrals: {
        title: "Invite Friends",
        subtitle: "Share DramaDetector with friends and earn rewards when they subscribe.",
        your_link: "Your Referral Link",
        copy_link: "Copy referral link",
        share_email: "Email",
        share_sms: "SMS",
        share_qr: "QR Code",
        generate_prompt: "Generate your unique referral link to start inviting friends.",
        generating: "Generating...",
        generate_code: "Get My Referral Link",
        stat_invited: "Invited",
        stat_converted: "Subscribed",
        activity: "Referral Activity",
        pending_signup: "Pending signup",
        status_pending: "Pending",
        status_signed_up: "Signed up",
        status_subscribed: "Subscribed",
        status_rewarded: "Rewarded",
        status_expired: "Expired",
        status_fraudulent: "Flagged"
      },
      referral_banner: {
        title: "You were invited!",
        subtitle: "Subscribe now and your friend earns a reward. You get 30 days of Drama+ free as a guest pass!"
      },
      not_found: {
        title: "Page not found",
        redirecting: "Redirecting to home..."
      },
      skip: "Skip",
      next: "Next",
      get_started: "Get Started",
      step_counter: "{{current}} of {{total}}",
      step_indicator: "Step {{current}} of {{total}}",
      welcome_greeting: "Welcome to DramaDetector!",
      welcome_greeting_name: "Welcome, {{name}}!",
      welcome_subtitle: "Your AI-powered communication coach",
      welcome_value_detect: "Detect hidden patterns in conversations",
      welcome_value_insights: "Get actionable insights to communicate better",
      welcome_value_rewrite: "Rewrite messages with healthier alternatives",
      how_it_works_title: "How It Works",
      how_it_works_subtitle: "Three simple steps to better communication",
      how_step_paste_title: "Paste",
      how_step_paste_desc: "Copy any conversation \u2014 texts, emails, DMs, or group chats.",
      how_step_analyze_title: "Analyze",
      how_step_analyze_desc: "Our AI detects drama patterns, communication styles, and emotional dynamics.",
      how_step_improve_title: "Improve",
      how_step_improve_desc: "Get rewritten messages and actionable advice to communicate healthier.",
      privacy_title: "Your Privacy Matters",
      privacy_subtitle: "Built with privacy at the core",
      privacy_private_title: "Conversations stay private",
      privacy_private_desc: "Your messages are analyzed and discarded. We never store conversation content.",
      privacy_no_selling_title: "No data selling",
      privacy_no_selling_desc: "Your data is never sold to third parties. Period.",
      privacy_anonymous_title: "Anonymous analytics only",
      privacy_anonymous_desc: "Usage analytics are fully anonymized. We track patterns, not people.",
      privacy_delete_title: "Delete anytime",
      privacy_delete_desc: "Your account and all associated data can be deleted instantly from Settings.",
      history_item: {
        category: {
          safe: "Safe",
          caution: "Caution",
          risky: "Risky"
        },
        time: {
          just_now: "Just now",
          minutes_ago: "{count}m ago",
          hours_ago: "{count}h ago"
        },
        accessibility: {
          analysis_result: "Analysis result: {category}, score {score}"
        }
      }
    };
  }
});

// src/i18n/locales/en/auth.json
var require_auth = __commonJS({
  "src/i18n/locales/en/auth.json"(exports, module) {
    module.exports = {
      login: {
        title: "Welcome Back",
        subtitle: "Sign in to continue to DramaDetector",
        divider: "or",
        email_label: "Email",
        email_placeholder: "you@example.com",
        password_label: "Password",
        password_placeholder: "Enter your password",
        sign_in_button: "Sign In",
        signing_in: "Signing in...",
        no_account: "Don't have an account?",
        sign_up_link: "Sign Up",
        verification_required: "Please complete verification to continue",
        errors: {
          login_failed: "Login Failed",
          unexpected_error: "An unexpected error occurred"
        },
        accessibility: {
          email_address: "Email address",
          email_hint: "Enter your email address to sign in",
          password: "Password",
          password_hint: "Enter your password",
          sign_up: "Sign up"
        }
      },
      signup: {
        title: "Create Account",
        subtitle: "Sign up to start using DramaDetector",
        divider: "or",
        email_label: "Email",
        email_placeholder: "you@example.com",
        password_label: "Password",
        password_placeholder: "At least 6 characters",
        confirm_password_label: "Confirm Password",
        confirm_password_placeholder: "Re-enter your password",
        sign_up_button: "Sign Up",
        creating_account: "Creating account...",
        already_have_account: "Already have an account?",
        sign_in_link: "Sign In",
        verification_required: "Please complete verification to continue",
        success: {
          title: "Success",
          message: "Account created! Please check your email to confirm your account."
        },
        errors: {
          signup_failed: "Signup Failed",
          unexpected_error: "An unexpected error occurred"
        },
        accessibility: {
          email_address: "Email address",
          email_hint: "Enter your email address to create an account",
          password: "Password",
          password_hint: "Create a password with at least 6 characters",
          confirm_password: "Confirm password",
          confirm_password_hint: "Re-enter your password to confirm",
          sign_in: "Sign in"
        }
      },
      session_expiry: {
        title: "Session Expired",
        message: "Your session has expired. Please sign in again to continue.",
        sign_in: "Sign In"
      }
    };
  }
});

// src/i18n/locales/en/home.json
var require_home = __commonJS({
  "src/i18n/locales/en/home.json"(exports, module) {
    module.exports = {
      home: {
        subtitle: "Get expert review on your message before you hit send",
        input_placeholder: "Type or paste your drama here...",
        input_placeholder_message_before_send: "Paste a message you're about to send...",
        modern: {
          title: "Modern Experience",
          switch_to_classic: "Switch to classic view \u2192",
          processing: "Processing...",
          animation_error: "Animation failed. Showing results...",
          animation_speed: "Animation Speed",
          speed_option: "{speed} animation speed",
          drama_score: "Drama Score",
          analyze_another: "Analyze Another",
          view_full_analysis: "View Full Analysis",
          view_details_classic: "View Details (Classic)",
          tap_to_skip: "Tap anywhere to skip",
          skip_animation: "Skip animation",
          analysis_summary: "Analysis Summary",
          issues_detected: "Issues Detected",
          suggested_improvements: "Suggested Improvements",
          original: "Original:",
          suggested: "Suggested:",
          pattern_spotlight: "Pattern Spotlight",
          found_times: "Found {count} time(s)",
          transformation_insights: "Transformation Insights",
          before: "Before:",
          after: "After:",
          insights: "Key Insights:",
          impact_high: "High Impact",
          impact_moderate: "Moderate Impact",
          impact_low: "Low Impact",
          likely_impact_value: "Likely impact: {impact}",
          was_helpful: "Was this analysis helpful?",
          helpful_yes: "Yes, helpful",
          helpful_no: "No, not helpful",
          quick_nav_label: "Quick navigation",
          score_nav: "Score",
          summary_nav: "Summary",
          issues_nav: "Issues",
          suggestions_nav: "Suggestions",
          patterns_nav: "Patterns",
          transformations_nav: "Insights",
          feedback_nav: "Feedback",
          show_more: "Show {count} more",
          show_less: "Show less",
          accordion_toggle: "{title}, {count} items, {state}",
          expanded: "expanded",
          collapsed: "collapsed",
          loading_results: "Loading results...",
          back_to_home: "\u2190 Back to Home",
          try_drama_detector: "\u2192 Try DramaDetector",
          inline_annotations: "View inline annotations"
        },
        first_time_intro: {
          title: "\u{1F3AD} Meet Your Two Voices",
          body: "You'll hear from two perspectives: the Narrator (who frames your message like an episode) and the Drama Expert (who analyzes what's really happening). Both help you avoid drama before you hit send.",
          cta: "Got it!"
        },
        two_voices_hint: {
          title: "\u{1F3AC} Two Voices, One Mission",
          body: "You'll hear from two perspectives: the Narrator (who frames your message like an episode) and the Drama Expert (who analyzes what's really happening). Both help you avoid drama before you hit send.",
          cta: "Got it!"
        },
        choose_experience: "Choose your experience:",
        context_label: "Message Context",
        analyze_button: "Analyze Message",
        analyzing: "Analyzing...",
        animation_analyzing: "ANALYZING... {{percent}}%",
        animation_complete: "COMPLETE",
        category_label: {
          safe: "Low Drama",
          caution: "Caution",
          high_drama: "High Drama",
          extreme_drama: "Extreme Drama",
          safety: "Support Available"
        },
        verification_required: "Verification required - please try again",
        trial_quota: "\u{1F512} {remaining} of {limit} free analyses remaining this week",
        trial_quota_exhausted: "{remaining} of {limit} analyses remaining",
        quota_resets: "Your quota resets {resetTime}",
        quota_low_warning: "Running low! Quota resets {resetTime}",
        quota_exhausted_button: "Quota Reached",
        upgrade_to_pro: "Upgrade to Pro",
        view_plans: "View Plans",
        anonCta: {
          headline: "Sign up to keep your history for 7 days",
          body: "Your anonymous analyses expire in 24 hours. Sign up free and they stick around for 7 days \u2014 plus 10 analyses every day and 1000-character messages.",
          primary: "Sign up free",
          dismiss: "Continue as guest"
        },
        anonCtaExhausted: {
          headline: "Sign up to keep analyzing",
          body: "You've used all {{limit}} weekly analyses. Sign up free for 10 every day, 1000-character messages, and saved history."
        },
        help_text: '\u{1F4A1} Enter a message above and tap "Analyze Message" to see its drama score, potential issues, and suggested improvements.',
        errors: {
          analysis_failed: "Analysis Failed",
          unexpected_error: "An unexpected error occurred. Please try again.",
          network_error: "Network connection failed. Please check your internet connection and try again.",
          network_timeout: "Request timed out. Please check your connection and try again.",
          results_not_found: "Results Not Found",
          results_not_found_message: "The analysis you're looking for doesn't exist or has been deleted.",
          shared_link_invalid: "Link Not Found",
          shared_link_invalid_message: "This shared link is invalid, expired, or has been deleted.",
          shared_link_expired_title: "Link Expired",
          shared_link_expired_message: "This shared link has expired. Please request a new link from the sender.",
          shared_link_revoked_title: "Link Revoked",
          shared_link_revoked_message: "This link has been revoked by the owner and is no longer accessible.",
          shared_link_invalid_token_title: "Invalid Link",
          shared_link_invalid_token_message: "This link is invalid or malformed. Please check the URL and try again.",
          shared_link_private_title: "Private Analysis",
          shared_link_private_message: "This analysis is private and cannot be shared.",
          shared_link_not_found_title: "Link Not Found",
          shared_link_not_found_message: "This shared link doesn't exist or has been deleted."
        }
      },
      message_input: {
        placeholder: "Type your message here...",
        clear_button: "Clear",
        validation: {
          empty: "Please enter a message to analyze",
          too_short: "Message must be at least {min} characters",
          too_long: "Message exceeds {max} character limit"
        },
        accessibility: {
          input_label: "Message input",
          input_hint: "Enter the message you want to analyze",
          clear_message: "Clear message"
        }
      },
      privacy_badge: {
        label: "Encrypted",
        accessibility_hint: "Tap to view privacy details",
        modal: {
          title: "Your Privacy is Protected",
          close: "Close",
          sections: {
            encryption: {
              title: "End-to-End Encryption",
              description: "Your messages are encrypted with AES-256-GCM before storage. Only you can access your analysis history."
            },
            pii_scrubbing: {
              title: "PII Scrubbing",
              description: "Names, emails, phone numbers, and addresses are automatically redacted before AI analysis."
            },
            data_retention: {
              title: "Data Retention",
              description: "Free tier analyses are retained for 30 days. Paid plans include extended retention with full deletion controls."
            },
            deletion: {
              title: "Right to Deletion",
              description: "Delete all your data at any time from Settings. Deletion is permanent and irreversible."
            }
          },
          footer: "DramaDetector follows GDPR and CCPA guidelines for data protection."
        }
      },
      context_selector: {
        options: {
          family: "Family",
          work: "Work",
          friends: "Friends",
          dating: "Dating"
        },
        accessibility: {
          label: "Context selector",
          select_family: "Select Family context",
          select_work: "Select Work context",
          select_friends: "Select Friends context",
          select_dating: "Select Dating context"
        }
      },
      tier_card: {
        current_plan: "Current Plan",
        subscribe_button: "Subscribe",
        no_payment_required: "No payment required",
        accessibility: {
          subscribe_to: "Subscribe to {name}"
        }
      },
      tabs: {
        home: "Home",
        history: "History",
        stats: "Stats",
        settings: "Settings",
        messaging: "Messaging"
      },
      trial: {
        inline_banner: {
          title: "Great start! You have {remaining} more free weekly analyses",
          body: "You're off to a great start! Sign up to get 10 daily analyses and save your history forever.",
          cta: "Sign Up Free",
          accessibility: {
            dismiss: "Dismiss notification",
            banner: "Trial usage notification"
          }
        },
        blur_overlay: {
          title: "Only {remaining} weekly analysis left!",
          body: "You're running low on free weekly analyses. Sign up now to get 10 daily analyses and save your progress forever.",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account"
          },
          cta: "Sign Up Free",
          accessibility: {
            dismiss: "Dismiss reminder"
          }
        },
        bottom_sheet: {
          title: "You've used all 10 free weekly analyses!",
          body: "Great work! You've experienced the power of DramaDetector. Sign up now to keep improving your communication.",
          benefits_title: "What you'll get:",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account",
            support: "\u26A1 Email support included"
          },
          cta_signup: "Sign Up Free",
          cta_later: "Maybe Later",
          disclaimer: "No credit card required \u2022 Cancel anytime"
        },
        exhausted: {
          title: "Weekly Limit Reached",
          body: "You've used all 10 free weekly analyses. Resets every Monday at 00:00 UTC. Sign up to continue!",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account"
          },
          cta_signup: "Sign Up Free",
          cta_later: "Maybe Later"
        },
        ip_limit: {
          title: "Weekly Limit Reached",
          body: "You've used all 10 free weekly analyses. Resets every Monday at 00:00 UTC. Sign up for unlimited analyses!",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account"
          },
          reset_info: "Limit resets every Monday at 00:00 UTC.",
          cta_signup: "Sign Up Free",
          cta_later: "Maybe Later"
        }
      },
      quota: {
        paywall: {
          title: "\u{1F4CA} Daily Analysis Limit Reached",
          message: "You've used all 10 free daily analyses. Upgrade to Drama+ for 500 analyses/day or DramaX for unlimited analyses.",
          cta_hint: "Choose a plan below to continue analyzing messages"
        }
      }
    };
  }
});

// src/i18n/locales/en/loading.json
var require_loading = __commonJS({
  "src/i18n/locales/en/loading.json"(exports, module) {
    module.exports = {
      loading: {
        analyzing_your_message: "Analyzing your message...",
        complete_tap_to_continue: "Complete. Tap to continue.",
        two_voices_analyzing: "Two Voices Analyzing...",
        reviewing_your_message: "Reviewing your message...",
        meanwhile: "Meanwhile...",
        review_complete: "Review Complete",
        ready_to_send: "Ready to send (or revise!)",
        learn_more_link: "About the two voices",
        explainer_modal: {
          title: "About Your Two Voices",
          intro: "DramaDetector uses two distinct voices to help you communicate better:",
          narrator_section: "The Narrator",
          narrator_body: "Frames your messages like TV episodes, with playful observations and episodic framing.",
          expert_section: "The Drama Expert",
          expert_body: "Analyzes what's really happening using pattern recognition and framework-based advice.",
          why_two: "Why Two Voices?",
          why_two_body: "The Narrator keeps things entertaining while the Drama Expert gives you actionable insights.",
          cta: "Got it, thanks!",
          close_button: "Close modal",
          session5_reveal: {
            title: "Meet Your Two Voices",
            intro: "You've been working with two distinct voices all along\u2014now let's officially introduce them.",
            narrator_section: "The Narrator",
            narrator_body: "Frames your messages like TV episodes, with playful observations and episodic framing. You've seen their work in the loading quips and analysis intros.",
            expert_section: "The Drama Expert",
            expert_body: "Analyzes what's really happening using pattern recognition and framework-based advice. They cut through the drama with reality TV metaphors and evidence-based insights.",
            why_two: "Why Two Voices?",
            why_two_body: "The Narrator keeps things entertaining while the Drama Expert gives you actionable insights. Together, they help you avoid sending messages you'll regret\u2014without feeling like a therapy session.",
            cta: "Got it!",
            close_button: "Close"
          }
        }
      },
      skip_to_results: {
        analyzing_message: "Analyzing your message...",
        detecting_patterns: "Detecting patterns...",
        generating_insights: "Generating insights...",
        preparing_results: "Preparing your results...",
        your_message: "Your message",
        premium_experience: "Premium experience"
      },
      narrator_episode: {
        previously_on: "Previously on Your Life",
        this_episode: "This Episode",
        attribution: "Narrated by your story's observer",
        summary: {
          low: "You're communicating clearly. No major conflicts detected.",
          medium: "Some tension detected. Let's analyze the patterns.",
          high: "High-stakes communication ahead. Drama Expert insights below."
        }
      },
      drama_expert: {
        section_header: "Drama Expert Analysis",
        section_subheader: "Pattern recognition and actionable insights"
      }
    };
  }
});

// src/i18n/locales/en/subscription.json
var require_subscription = __commonJS({
  "src/i18n/locales/en/subscription.json"(exports, module) {
    module.exports = {
      intervals: {
        week: "1 week",
        month: "1 month",
        quarter: "3 months",
        semester: "6 months",
        year: "12 months"
      },
      badges: {
        new: "New",
        best_value: "Best Value"
      },
      savings: {
        ten_percent: "Save 10%",
        twenty_percent: "Save 20%",
        twenty_five_percent: "Save 25%"
      },
      pricing: {
        per_week_short: "/wk",
        per_month_short: "/mo",
        per_year_short: "/yr",
        per_person: "/person",
        per_person_per_week: "/person per week",
        billed_monthly: "/month",
        every_months: "every {count} months",
        every_year: "/year"
      },
      tiers: {
        drama_plus: "Drama+",
        dramax: "DramaX"
      },
      plan_types: {
        individual: "Individual",
        family: "Family (5)"
      },
      features: {
        drama_plus: {
          analyses: "100 analyses per day",
          patterns: "Pattern tracking"
        },
        dramax: {
          analyses: "200 analyses per day",
          multimodal: "Full multimodal analysis",
          archetypes: "Advanced archetypes",
          origins: "Pattern Origins (NC reveal)",
          transformation: "Transformation Suite",
          practitioner: "Practitioner Access",
          group: "Group Analysis"
        }
      },
      hero: {
        drama_plus: "Master your communication patterns",
        dramax: "Transform your narrative together",
        individual: "Unlimited access to premium features",
        family: "Share with up to 5 family members"
      },
      cta: {
        button: "Get {interval} for {price}",
        coming_soon: "Coming Soon",
        terms: "Auto-renews. Cancel anytime via Google Play/App Store settings."
      },
      family_banner: {
        title: "\u{1F389} You're in a {tier} Family Plan"
      },
      comparison: {
        title: "Feature comparison",
        most_popular: "MOST POPULAR",
        billed_monthly: "Billed monthly",
        scroll_hint: "Swipe to see all features"
      },
      errors: {
        try_again: "Please try again later",
        auth_required_title: "Sign In Required",
        auth_required_message: "Please sign in to subscribe to a paid plan.",
        checkout_error_title: "Error",
        checkout_error_message: "Failed to start checkout: {message}",
        cannot_open_url: "Cannot open checkout URL",
        change_billing_cycle_with_status: "Failed to change billing cycle ({{status}})"
      },
      subscription_success: {
        title: "Subscription Activated!",
        message: "Your subscription has been successfully activated. You now have access to all premium features.",
        syncing: "Syncing your subscription...",
        synced: "Subscription synced",
        redirecting: "Redirecting to settings in {countdown} second{plural}..."
      },
      subscription_cancel: {
        title: "Checkout Canceled",
        message: "No worries! You can subscribe anytime from the Plans tab. Your current plan remains active.",
        cta: "View Plans Again",
        accessibility: {
          return: "Return to subscription plans"
        },
        redirecting: "Returning to plans in {countdown} second{plural}..."
      },
      quota: {
        title: "Usage & Quota",
        daily_analyses: "Daily Analyses",
        weekly_analyses: "Weekly Analyses",
        free_trial: "Free",
        tiers: {
          free: "Free",
          drama_plus: "Drama+",
          dramax: "DramaX",
          anonymous: "Guest"
        },
        usage: "{used} of {limit} used ({remaining} remaining)",
        reset: {
          in: "Resets in {time}",
          monday: "Resets Monday",
          updating: "Updating quota...",
          relative: {
            about_hours: "about {count} hours",
            about_hours_one: "about 1 hour",
            minutes: "{count} minutes",
            less_than_minute: "less than a minute",
            days: "{count} days",
            one_day: "1 day"
          }
        },
        actions: {
          upgrade: "Upgrade to {tier} ({quota}/day)",
          sign_up: "Sign up for unlimited analyses"
        },
        errors: {
          load_failed: "Unable to load usage data: {message}",
          retry: "Retry"
        },
        exceeded: {
          title: "Weekly Limit Reached",
          title_authenticated: "Daily Limit Reached",
          message: "You've used all 10 free weekly analyses. Resets every Monday at 00:00 UTC.",
          message_authenticated: "You've used {used} of {limit} analyses today",
          cta: "Upgrade to {tier} for {quota}/day",
          by_tier: {
            anonymous: {
              title: "Weekly Limit Reached",
              body: "You've used all 10 free weekly analyses. Sign up to get 10 analyses daily and save your history!",
              cta_primary: "Sign Up Free",
              cta_secondary: "Maybe Later",
              benefits: {
                item1: "\u2728 10 analyses daily, free forever",
                item2: "\u{1F4CA} Save your analysis history",
                item3: "\u{1F512} Secure & private account"
              }
            },
            free: {
              title: "Daily Limit Reached",
              body: "You've used all 10 free daily analyses. Upgrade to Drama+ for 100 analyses per day and advanced features!",
              cta_primary: "\u{1F48E} Upgrade to Drama+",
              cta_secondary: "Maybe Tomorrow",
              benefits: {
                item1: "\u2728 100 analyses per day",
                item2: "\u{1F4C8} Pattern tracking & insights",
                item3: "\u{1F48E} Premium features"
              }
            },
            drama_plus: {
              title: "Daily Limit Reached",
              body: "You've used all 100 analyses today. Upgrade to DramaX for 200 analyses per day plus advanced transformation features!",
              cta_primary: "\u{1F451} Upgrade to DramaX",
              cta_secondary: "Maybe Tomorrow",
              benefits: {
                item1: "\u2728 200 analyses per day",
                item2: "\u{1F52E} Pattern Origins & NC Reveal",
                item3: "\u{1F9D8} Full Transformation Suite"
              }
            },
            dramax: {
              title: "Daily Limit Reached",
              body: "Impressive! You've used all 200 analyses today. That's serious dedication to self-improvement! Need more? Consider our family plan.",
              cta_primary: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Family Plan",
              cta_secondary: "Wait Until Tomorrow",
              benefits: {
                item1: "\u2728 Shared family quota",
                item2: "\u{1F464} Support for family members",
                item3: "\u{1F3E2} Team & practitioner options"
              }
            },
            family_member: {
              title: "Family Quota Exhausted",
              body: "Your family's shared quota has been used today. Talk to your family admin about upgrading or wait until tomorrow.",
              cta_primary: "\u{1F4F1} Message Family Admin",
              cta_secondary: "Wait Until Tomorrow",
              benefits: {
                item1: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Shared family quota",
                item2: "\u{1F4AC} Coordinate with your family",
                item3: "\u23F0 Resets daily at midnight UTC"
              }
            }
          }
        },
        warning: {
          banner: {
            title: "You've used 50% of your weekly analyses",
            title_authenticated: "You've used 50% of your daily analyses",
            description: "{used} of {limit} used. Quota resets {resetTime}.",
            accessibility: {
              dismiss: "Dismiss warning"
            }
          },
          toast: {
            title: "Running low on analyses!",
            description: "You've used 80% of your weekly analyses ({used} of {limit}). Quota resets Monday 00:00 UTC.",
            description_authenticated: "You've used 80% of your daily analyses ({used} of {limit}). Consider upgrading for unlimited access.",
            cta: "View Plans",
            accessibility: {
              dismiss: "Dismiss warning",
              view_plans: "View upgrade plans"
            }
          },
          modal: {
            title: "Almost at your limit!",
            description: "You've used 90% of your weekly analyses",
            description_authenticated: "You've used 90% of your daily analyses",
            upgrade_benefits: "Upgrade to get:",
            benefits: {
              unlimited: "Unlimited daily analyses",
              priority_support: "Priority support",
              advanced_analytics: "Advanced analytics"
            },
            cta_upgrade: "\u{1F48E} Upgrade Now",
            cta_later: "Remind Me Later",
            by_tier: {
              anonymous: {
                title: "Almost at your limit!",
                body: "You've used 90% of your 10 weekly free analyses. Sign up now to get 10 analyses daily!",
                cta_primary: "Sign Up Free",
                cta_secondary: "Remind Me Later",
                benefits: {
                  item1: "\u2728 10 daily analyses (vs 10 weekly)",
                  item2: "\u{1F4CA} Save your analysis history",
                  item3: "\u{1F512} Secure & private account"
                }
              },
              free: {
                title: "Running low on analyses",
                body: "You've used 90% of today's 10 free analyses. Upgrade to Drama+ for 50x more!",
                cta_primary: "\u{1F48E} Upgrade to Drama+",
                cta_secondary: "Remind Me Later",
                benefits: {
                  item1: "\u2728 100 analyses per day",
                  item2: "\u{1F4C8} Pattern tracking",
                  item3: "\u{1F48E} Premium features"
                }
              },
              drama_plus: {
                title: "High usage today!",
                body: "You've used 90% of today's 100 analyses. Upgrade to DramaX for advanced transformation features!",
                cta_primary: "\u{1F451} Upgrade to DramaX",
                cta_secondary: "Remind Me Later",
                benefits: {
                  item1: "\u2728 200 analyses per day",
                  item2: "\u{1F52E} Pattern Origins revealed",
                  item3: "\u{1F9D8} Transformation Suite"
                }
              },
              dramax: {
                title: "You're a power user!",
                body: "You've used 90% of today's 200 analyses. Amazing dedication! Consider our family plan for shared quota.",
                cta_primary: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Family Plan",
                cta_secondary: "Wait Until Tomorrow",
                benefits: {
                  item1: "\u2728 Shared family quota",
                  item2: "\u{1F464} Dedicated support",
                  item3: "\u{1F3E2} Team solutions"
                }
              },
              family_member: {
                title: "Family quota running low",
                body: "Your family has used 90% of the shared daily quota. You may want to coordinate usage.",
                cta_primary: "\u{1F4F1} Message Family Admin",
                cta_secondary: "Got It",
                benefits: {
                  item1: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Shared with {memberCount} members",
                  item2: "\u{1F4AC} Coordinate with family",
                  item3: "\u23F0 Resets at midnight UTC"
                }
              }
            }
          }
        }
      },
      family: {
        title: "Family Plan",
        manageFamily: "Manage Family",
        tierName: {
          drama_plus: "Drama+",
          dramax: "DramaX"
        },
        tierBadge: {
          drama_plus: "\u{1F48E} Drama+",
          dramax: "\u{1F451} DramaX"
        },
        notMember: "You're not in a family plan",
        notMemberDescription: "Subscribe to a family plan to share DramaDetector with up to 5 people.",
        billingInterval: "{interval}",
        dailyQuota: "Daily Quota",
        weeklyQuota: "Weekly Quota",
        members: "Members",
        inviteMember: "Invite Member",
        slotsLeft: "slots left",
        planFull: "Your family plan is full. Remove a member to invite someone new.",
        inviteByEmail: "Invite by Email",
        emailPlaceholder: "family@example.com",
        emailInvalid: "Please enter a valid email address",
        inviteMessage: "Join my {tier} family plan on DramaDetector! {link}",
        inviteSent: "Invitation Sent",
        inviteLinkCopied: "Invitation link copied to clipboard. Send it to {email}.",
        inviteFailed: "Failed to send invitation",
        pendingInvites: "Pending Invitations",
        expiresAt: "Expires {date}",
        confirmRemove: "Remove Member?",
        confirmRemoveMessage: "Are you sure you want to remove {name} from your family plan?",
        success: "Success",
        memberRemoved: "Member removed from family plan",
        removeFailed: "Failed to remove member",
        confirmCancelInvite: "Cancel Invitation?",
        confirmCancelInviteMessage: "Are you sure you want to cancel the invitation to {email}?",
        inviteCancelled: "Invitation cancelled",
        cancelInviteFailed: "Failed to cancel invitation",
        membersList: "Family Members",
        admin: "Admin",
        joinedAt: "Joined {date}",
        privacyTitle: "\u{1F512} Privacy First",
        privacyDescription: "Family members can see names and quotas, but not individual analysis content. Your conversations stay private.",
        error: "Error",
        acceptInvite: {
          title: "Join Family Plan",
          description: "You've been invited to join a family plan!",
          invitedBy: "You've been invited to join a {tierName} family plan by {adminName}.",
          statusProcessed: "This invitation has already been {status}. Please request a new invitation.",
          signInRequired: "Sign In Required",
          signInMessage: "Please sign in to accept this family plan invitation.",
          signInButton: "Sign In",
          planDetailsHeader: "Plan Details",
          analysesPerDay: "analyses/day",
          quotaShared: "Shared across all family members",
          expirationNotice: "This invitation expires on {date}.",
          tierLabel: "Plan Tier",
          quotaLabel: "Daily Quota",
          adminLabel: "Managed by",
          acceptButton: "Accept Invitation",
          declineButton: "Decline",
          success: "Welcome to the family plan!",
          error: "Failed to accept invitation",
          invalidCode: "This invitation link is invalid or has expired.",
          alreadyMember: "You're already a member of a family plan. Leave your current plan first."
        }
      },
      practitioner: {
        title: "Practitioner Groups",
        manageGroups: "Manage Groups",
        noGroups: "No Practitioner Groups",
        noGroupsDescription: "You're not in any practitioner groups yet. A practitioner will need to invite you, or you can create your own group if you have a DramaX subscription.",
        createGroup: "Create Practitioner Group",
        groupCreated: "Practitioner group created successfully",
        groupsList: "Your Groups",
        members: "Members",
        maxMembers: "of {max}",
        owner: "Owner",
        member: "Member",
        joinedAt: "Joined {date}",
        status: {
          active: "Active",
          inactive: "Inactive"
        },
        role: {
          owner: "You manage this group",
          member: "You are a patient in this group"
        },
        inviteMember: "Invite Patient",
        slotsLeft: "slots available",
        groupFull: "This group has reached its member limit.",
        inviteByEmail: "Invite by Email",
        emailPlaceholder: "patient@example.com",
        emailInvalid: "Please enter a valid email address",
        inviteSent: "Invitation Sent",
        inviteLinkCopied: "Invitation link copied to clipboard. Send it to {email}.",
        inviteFailed: "Failed to send invitation",
        pendingInvites: "Pending Invitations",
        expiresAt: "Expires {date}",
        confirmRemove: "Remove Patient?",
        confirmRemoveMessage: "Are you sure you want to remove this patient from your practitioner group?",
        success: "Success",
        memberRemoved: "Patient removed from practitioner group",
        removeFailed: "Failed to remove patient",
        confirmLeave: "Leave Group?",
        confirmLeaveMessage: "Are you sure you want to leave this practitioner group? You can be re-invited later.",
        leftGroup: "You have left the practitioner group",
        leaveFailed: "Failed to leave group",
        leaveGroup: "Leave Group",
        manageMembers: "Manage Patients",
        viewGroup: "View Group",
        privacyTitle: "\u{1F512} HIPAA Privacy",
        privacyDescription: "Practitioners can see patient membership status only. Patient analysis content is never shared. Your conversations stay completely private.",
        error: "Error",
        multiGroupInfo: "You can be a member of multiple practitioner groups. Your family plan (if any) remains separate from practitioner groups.",
        acceptInvite: {
          title: "Join Practitioner Group",
          description: "You've been invited to join a practitioner's care group.",
          signInRequired: "Sign In Required",
          signInMessage: "Please sign in to accept this practitioner group invitation.",
          signInButton: "Sign In",
          groupDetails: "Group Details",
          practitioner: "Practitioner",
          patients: "Current Patients",
          expirationNotice: "This invitation expires on {date}.",
          acceptButton: "Join Group",
          declineButton: "Decline",
          success: "Welcome to the practitioner group!",
          error: "Failed to join practitioner group",
          invalidCode: "This invitation link is invalid or has expired."
        }
      }
    };
  }
});

// src/i18n/locales/en/features.json
var require_features = __commonJS({
  "src/i18n/locales/en/features.json"(exports, module) {
    module.exports = {
      analysis: {
        title: "Analyze Your Message",
        feedback: {
          title: "How accurate was this analysis?",
          thumbs_up: "Helpful",
          thumbs_down: "Not Helpful",
          thank_you: "Thanks for your feedback! This helps us improve."
        }
      },
      home: {
        subtitle: "Get expert review on your message before you hit send",
        first_time_intro: {
          title: "\u{1F3AD} Meet Your Two Voices",
          body: "You'll hear from two perspectives: the Narrator (who frames your message like an episode) and the Drama Expert (who analyzes what's really happening). Both help you avoid drama before you hit send.",
          cta: "Got it!"
        },
        two_voices_hint: {
          title: "\u{1F3AC} Two Voices, One Mission",
          body: "You'll hear from two perspectives: the Narrator (who frames your message like an episode) and the Drama Expert (who analyzes what's really happening). Both help you avoid drama before you hit send.",
          cta: "Got it!"
        },
        context_label: "Message Context",
        analyze_button: "Analyze Message",
        analyzing: "Analyzing...",
        verification_required: "Verification required - please try again",
        trial_quota: "\u{1F512} {remaining} of {limit} free analyses remaining this week",
        help_text: '\u{1F4A1} Enter a message above and tap "Analyze Message" to see its drama score, potential issues, and suggested improvements.',
        errors: {
          analysis_failed: "Analysis Failed",
          unexpected_error: "An unexpected error occurred. Please try again."
        }
      },
      history: {
        subtitle: "Your past analysis results"
      },
      history_item: {
        category: {
          safe: "Safe",
          caution: "Caution",
          risky: "Risky"
        },
        time: {
          just_now: "Just now",
          minutes_ago: "{count}m ago",
          hours_ago: "{count}h ago",
          days_ago: "{days}d ago"
        },
        accessibility: {
          analysis_result: "Analysis result: {category}, score {score}"
        }
      },
      history_grouping: {
        today: "Today",
        yesterday: "Yesterday",
        this_week: "This Week",
        last_week: "Last Week",
        this_month: "This Month"
      },
      episode_history: {
        title: "Episode History",
        swipe_hint: "Swipe to browse episodes like changing TV channels",
        accessibility: {
          list_label: "Episode history. Swipe to browse {count} episodes"
        }
      },
      history_list: {
        empty: {
          title: "No History Yet",
          message: "Your analyzed messages will appear here. Head to the Home tab to analyze your first message!"
        },
        errors: {
          load_failed: "Failed to Load History",
          pull_to_retry: "Pull down to retry"
        }
      },
      analysis_detail_modal: {
        title: "Analysis Details",
        message_label: "Message",
        actions: {
          edit_and_reanalyze: "Edit & Re-analyze",
          done: "Done"
        },
        accessibility: {
          close_modal: "Close modal",
          edit_and_reanalyze: "Edit and re-analyze this message"
        }
      },
      analysis_results: {
        issues_detected: "Issues Detected",
        suggested_improvements: "Suggested Improvements",
        pattern_spotlight: "Pattern Spotlight",
        transformation_insights: "Transformation Insights"
      },
      score_card: {
        drama_score: "Drama Score",
        estimated_label: "Estimated",
        accessibility: {
          drama_score_value: "Drama score: {score} out of 10, {category}"
        }
      },
      suggestions: {
        before: "Before",
        after: "After",
        copy_button: "Copy",
        copied: "Copied!",
        empty: {
          title: "No suggestions available",
          message: "Your message looks good as is!"
        },
        accessibility: {
          improvement_area: "Improvement area: {area}",
          copy_to_clipboard: "Copy to clipboard",
          copied_to_clipboard: "Copied to clipboard",
          no_suggestions: "No suggestions available"
        }
      },
      issues: {
        position_label: "Position: ",
        full_snippet_label: "Full snippet: ",
        show_more: "Show More \u25BC",
        show_less: "Show Less \u25B2",
        empty: {
          title: "No issues detected",
          message: "Your message looks good!"
        },
        accessibility: {
          severity: "Severity: {severity}",
          weight: "This issue contributes {percent} percent to the overall drama score",
          no_issues: "No issues detected. Message looks good!"
        }
      },
      message_input: {
        placeholder: "Type your message here...",
        clear_button: "Clear",
        accessibility: {
          input_label: "Message input",
          input_hint: "Enter the message you want to analyze",
          clear_message: "Clear message"
        }
      },
      context_selector: {
        options: {
          family: "Family",
          work: "Work",
          friends: "Friends",
          dating: "Dating"
        },
        accessibility: {
          label: "Context selector",
          select_family: "Select Family context",
          select_work: "Select Work context",
          select_friends: "Select Friends context",
          select_dating: "Select Dating context"
        }
      },
      tier_card: {
        current_plan: "Current Plan",
        subscribe_button: "Subscribe",
        no_payment_required: "No payment required",
        accessibility: {
          subscribe_to: "Subscribe to {name}"
        }
      },
      tabs: {
        home: "Home",
        history: "History",
        stats: "Stats",
        settings: "Settings"
      },
      trial: {
        inline_banner: {
          title: "Great start! You have {remaining} more free weekly analyses",
          body: "You're off to a great start! Sign up to get 10 daily analyses and save your history forever.",
          cta: "Sign Up Free",
          accessibility: {
            dismiss: "Dismiss notification",
            banner: "Trial usage notification"
          }
        },
        blur_overlay: {
          title: "Only {remaining} weekly analysis left!",
          body: "You're running low on free weekly analyses. Sign up now to get 10 daily analyses and save your progress forever.",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account"
          },
          cta: "Sign Up Free",
          accessibility: {
            dismiss: "Dismiss reminder"
          }
        },
        bottom_sheet: {
          title: "You've used all 10 free weekly analyses!",
          body: "Great work! You've experienced the power of DramaDetector. Sign up now to keep improving your communication.",
          benefits_title: "What you'll get:",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account",
            support: "\u26A1 Email support included"
          },
          cta_signup: "Sign Up Free",
          cta_later: "Maybe Later",
          disclaimer: "No credit card required \u2022 Cancel anytime"
        },
        exhausted: {
          title: "Weekly Limit Reached",
          body: "You've used all 10 free weekly analyses. Resets every Monday at 00:00 UTC. Sign up to continue!",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account"
          },
          cta_signup: "Sign Up Free",
          cta_later: "Maybe Later"
        },
        ip_limit: {
          title: "Weekly Limit Reached",
          body: "You've used all 10 free weekly analyses. Resets every Monday at 00:00 UTC. Sign up for daily analyses!",
          benefits: {
            analyses: "\u2728 10 analyses daily, free forever",
            history: "\u{1F4CA} Save your analysis history",
            account: "\u{1F512} Secure & private account"
          },
          reset_info: "Limit resets every Monday at 00:00 UTC.",
          cta_signup: "Sign Up Free",
          cta_later: "Maybe Later"
        }
      },
      loading: {
        analyzing_your_message: "Analyzing your message...",
        complete_tap_to_continue: "Complete. Tap to continue.",
        two_voices_analyzing: "Two Voices Analyzing...",
        reviewing_your_message: "Reviewing your message...",
        meanwhile: "Meanwhile...",
        review_complete: "Review Complete",
        ready_to_send: "Ready to send (or revise!)",
        learn_more_link: "About the two voices",
        explainer_modal: {
          title: "About Your Two Voices",
          intro: "DramaDetector uses two distinct voices to help you communicate better:",
          narrator_section: "The Narrator",
          narrator_body: "Frames your messages like TV episodes, with playful observations and episodic framing.",
          expert_section: "The Drama Expert",
          expert_body: "Analyzes what's really happening using pattern recognition and framework-based advice.",
          why_two: "Why Two Voices?",
          why_two_body: "The Narrator keeps things entertaining while the Drama Expert gives you actionable insights.",
          cta: "Got it, thanks!",
          close_button: "Close modal",
          session5_reveal: {
            title: "\u{1F3AD} Meet Your Two Voices",
            intro: "You've been working with two distinct voices all along\u2014now let's officially introduce them.",
            narrator_section: "The Narrator",
            narrator_body: "Frames your messages like TV episodes, with playful observations and episodic framing. You've seen their work in the loading quips and analysis intros.",
            expert_section: "The Drama Expert",
            expert_body: "Analyzes what's really happening using pattern recognition and framework-based advice. They cut through the drama with reality TV metaphors and evidence-based insights.",
            why_two: "Why Two Voices?",
            why_two_body: "The Narrator keeps things entertaining while the Drama Expert gives you actionable insights. Together, they help you avoid sending messages you'll regret\u2014without feeling like a therapy session.",
            cta: "Got it!",
            close_button: "Close"
          }
        }
      },
      share: {
        button: "Share Your Results",
        public_result: {
          acknowledge_hint: "Tap the checkbox to agree before publishing."
        },
        modal: {
          title: "Share Your Analysis",
          subtitle: "Preview the image, choose the size, then share it anywhere.",
          select_template: "Select template",
          preview_title: "Preview",
          preview_support: "Preview the exact image asset before you share it.",
          format_title: "Image Size",
          format_helper: "Choose where this image will be posted. This changes the exported image size and crop.",
          selection_helper: "Image size changes the export. Post style changes the voice and caption.",
          post_style_title: "Post Style",
          template_playful: "Choose the vibe for your reality-show moment.",
          template_editorial: "Choose the angle for your panel-worthy reveal.",
          template_clinical: "Choose the clearest way to frame the pattern.",
          selected: "Selected",
          export_title: "Export share-ready image",
          export_description: "Your selected image size will be used for the generated share asset.",
          primary_image_cta: "Create & share image",
          primary_text_cta: "Share post text",
          secondary_link_title: "Share link instead",
          secondary_link_description: "Use a link when you want the interactive page instead of an image asset."
        },
        format: {
          fallback: {
            portrait: {
              label: "Your Episode",
              sublabel: "Feed \xB7 4:5",
              hint: "Best for Instagram Feed, Facebook"
            },
            square: {
              label: "Your Score",
              sublabel: "Grid \xB7 1:1",
              hint: "Good for profile grids, multi-platform"
            },
            reel: {
              label: "Reality Moment",
              sublabel: "Reel \xB7 9:16",
              hint: "Best for Reels, TikTok, Stories"
            },
            horizontal: {
              label: "Quick Take",
              sublabel: "Link \xB7 16:9",
              hint: "Best for messaging & link previews"
            }
          }
        },
        voice: {
          narrator: "Narrator",
          expert: "Drama Expert"
        },
        link_option: {
          title: "Share via Link",
          description: "Create a link anyone can open",
          creating: "Creating link...",
          label: "Share via Link",
          copied: "Copied!"
        },
        templates: {
          episode_framing: {
            title: "Episode Framing",
            description: "Share as your life's dramatic episode",
            text: "Episode Alert: Drama score {score}/10 in my{context} life \u{1F480}\n\nPreviously on My Life: things were calm.\nThe analysis continues..."
          },
          pattern_recognition: {
            title: "Pattern Recognition",
            description: "Share the pattern your expert spotted",
            text: `My drama expert just diagnosed me with "{pattern}" and honestly? They're not wrong \u{1F62D}`
          },
          advice_wisdom: {
            title: "Drama Expert Wisdom",
            description: "Share the helpful advice you got",
            text: "Why is my drama expert giving better advice than my actual friends \u{1F4A1}"
          },
          reality_tv_commentary: {
            title: "Reality TV Commentary",
            description: "Share the meta-commentary on your text",
            text: "Me: *opens text at 11:47 PM*\n\nMy narrator: Drama score {score}/10\n\nI feel SO seen \u{1F440}"
          },
          basic: {
            title: "Share Results",
            description: "Basic share template",
            text: "Just got my drama score: {score}/10\n\nChecking my messages before I send them now..."
          }
        }
      },
      transformationInsightCard: {
        labels: {
          before: "Before",
          after: "After"
        },
        insights_label: "Key Insights",
        accessibility: {
          shareTransformation: "Share {transformationType} transformation",
          beforeText: "Original message",
          afterText: "Transformed message"
        }
      },
      narrator_episode: {
        previously_on: "Previously on Your Life",
        this_episode: "This Episode",
        attribution: "Narrated by your story's observer",
        summary: {
          low: "You're communicating clearly. No major conflicts detected.",
          medium: "Some tension detected. Let's analyze the patterns.",
          high: "High-stakes communication ahead. Drama Expert insights below."
        }
      },
      drama_expert: {
        section_header: "Drama Expert Analysis",
        section_subheader: "Pattern recognition and actionable insights"
      },
      share_card: {
        watermark: "DramaDetector.app",
        narrator: {
          score_label: "Drama Score:",
          attribution: "Narrated by your story's observer",
          section_label: "NARRATOR"
        },
        expert: {
          header: "My Drama Expert said...",
          attribution: "Drama Expert by DramaDetector",
          section_label: "DRAMA EXPERT"
        },
        context: {
          work: "\u{1F4BC} Work",
          dating: "\u{1F495} Dating",
          family: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Family",
          friends: "\u{1F465} Friends"
        }
      },
      transformation_insight: {
        communication_pattern_shift: {
          type: "Communication Pattern Shift",
          before: "Your current pattern shows defensive language in high-stress contexts",
          after: "Embrace vulnerable authenticity by naming emotions directly",
          insights: [
            "Observation without Evaluation: Separate facts from interpretations",
            "High impact transformation reduces conflict escalation",
            "Practice naming emotions directly without defensive framing"
          ]
        }
      },
      quota: {
        paywall: {
          title: "\u{1F4CA} Daily Analysis Limit Reached",
          message: "You've used all 10 free daily analyses. Upgrade to Drama+ for 500 analyses/day or DramaX for unlimited analyses.",
          cta_hint: "Choose a plan below to continue analyzing messages"
        }
      },
      patternSpotlightCard: {
        detected: "{count, plural, =0 {Not detected} one {Detected # time} other {Detected # times}}",
        recurring_theme: "Recurring Theme",
        recurring_description: "Your most frequent communication challenge across conversations",
        accessibility: {
          sharePattern: "Share {patternType} pattern"
        }
      },
      historyPremiumInsights: {
        pattern_recognition: {
          type: "Pattern Recognition & Transformation",
          before: "Your history shows repeated escalation patterns",
          after: "Practice the four-step Nonviolent Communication framework",
          insights: [
            "Needs-Based Communication: Identify underlying needs driving behavior",
            "Break escalation cycles by addressing root causes",
            "Four-step NVC: Observation \u2192 Feeling \u2192 Need \u2192 Request"
          ]
        }
      },
      gating: {
        unlock_more: "Unlock {count} more {count, plural, one {issue} other {issues}}",
        upgrade_to: "Upgrade to {tierName}",
        unlock_now: "Unlock Now",
        premium_feature_title: "Premium Feature",
        premium_feature_description: "This feature requires {tierName}. Upgrade to unlock advanced insights.",
        upgrade_to_tier: "Upgrade to {tierName}",
        view_upgrade_options: "View upgrade options",
        tap_to_unlock: "Tap to unlock {tierName} features",
        preview_title: "Get clearer rewrite help before you send",
        preview_subtitle: "Drama+ adds better rewrite guidance, inline notes, and pattern spotting. DramaX goes deeper with transformation plans.",
        try_drama_plus: "Try Drama+ rewrite help",
        feature_preview_title_patterns: "Pattern Spotlight",
        feature_preview_desc_patterns: "See the communication pattern this message may repeat.",
        feature_preview_title_rewrite_help: "Better Rewrite Help",
        feature_preview_desc_rewrite_help: "Get clearer suggestions to soften tone and improve this message before you send.",
        feature_preview_title_annotations: "Inline Annotations",
        feature_preview_desc_annotations: "See what to change directly in the message, right where it lands.",
        pattern_spotlight_teaser: "See the pattern behind this message",
        pattern_spotlight_title: "Your Pattern Is Showing",
        pattern_spotlight_body: "You've sent messages like this before. Drama+ shows you the recurring patterns in your communication \u2014 so you can break them before they break relationships.",
        pattern_spotlight_cta: "Unlock Drama+ \u2014 {price}",
        pattern_spotlight_dismiss: "Not now \u2014 I'll figure it out on my own",
        quota_free_title: "You're On A Roll",
        quota_free_body: "You've used all 10 free analyses today. That's the sign of someone taking their communication seriously. Drama+ gives you 100 analyses a day \u2014 and shows you the patterns behind all of them.",
        quota_free_cta: "Upgrade to Drama+",
        quota_drama_plus_body: "Reached your 100/day limit. DramaX gives you 200 \u2014 plus the transformation toolkit.",
        pattern_teaser: {
          unlock_patterns: "Unlock {count} More Patterns with Drama+",
          tooltip: "Unlock your full pattern history with Drama+",
          one_visible: "1 pattern visible"
        },
        transformation_insight_teaser: "See how to rewrite this moment",
        transformation_insight_free_title: "This Is Transformable",
        transformation_insight_free_body: "Your drama score is high \u2014 and that means there's a real opportunity here. DramaX shows you exactly how to reframe this message using the NVC framework, plus your personalized transformation plan.",
        transformation_insight_free_cta: "Unlock DramaX \u2014 {price}",
        transformation_insight_plus_title: "Go Beyond Patterns",
        transformation_insight_plus_body: "You've mastered spotting your patterns. DramaX takes the next step: your personalized communication transformation plan, rooted in the Nonviolent Communication framework.",
        transformation_insight_plus_cta: "Upgrade to DramaX"
      },
      inline_annotations: {
        header: "Your Message",
        issues_count: "{count, plural, one {1 issue detected} other {{count} issues detected}}",
        progress: "{addressed} of {total} addressed",
        suggestions_applied: "{count, plural, one {1 suggestion applied} other {{count} suggestions applied}}",
        copy: "Copy",
        copied: "Copied!",
        copy_revised: "Copy revised message",
        accept: "Accept",
        ignore: "Ignore",
        accepted: "\u2713 Accepted",
        ignored: "Ignored",
        drama: "drama",
        why_this_matters: "Why this matters",
        original: "Original",
        revised: "Revised",
        score_delta: "{count, plural, one {+1 point} other {+{count} points}}",
        score_delta_aria: "{count, plural, one {Score improved by 1 point} other {Score improved by {count} points}}",
        all_reviewed: "All issues reviewed!",
        progress_complete_aria: "All {total} issues have been reviewed",
        almost_safe: "Accept to reach Safe zone",
        almost_caution: "One step from High to Caution",
        almost_high: "Almost out of Extreme range"
      },
      consent: {
        headline: "Ready to go deeper?",
        body: "You've completed {count} analyses. DramaX reveals Pattern Origins, Influential Voices, and full Narrative Clarity methodology.",
        cta: "Explore DramaX",
        dismiss: "Not now",
        banner_text: "You've analyzed {count} conversations. See the patterns behind your patterns with DramaX.",
        benefits: {
          pattern_origins: "Pattern Origins \u2014 understand where your communication habits come from",
          influential_voices: "Influential Voices \u2014 identify who shaped your communication style",
          narrative_clarity: "Full Narrative Clarity methodology for lasting change"
        }
      },
      celebration: {
        category_improved: "Nice! You moved to {category}!",
        safe_reached: "All clear! Your message looks great."
      },
      nudge: {
        almost_there: "Almost there! {points} points from {category} zone"
      }
    };
  }
});

// src/i18n/locales/en/safety.json
var require_safety = __commonJS({
  "src/i18n/locales/en/safety.json"(exports, module) {
    module.exports = {
      banner: {
        text_default: "Need help? Get support",
        text_triggered: "We noticed some concerning language. Get support",
        accessibility_label: "Crisis support resources",
        accessibility_hint: "Tap to view mental health resources and crisis hotlines",
        get_help_button: "Talk to a Professional",
        get_help_accessibility_label: "Connect with a mental health professional",
        get_help_accessibility_hint: "Opens options to reach your therapist or counselor for support"
      },
      modal: {
        title_default: "You're Not Alone",
        title_triggered: "We're Here for You",
        subtitle: "If you're struggling, help is available 24/7. These resources are free and confidential.",
        resource_988_name: "988 Suicide & Crisis Lifeline",
        resource_988_description: "Free, confidential support 24/7",
        call_now: "Call Now",
        call_988_accessibility: "Call 988 Suicide and Crisis Lifeline",
        call_988_hint: "Opens phone to call 988 for immediate crisis support",
        resource_text_name: "Crisis Text Line",
        resource_text_description: "Text HOME to 741741",
        text_now: "Text Now",
        text_741741_accessibility: "Text Crisis Text Line",
        text_741741_hint: "Opens messaging app to text HOME to 741741",
        resource_international_name: "International Resources",
        resource_international_description: "Find help in your country",
        international_accessibility: "View international crisis resources",
        disclaimer: "DramaDetector is not a crisis service. If you're in immediate danger, please call emergency services (911 in the US) or contact a crisis hotline.",
        close: "Close",
        close_accessibility: "Close crisis resources modal",
        ok: "OK",
        call_fallback_title: "Call 988",
        call_fallback_message: "To reach the Suicide & Crisis Lifeline, please dial {phone} on your phone.",
        sms_fallback_title: "Text Crisis Line",
        sms_fallback_message: "To reach the Crisis Text Line, open your messaging app and text HOME to 741741."
      },
      concern_flag: {
        button_label: "I'm Concerned",
        button_hint: "Report concerning content for internal review",
        modal_title: "What concerns you?",
        modal_subtitle: "Your feedback helps us improve. All reports are confidential.",
        reason_self_harm: "Self-harm or crisis indicators",
        reason_harmful: "Harmful or dangerous content",
        reason_other: "Something else",
        context_placeholder: "Tell us more (optional)",
        submit: "Submit Report",
        cancel: "Cancel",
        success_title: "Thank You",
        success_message: "Your concern has been noted. Remember, if you or someone you know is in crisis, please contact a crisis hotline.",
        error_title: "Unable to Submit",
        error_message: "Something went wrong. Please try again later."
      },
      tos: {
        title: "Important Information",
        body: "DramaDetector helps you understand communication patterns and reduce drama in your messages. Please remember:",
        bullet_1: "This is an educational tool, not a mental health service",
        bullet_2: "It's not a substitute for professional therapy or counseling",
        bullet_3: "If you're in crisis, please contact 988 or a mental health professional",
        checkbox_label: "I understand and accept these terms",
        continue: "Continue",
        decline: "Decline"
      },
      practitioner_prompt: {
        title: "Would you like to reach out?",
        subtitle: "Your therapist or counselor is available to support you.",
        description: "We'll let them know you could use some support. They can reach back when they're available.",
        privacy_notice: "Only the general concern type will be shared, not specific message content.",
        request_support: "Request Support",
        not_now: "Not Now",
        accessibility_label: "Request support from your practitioner",
        accessibility_hint: "Opens a form to send a support request to your therapist or counselor"
      },
      practitioner_selector: {
        title: "Who would you like to reach?",
        subtitle: "Select a practitioner to notify",
        no_practitioners: "No practitioners available",
        no_practitioners_description: "You don't have any practitioners with crisis notifications enabled.",
        select_accessibility: "Select practitioner to receive your support request",
        send_request: "Send Request",
        cancel: "Cancel",
        default_name: "Your Practitioner",
        sending: "Sending request..."
      },
      request_status: {
        pending: "Request Sent",
        pending_description: "Your practitioner will be notified soon",
        viewed: "Viewed",
        viewed_description: "Your practitioner has seen your request",
        responded: "Response Received",
        responded_description: "Your practitioner has responded",
        resolved: "Resolved",
        resolved_description: "This request has been resolved",
        expired: "Expired",
        expired_description: "This request has expired after 72 hours",
        view_response: "View Response",
        mark_resolved: "Mark as Resolved",
        expires_in: "Expires in {time}"
      },
      request_message: {
        placeholder: "Add a message for your practitioner (optional)",
        char_limit: "{count}/{max} characters",
        accessibility_hint: "Optional message to provide context to your practitioner"
      },
      request_success: {
        title: "Support Request Sent",
        description: "Your practitioner has been notified. They'll reach out when they're available.",
        reminder: "Remember, if you're in immediate danger, please call 988 or emergency services.",
        done: "Done"
      },
      request_error: {
        title: "Unable to Send Request",
        description: "We couldn't send your request right now. Please try again or contact your practitioner directly.",
        retry: "Try Again",
        contact_directly: "Contact Directly"
      },
      practitioner_response: {
        title: "Message from Your Practitioner",
        responded_at: "Responded {time}",
        close: "Close",
        resolve: "Mark as Resolved"
      },
      detection_feedback: {
        inline_trigger: "Was this banner accurate?",
        inline_trigger_accessibility: "Provide feedback on crisis detection accuracy",
        inline_trigger_hint: "Opens a quick feedback form to help us improve",
        sheet_title: "Help us improve",
        sheet_subtitle: "Your feedback keeps detection accurate.",
        category_accurate_resources_helped: "Accurate \u2013 Resources Helped",
        subtag_placeholder: "Select a reason",
        subtag_roleplay: "Roleplay or character dialogue",
        subtag_quote: "Quote from media",
        subtag_sarcasm: "Sarcasm or joke",
        subtag_lyrics: "Song lyrics or poetry",
        subtag_academic: "Academic discussion",
        subtag_historical: "Historical reference",
        subtag_other: "Something else",
        prompt_title: "Was this helpful?",
        prompt_subtitle: "Your feedback helps us improve crisis detection.",
        accurate_button: "Yes, this was accurate",
        inaccurate_button: "This wasn't right",
        skip_button: "Skip",
        category_title: "What type of content was this?",
        category_subtitle: "This helps us reduce false alerts in the future.",
        category_fictional: "Fictional content",
        category_fictional_description: "Story, novel, screenplay, roleplay",
        category_academic: "Academic discussion",
        category_academic_description: "Research, education, historical analysis",
        category_creative: "Creative writing",
        category_creative_description: "Song lyrics, poetry, art description",
        category_historical: "Historical reference",
        category_historical_description: "News, documentaries, past events",
        category_actual_crisis: "I needed these resources",
        category_actual_crisis_description: "The detection was helpful",
        category_other: "Something else",
        category_other_description: "None of the above",
        context_placeholder: "Tell us more (optional)",
        context_hint: "Your message content is never stored",
        submit: "Submit Feedback",
        submitting: "Submitting...",
        cancel: "Cancel",
        retry: "Try Again",
        success_title: "Thank you",
        success_message: "Your feedback helps us improve.",
        error_title: "Unable to Submit",
        error_message: "Please try again later.",
        privacy_notice: "Your feedback is anonymous. Message content is never stored.",
        accessibility_accurate: "Mark detection as accurate",
        accessibility_inaccurate: "Mark detection as inaccurate",
        accessibility_category_select: "Select the type of content"
      }
    };
  }
});

// src/i18n/locales/es/common.json
var require_common2 = __commonJS({
  "src/i18n/locales/es/common.json"(exports, module) {
    module.exports = {
      app_name: "DramaDetector",
      loading: "Cargando...",
      error: "Algo sali\xF3 mal",
      try_again: "Intentar Nuevamente",
      tier_drama_plus: "Drama+",
      tier_dramax: "DramaX",
      error_boundary: {
        title: "Algo sali\xF3 mal",
        description: "Encontramos un problema al mostrar este contenido."
      },
      cancel: "Cancelar",
      confirm: "Confirmar",
      close: "Cerrar",
      success: "\xC9xito",
      share: "Compartir",
      remove: "Eliminar",
      send: "Enviar",
      back: "Atr\xE1s",
      yearly: "Anual",
      monthly: "Mensual",
      cancelInvite: "Cancelar Invitaci\xF3n",
      copied: "\xA1Copiado!",
      free: "Gratis",
      referrals: {
        title: "Invitar Amigos",
        subtitle: "Comparte DramaDetector con amigos y gana recompensas cuando se suscriban.",
        your_link: "Tu Enlace de Referido",
        copy_link: "Copiar enlace de referido",
        share_email: "Correo",
        share_sms: "SMS",
        share_qr: "C\xF3digo QR",
        generate_prompt: "Genera tu enlace de referido \xFAnico para comenzar a invitar amigos.",
        generating: "Generando...",
        generate_code: "Obtener Mi Enlace de Referido",
        stat_invited: "Invitados",
        stat_converted: "Suscritos",
        activity: "Actividad de Referidos",
        pending_signup: "Registro pendiente",
        status_pending: "Pendiente",
        status_signed_up: "Registrado",
        status_subscribed: "Suscrito",
        status_rewarded: "Recompensado",
        status_expired: "Expirado",
        status_fraudulent: "Marcado"
      },
      referral_banner: {
        title: "\xA1Fuiste invitado!",
        subtitle: "Suscr\xEDbete ahora y tu amigo gana una recompensa. \xA1Obtienes 30 d\xEDas de Drama+ gratis como pase de invitado!"
      },
      not_found: {
        title: "P\xE1gina no encontrada",
        redirecting: "Redirigiendo al inicio..."
      },
      skip: "Omitir",
      next: "Siguiente",
      get_started: "Comenzar",
      step_counter: "{{current}} de {{total}}",
      step_indicator: "Paso {{current}} de {{total}}",
      welcome_greeting: "\xA1Bienvenido a DramaDetector!",
      welcome_greeting_name: "\xA1Bienvenido, {{name}}!",
      welcome_subtitle: "Tu coach de comunicaci\xF3n con IA",
      welcome_value_detect: "Detecta patrones ocultos en conversaciones",
      welcome_value_insights: "Obt\xE9n ideas pr\xE1cticas para comunicarte mejor",
      welcome_value_rewrite: "Reescribe mensajes con alternativas m\xE1s saludables",
      how_it_works_title: "C\xF3mo Funciona",
      how_it_works_subtitle: "Tres simples pasos para una mejor comunicaci\xF3n",
      how_step_paste_title: "Pegar",
      how_step_paste_desc: "Copia cualquier conversaci\xF3n \u2014 textos, correos, mensajes directos o chats grupales.",
      how_step_analyze_title: "Analizar",
      how_step_analyze_desc: "Nuestra IA detecta patrones de drama, estilos de comunicaci\xF3n y din\xE1micas emocionales.",
      how_step_improve_title: "Mejorar",
      how_step_improve_desc: "Obt\xE9n mensajes reescritos y consejos pr\xE1cticos para comunicarte de forma m\xE1s saludable.",
      privacy_title: "Tu Privacidad Importa",
      privacy_subtitle: "Construido con la privacidad como prioridad",
      privacy_private_title: "Las conversaciones son privadas",
      privacy_private_desc: "Tus mensajes se analizan y se descartan. Nunca almacenamos el contenido de las conversaciones.",
      privacy_no_selling_title: "Sin venta de datos",
      privacy_no_selling_desc: "Tus datos nunca se venden a terceros. Punto.",
      privacy_anonymous_title: "Solo anal\xEDticas an\xF3nimas",
      privacy_anonymous_desc: "Las anal\xEDticas de uso son completamente an\xF3nimas. Rastreamos patrones, no personas.",
      privacy_delete_title: "Elimina cuando quieras",
      privacy_delete_desc: "Tu cuenta y todos los datos asociados pueden eliminarse al instante desde Configuraci\xF3n.",
      history_item: {
        category: {
          safe: "Seguro",
          caution: "Precauci\xF3n",
          risky: "Riesgoso"
        },
        time: {
          just_now: "Justo ahora",
          minutes_ago: "hace {count}m",
          hours_ago: "hace {count}h"
        },
        accessibility: {
          analysis_result: "Resultado de an\xE1lisis: {category}, puntuaci\xF3n {score}"
        }
      }
    };
  }
});

// src/i18n/locales/es/auth.json
var require_auth2 = __commonJS({
  "src/i18n/locales/es/auth.json"(exports, module) {
    module.exports = {
      login: {
        title: "Bienvenido de Nuevo",
        subtitle: "Inicia sesi\xF3n para continuar en DramaDetector",
        divider: "o",
        email_label: "Email",
        email_placeholder: "you@example.com",
        password_label: "Contrase\xF1a",
        password_placeholder: "Ingresa tu contrase\xF1a",
        sign_in_button: "Iniciar Sesi\xF3n",
        signing_in: "Iniciando sesi\xF3n...",
        no_account: "\xBFNo tienes una cuenta?",
        sign_up_link: "Reg\xEDstrate",
        verification_required: "Por favor completa la verificaci\xF3n para continuar",
        errors: {
          login_failed: "Error al Iniciar Sesi\xF3n",
          unexpected_error: "Ocurri\xF3 un error inesperado"
        },
        accessibility: {
          email_address: "Direcci\xF3n de email",
          email_hint: "Ingresa tu direcci\xF3n de email para iniciar sesi\xF3n",
          password: "Contrase\xF1a",
          password_hint: "Ingresa tu contrase\xF1a",
          sign_up: "Registrarse"
        }
      },
      signup: {
        title: "Crear Cuenta",
        subtitle: "Reg\xEDstrate para comenzar a usar DramaDetector",
        divider: "o",
        email_label: "Email",
        email_placeholder: "you@example.com",
        password_label: "Contrase\xF1a",
        password_placeholder: "Al menos 6 caracteres",
        confirm_password_label: "Confirmar Contrase\xF1a",
        confirm_password_placeholder: "Vuelve a ingresar tu contrase\xF1a",
        sign_up_button: "Registrarse",
        creating_account: "Creando cuenta...",
        already_have_account: "\xBFYa tienes una cuenta?",
        sign_in_link: "Iniciar Sesi\xF3n",
        verification_required: "Por favor completa la verificaci\xF3n para continuar",
        success: {
          title: "\xC9xito",
          message: "\xA1Cuenta creada! Por favor revisa tu email para confirmar tu cuenta."
        },
        errors: {
          signup_failed: "Error al Registrarse",
          unexpected_error: "Ocurri\xF3 un error inesperado"
        },
        accessibility: {
          email_address: "Direcci\xF3n de email",
          email_hint: "Ingresa tu direcci\xF3n de email para crear una cuenta",
          password: "Contrase\xF1a",
          password_hint: "Crea una contrase\xF1a con al menos 6 caracteres",
          confirm_password: "Confirmar contrase\xF1a",
          confirm_password_hint: "Vuelve a ingresar tu contrase\xF1a para confirmar",
          sign_in: "Iniciar sesi\xF3n"
        }
      },
      session_expiry: {
        title: "Sesi\xF3n Expirada",
        message: "Tu sesi\xF3n ha expirado. Por favor inicia sesi\xF3n nuevamente para continuar.",
        sign_in: "Iniciar Sesi\xF3n"
      }
    };
  }
});

// src/i18n/locales/es/home.json
var require_home2 = __commonJS({
  "src/i18n/locales/es/home.json"(exports, module) {
    module.exports = {
      home: {
        subtitle: "Recibe una revisi\xF3n experta de tu mensaje antes de enviarlo",
        input_placeholder: "Escribe o pega tu drama aqu\xED...",
        input_placeholder_message_before_send: "Pega un mensaje que est\xE1s a punto de enviar...",
        modern: {
          title: "Experiencia Moderna",
          switch_to_classic: "Cambiar a vista cl\xE1sica \u2192",
          processing: "Procesando...",
          animation_error: "La animaci\xF3n fall\xF3. Mostrando resultados...",
          animation_speed: "Velocidad de Animaci\xF3n",
          speed_option: "Velocidad de animaci\xF3n {speed}",
          drama_score: "Puntuaci\xF3n de Drama",
          analyze_another: "Analizar Otro",
          view_full_analysis: "Ver An\xE1lisis Completo",
          view_details_classic: "Ver Detalles (Cl\xE1sico)",
          tap_to_skip: "Toca en cualquier lugar para omitir",
          skip_animation: "Omitir animaci\xF3n",
          analysis_summary: "Resumen del An\xE1lisis",
          issues_detected: "Problemas Detectados",
          suggested_improvements: "Mejoras Sugeridas",
          original: "Original:",
          suggested: "Sugerido:",
          pattern_spotlight: "Patr\xF3n Destacado",
          found_times: "Encontrado {count} vez/veces",
          transformation_insights: "Ideas de Transformaci\xF3n",
          before: "Antes:",
          after: "Despu\xE9s:",
          insights: "Ideas Clave:",
          impact_high: "Alto Impacto",
          impact_moderate: "Impacto Moderado",
          impact_low: "Bajo Impacto",
          likely_impact_value: "Impacto probable: {impact}",
          was_helpful: "\xBFTe result\xF3 \xFAtil este an\xE1lisis?",
          helpful_yes: "S\xED, \xFAtil",
          helpful_no: "No, no \xFAtil",
          quick_nav_label: "Navegaci\xF3n r\xE1pida",
          score_nav: "Puntuaci\xF3n",
          summary_nav: "Resumen",
          issues_nav: "Problemas",
          suggestions_nav: "Sugerencias",
          patterns_nav: "Patrones",
          transformations_nav: "Ideas",
          feedback_nav: "Retroalimentaci\xF3n",
          show_more: "Mostrar {count} m\xE1s",
          show_less: "Mostrar menos",
          accordion_toggle: "{title}, {count} elementos, {state}",
          expanded: "expandido",
          collapsed: "contra\xEDdo",
          loading_results: "Cargando resultados...",
          back_to_home: "\u2190 Volver al Inicio",
          try_drama_detector: "\u2192 Prueba DramaDetector",
          inline_annotations: "Ver anotaciones en l\xEDnea"
        },
        first_time_intro: {
          title: "\u{1F3AD} Conoce Tus Dos Voces",
          body: "Escuchar\xE1s dos perspectivas: el Narrador (quien presenta tu mensaje como un episodio) y el Experto en Drama (quien analiza lo que realmente est\xE1 pasando). Ambos te ayudan a evitar el drama antes de enviar.",
          cta: "\xA1Entendido!"
        },
        two_voices_hint: {
          title: "\u{1F3AC} Dos Voces, Una Misi\xF3n",
          body: "Escuchar\xE1s dos perspectivas: el Narrador (quien presenta tu mensaje como un episodio) y el Experto en Drama (quien analiza lo que realmente est\xE1 pasando). Ambos te ayudan a evitar el drama antes de enviar.",
          cta: "\xA1Entendido!"
        },
        choose_experience: "Elige tu experiencia:",
        context_label: "Contexto del Mensaje",
        analyze_button: "Analizar Mensaje",
        analyzing: "Analizando...",
        animation_analyzing: "ANALIZANDO... {{percent}}%",
        animation_complete: "COMPLETO",
        category_label: {
          safe: "Drama Bajo",
          caution: "Precauci\xF3n",
          high_drama: "Drama Alto",
          extreme_drama: "Drama Extremo",
          safety: "Apoyo Disponible"
        },
        verification_required: "Verificaci\xF3n requerida - por favor intenta de nuevo",
        trial_quota: "\u{1F512} {remaining} de {limit} an\xE1lisis gratuitos restantes esta semana",
        trial_quota_exhausted: "{remaining} de {limit} an\xE1lisis restantes",
        quota_resets: "Tu cuota se reinicia {resetTime}",
        quota_low_warning: "\xA1Se est\xE1 agotando! La cuota se reinicia {resetTime}",
        quota_exhausted_button: "Cuota Alcanzada",
        upgrade_to_pro: "Actualizar a Pro",
        view_plans: "Ver Planes",
        anonCta: {
          headline: "Reg\xEDstrate para guardar tu historial 7 d\xEDas",
          body: "Tus an\xE1lisis an\xF3nimos expiran en 24 horas. Reg\xEDstrate gratis y se conservan 7 d\xEDas \u2014 adem\xE1s de 10 an\xE1lisis al d\xEDa y mensajes de 1000 caracteres.",
          primary: "Reg\xEDstrate gratis",
          dismiss: "Continuar como invitado"
        },
        anonCtaExhausted: {
          headline: "Reg\xEDstrate para seguir analizando",
          body: "Has usado tus {{limit}} an\xE1lisis semanales. Reg\xEDstrate gratis para obtener 10 al d\xEDa, mensajes de 1000 caracteres e historial guardado."
        },
        help_text: '\u{1F4A1} Escribe un mensaje arriba y toca "Analizar Mensaje" para ver su nivel de drama, problemas potenciales y mejoras sugeridas.',
        errors: {
          analysis_failed: "An\xE1lisis Fallido",
          unexpected_error: "Ocurri\xF3 un error inesperado. Por favor intenta de nuevo.",
          network_error: "Error de conexi\xF3n de red. Por favor verifica tu conexi\xF3n a internet e intenta de nuevo.",
          network_timeout: "Tiempo de espera agotado. Por favor verifica tu conexi\xF3n e intenta de nuevo.",
          results_not_found: "Resultados No Encontrados",
          results_not_found_message: "El an\xE1lisis que buscas no existe o ha sido eliminado.",
          shared_link_invalid: "Enlace No Encontrado",
          shared_link_invalid_message: "Este enlace compartido no es v\xE1lido, ha expirado o ha sido eliminado.",
          shared_link_expired_title: "Enlace Expirado",
          shared_link_expired_message: "Este enlace compartido ha expirado. Por favor solicita un nuevo enlace al remitente.",
          shared_link_revoked_title: "Enlace Revocado",
          shared_link_revoked_message: "Este enlace ha sido revocado por el propietario y ya no es accesible.",
          shared_link_invalid_token_title: "Enlace Inv\xE1lido",
          shared_link_invalid_token_message: "Este enlace no es v\xE1lido o est\xE1 malformado. Por favor verifica la URL e intenta de nuevo.",
          shared_link_private_title: "An\xE1lisis Privado",
          shared_link_private_message: "Este an\xE1lisis es privado y no se puede compartir.",
          shared_link_not_found_title: "Enlace No Encontrado",
          shared_link_not_found_message: "Este enlace compartido no existe o ha sido eliminado."
        },
        accessibility: {}
      },
      privacy_badge: {
        label: "Cifrado",
        accessibility_hint: "Toca para ver detalles de privacidad",
        modal: {
          title: "Tu privacidad est\xE1 protegida",
          close: "Cerrar",
          sections: {
            encryption: {
              title: "Cifrado de extremo a extremo",
              description: "Tus mensajes se cifran con AES-256-GCM antes de almacenarse. Solo t\xFA puedes acceder a tu historial de an\xE1lisis."
            },
            pii_scrubbing: {
              title: "Eliminaci\xF3n de datos personales",
              description: "Nombres, correos, n\xFAmeros de tel\xE9fono y direcciones se eliminan autom\xE1ticamente antes del an\xE1lisis con IA."
            },
            data_retention: {
              title: "Retenci\xF3n de datos",
              description: "Los an\xE1lisis del plan gratuito se conservan por 30 d\xEDas. Los planes de pago incluyen retenci\xF3n extendida con controles de eliminaci\xF3n."
            },
            deletion: {
              title: "Derecho a la eliminaci\xF3n",
              description: "Elimina todos tus datos en cualquier momento desde Configuraci\xF3n. La eliminaci\xF3n es permanente e irreversible."
            }
          },
          footer: "DramaDetector cumple con las directrices de GDPR y CCPA para la protecci\xF3n de datos."
        }
      },
      message_input: {
        placeholder: "Escribe tu mensaje aqu\xED...",
        clear_button: "Limpiar",
        validation: {
          empty: "Por favor escribe un mensaje para analizar",
          too_short: "El mensaje debe tener al menos {min} caracteres",
          too_long: "El mensaje excede el l\xEDmite de {max} caracteres"
        },
        accessibility: {
          input_label: "Entrada de mensaje",
          input_hint: "Escribe el mensaje que quieres analizar",
          clear_message: "Limpiar mensaje"
        }
      },
      context_selector: {
        options: {
          family: "Familia",
          work: "Trabajo",
          friends: "Amigos",
          dating: "Citas"
        },
        accessibility: {
          label: "Selector de contexto",
          select_family: "Seleccionar contexto Familia",
          select_work: "Seleccionar contexto Trabajo",
          select_friends: "Seleccionar contexto Amigos",
          select_dating: "Seleccionar contexto Citas"
        }
      },
      tier_card: {
        current_plan: "Plan Actual",
        subscribe_button: "Suscribirse",
        no_payment_required: "Sin tarjeta de cr\xE9dito",
        accessibility: {
          subscribe_to: "Suscribirse a {name}"
        }
      },
      tabs: {
        home: "Inicio",
        history: "Historial",
        stats: "Estad\xEDsticas",
        settings: "Configuraci\xF3n",
        messaging: "Mensajes"
      },
      trial: {
        inline_banner: {
          title: "\xA1Buen inicio! Tienes {remaining} an\xE1lisis semanales gratuitos m\xE1s",
          body: "\xA1Vas muy bien! Reg\xEDstrate para obtener 10 an\xE1lisis diarios y guardar tu historial para siempre.",
          cta: "Reg\xEDstrate Gratis",
          accessibility: {
            dismiss: "Descartar notificaci\xF3n",
            banner: "Notificaci\xF3n de uso de prueba"
          }
        },
        blur_overlay: {
          title: "\xA1Solo te queda {remaining} an\xE1lisis semanal!",
          body: "Tus an\xE1lisis semanales gratuitos se est\xE1n agotando. Reg\xEDstrate ahora para obtener 10 an\xE1lisis diarios y guardar tu progreso para siempre.",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada"
          },
          cta: "Reg\xEDstrate Gratis",
          accessibility: {
            dismiss: "Descartar recordatorio"
          }
        },
        bottom_sheet: {
          title: "\xA1Usaste los 10 an\xE1lisis semanales gratuitos!",
          body: "\xA1Excelente trabajo! Experimentaste el poder de DramaDetector. Reg\xEDstrate ahora para seguir mejorando tu comunicaci\xF3n.",
          benefits_title: "Lo que obtendr\xE1s:",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada",
            support: "\u26A1 Soporte por email incluido"
          },
          cta_signup: "Reg\xEDstrate Gratis",
          cta_later: "Quiz\xE1s Despu\xE9s",
          disclaimer: "Sin tarjeta de cr\xE9dito \u2022 Cancela cuando quieras"
        },
        exhausted: {
          title: "L\xEDmite Semanal Alcanzado",
          body: "Usaste los 10 an\xE1lisis semanales gratuitos. Se reinicia cada lunes a las 00:00 UTC. \xA1Reg\xEDstrate para continuar!",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada"
          },
          cta_signup: "Reg\xEDstrate Gratis",
          cta_later: "Quiz\xE1s Despu\xE9s"
        },
        ip_limit: {
          title: "L\xEDmite Semanal Alcanzado",
          body: "Has usado todos los 10 an\xE1lisis semanales gratuitos. Se reinicia cada lunes a las 00:00 UTC. \xA1Reg\xEDstrate para an\xE1lisis ilimitados!",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada"
          },
          reset_info: "El l\xEDmite se reinicia cada lunes a las 00:00 UTC.",
          cta_signup: "Reg\xEDstrate Gratis",
          cta_later: "Quiz\xE1s Despu\xE9s"
        }
      },
      quota: {
        paywall: {
          title: "\u{1F4CA} L\xEDmite de An\xE1lisis Diario Alcanzado",
          message: "Usaste los 10 an\xE1lisis diarios gratuitos. Actualiza a Drama+ para 500 an\xE1lisis/d\xEDa o DramaX para an\xE1lisis ilimitados.",
          cta_hint: "Elige un plan abajo para continuar analizando mensajes"
        }
      }
    };
  }
});

// src/i18n/locales/es/loading.json
var require_loading2 = __commonJS({
  "src/i18n/locales/es/loading.json"(exports, module) {
    module.exports = {
      loading: {
        analyzing_your_message: "Analizando tu mensaje...",
        complete_tap_to_continue: "Completo. Toca para continuar.",
        two_voices_analyzing: "Dos Voces Analizando...",
        reviewing_your_message: "Revisando tu mensaje...",
        meanwhile: "Mientras tanto...",
        review_complete: "Revision Completa",
        ready_to_send: "Listo para enviar (o revisar de nuevo!)",
        learn_more_link: "Sobre las dos voces",
        explainer_modal: {
          title: "Sobre Tus Dos Voces",
          intro: "DramaDetector usa dos voces distintas para ayudarte a comunicarte mejor:",
          narrator_section: "El Narrador",
          narrator_body: "Presenta tus mensajes como episodios de TV, con observaciones juguetonas y estructura episodica.",
          expert_section: "El Experto en Drama",
          expert_body: "Analiza lo que realmente esta pasando usando reconocimiento de patrones y consejos basados en marcos teoricos.",
          why_two: "Por Que Dos Voces?",
          why_two_body: "El Narrador mantiene las cosas entretenidas mientras el Experto en Drama te da ideas accionables.",
          cta: "Entendido, gracias!",
          close_button: "Cerrar modal",
          session5_reveal: {
            title: "Conoce Tus Dos Voces",
            intro: "Has estado trabajando con dos voces distintas todo este tiempo\u2014ahora te las presentamos oficialmente.",
            narrator_section: "El Narrador",
            narrator_body: "Presenta tus mensajes como episodios de TV, con observaciones juguetonas y estructura episodica. Has visto su trabajo en los comentarios de carga y las introducciones de analisis.",
            expert_section: "El Experto en Drama",
            expert_body: "Analiza lo que realmente esta pasando usando reconocimiento de patrones y consejos basados en marcos teoricos. Corta el drama con metaforas de reality shows y perspectivas basadas en evidencia.",
            why_two: "Por Que Dos Voces?",
            why_two_body: "El Narrador mantiene las cosas entretenidas mientras el Experto en Drama te da ideas accionables. Juntos, te ayudan a evitar enviar mensajes de los que te arrepentiras\u2014sin que se sienta como una sesion de terapia.",
            cta: "Entendido!",
            close_button: "Cerrar"
          }
        }
      },
      skip_to_results: {
        analyzing_message: "Analizando tu mensaje...",
        detecting_patterns: "Detectando patrones...",
        generating_insights: "Generando insights...",
        preparing_results: "Preparando tus resultados...",
        your_message: "Tu mensaje",
        premium_experience: "Experiencia premium"
      },
      narrator_episode: {
        previously_on: "Anteriormente en Tu Vida",
        this_episode: "Este Episodio",
        attribution: "Narrado por el observador de tu historia",
        summary: {
          low: "Te estas comunicando claramente. No se detectaron conflictos importantes.",
          medium: "Se detecto algo de tension. Analicemos los patrones.",
          high: "Comunicacion de alto riesgo por delante. Analisis del Experto en Drama abajo."
        },
        accessibility: {}
      },
      drama_expert: {
        section_header: "Analisis del Experto en Drama",
        section_subheader: "Reconocimiento de patrones e insights accionables"
      }
    };
  }
});

// src/i18n/locales/es/subscription.json
var require_subscription2 = __commonJS({
  "src/i18n/locales/es/subscription.json"(exports, module) {
    module.exports = {
      intervals: {
        week: "1 semana",
        month: "1 mes",
        quarter: "3 meses",
        semester: "6 meses",
        year: "12 meses"
      },
      badges: {
        new: "Nuevo",
        best_value: "Mejor Valor"
      },
      savings: {
        ten_percent: "Ahorra 10%",
        twenty_percent: "Ahorra 20%",
        twenty_five_percent: "Ahorra 25%"
      },
      pricing: {
        per_week_short: "/sem",
        per_month_short: "/mes",
        per_year_short: "/a\xF1o",
        per_person: "/persona",
        per_person_per_week: "/persona por semana",
        billed_monthly: "/mes",
        every_months: "cada {count} meses",
        every_year: "/a\xF1o"
      },
      tiers: {
        drama_plus: "Drama+",
        dramax: "DramaX"
      },
      plan_types: {
        individual: "Individual",
        family: "Familia (5)"
      },
      features: {
        drama_plus: {
          analyses: "100 an\xE1lisis por d\xEDa",
          patterns: "Seguimiento de patrones"
        },
        dramax: {
          analyses: "200 an\xE1lisis por d\xEDa",
          multimodal: "An\xE1lisis multimodal completo",
          archetypes: "Arquetipos avanzados",
          origins: "Or\xEDgenes de Patrones (revelaci\xF3n NC)",
          transformation: "Suite de Transformaci\xF3n",
          practitioner: "Acceso a Profesionales",
          group: "An\xE1lisis Grupal"
        }
      },
      hero: {
        drama_plus: "Domina tus patrones de comunicaci\xF3n",
        dramax: "Transforma tu narrativa juntos",
        individual: "Acceso ilimitado a caracter\xEDsticas premium",
        family: "Comparte con hasta 5 familiares"
      },
      cta: {
        button: "Obtener {interval} por {price}",
        coming_soon: "Pr\xF3ximamente",
        terms: "Renovaci\xF3n autom\xE1tica. Cancela en cualquier momento desde Google Play/App Store."
      },
      family_banner: {
        title: "\u{1F389} Est\xE1s en un Plan Familiar {tier}"
      },
      comparison: {
        title: "Comparaci\xF3n de caracter\xEDsticas",
        most_popular: "M\xC1S POPULAR",
        billed_monthly: "Facturado mensualmente",
        scroll_hint: "Desliza para ver todas las caracter\xEDsticas"
      },
      errors: {
        try_again: "Por favor intenta de nuevo m\xE1s tarde",
        auth_required_title: "Inicio de Sesi\xF3n Requerido",
        auth_required_message: "Por favor inicia sesi\xF3n para suscribirte a un plan de pago.",
        checkout_error_title: "Error",
        checkout_error_message: "Error al iniciar el proceso de pago: {message}",
        cannot_open_url: "No se puede abrir la URL de pago",
        change_billing_cycle_with_status: "Error al cambiar el ciclo de facturaci\xF3n ({{status}})"
      },
      subscription_success: {
        title: "\xA1Suscripci\xF3n Activada!",
        message: "Tu suscripci\xF3n ha sido activada exitosamente. Ahora tienes acceso a todas las caracter\xEDsticas premium.",
        syncing: "Sincronizando tu suscripci\xF3n...",
        redirecting: "Redirigiendo a configuraci\xF3n en {countdown} segundo{plural}...",
        synced: "Suscripci\xF3n sincronizada"
      },
      subscription_cancel: {
        title: "Pago Cancelado",
        message: "\xA1No te preocupes! Puedes suscribirte en cualquier momento desde la pesta\xF1a de Planes. Tu plan actual permanece activo.",
        cta: "Ver Planes Nuevamente",
        accessibility: {
          return: "Regresar a los planes de suscripci\xF3n"
        },
        redirecting: "Regresando a planes en {countdown} segundo{plural}..."
      },
      quota: {
        title: "Uso y Cuota",
        daily_analyses: "An\xE1lisis Diarios",
        weekly_analyses: "An\xE1lisis Semanales",
        free_trial: "Prueba Gratuita",
        usage: "{used} de {limit} usados ({remaining} restantes)",
        reset: {
          in: "Se reinicia en {time}",
          monday: "Se reinicia el lunes",
          refresh_prompt: "Reinicio disponible - actualiza para actualizar",
          relative: {
            about_hours: "alrededor de {count} horas",
            about_hours_one: "alrededor de 1 hora",
            minutes: "{count} minutos",
            less_than_minute: "menos de un minuto",
            days: "{count} d\xEDas",
            one_day: "1 d\xEDa"
          },
          updating: "Actualizando cuota..."
        },
        actions: {
          refresh: "Actualizar Cuota",
          refreshing: "Actualizando...",
          upgrade: "Actualizar a {tier} ({quota}/d\xEDa)",
          sign_up: "Reg\xEDstrate para an\xE1lisis ilimitados"
        },
        errors: {
          load_failed: "No se pueden cargar los datos de uso: {message}",
          retry: "Reintentar"
        },
        exceeded: {
          title: "L\xEDmite Semanal Alcanzado",
          title_authenticated: "L\xEDmite Diario Alcanzado",
          message: "Has usado todos los 10 an\xE1lisis semanales gratuitos. Se reinicia cada lunes a las 00:00 UTC.",
          message_authenticated: "Has usado {used} de {limit} an\xE1lisis hoy",
          cta: "Actualizar a {tier} para {quota}/d\xEDa",
          by_tier: {
            anonymous: {
              title: "L\xEDmite Semanal Alcanzado",
              body: "Has usado los 10 an\xE1lisis semanales gratuitos. \xA1Reg\xEDstrate para obtener 10 an\xE1lisis diarios y guardar tu historial!",
              cta_primary: "Registrarse Gratis",
              cta_secondary: "Tal Vez Luego",
              benefits: {
                item1: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
                item2: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
                item3: "\u{1F512} Cuenta segura y privada"
              }
            },
            free: {
              title: "L\xEDmite Diario Alcanzado",
              body: "Has usado los 10 an\xE1lisis diarios gratuitos. \xA1Actualiza a Drama+ para 100 an\xE1lisis por d\xEDa y funciones avanzadas!",
              cta_primary: "\u{1F48E} Actualizar a Drama+",
              cta_secondary: "Tal Vez Ma\xF1ana",
              benefits: {
                item1: "\u2728 100 an\xE1lisis por d\xEDa",
                item2: "\u{1F4C8} Seguimiento de patrones y perspectivas",
                item3: "\u{1F48E} Funciones premium"
              }
            },
            drama_plus: {
              title: "L\xEDmite Diario Alcanzado",
              body: "Has usado los 100 an\xE1lisis de hoy. \xA1Actualiza a DramaX para 200 an\xE1lisis por d\xEDa m\xE1s funciones avanzadas de transformaci\xF3n!",
              cta_primary: "\u{1F451} Actualizar a DramaX",
              cta_secondary: "Tal Vez Ma\xF1ana",
              benefits: {
                item1: "\u2728 200 an\xE1lisis por d\xEDa",
                item2: "\u{1F52E} Or\xEDgenes de Patrones y Revelaci\xF3n NC",
                item3: "\u{1F9D8} Suite Completa de Transformaci\xF3n"
              }
            },
            dramax: {
              title: "L\xEDmite Diario Alcanzado",
              body: "\xA1Impresionante! Has usado los 200 an\xE1lisis de hoy. \xA1Esa es una dedicaci\xF3n seria a la superaci\xF3n personal! \xBFNecesitas m\xE1s? Considera nuestro plan familiar.",
              cta_primary: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Plan Familiar",
              cta_secondary: "Esperar Hasta Ma\xF1ana",
              benefits: {
                item1: "\u2728 Cuota familiar compartida",
                item2: "\u{1F464} Soporte para miembros de la familia",
                item3: "\u{1F3E2} Opciones para equipos y profesionales"
              }
            },
            family_member: {
              title: "Cuota Familiar Agotada",
              body: "La cuota compartida de tu familia se ha usado hoy. Habla con el administrador de tu familia sobre actualizar o espera hasta ma\xF1ana.",
              cta_primary: "\u{1F4F1} Mensaje al Admin Familiar",
              cta_secondary: "Esperar Hasta Ma\xF1ana",
              benefits: {
                item1: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Cuota familiar compartida",
                item2: "\u{1F4AC} Coordina con tu familia",
                item3: "\u23F0 Se restablece diariamente a medianoche UTC"
              }
            }
          }
        },
        warning: {
          banner: {
            title: "Has usado el 50% de tus an\xE1lisis semanales",
            title_authenticated: "Has usado el 50% de tus an\xE1lisis diarios",
            description: "{used} de {limit} usados. La cuota se reinicia {resetTime}.",
            accessibility: {
              dismiss: "Descartar advertencia"
            }
          },
          toast: {
            title: "\xA1Te est\xE1s quedando sin an\xE1lisis!",
            description: "Has usado el 80% de tus an\xE1lisis semanales ({used} de {limit}). La cuota se reinicia el lunes a las 00:00 UTC.",
            description_authenticated: "Has usado el 80% de tus an\xE1lisis diarios ({used} de {limit}). Considera actualizar para acceso ilimitado.",
            cta: "Ver Planes",
            accessibility: {
              dismiss: "Descartar advertencia",
              view_plans: "Ver planes de actualizaci\xF3n"
            }
          },
          modal: {
            title: "\xA1Casi en tu l\xEDmite!",
            description: "Has usado el 90% de tus an\xE1lisis semanales",
            description_authenticated: "Has usado el 90% de tus an\xE1lisis diarios",
            upgrade_benefits: "Actualiza para obtener:",
            benefits: {
              unlimited: "An\xE1lisis diarios ilimitados",
              priority_support: "Soporte prioritario",
              advanced_analytics: "An\xE1lisis avanzados"
            },
            cta_upgrade: "\u{1F48E} Actualizar Ahora",
            cta_later: "Record\xE1rmelo M\xE1s Tarde",
            by_tier: {
              anonymous: {
                title: "\xA1Casi en tu l\xEDmite!",
                body: "Has usado el 90% de tus 10 an\xE1lisis semanales gratuitos. \xA1Reg\xEDstrate ahora para obtener 10 an\xE1lisis diarios!",
                cta_primary: "Registrarse Gratis",
                cta_secondary: "Recordarme Luego",
                benefits: {
                  item1: "\u2728 10 an\xE1lisis diarios (vs 10 semanales)",
                  item2: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
                  item3: "\u{1F512} Cuenta segura y privada"
                }
              },
              free: {
                title: "Pocos an\xE1lisis restantes",
                body: "Has usado el 90% de los 10 an\xE1lisis gratuitos de hoy. \xA1Actualiza a Drama+ para 50x m\xE1s!",
                cta_primary: "\u{1F48E} Actualizar a Drama+",
                cta_secondary: "Recordarme Luego",
                benefits: {
                  item1: "\u2728 100 an\xE1lisis por d\xEDa",
                  item2: "\u{1F4C8} Seguimiento de patrones",
                  item3: "\u{1F48E} Funciones premium"
                }
              },
              drama_plus: {
                title: "\xA1Alto uso hoy!",
                body: "Has usado el 90% de los 100 an\xE1lisis de hoy. \xA1Actualiza a DramaX para funciones avanzadas de transformaci\xF3n!",
                cta_primary: "\u{1F451} Actualizar a DramaX",
                cta_secondary: "Recordarme Luego",
                benefits: {
                  item1: "\u2728 200 an\xE1lisis por d\xEDa",
                  item2: "\u{1F52E} Or\xEDgenes de patrones revelados",
                  item3: "\u{1F9D8} Suite de Transformaci\xF3n"
                }
              },
              dramax: {
                title: "\xA1Eres un usuario avanzado!",
                body: "Has usado el 90% de los 200 an\xE1lisis de hoy. \xA1Dedicaci\xF3n incre\xEDble! Considera nuestro plan familiar para cuota compartida.",
                cta_primary: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Plan Familiar",
                cta_secondary: "Esperar Hasta Ma\xF1ana",
                benefits: {
                  item1: "\u2728 Cuota familiar compartida",
                  item2: "\u{1F464} Soporte dedicado",
                  item3: "\u{1F3E2} Soluciones para equipos"
                }
              },
              family_member: {
                title: "Cuota familiar baja",
                body: "Tu familia ha usado el 90% de la cuota diaria compartida. Quiz\xE1s quieras coordinar el uso.",
                cta_primary: "\u{1F4F1} Mensaje al Admin Familiar",
                cta_secondary: "Entendido",
                benefits: {
                  item1: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Compartido con {memberCount} miembros",
                  item2: "\u{1F4AC} Coordina con la familia",
                  item3: "\u23F0 Se restablece a medianoche UTC"
                }
              }
            }
          }
        },
        tiers: {
          free: "Prueba Gratis",
          drama_plus: "Drama+",
          dramax: "DramaX",
          anonymous: "Invitado"
        }
      },
      family: {
        title: "Plan Familiar",
        manageFamily: "Administrar Familia",
        tierBadge: {
          drama_plus: "\u{1F48E} Drama+",
          dramax: "\u{1F451} DramaX"
        },
        notMember: "No est\xE1s en un plan familiar",
        notMemberDescription: "Suscr\xEDbete a un plan familiar para compartir DramaDetector con hasta 5 personas.",
        billingInterval: "{interval}",
        dailyQuota: "Cuota Diaria",
        weeklyQuota: "Cuota Semanal",
        members: "Miembros",
        inviteMember: "Invitar Miembro",
        slotsLeft: "espacios disponibles",
        planFull: "Tu plan familiar est\xE1 lleno. Elimina un miembro para invitar a alguien nuevo.",
        inviteByEmail: "Invitar por Correo",
        emailPlaceholder: "familia@ejemplo.com",
        emailInvalid: "Por favor ingresa una direcci\xF3n de correo v\xE1lida",
        inviteMessage: "\xA1\xDAnete a mi plan familiar {tier} en DramaDetector! {link}",
        inviteSent: "Invitaci\xF3n Enviada",
        inviteLinkCopied: "Enlace de invitaci\xF3n copiado al portapapeles. Env\xEDalo a {email}.",
        inviteFailed: "Error al enviar la invitaci\xF3n",
        pendingInvites: "Invitaciones Pendientes",
        expiresAt: "Expira el {date}",
        confirmRemove: "\xBFEliminar Miembro?",
        confirmRemoveMessage: "\xBFEst\xE1s seguro de que quieres eliminar a {name} de tu plan familiar?",
        success: "\xC9xito",
        memberRemoved: "Miembro eliminado del plan familiar",
        removeFailed: "Error al eliminar miembro",
        confirmCancelInvite: "\xBFCancelar Invitaci\xF3n?",
        confirmCancelInviteMessage: "\xBFEst\xE1s seguro de que quieres cancelar la invitaci\xF3n a {email}?",
        inviteCancelled: "Invitaci\xF3n cancelada",
        cancelInviteFailed: "Error al cancelar la invitaci\xF3n",
        membersList: "Miembros de la Familia",
        admin: "Administrador",
        joinedAt: "Se uni\xF3 el {date}",
        privacyTitle: "\u{1F512} Privacidad Primero",
        privacyDescription: "Los miembros de la familia pueden ver nombres y cuotas, pero no el contenido de an\xE1lisis individuales. Tus conversaciones permanecen privadas.",
        error: "Error",
        acceptInvite: {
          title: "Unirse al Plan Familiar",
          description: "\xA1Has sido invitado a unirte a un plan familiar!",
          invitedBy: "Has sido invitado a unirte a un plan familiar {tierName} por {adminName}.",
          statusProcessed: "Esta invitaci\xF3n ya ha sido {status}. Por favor solicita una nueva invitaci\xF3n.",
          signInRequired: "Inicio de Sesi\xF3n Requerido",
          signInMessage: "Por favor inicia sesi\xF3n para aceptar esta invitaci\xF3n al plan familiar.",
          signInButton: "Iniciar Sesi\xF3n",
          planDetailsHeader: "Detalles del Plan",
          analysesPerDay: "an\xE1lisis/d\xEDa",
          quotaShared: "Compartido entre todos los miembros de la familia",
          expirationNotice: "Esta invitaci\xF3n expira el {date}.",
          tierLabel: "Nivel del Plan",
          quotaLabel: "Cuota Diaria",
          adminLabel: "Administrado por",
          acceptButton: "Aceptar Invitaci\xF3n",
          declineButton: "Rechazar",
          success: "\xA1Bienvenido al plan familiar!",
          error: "Error al aceptar la invitaci\xF3n",
          invalidCode: "Este enlace de invitaci\xF3n es inv\xE1lido o ha expirado.",
          alreadyMember: "Ya eres miembro de un plan familiar. Abandona tu plan actual primero."
        },
        tierName: {
          drama_plus: "Drama+",
          dramax: "DramaX"
        }
      },
      practitioner: {
        title: "Grupos de Profesionales",
        manageGroups: "Administrar Grupos",
        noGroups: "Sin Grupos de Profesionales",
        noGroupsDescription: "A\xFAn no est\xE1s en ning\xFAn grupo de profesionales. Un profesional necesitar\xE1 invitarte, o puedes crear tu propio grupo si tienes una suscripci\xF3n DramaX.",
        createGroup: "Crear Grupo de Profesional",
        groupCreated: "Grupo de profesional creado exitosamente",
        groupsList: "Tus Grupos",
        members: "Miembros",
        maxMembers: "de {max}",
        owner: "Propietario",
        member: "Miembro",
        joinedAt: "Se uni\xF3 el {date}",
        status: {
          active: "Activo",
          inactive: "Inactivo"
        },
        role: {
          owner: "Administras este grupo",
          member: "Eres paciente en este grupo"
        },
        inviteMember: "Invitar Paciente",
        slotsLeft: "espacios disponibles",
        groupFull: "Este grupo ha alcanzado su l\xEDmite de miembros.",
        inviteByEmail: "Invitar por Correo",
        emailPlaceholder: "paciente@ejemplo.com",
        emailInvalid: "Por favor ingresa un correo electr\xF3nico v\xE1lido",
        inviteSent: "Invitaci\xF3n Enviada",
        inviteLinkCopied: "Enlace de invitaci\xF3n copiado al portapapeles. Env\xEDalo a {email}.",
        inviteFailed: "Error al enviar la invitaci\xF3n",
        pendingInvites: "Invitaciones Pendientes",
        expiresAt: "Expira el {date}",
        confirmRemove: "\xBFEliminar Paciente?",
        confirmRemoveMessage: "\xBFEst\xE1s seguro de que quieres eliminar a este paciente de tu grupo de profesional?",
        success: "\xC9xito",
        memberRemoved: "Paciente eliminado del grupo de profesional",
        removeFailed: "Error al eliminar paciente",
        confirmLeave: "\xBFAbandonar Grupo?",
        confirmLeaveMessage: "\xBFEst\xE1s seguro de que quieres abandonar este grupo de profesional? Puedes ser re-invitado despu\xE9s.",
        leftGroup: "Has abandonado el grupo de profesional",
        leaveFailed: "Error al abandonar el grupo",
        leaveGroup: "Abandonar Grupo",
        manageMembers: "Administrar Pacientes",
        viewGroup: "Ver Grupo",
        privacyTitle: "\u{1F512} Privacidad HIPAA",
        privacyDescription: "Los profesionales solo pueden ver el estado de membres\xEDa del paciente. El contenido de an\xE1lisis del paciente nunca se comparte. Tus conversaciones permanecen completamente privadas.",
        error: "Error",
        multiGroupInfo: "Puedes ser miembro de m\xFAltiples grupos de profesionales. Tu plan familiar (si tienes alguno) permanece separado de los grupos de profesionales.",
        acceptInvite: {
          title: "Unirse al Grupo de Profesional",
          description: "Has sido invitado a unirte al grupo de cuidado de un profesional.",
          signInRequired: "Inicio de Sesi\xF3n Requerido",
          signInMessage: "Por favor inicia sesi\xF3n para aceptar esta invitaci\xF3n al grupo de profesional.",
          signInButton: "Iniciar Sesi\xF3n",
          groupDetails: "Detalles del Grupo",
          practitioner: "Profesional",
          patients: "Pacientes Actuales",
          expirationNotice: "Esta invitaci\xF3n expira el {date}.",
          acceptButton: "Unirse al Grupo",
          declineButton: "Rechazar",
          success: "\xA1Bienvenido al grupo de profesional!",
          error: "Error al unirse al grupo de profesional",
          invalidCode: "Este enlace de invitaci\xF3n es inv\xE1lido o ha expirado."
        }
      }
    };
  }
});

// src/i18n/locales/es/features.json
var require_features2 = __commonJS({
  "src/i18n/locales/es/features.json"(exports, module) {
    module.exports = {
      analysis: {
        title: "Analiza Tu Mensaje",
        feedback: {
          title: "\xBFQu\xE9 tan preciso fue este an\xE1lisis?",
          thumbs_up: "\xDAtil",
          thumbs_down: "No \xDAtil",
          thank_you: "\xA1Gracias por tu comentario! Esto nos ayuda a mejorar."
        }
      },
      home: {
        subtitle: "Obt\xE9n una revisi\xF3n experta de tu mensaje antes de enviarlo",
        first_time_intro: {
          title: "\u{1F3AD} Conoce Tus Dos Voces",
          body: "Escuchar\xE1s dos perspectivas: el Narrador (que enmarca tu mensaje como un episodio) y el Experto en Drama (que analiza lo que realmente est\xE1 pasando). Ambos te ayudan a evitar el drama antes de enviar.",
          cta: "\xA1Entendido!"
        },
        two_voices_hint: {
          title: "\u{1F3AC} Dos Voces, Una Misi\xF3n",
          body: "Escuchar\xE1s dos perspectivas: el Narrador (que enmarca tu mensaje como un episodio) y el Experto en Drama (que analiza lo que realmente est\xE1 pasando). Ambos te ayudan a evitar el drama antes de enviar.",
          cta: "\xA1Entendido!"
        },
        context_label: "Contexto del Mensaje",
        analyze_button: "Analizar Mensaje",
        analyzing: "Analizando...",
        verification_required: "Verificaci\xF3n requerida - intenta de nuevo",
        trial_quota: "\u{1F512} {remaining} de {limit} an\xE1lisis gratis restantes esta semana",
        help_text: '\u{1F4A1} Escribe un mensaje arriba y toca "Analizar Mensaje" para ver su puntuaci\xF3n de drama, problemas potenciales y mejoras sugeridas.',
        errors: {
          analysis_failed: "An\xE1lisis Fallido",
          unexpected_error: "Ocurri\xF3 un error inesperado. Intenta de nuevo."
        },
        accessibility: {}
      },
      history: {
        subtitle: "Tus resultados de an\xE1lisis anteriores"
      },
      history_item: {
        category: {
          safe: "Seguro",
          caution: "Precauci\xF3n",
          risky: "Riesgoso"
        },
        time: {
          just_now: "Justo ahora",
          minutes_ago: "hace {count}m",
          hours_ago: "hace {count}h",
          days_ago: "hace {days}d"
        },
        accessibility: {
          analysis_result: "Resultado de an\xE1lisis: {category}, puntuaci\xF3n {score}"
        }
      },
      history_grouping: {
        today: "Hoy",
        yesterday: "Ayer",
        this_week: "Esta Semana",
        last_week: "La Semana Pasada",
        this_month: "Este Mes"
      },
      episode_history: {
        title: "Historial de Episodios",
        swipe_hint: "Desliza para navegar episodios como cambiar canales de TV",
        accessibility: {
          list_label: "Historial de episodios. Desliza para ver {count} episodios"
        }
      },
      history_list: {
        empty: {
          title: "Sin Historial A\xFAn",
          message: "Tus mensajes analizados aparecer\xE1n aqu\xED. \xA1Ve a la pesta\xF1a Inicio para analizar tu primer mensaje!"
        },
        errors: {
          load_failed: "Error al Cargar el Historial",
          pull_to_retry: "Desliza hacia abajo para reintentar"
        }
      },
      analysis_detail_modal: {
        title: "Detalles del An\xE1lisis",
        message_label: "Mensaje",
        actions: {
          edit_and_reanalyze: "Editar y Re-analizar",
          done: "Listo"
        },
        accessibility: {
          close_modal: "Cerrar modal",
          edit_and_reanalyze: "Editar y re-analizar este mensaje"
        }
      },
      analysis_results: {
        issues_detected: "Problemas Detectados",
        suggested_improvements: "Mejoras Sugeridas",
        pattern_spotlight: "Patr\xF3n Destacado",
        transformation_insights: "Perspectivas de Transformaci\xF3n",
        accessibility: {}
      },
      score_card: {
        drama_score: "Puntuaci\xF3n de Drama",
        estimated_label: "Estimado",
        accessibility: {
          drama_score_value: "Puntuaci\xF3n de drama: {score} de 10, {category}"
        }
      },
      suggestions: {
        before: "Antes",
        after: "Despu\xE9s",
        copy_button: "Copiar",
        copied: "\xA1Copiado!",
        empty: {
          title: "No hay sugerencias disponibles",
          message: "\xA1Tu mensaje se ve bien tal como est\xE1!"
        },
        accessibility: {
          improvement_area: "\xC1rea de mejora: {area}",
          copy_to_clipboard: "Copiar al portapapeles",
          copied_to_clipboard: "Copiado al portapapeles",
          no_suggestions: "No hay sugerencias disponibles"
        }
      },
      issues: {
        position_label: "Posici\xF3n: ",
        full_snippet_label: "Fragmento completo: ",
        show_more: "Mostrar M\xE1s \u25BC",
        show_less: "Mostrar Menos \u25B2",
        empty: {
          title: "No se detectaron problemas",
          message: "\xA1Tu mensaje se ve bien!"
        },
        accessibility: {
          severity: "Severidad: {severity}",
          weight: "Este problema contribuye {percent} por ciento a la puntuaci\xF3n general de drama",
          no_issues: "No se detectaron problemas. \xA1El mensaje se ve bien!"
        }
      },
      message_input: {
        placeholder: "Escribe tu mensaje aqu\xED...",
        clear_button: "Borrar",
        accessibility: {
          input_label: "Entrada de mensaje",
          input_hint: "Ingresa el mensaje que quieres analizar",
          clear_message: "Borrar mensaje"
        }
      },
      context_selector: {
        options: {
          family: "Familia",
          work: "Trabajo",
          friends: "Amigos",
          dating: "Citas"
        },
        accessibility: {
          label: "Selector de contexto",
          select_family: "Seleccionar contexto Familia",
          select_work: "Seleccionar contexto Trabajo",
          select_friends: "Seleccionar contexto Amigos",
          select_dating: "Seleccionar contexto Citas"
        }
      },
      tier_card: {
        current_plan: "Plan Actual",
        subscribe_button: "Suscribirse",
        no_payment_required: "No requiere pago",
        accessibility: {
          subscribe_to: "Suscribirse a {name}"
        }
      },
      tabs: {
        home: "Inicio",
        history: "Historial",
        stats: "Estad\xEDsticas",
        settings: "Configuraci\xF3n"
      },
      trial: {
        inline_banner: {
          title: "\xA1Buen comienzo! Te quedan {remaining} an\xE1lisis semanales gratis m\xE1s",
          body: "\xA1Vas por buen camino! Reg\xEDstrate para obtener 10 an\xE1lisis diarios y guardar tu historial para siempre.",
          cta: "Reg\xEDstrate Gratis",
          accessibility: {
            dismiss: "Descartar notificaci\xF3n",
            banner: "Notificaci\xF3n de uso de prueba"
          }
        },
        blur_overlay: {
          title: "\xA1Solo te queda {remaining} an\xE1lisis semanal!",
          body: "Te est\xE1s quedando sin an\xE1lisis semanales gratis. Reg\xEDstrate ahora para obtener 10 an\xE1lisis diarios y guardar tu progreso para siempre.",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada"
          },
          cta: "Reg\xEDstrate Gratis",
          accessibility: {
            dismiss: "Descartar recordatorio"
          }
        },
        bottom_sheet: {
          title: "\xA1Usaste los 10 an\xE1lisis semanales gratis!",
          body: "\xA1Excelente trabajo! Has experimentado el poder de DramaDetector. Reg\xEDstrate ahora para seguir mejorando tu comunicaci\xF3n.",
          benefits_title: "Lo que obtendr\xE1s:",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada",
            support: "\u26A1 Soporte por email incluido"
          },
          cta_signup: "Reg\xEDstrate Gratis",
          cta_later: "Tal Vez M\xE1s Tarde",
          disclaimer: "No requiere tarjeta de cr\xE9dito \u2022 Cancela cuando quieras"
        },
        exhausted: {
          title: "L\xEDmite Semanal Alcanzado",
          body: "Usaste los 10 an\xE1lisis semanales gratis. Se reinicia cada lunes a las 00:00 UTC. \xA1Reg\xEDstrate para continuar!",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada"
          },
          cta_signup: "Reg\xEDstrate Gratis",
          cta_later: "Tal Vez M\xE1s Tarde"
        },
        ip_limit: {
          title: "L\xEDmite Semanal Alcanzado",
          body: "Has usado todos los 10 an\xE1lisis semanales gratuitos. Se reinicia cada lunes a las 00:00 UTC. \xA1Reg\xEDstrate para an\xE1lisis ilimitados!",
          benefits: {
            analyses: "\u2728 10 an\xE1lisis diarios, gratis para siempre",
            history: "\u{1F4CA} Guarda tu historial de an\xE1lisis",
            account: "\u{1F512} Cuenta segura y privada"
          },
          reset_info: "El l\xEDmite se reinicia cada lunes a las 00:00 UTC.",
          cta_signup: "Reg\xEDstrate Gratis",
          cta_later: "Tal Vez M\xE1s Tarde"
        }
      },
      loading: {
        analyzing_your_message: "Analizando tu mensaje...",
        complete_tap_to_continue: "Completo. Toca para continuar.",
        two_voices_analyzing: "Dos Voces Analizando...",
        reviewing_your_message: "Revisando tu mensaje...",
        meanwhile: "Mientras tanto...",
        review_complete: "Revisi\xF3n Completa",
        ready_to_send: "Listo para enviar (\xA1o revisar!)",
        learn_more_link: "Acerca de las dos voces",
        explainer_modal: {
          title: "Acerca de Tus Dos Voces",
          intro: "DramaDetector usa dos voces distintas para ayudarte a comunicarte mejor:",
          narrator_section: "El Narrador",
          narrator_body: "Enmarca tus mensajes como episodios de TV, con observaciones juguetonas y encuadre epis\xF3dico.",
          expert_section: "El Experto en Drama",
          expert_body: "Analiza lo que realmente est\xE1 pasando usando reconocimiento de patrones y consejos basados en marcos de referencia.",
          why_two: "\xBFPor Qu\xE9 Dos Voces?",
          why_two_body: "El Narrador mantiene las cosas entretenidas mientras el Experto en Drama te da perspectivas accionables.",
          cta: "\xA1Entendido, gracias!",
          close_button: "Cerrar modal",
          session5_reveal: {
            title: "\u{1F3AD} Conoce Tus Dos Voces",
            intro: "Has estado trabajando con dos voces distintas todo el tiempo\u2014ahora vamos a presentarlas oficialmente.",
            narrator_section: "El Narrador",
            narrator_body: "Enmarca tus mensajes como episodios de TV, con observaciones juguetonas y encuadre epis\xF3dico. Has visto su trabajo en las bromas de carga y las introducciones de an\xE1lisis.",
            expert_section: "El Experto en Drama",
            expert_body: "Analiza lo que realmente est\xE1 pasando usando reconocimiento de patrones y consejos basados en marcos de referencia. Cortan a trav\xE9s del drama con met\xE1foras de reality TV y perspectivas basadas en evidencia.",
            why_two: "\xBFPor Qu\xE9 Dos Voces?",
            why_two_body: "El Narrador mantiene las cosas entretenidas mientras el Experto en Drama te da perspectivas accionables. Juntos, te ayudan a evitar enviar mensajes de los que te arrepentir\xE1s\u2014sin sentirse como una sesi\xF3n de terapia.",
            cta: "\xA1Entendido!",
            close_button: "Cerrar"
          }
        }
      },
      share: {
        button: "Comparte Tus Resultados",
        public_result: {
          acknowledge_hint: "Toca la casilla para aceptar antes de publicar."
        },
        modal: {
          title: "Comparte Tu An\xE1lisis",
          subtitle: "Vista previa de la imagen, elige el tama\xF1o y comp\xE1rtela donde quieras.",
          select_template: "Seleccionar plantilla",
          preview_title: "Vista previa",
          preview_support: "Previsualiza la imagen exacta antes de compartirla.",
          format_title: "Tama\xF1o de imagen",
          format_helper: "Elige d\xF3nde se publicar\xE1 esta imagen. Esto cambia el tama\xF1o y el recorte de la imagen exportada.",
          selection_helper: "El tama\xF1o de imagen cambia la exportaci\xF3n. El estilo de publicaci\xF3n cambia la voz y el texto.",
          post_style_title: "Estilo de publicaci\xF3n",
          template_playful: "Elige la vibra para tu momento de reality show.",
          template_editorial: "Elige el \xE1ngulo para tu revelaci\xF3n digna de panel.",
          template_clinical: "Elige la forma m\xE1s clara de enmarcar el patr\xF3n.",
          selected: "Seleccionado",
          export_title: "Exportar imagen lista para compartir",
          export_description: "El tama\xF1o de imagen seleccionado se usar\xE1 para la imagen generada para compartir.",
          primary_image_cta: "Crear y compartir imagen",
          primary_text_cta: "Compartir texto de la publicaci\xF3n",
          secondary_link_title: "Compartir enlace en su lugar",
          secondary_link_description: "Usa un enlace cuando quieras la p\xE1gina interactiva en lugar de una imagen."
        },
        format: {
          fallback: {
            portrait: {
              label: "Tu episodio",
              sublabel: "Feed \xB7 4:5",
              hint: "Ideal para Instagram Feed y Facebook"
            },
            square: {
              label: "Tu puntuaci\xF3n",
              sublabel: "Grid \xB7 1:1",
              hint: "Bueno para cuadr\xEDculas de perfil y multiplataforma"
            },
            reel: {
              label: "Momento reality",
              sublabel: "Reel \xB7 9:16",
              hint: "Ideal para Reels, TikTok y Stories"
            },
            horizontal: {
              label: "Toma r\xE1pida",
              sublabel: "Enlace \xB7 16:9",
              hint: "Ideal para mensajer\xEDa y vistas previas de enlaces"
            }
          }
        },
        voice: {
          narrator: "Narrador",
          expert: "Experto en Drama"
        },
        templates: {
          episode_framing: {
            title: "Encuadre de Episodio",
            description: "Comparte como el episodio dram\xE1tico de tu vida",
            text: "Alerta de Episodio: Puntuaci\xF3n de drama {score}/10 en mi vida{context} \u{1F480}\n\nAnteriormente en Mi Vida: las cosas estaban tranquilas.\nEl an\xE1lisis contin\xFAa..."
          },
          pattern_recognition: {
            title: "Reconocimiento de Patrones",
            description: "Comparte el patr\xF3n que tu experto detect\xF3",
            text: 'Mi experto en drama acaba de diagnosticarme con "{pattern}" y honestamente? No est\xE1n equivocados \u{1F62D}'
          },
          advice_wisdom: {
            title: "Sabidur\xEDa del Experto en Drama",
            description: "Comparte el consejo \xFAtil que recibiste",
            text: "\xBFPor qu\xE9 mi experto en drama da mejores consejos que mis amigos reales? \u{1F4A1}"
          },
          reality_tv_commentary: {
            title: "Comentario de Reality TV",
            description: "Comparte el meta-comentario sobre tu texto",
            text: "Yo: *abro un mensaje a las 11:47 PM*\n\nMi narrador: Puntuaci\xF3n de drama {score}/10\n\nMe siento TAN visto \u{1F440}"
          },
          basic: {
            title: "Compartir Resultados",
            description: "Plantilla b\xE1sica para compartir",
            text: "Acabo de obtener mi puntuaci\xF3n de drama: {score}/10\n\nAhora reviso mis mensajes antes de enviarlos..."
          }
        },
        link_option: {
          title: "Compartir mediante Enlace",
          description: "Crear un enlace que cualquiera puede abrir",
          creating: "Creando enlace...",
          label: "Compartir mediante Enlace",
          copied: "\xA1Copiado!"
        }
      },
      transformationInsightCard: {
        labels: {
          before: "Antes",
          after: "Despu\xE9s"
        },
        insights_label: "Perspectivas Clave",
        accessibility: {
          shareTransformation: "Compartir transformaci\xF3n de {transformationType}",
          beforeText: "Mensaje original",
          afterText: "Mensaje transformado"
        }
      },
      narrator_episode: {
        previously_on: "Anteriormente en Tu Vida",
        this_episode: "Este Episodio",
        attribution: "Narrado por el observador de tu historia",
        summary: {
          low: "Te est\xE1s comunicando claramente. No se detectaron conflictos importantes.",
          medium: "Se detect\xF3 algo de tensi\xF3n. Analicemos los patrones.",
          high: "Comunicaci\xF3n de alto riesgo por delante. Perspectivas del Experto en Drama a continuaci\xF3n."
        },
        accessibility: {}
      },
      drama_expert: {
        section_header: "An\xE1lisis del Experto en Drama",
        section_subheader: "Reconocimiento de patrones y perspectivas accionables"
      },
      share_card: {
        watermark: "DramaDetector.app",
        narrator: {
          score_label: "Puntuaci\xF3n de Drama:",
          attribution: "Narrado por el observador de tu historia",
          section_label: "NARRADOR"
        },
        expert: {
          header: "Mi Experto en Drama dijo...",
          attribution: "Experto en Drama por DramaDetector",
          section_label: "EXPERTO EN DRAMA"
        },
        context: {
          work: "\u{1F4BC} Trabajo",
          dating: "\u{1F495} Citas",
          family: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Familia",
          friends: "\u{1F465} Amigos"
        }
      },
      transformation_insight: {
        communication_pattern_shift: {
          type: "Cambio de Patr\xF3n de Comunicaci\xF3n",
          before: "Tu patr\xF3n actual muestra lenguaje defensivo en contextos de alto estr\xE9s",
          after: "Abraza la autenticidad vulnerable nombrando las emociones directamente",
          insights: [
            "Observaci\xF3n sin Evaluaci\xF3n: Separa los hechos de las interpretaciones",
            "La transformaci\xF3n de alto impacto reduce la escalada de conflictos",
            "Practica nombrar emociones directamente sin encuadre defensivo"
          ]
        }
      },
      quota: {
        paywall: {
          title: "\u{1F4CA} L\xEDmite de An\xE1lisis Diario Alcanzado",
          message: "Has usado todos los 10 an\xE1lisis diarios gratuitos. Actualiza a Drama+ para 500 an\xE1lisis/d\xEDa o DramaX para an\xE1lisis ilimitados.",
          cta_hint: "Elige un plan a continuaci\xF3n para continuar analizando mensajes"
        }
      },
      patternSpotlightCard: {
        detected: "{count, plural, =0 {No detectado} one {Detectado # vez} other {Detectado # veces}}",
        recurring_theme: "Tema Recurrente",
        recurring_description: "Tu desaf\xEDo de comunicaci\xF3n m\xE1s frecuente en las conversaciones",
        accessibility: {
          sharePattern: "Compartir patr\xF3n {patternType}"
        }
      },
      historyPremiumInsights: {
        pattern_recognition: {
          type: "Reconocimiento de Patrones y Transformaci\xF3n",
          before: "Tu historial muestra patrones de escalada repetidos",
          after: "Practica el marco de Comunicaci\xF3n No Violenta de cuatro pasos",
          insights: [
            "Comunicaci\xF3n Basada en Necesidades: Identifica las necesidades subyacentes que impulsan el comportamiento",
            "Rompe los ciclos de escalada abordando las causas ra\xEDz",
            "CNV de cuatro pasos: Observaci\xF3n \u2192 Sentimiento \u2192 Necesidad \u2192 Petici\xF3n"
          ]
        }
      },
      gating: {
        unlock_more: "Desbloquear {count} {count, plural, one {problema} other {problemas}} m\xE1s",
        upgrade_to: "Actualizar a {tierName}",
        unlock_now: "Desbloquear Ahora",
        premium_feature_title: "Funci\xF3n Premium",
        premium_feature_description: "Esta funci\xF3n requiere {tierName}. Actualiza para desbloquear perspectivas avanzadas.",
        upgrade_to_tier: "Actualizar a {tierName}",
        view_upgrade_options: "Ver opciones de actualizaci\xF3n",
        tap_to_unlock: "Toca para desbloquear funciones de {tierName}",
        preview_title: "Obt\xE9n ayuda m\xE1s clara para reescribir antes de enviar",
        preview_subtitle: "Drama+ a\xF1ade mejor gu\xEDa de reescritura, notas en l\xEDnea y detecci\xF3n de patrones. DramaX profundiza con planes de transformaci\xF3n.",
        try_drama_plus: "Probar ayuda de reescritura con Drama+",
        feature_preview_title_patterns: "Patr\xF3n Destacado",
        feature_preview_desc_patterns: "Detecta el patr\xF3n de comunicaci\xF3n que este mensaje podr\xEDa repetir.",
        feature_preview_title_rewrite_help: "Mejor ayuda para reescribir",
        feature_preview_desc_rewrite_help: "Obt\xE9n sugerencias m\xE1s claras para suavizar el tono y mejorar este mensaje antes de enviarlo.",
        feature_preview_title_annotations: "Anotaciones en l\xEDnea",
        feature_preview_desc_annotations: "Ve qu\xE9 cambiar directamente en el mensaje, justo donde impacta.",
        pattern_spotlight_teaser: "Ver el patr\xF3n detr\xE1s de este mensaje",
        pattern_spotlight_title: "Tu Patr\xF3n Est\xE1 Mostrando",
        pattern_spotlight_body: "Has enviado mensajes como este antes. Drama+ te muestra los patrones recurrentes en tu comunicaci\xF3n \u2014 para que puedas romperlos antes de que rompan las relaciones.",
        pattern_spotlight_cta: "Desbloquear Drama+ \u2014 {price}",
        pattern_spotlight_dismiss: "Ahora no \u2014 lo resolver\xE9 por mi cuenta",
        quota_free_title: "Est\xE1s En Racha",
        quota_free_body: "Has usado los 10 an\xE1lisis gratuitos de hoy. Eso es la se\xF1al de alguien que se toma en serio su comunicaci\xF3n. Drama+ te da 100 an\xE1lisis al d\xEDa \u2014 y te muestra los patrones detr\xE1s de todos ellos.",
        quota_free_cta: "Actualizar a Drama+",
        quota_drama_plus_body: "Alcanzaste tu l\xEDmite de 100/d\xEDa. DramaX te da 200 \u2014 m\xE1s el kit de transformaci\xF3n.",
        pattern_teaser: {
          unlock_patterns: "Desbloquear {count} Patrones M\xE1s con Drama+",
          tooltip: "Desbloquea tu historial completo de patrones con Drama+",
          one_visible: "1 patr\xF3n visible"
        },
        transformation_insight_teaser: "Ver c\xF3mo reescribir este momento",
        transformation_insight_free_title: "Esto Es Transformable",
        transformation_insight_free_body: "Tu puntuaci\xF3n de drama es alta \u2014 y eso significa que hay una oportunidad real aqu\xED. DramaX te muestra exactamente c\xF3mo reformular este mensaje usando el marco CNV, m\xE1s tu plan de transformaci\xF3n personalizado.",
        transformation_insight_free_cta: "Desbloquear DramaX \u2014 {price}",
        transformation_insight_plus_title: "Ve M\xE1s All\xE1 de los Patrones",
        transformation_insight_plus_body: "Has dominado la identificaci\xF3n de tus patrones. DramaX da el siguiente paso: tu plan personalizado de transformaci\xF3n de comunicaci\xF3n, basado en el marco de Comunicaci\xF3n No Violenta.",
        transformation_insight_plus_cta: "Actualizar a DramaX"
      },
      inline_annotations: {
        header: "Tu Mensaje",
        issues_count: "{count, plural, one {1 problema detectado} other {{count} problemas detectados}}",
        progress: "{addressed} de {total} resueltos",
        suggestions_applied: "{count, plural, one {1 sugerencia aplicada} other {{count} sugerencias aplicadas}}",
        copy: "Copiar",
        copied: "\xA1Copiado!",
        copy_revised: "Copiar mensaje revisado",
        accept: "Aceptar",
        ignore: "Ignorar",
        accepted: "\u2713 Aceptado",
        ignored: "Ignorado",
        drama: "drama",
        why_this_matters: "Por qu\xE9 esto importa",
        original: "Original",
        revised: "Revisado",
        score_delta: "{count, plural, one {+1 punto} other {+{count} puntos}}",
        score_delta_aria: "{count, plural, one {Puntuaci\xF3n mejorada en 1 punto} other {Puntuaci\xF3n mejorada en {count} puntos}}",
        all_reviewed: "Todos los problemas revisados!",
        progress_complete_aria: "Los {total} problemas han sido revisados",
        almost_safe: "Acepta para llegar a zona Segura",
        almost_caution: "Un paso de Alto a Precaucion",
        almost_high: "Casi fuera del rango Extremo"
      },
      consent: {
        headline: "\xBFListo para profundizar?",
        body: "Has completado {count} an\xE1lisis. DramaX revela Or\xEDgenes de Patrones, Voces Influyentes y la metodolog\xEDa completa de Claridad Narrativa.",
        cta: "Explorar DramaX",
        dismiss: "Ahora no",
        banner_text: "Has analizado {count} conversaciones. Descubre los patrones detr\xE1s de tus patrones con DramaX.",
        benefits: {
          pattern_origins: "Or\xEDgenes de Patrones \u2014 comprende de d\xF3nde vienen tus h\xE1bitos de comunicaci\xF3n",
          influential_voices: "Voces Influyentes \u2014 identifica qui\xE9n molde\xF3 tu estilo de comunicaci\xF3n",
          narrative_clarity: "Metodolog\xEDa completa de Claridad Narrativa para un cambio duradero"
        }
      },
      celebration: {
        category_improved: "\xA1Genial! \xA1Pasaste a {category}!",
        safe_reached: "\xA1Todo bien! Tu mensaje se ve genial."
      },
      nudge: {
        almost_there: "\xA1Casi! {points} puntos de la zona {category}"
      }
    };
  }
});

// src/i18n/locales/es/safety.json
var require_safety2 = __commonJS({
  "src/i18n/locales/es/safety.json"(exports, module) {
    module.exports = {
      banner: {
        text_default: "\xBFNecesitas ayuda? Obt\xE9n apoyo",
        text_triggered: "Notamos un lenguaje preocupante. Obt\xE9n apoyo",
        accessibility_label: "Recursos de apoyo en crisis",
        accessibility_hint: "Toca para ver recursos de salud mental y l\xEDneas de crisis",
        get_help_button: "Hablar con un Profesional",
        get_help_accessibility_label: "Conectar con un profesional de salud mental",
        get_help_accessibility_hint: "Abre opciones para comunicarte con tu terapeuta o consejero para obtener apoyo"
      },
      modal: {
        title_default: "No Est\xE1s Solo/a",
        title_triggered: "Estamos Aqu\xED Para Ti",
        subtitle: "Si est\xE1s pasando por un momento dif\xEDcil, hay ayuda disponible las 24 horas. Estos recursos son gratuitos y confidenciales.",
        resource_988_name: "L\xEDnea de Crisis 988 (EE.UU.)",
        resource_988_description: "Apoyo gratuito y confidencial 24/7",
        call_now: "Llamar Ahora",
        call_988_accessibility: "Llamar a la L\xEDnea de Crisis 988",
        call_988_hint: "Abre el tel\xE9fono para llamar al 988",
        resource_text_name: "L\xEDnea de Texto de Crisis",
        resource_text_description: "Env\xEDa HOME al 741741",
        text_now: "Enviar Mensaje",
        text_741741_accessibility: "Enviar mensaje a la L\xEDnea de Crisis",
        text_741741_hint: "Abre mensajes para enviar HOME al 741741",
        resource_international_name: "Recursos Internacionales",
        resource_international_description: "Encuentra ayuda en tu pa\xEDs",
        international_accessibility: "Ver recursos de crisis internacionales",
        disclaimer: "DramaDetector no es un servicio de crisis. Si est\xE1s en peligro inmediato, llama a servicios de emergencia (911 en EE.UU.) o contacta una l\xEDnea de crisis.",
        close: "Cerrar",
        close_accessibility: "Cerrar modal de recursos de crisis",
        ok: "Aceptar",
        call_fallback_title: "Llamar al 988",
        call_fallback_message: "Para comunicarte con la L\xEDnea de Crisis, marca {phone} en tu tel\xE9fono.",
        sms_fallback_title: "Enviar Mensaje",
        sms_fallback_message: "Para comunicarte con la L\xEDnea de Crisis por texto, abre tu app de mensajes y env\xEDa HOME al 741741."
      },
      concern_flag: {
        button_label: "Estoy Preocupado/a",
        button_hint: "Reportar contenido preocupante para revisi\xF3n interna",
        modal_title: "\xBFQu\xE9 te preocupa?",
        modal_subtitle: "Tu opini\xF3n nos ayuda a mejorar. Todos los reportes son confidenciales.",
        reason_self_harm: "Indicadores de autolesi\xF3n o crisis",
        reason_harmful: "Contenido da\xF1ino o peligroso",
        reason_other: "Otra cosa",
        context_placeholder: "Cu\xE9ntanos m\xE1s (opcional)",
        submit: "Enviar Reporte",
        cancel: "Cancelar",
        success_title: "Gracias",
        success_message: "Tu preocupaci\xF3n ha sido registrada. Recuerda, si t\xFA o alguien que conoces est\xE1 en crisis, contacta una l\xEDnea de crisis.",
        error_title: "No se Pudo Enviar",
        error_message: "Algo sali\xF3 mal. Por favor intenta de nuevo m\xE1s tarde."
      },
      tos: {
        title: "Informaci\xF3n Importante",
        body: "DramaDetector te ayuda a entender patrones de comunicaci\xF3n y reducir el drama en tus mensajes. Por favor recuerda:",
        bullet_1: "Esta es una herramienta educativa, no un servicio de salud mental",
        bullet_2: "No sustituye la terapia o consejer\xEDa profesional",
        bullet_3: "Si est\xE1s en crisis, contacta al 988 o a un profesional de salud mental",
        checkbox_label: "Entiendo y acepto estos t\xE9rminos",
        continue: "Continuar",
        decline: "Rechazar"
      },
      practitioner_prompt: {
        title: "\xBFTe gustar\xEDa comunicarte?",
        subtitle: "Tu terapeuta o consejero est\xE1 disponible para apoyarte.",
        description: "Le haremos saber que podr\xEDas usar algo de apoyo. Pueden responder cuando est\xE9n disponibles.",
        privacy_notice: "Solo se compartir\xE1 el tipo general de preocupaci\xF3n, no el contenido espec\xEDfico del mensaje.",
        request_support: "Solicitar Apoyo",
        not_now: "Ahora No",
        accessibility_label: "Solicitar apoyo de tu profesional",
        accessibility_hint: "Abre un formulario para enviar una solicitud de apoyo a tu terapeuta o consejero"
      },
      practitioner_selector: {
        title: "Seleccionar Profesional",
        subtitle: "Elige a qui\xE9n te gustar\xEDa contactar",
        no_practitioners: "No tienes profesionales conectados",
        connect_prompt: "Puedes conectar con un profesional en Configuraci\xF3n",
        no_practitioners_description: "No tienes profesionales con notificaciones de crisis habilitadas.",
        select_accessibility: "Selecciona un profesional para recibir tu solicitud de apoyo",
        send_request: "Enviar Solicitud",
        cancel: "Cancelar",
        default_name: "Tu Profesional",
        sending: "Enviando solicitud..."
      },
      request_status: {
        sending: "Enviando solicitud...",
        sent: "Solicitud enviada",
        pending: "Esperando respuesta",
        responded: "Tu profesional ha respondido",
        pending_description: "Tu profesional ser\xE1 notificado pronto",
        viewed: "Visto",
        viewed_description: "Tu profesional ha visto tu solicitud",
        responded_description: "Tu profesional ha respondido",
        resolved: "Resuelto",
        resolved_description: "Esta solicitud ha sido resuelta",
        expired: "Expirado",
        expired_description: "Esta solicitud expir\xF3 despu\xE9s de 72 horas",
        view_response: "Ver Respuesta",
        mark_resolved: "Marcar como Resuelto",
        expires_in: "Expira en {time}"
      },
      request_message: {
        placeholder: "Agrega un mensaje breve (opcional)",
        hint: "Esto ayuda a tu profesional a entender c\xF3mo apoyarte mejor",
        char_limit: "{{current}}/{{max}} caracteres",
        accessibility_hint: "Mensaje opcional para proporcionar contexto a tu profesional"
      },
      request_success: {
        title: "Solicitud Enviada",
        message: "Tu profesional ha sido notificado. Te contactar\xE1n cuando est\xE9n disponibles.",
        what_next: "\xBFQu\xE9 sigue?",
        next_step_1: "Tu profesional recibir\xE1 una notificaci\xF3n segura",
        next_step_2: "Se comunicar\xE1n a trav\xE9s de su m\xE9todo de contacto habitual",
        next_step_3: "Si es urgente, usa los recursos de crisis de arriba",
        description: "Tu profesional ha sido notificado. Se comunicar\xE1n cuando est\xE9n disponibles.",
        reminder: "Recuerda, si est\xE1s en peligro inmediato, llama al 988 o a servicios de emergencia.",
        done: "Listo"
      },
      request_error: {
        title: "No se pudo enviar",
        message: "No pudimos enviar tu solicitud. Por favor intenta de nuevo o usa los recursos de crisis de arriba.",
        retry: "Intentar de Nuevo",
        description: "No pudimos enviar tu solicitud en este momento. Intenta de nuevo o contacta directamente a tu profesional.",
        contact_directly: "Contactar Directamente"
      },
      practitioner_response: {
        notification_title: "Tu profesional respondi\xF3",
        notification_body: "{{practitionerName}} ha reconocido tu solicitud de apoyo",
        view_response: "Ver Respuesta",
        title: "Mensaje de Tu Profesional",
        responded_at: "Respondi\xF3 {time}",
        close: "Cerrar",
        resolve: "Marcar como Resuelto"
      },
      detection_feedback: {
        inline_trigger: "\xBFFue preciso este aviso?",
        inline_trigger_accessibility: "Dar opini\xF3n sobre la precisi\xF3n de la detecci\xF3n de crisis",
        inline_trigger_hint: "Abre un formulario r\xE1pido para ayudarnos a mejorar",
        sheet_title: "Ay\xFAdanos a mejorar",
        sheet_subtitle: "Tu opini\xF3n mantiene la detecci\xF3n precisa.",
        category_accurate_resources_helped: "Preciso \u2013 Los recursos ayudaron",
        subtag_placeholder: "Selecciona una raz\xF3n",
        subtag_roleplay: "Juego de roles o di\xE1logo de personaje",
        subtag_quote: "Cita de medios",
        subtag_sarcasm: "Sarcasmo o broma",
        subtag_lyrics: "Letras de canciones o poes\xEDa",
        subtag_academic: "Discusi\xF3n acad\xE9mica",
        subtag_historical: "Referencia hist\xF3rica",
        subtag_other: "Otra cosa",
        prompt_title: "\xBFFue \xFAtil?",
        prompt_subtitle: "Tu opini\xF3n nos ayuda a mejorar la detecci\xF3n de crisis.",
        accurate_button: "S\xED, fue preciso",
        inaccurate_button: "No fue correcto",
        skip_button: "Omitir",
        category_title: "\xBFQu\xE9 tipo de contenido era?",
        category_subtitle: "Esto nos ayuda a reducir falsas alarmas en el futuro.",
        category_fictional: "Contenido ficticio",
        category_fictional_description: "Historia, novela, guion, juego de roles",
        category_academic: "Discusi\xF3n acad\xE9mica",
        category_academic_description: "Investigaci\xF3n, educaci\xF3n, an\xE1lisis hist\xF3rico",
        category_creative: "Escritura creativa",
        category_creative_description: "Letras de canciones, poes\xEDa, descripci\xF3n art\xEDstica",
        category_historical: "Referencia hist\xF3rica",
        category_historical_description: "Noticias, documentales, eventos pasados",
        category_actual_crisis: "Necesitaba estos recursos",
        category_actual_crisis_description: "La detecci\xF3n fue \xFAtil",
        category_other: "Otra cosa",
        category_other_description: "Ninguna de las anteriores",
        context_placeholder: "Cu\xE9ntanos m\xE1s (opcional)",
        context_hint: "El contenido de tu mensaje nunca se almacena",
        submit: "Enviar Opini\xF3n",
        submitting: "Enviando...",
        cancel: "Cancelar",
        retry: "Intentar de Nuevo",
        success_title: "Gracias",
        success_message: "Tu opini\xF3n nos ayuda a mejorar.",
        error_title: "No se pudo enviar",
        error_message: "Por favor intenta de nuevo m\xE1s tarde.",
        privacy_notice: "Tu opini\xF3n es an\xF3nima. El contenido del mensaje nunca se almacena.",
        accessibility_accurate: "Marcar detecci\xF3n como precisa",
        accessibility_inaccurate: "Marcar detecci\xF3n como imprecisa",
        accessibility_category_select: "Seleccionar el tipo de contenido"
      }
    };
  }
});

// src/i18n/locales/en/analysis.json
var require_analysis = __commonJS({
  "src/i18n/locales/en/analysis.json"(exports, module) {
    module.exports = {
      analysis: {
        title: "Analyze Your Message",
        drama_score_gauge: "Drama score gauge showing {score} out of 10",
        drama_score: "Drama Score"
      },
      feedback: {
        title: "Was this analysis helpful?",
        thumbs_up: "Yes, helpful",
        thumbs_down: "Not helpful",
        thank_you: "Thank you for your feedback!"
      },
      analysis_detail_modal: {
        title: "Analysis Details",
        message_label: "Message",
        actions: {
          edit_and_reanalyze: "Edit & Re-analyze",
          done: "Done"
        },
        accessibility: {
          close_modal: "Close modal",
          edit_and_reanalyze: "Edit and re-analyze this message"
        }
      },
      analysis_results: {
        issues_detected: "Issues Detected",
        suggested_improvements: "Suggested Improvements",
        pattern_spotlight: "Pattern Spotlight",
        transformation_insights: "Transformation Insights"
      },
      score_card: {
        drama_score: "Drama Score",
        accessibility: {
          drama_score_value: "Drama score: {score} out of 10, {category}"
        }
      },
      suggestions: {
        before: "Before",
        after: "After",
        copy_button: "Copy",
        copied: "Copied!",
        empty: {
          title: "No suggestions available",
          message: "Your message looks good as is!"
        },
        accessibility: {
          improvement_area: "Improvement area: {area}",
          copy_to_clipboard: "Copy to clipboard",
          copied_to_clipboard: "Copied to clipboard",
          no_suggestions: "No suggestions available"
        }
      },
      issues: {
        position_label: "Position: ",
        full_snippet_label: "Full snippet: ",
        show_more: "Show More \u25BC",
        show_less: "Show Less \u25B2",
        empty: {
          title: "No issues detected",
          message: "Your message looks good!"
        },
        accessibility: {
          severity: "Severity: {severity}",
          no_issues: "No issues detected. Message looks good!"
        }
      },
      transformationInsightCard: {
        labels: {
          before: "Before",
          after: "After"
        },
        insights_label: "Key Insights",
        accessibility: {
          shareTransformation: "Share {transformationType} transformation",
          beforeText: "Original message",
          afterText: "Transformed message"
        }
      },
      transformation_insight: {
        communication_pattern_shift: {
          type: "Communication Pattern Shift",
          before: "Your current pattern shows defensive language in high-stress contexts",
          after: "Embrace vulnerable authenticity by naming emotions directly",
          insights: [
            "Observation without Evaluation: Separate facts from interpretations",
            "High impact transformation reduces conflict escalation",
            "Practice naming emotions directly without defensive framing"
          ]
        }
      },
      style_consistency: {
        header: "Communication Style Insight",
        formality_pill: {
          consistent: "Consistent tone",
          some_variation: "Some tone variation",
          notable_shift: "Notable tone shift"
        },
        punctuation_pill: {
          informal: "Informal punctuation",
          mixed: "Mixed punctuation",
          formal: "Formal punctuation"
        },
        length_pill: {
          brief: "Brief",
          moderate: "Moderate",
          lengthy: "Lengthy"
        },
        formality_level: "Formality Level",
        formality_description: "How consistent the level of formality is throughout the message",
        formality_desc: {
          low: "Your tone stays steady throughout the message",
          medium: "Your writing shifts between casual and formal",
          high: "A clear change in how formal you sound midway"
        },
        vocabulary_diversity: "Vocabulary Diversity",
        vocabulary_description: "Ratio of unique meaningful words used in the message",
        vocabulary_desc: {
          low: "You repeat key words -- this can feel emphatic",
          medium: "A natural mix of familiar and varied phrasing",
          high: "Wide range of words -- your expression is varied"
        },
        subtitle: {
          consistent: "Your communication style feels natural and steady",
          some_variation: "Your tone shifts in places -- worth a second look",
          notable_shift: "Your writing style changes noticeably in this message"
        },
        style_flags: "Style Flags",
        no_anomalies: "No anomalies detected",
        punctuation_pattern: {
          informal: "Informal",
          mixed: "Mixed",
          formal: "Formal"
        },
        accessibility: {
          toggle_details: "Toggle communication style details",
          formality_value: "Formality shift: {{value}}",
          vocabulary_value: "Vocabulary diversity: {{value}}"
        }
      },
      ai_detection: {
        header: "Communication Pattern Insight",
        label: {
          natural: "Written naturally",
          mixed: "Mixed communication pattern",
          likely_assisted: "Notable style variation detected"
        },
        status: {
          natural: "Natural communication style",
          mixed: "Communication pattern variation detected",
          likely_assisted: "Unusual communication pattern change"
        },
        pattern_confidence: "Pattern Confidence",
        contributing_signals: "Contributing Signals",
        info_note: "This insight compares the current message style against your established writing patterns. Variations are normal and may reflect different contexts or moods.",
        signal_name: {
          vocabulary_markers: "Vocabulary Markers",
          formality_shift: "Formality Shift",
          punctuation_patterns: "Punctuation Patterns",
          sentence_structure: "Sentence Structure",
          em_dash_frequency: "Punctuation Style"
        },
        context: {
          natural: "Your writing matches your usual patterns closely",
          mixed: "Some parts differ from your typical style",
          likely_assisted: "This message differs noticeably from your baseline"
        },
        reasons: {
          natural: "This is typical -- your voice comes through clearly",
          mixed: "Common causes: different topic, stress, or templates",
          likely_assisted: "Could reflect: templates, editing tools, or new context"
        },
        suggestion: {
          mixed: "Try comparing with your other recent messages",
          likely_assisted: "Review if this sounds like you want it to"
        },
        suggestion_dynamic: {
          vocabulary: "Your word choices shifted \u2014 if you used a template, consider personalizing it",
          formality: "The tone change stands out \u2014 check if it matches the conversation context",
          punctuation: "Your punctuation habits changed \u2014 this often happens when copying text",
          structure: "Your sentence rhythm differs \u2014 try reading it aloud to check if it sounds like you",
          punctuation_style: "Your punctuation style shifted \u2014 common when editing or using writing tools",
          multiple: "Several patterns shifted at once \u2014 this often happens when switching contexts"
        },
        takeaway: {
          natural: "Consistent with how you usually write",
          mixed: "Tap to see which patterns shifted",
          likely_assisted: "Tap to understand the style differences"
        },
        signal_strength: {
          strong: "Strong",
          moderate: "Moderate",
          minor: "Minor"
        },
        signal_desc: {
          vocabulary_markers: "Word choices differ from your usual vocabulary",
          formality_shift: "Formality level changed compared to your norm",
          punctuation_patterns: "Punctuation habits look different than usual",
          sentence_structure: "Sentence length and rhythm shifted from typical",
          em_dash_frequency: "Punctuation style differs from your usual pattern"
        },
        accessibility: {
          toggle_details: "Toggle communication pattern details",
          confidence_value: "Pattern confidence: {{value}} percent"
        }
      },
      progressive_disclosure: {
        building_baseline: "Building your writing baseline",
        analyses_count: "{{current}}/{{required}} analyses",
        analyses_remaining: "{{remaining}} more to unlock",
        early_insight: "Early insight",
        early_insight_tooltip: "Based on limited data \u2014 accuracy improves with more analyses",
        growing_confidence: "Growing confidence",
        full_confidence: "Full confidence",
        insight_unlocked: "{{moduleName}} is ready",
        upgrade_to_unlock: "Upgrade to Drama+ to unlock"
      }
    };
  }
});

// src/i18n/locales/en/history.json
var require_history = __commonJS({
  "src/i18n/locales/en/history.json"(exports, module) {
    module.exports = {
      history: {
        subtitle: "Your past analysis results",
        anon: {
          empty: {
            cta_analyze: "Analyze a message"
          },
          cta: {
            headline: "Sign up to keep your history for 7 days",
            body: "Right now your analyses disappear in 24 hours. Sign up free and they stick around for 7 days.",
            button: "Sign up to keep history"
          }
        }
      },
      history_item: {
        category: {
          safe: "Safe",
          caution: "Caution",
          high_drama: "High Drama",
          extreme_drama: "Extreme Drama",
          unknown: "Unknown"
        },
        time: {
          just_now: "Just now",
          minutes_ago: "{count}m ago",
          hours_ago: "{count}h ago",
          days_ago: "{days}d ago"
        },
        accessibility: {
          analysis_result: "Analysis result: {category}, score {score}"
        }
      },
      history_grouping: {
        today: "Today",
        yesterday: "Yesterday",
        this_week: "This Week",
        this_month: "This Month"
      },
      episode_history: {
        title: "Episode History",
        swipe_hint: "Swipe to browse episodes like changing TV channels",
        accessibility: {
          list_label: "Episode history. Swipe to browse {count} episodes"
        }
      },
      history_list: {
        empty: {
          title: "No History Yet",
          message: "Your analyzed messages will appear here. Head to the Home tab to analyze your first message!"
        },
        errors: {
          load_failed: "Failed to Load History",
          pull_to_retry: "Pull down to retry"
        },
        load_more: "Load More"
      }
    };
  }
});

// src/i18n/locales/en/settings.json
var require_settings = __commonJS({
  "src/i18n/locales/en/settings.json"(exports, module) {
    module.exports = {
      subtitle: "Manage preferences and data",
      sections: {
        subscription: "Subscription",
        account: "Account",
        language: "Language",
        retention: "Data Retention",
        data: "Data Management",
        app_info: "App Information"
      },
      language: {
        title: "App Language",
        description: "Choose your preferred language",
        english: "English",
        spanish: "Espa\xF1ol (Spanish)",
        change_success: "Language changed to {language}"
      },
      retention: {
        title: "Auto-Delete Policy",
        description: "Choose how long your analysis data is kept before automatic deletion",
        days_30: "30 days",
        days_60: "60 days",
        days_90: "90 days (default)",
        days_180: "180 days",
        days_365: "1 year",
        updating: "Saving preference..."
      },
      cache: {
        clear: "Clear Cache",
        description: "Remove locally cached data",
        confirm_title: "Clear Cache",
        confirm_message: "This will remove all cached analysis data from memory and storage. You'll need an internet connection to reload data.",
        success: "Cache cleared successfully from memory and storage",
        error: "Failed to clear cache: {message}"
      },
      history: {
        clear: "Clear History",
        description: "Delete all analysis records from this device",
        confirm_title: "Clear History",
        confirm_message: "Are you sure you want to delete {count, plural, one {# analysis record} other {# analysis records}}? This cannot be undone.",
        no_history: "Your analysis history is already empty.",
        success: "Successfully deleted {count, plural, one {# record} other {# records}}",
        error: "Failed to clear history"
      },
      delete_data: {
        title: "Delete All My Data",
        description: "Permanently erase all your data from our servers",
        confirm_title: "Delete All Data?",
        confirm_message: "This will permanently delete ALL your data including analysis history, shared links, preferences, and cached data. This action cannot be undone.",
        confirm_button: "Delete Everything",
        requires_auth: "You must be signed in to delete your data.",
        success_title: "Data Deleted",
        success_message: "All your data has been permanently deleted ({count} records removed).",
        error: "Failed to delete data. Please try again or contact support."
      },
      account_actions: {
        sign_in: "Sign In",
        sign_out: "Sign Out",
        signed_in_as: "Signed in as",
        sign_out_confirm_title: "Sign Out",
        sign_out_confirm_message: "Are you sure you want to sign out?"
      },
      subscription_manage: {
        title: "Manage Subscription",
        description: "View plans and billing"
      },
      family_plan: {
        title: "Family Plan",
        admin_description: "Manage your family members and invitations",
        member_description: "View your family plan details"
      },
      practitioner_groups: {
        title: "Practitioner Groups",
        description: "{count, plural, one {# group} other {# groups}} you belong to"
      },
      practitioner_access: {
        title: "Practitioner Access",
        description: "Control what your practitioners can see"
      },
      practitioner_section: {
        title: "Professional",
        open_dashboard: "Open Practitioner Dashboard",
        stats: "{clients} active clients \xB7 {earnings} this month",
        certified: "Certified Practitioner"
      },
      about: {
        title: "About",
        coming_soon: "Coming soon"
      },
      privacy: {
        title: "Privacy Policy"
      },
      terms: {
        title: "Terms of Service"
      },
      footer: {
        version: "DramaDetector v{version}",
        powered_by: "Powered by NarrativeClarity.ai \u2764\uFE0F",
        tagline: "Your narrative evolution begins here."
      },
      auth: {
        not_authenticated: "Not authenticated"
      },
      errors: {
        network_retry: "Network error. Please try again.",
        change_billing_cycle_with_status: "Failed to change billing cycle ({{status}})"
      },
      anon: {
        section_label: "Save your data",
        cta: {
          headline: "Sign up to keep your history for 7 days",
          body: "Your anonymous analyses expire in 24 hours. Sign up free and they stick around for 7 days \u2014 plus 10 analyses every day and 1000-character messages.",
          button: "Sign up free"
        }
      }
    };
  }
});

// src/i18n/locales/en/share.json
var require_share = __commonJS({
  "src/i18n/locales/en/share.json"(exports, module) {
    module.exports = {
      share: {
        button: "Share score + summary",
        dialog_title: "Share score + summary",
        modal: {
          title: "Share score + summary",
          subtitle: "Choose a public share format for the score, likely impact, and summary",
          select_template: "Select template",
          publish_result_link_title: "Publish public score and summary",
          publish_result_link_disclosure: "Only your drama score and summary will be public.",
          revoke_result_link_title: "Revoke public link",
          revoke_result_link_disclosure: "This immediately makes this public link unavailable."
        },
        workflow: {
          description: "Choose how to share the score, likely impact, and summary"
        },
        link_option: {
          title: "Share public link",
          description: "Copy a public link with score, likely impact, and summary",
          creating: "Creating link...",
          label: "Copy public link",
          copied: "Copied!"
        },
        explicit_result: {
          title: "Shared result",
          score_label: "Drama Score",
          summary_label: "Summary"
        },
        voice: {
          narrator: "Narrator",
          expert: "Drama Expert"
        },
        templates: {
          episode_framing: {
            title: "Episode Framing",
            description: "Share as your life's dramatic episode",
            text: "Episode Alert: Drama score {score}/10 in my{context} life \u{1F480}\n\nPreviously on My Life: things were calm.\nThe analysis continues..."
          },
          pattern_recognition: {
            title: "Pattern Recognition",
            description: "Share the pattern your expert spotted",
            text: `My drama expert just diagnosed me with "{pattern}" and honestly? They're not wrong \u{1F62D}`
          },
          advice_wisdom: {
            title: "Drama Expert Wisdom",
            description: "Share the helpful advice you got",
            text: "Why is my drama expert giving better advice than my actual friends \u{1F4A1}"
          },
          reality_tv_commentary: {
            title: "Reality TV Commentary",
            description: "Share the meta-commentary on your text",
            text: "Me: *opens text at 11:47 PM*\n\nMy narrator: Drama score {score}/10\n\nI feel SO seen \u{1F440}"
          },
          basic: {
            title: "Share Results",
            description: "Basic share template",
            text: "Just got my drama score: {score}/10\n\nChecking my messages before I send them now..."
          }
        }
      },
      share_card: {
        watermark: "DramaDetector.app",
        narrator: {
          score_label: "Drama Score:",
          attribution: "Narrated by your story's observer",
          section_label: "NARRATOR"
        },
        expert: {
          header: "My Drama Expert said...",
          attribution: "Drama Expert by DramaDetector",
          section_label: "DRAMA EXPERT"
        },
        context: {
          work: "\u{1F4BC} Work",
          dating: "\u{1F495} Dating",
          family: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Family",
          friends: "\u{1F465} Friends"
        }
      }
    };
  }
});

// src/i18n/locales/en/stats.json
var require_stats = __commonJS({
  "src/i18n/locales/en/stats.json"(exports, module) {
    module.exports = {
      stats: {
        subtitle: "Your communication patterns",
        category_breakdown: "Category Breakdown",
        category_chart: {
          empty: "No category data available yet"
        },
        category_patterns: {
          defensive_language: "Defensive Language",
          aggressive_tone: "Aggressive Tone",
          passive_aggressive: "Passive Aggressive",
          unclear_communication: "Unclear Communication",
          positive_communication: "Positive Communication"
        },
        labels: {
          total_analyses: "Total Analyses",
          average_score: "Average Score"
        },
        empty: {
          title: "No Stats Yet",
          message: "Start analyzing messages to see your communication patterns and statistics here!"
        },
        errors: {
          load_failed: "Failed to Load Stats",
          pull_to_retry: "Pull down to retry"
        },
        insights: {
          tip_label: "Tip",
          lower_scores: "Lower average scores indicate clearer, more respectful communication patterns."
        },
        pattern_description: "Your most common communication pattern based on analysis history",
        anon: {
          empty: {
            cta_analyze: "Analyze a message"
          },
          cta: {
            headline: "These patterns reset in 24 hours",
            body: "Sign up free to keep your stats for 7 days and start comparing week over week.",
            button: "Sign up to keep stats"
          }
        }
      }
    };
  }
});

// src/i18n/locales/en/content.json
var require_content = __commonJS({
  "src/i18n/locales/en/content.json"(exports, module) {
    module.exports = {
      producer_quips: {
        pitching_01: "Analyzing the pitch. A similar one was recently rejected by an exec in a hoodie.",
        pitching_02: "This story has potential. Now for the part where twelve executives slowly sand down the edges.",
        pitching_03: "Processing... Worse ideas have been pitched to Netflix. They bought two of them.",
        pitching_04: "A classic note: they loved the pitch, but want a rewrite. And a different character. And a new plot.",
        pitching_05: "Evaluating the premise. Is it 'brave' or 'career-limiting'? Let's find out.",
        pitching_06: "Hold on, an agent is calling. The 'passion project' is now a 'great tax write-off.'",
        pitching_07: "Currently on script version 14. The original writer quit on version 6. A good sign.",
        pitching_08: "The feedback was 'too original.' Which usually means it's time to pivot back to zombies.",
        pitching_09: "This is the part of the episode where a big star gets attached, only to drop out before filming.",
        pitching_10: "The pitch result is in: they want 'Gladiator,' but with influencers, for less money.",
        network_01: "The studio wants 'higher stakes.' The hero has already saved the world. Twice.",
        network_02: "Note from the network: 'Can the detective have a quirky, relatable dog?' Of course.",
        network_03: "Analyzing feedback. The test audience felt the ending was 'too realistic.'",
        network_04: "The mandate: 'Make it darker. But also funnier. And for a younger audience. But keep the grit.'",
        network_05: "A new note is in: 'Love the dialogue, but can they say less and text more?'",
        network_06: "The studio wants the villain to be more sympathetic. This particular villain kicks puppies for fun.",
        network_07: "Please wait. Legal is checking if the color blue can be used in episode three.",
        network_08: "They want to cut the most expensive scene. Which also happens to be the entire plot.",
        network_09: "Feedback is in: 'Could this be set in space? Space is testing well this quarter.'",
        network_10: "'Love the character, but does she have to be so... competent?' Yes, that was a real note.",
        budget_01: "An epic vision for this scene and a budget that covers a scooter rental.",
        budget_02: "That explosion was supposed to be bigger. So was the financing.",
        budget_03: "Analyzing the message while attempting to make three extras look like a roman army.",
        budget_04: "The script calls for a mansion. The budget allows for a well-maintained shed. Time for some creative problem-solving.",
        budget_05: "In production, 10% of the day is for art, 90% is for arguing about the price of coffee.",
        budget_06: "And here we observe a world-class actor eating a gas station burrito in a folding chair. The magic of filmmaking.",
        budget_07: "Welcome to filmmaking: where half the job is begging for more time or more money.",
        budget_08: "The final scene needs a majestic eagle. The budget allows for a well-trained pigeon.",
        budget_09: "The 'state-of-the-art' equipment is held together with gaffer tape and sheer hope.",
        budget_10: "'Don't worry, we'll fix it in post.' A sentence responsible for millions in budget overruns.",
        talent_01: "On a call with an agent. Assurances are being made that their client is perfect for the role.",
        talent_02: "The lead actor has decided the character should now have a mysterious limp. Spontaneous.",
        talent_03: "Processing... The director wants to shoot at dawn. The crew wants to sleep. A classic standoff.",
        talent_04: "Please wait. Mediating a dispute between the star and an emotional support peacock.",
        talent_05: "The stunt coordinator and the insurance agent are having a... spirited discussion.",
        talent_06: "Analyzing the drama. Elsewhere, a showrunner just quit via a cryptic text message.",
        talent_07: "The writer is on set. With... thoughts. This should be fun.",
        talent_08: "The star won't leave the trailer until a specific brand of artisanal kombucha is located.",
        talent_09: "Juggling three calls while someone needs approval on a specific shade of beige. Welcome to the set.",
        talent_10: "The hair and costume departments are not on speaking terms. Again.",
        trends_01: "Does this have franchise potential? The algorithm and the board need to know.",
        trends_02: "Checking the data... does this story align with the key demographic's viewing habits?",
        trends_03: "This is great, but can it be turned into a six-part cinematic universe?",
        trends_04: "Analyzing... The directive is to make this 'more viral' and 'less story.'",
        trends_05: "Is this a reboot, a remake, or a reimagining? The answer affects the bonus structure.",
        trends_06: "Marketing is asking if their new energy drink can be added into the final scene.",
        trends_07: "The studio just bought a board game. A script is due in three days.",
        trends_08: "The request is for a gritty, grounded take on a beloved cartoon character. What could go wrong?",
        trends_09: "Everyone wants the next big thing, as long as it's exactly like the last big thing.",
        trends_10: "Let's see... does this drama have a built-in fanbase? No? Then what's the point?",
        meta_01: "Analyzing this drama. It has to be better than the 200 unread emails about catering.",
        meta_02: "They say you get into this business to create art. You end up approving spreadsheets.",
        meta_03: "Analyzing this conflict while, somewhere else, a third act is completely falling apart.",
        meta_04: "Therapists recommend less conflict. This analyzer begs to differ.",
        meta_05: "Is this a compelling inciting incident? Or just another production meeting? Analyzing...",
        meta_06: "The goal is to detect drama, even when the production itself is one long, unresolvable plot twist.",
        meta_07: "Processing the story. The source material is a tragedy, but the goal is dramedy.",
        meta_08: "The job: solve fictional problems to escape from very real, logistical ones.",
        meta_09: "The irony of using a drama detector when the production calendar is a chaotic masterpiece.",
        meta_10: "Analyzing this story's structure. It's less chaotic than a series of frantic phone calls. Hopefully.",
        user_focused_01: "Analyzing what you've got. The last message like this led to a very awkward dinner conversation.",
        user_focused_02: "Reviewing this message while production juggles three calls and a budget crisis. Standard Tuesday.",
        user_focused_03: "Analyzing the text. The production inbox has 200 unread messages, so no pressure.",
        user_focused_04: "Checking this message for drama. The production calendar has enough for a limited series.",
        user_focused_05: "Reviewing this one. Last submission had more twists than a prestige thriller.",
        user_focused_06: "Evaluating the message while assistants remind everyone about four meetings in ten minutes.",
        user_focused_07: "Analyzing... The last text reviewed was a masterclass in diplomacy. The one before needed a rewrite.",
        user_focused_08: "Testing if this passes the drama test. Every great line needs a little polish.",
        user_focused_09: "Reviewing the submission. Therapists recommend seeing less conflict. This tool disagrees.",
        user_focused_10: "Checking the message for potential red flags. A second pair of eyes never hurts.",
        user_focused_11: "Analyzing while production phones ring off the hook. Another day, another crisis.",
        user_focused_12: "Reviewing this one. The industry has approved worse ideas that somehow made millions.",
        user_focused_13: "Evaluating the message. The last one reviewed led to a three-hour debate. Let's hope for better.",
        user_focused_14: "Analyzing... The job is to spot a tiny spark before it becomes a wildfire.",
        user_focused_15: "Reviewing the text while production simultaneously approves lunch orders.",
        user_focused_16: "Analyzing this message. After reviewing thousands, it's clear a great story can come from anywhere.",
        user_focused_17: "Checking for drama while the production calendar collapses. Just another Monday.",
        user_focused_18: "Analyzing the submission. The stakes feel high. Time to make sure this lands perfectly.",
        user_focused_19: "Reviewing the message. Last feedback was called 'blunt but fair.' Let's see what this one needs.",
        user_focused_20: "Checking this draft. Genius has been found in the roughest of drafts before.",
        dogfooding_family_01: "Ran that text to Mom through the analyzer first. She still asked why there aren't more calls. Result: 'medium drama.' Sounds about right.",
        dogfooding_family_02: "Thanksgiving reply went through the family group chat filter. Flagged for 'passive aggression.' Fair assessment.",
        dogfooding_family_03: "Analyzed the response to the sister's wedding drama. Tool recommended 'stay neutral.' Still trying.",
        dogfooding_family_04: "That 'I'll be there for dinner' text went through the analyzer first. Dad still detected excuses. Small steps.",
        dogfooding_family_05: "Scanned the sister's text about holiday plans. AI suggested de-escalation. Turns out 'whatever works' is a trigger phrase.",
        dogfooding_family_06: "Analyzed Dad's one-word text: 'Call.' AI rating: 'Maximum Drama.' The algorithm understands family dynamics.",
        dogfooding_family_07: "Used the analyzer on that cousin loan request response. Rewrote to be gentle but firm. A real-life script doctor.",
        dogfooding_family_08: "Mom's text about love life got flagged for 'unsolicited advice.' The screenshot temptation is real.",
        dogfooding_family_09: "That 'can't make the family reunion' text ran through the analyzer. The rewrite was basically a guilt-trip sitcom pilot.",
        dogfooding_family_10: "Checked the 'congrats on the new baby' text through the tool. AI suggested adding an emoji. Harder than casting decisions.",
        dogfooding_family_11: "Brother's business pitch went into the app. Result: 'high risk, low reward.' Same assessment as his last three pilots.",
        dogfooding_family_12: "The family group chat is a writer's room for a soap opera. This app serves as script supervisor.",
        dogfooding_family_13: "Analyzed the anniversary apology. AI recommended a 'grander gesture.' The budget implications are concerning.",
        dogfooding_family_14: "Used the tool to craft a reply to 'when are you having kids?' The AI's suggestion was a masterclass in deflection.",
        dogfooding_family_15: "Dad questioned why text analysis needs an app. Sent him his last email's analysis. Understanding achieved.",
        dogfooding_family_16: "Mother-in-law text ran through the analyzer. AI suggested adding three exclamation points. Different network requirements.",
        dogfooding_family_17: "Analyzed Uncle's political rant in the group chat. AI's suggested reply: 'Unsubscribe.' If only that worked.",
        dogfooding_family_18: "Used the analyzer to navigate family vacation planning. More complicated than multi-location shoot logistics.",
        dogfooding_family_19: "Nephew's text went through translation. AI converted Gen Z to English. Still unclear, but reply is now possible.",
        dogfooding_family_20: "Crafted a 'please take that photo down' text for Aunt. AI made it polite, not vain. Those dailies were unflattering.",
        dogfooding_family_21: "Simplified that job description for Grandpa through this. 'Help make the stories on TV.' He still thinks it means camera operator.",
        dogfooding_family_22: "Screened those surprise party planning texts for leaks. Tighter security than a season finale script.",
        dogfooding_family_23: "Brother's text about Dad's will went through the analyzer. Flagged for 'premature speculation.' That's putting it mildly.",
        dogfooding_family_24: "Analyzed Mom's 'you look tired' comment. AI suggested 'It's the lighting.' Classic Hollywood excuse.",
        dogfooding_family_25: "Drafted that text to siblings about Mom's health through this. Like co-producing the toughest project yet.",
        dogfooding_family_26: "Sister's text about the 'interesting' haircut scored 95% passive-aggression. The algorithm doesn't lie.",
        dogfooding_family_27: "Ran the 'no work talk at dinner' text through first. Added a gentle reminder. Setting boundaries is pre-production for peace.",
        dogfooding_family_28: "Used this to decline hosting Thanksgiving. The AI crafted an excuse so good it's almost believable.",
        dogfooding_family_29: "Checked that text about sister's new boyfriend. AI removed 'yikes.' Good note, robot.",
        dogfooding_family_30: "Dad forwarded another conspiracy theory. AI helped write 'fascinating stuff!' The family-friendly version of 'pass.'",
        dogfooding_work_01: "Ran that budget email to the network through this. Asking for another million without sounding desperate.",
        dogfooding_work_02: "Used DramaDetector on notes to the director. Revised twice. Still hated, but professionally.",
        dogfooding_work_03: "Giving notes while this app gives notes on the notes to the showrunner. It's notes all the way down.",
        dogfooding_work_04: "Analyzed that email about the lead actor situation. AI said 'high drama.' No kidding.",
        dogfooding_work_05: "Ran the pitch deck through here before investors saw it. Still rejected, but sounded confident.",
        dogfooding_work_06: "Scanned the studio email about budget overages. AI removed 80% of the apologies. Confidence is key.",
        dogfooding_work_07: "Used this on notes to a writer. Flagged as 'ambiguous.' The rewrite was cleaner. Good note.",
        dogfooding_work_08: "Analyzed text to a difficult agent. App suggested more flattery. Hollywood runs on it.",
        dogfooding_work_09: "Ran that pitch rejection through the detector. Sounded disappointed but not dismissive. Delicate art.",
        dogfooding_work_10: "This app navigates network notes. Translates 'make it pop' into actionable feedback.",
        dogfooding_work_11: "Drafted 'we're moving in a different direction' through this. Corporate equivalent of 'it's not you, it's me.'",
        dogfooding_work_12: "Ran the 'we're behind schedule' memo through here. AI made it sound like an exciting creative challenge.",
        dogfooding_work_13: "Checked that response to the rival's snarky email. AI suggested 'kill them with kindness.' Playing the long game.",
        dogfooding_work_14: "Assistant uses this to screen incoming messages. Like having a development exec for life.",
        dogfooding_work_15: "Analyzed the deadline extension request. AI's rewrite sounded strategic instead of desperate. Taking it.",
        dogfooding_work_16: "Ran HR response through this. AI removed all personality. Which is, of course, the point.",
        dogfooding_work_17: "Drafted 'no comment' about the script leak through this. Sounded mysterious, not panicked. Crisis averted.",
        dogfooding_work_18: "Got a script from the CEO's son. AI wrote feedback that was encouraging but also a hard pass. Tightrope walk.",
        dogfooding_work_19: "Analyzed pep talk to the crew after 16 hours. AI suggested 'free coffee.' Knows the way to their hearts.",
        dogfooding_work_20: "Analyzed Twitter backlash on the casting choice. Drama score broke the app. Trending, at least.",
        dogfooding_work_21: "Ran counter-offer through the app. Suggested a stronger opening. This thing should get an agent.",
        dogfooding_work_22: "Crafted the 'out of office' reply through this. AI made it sound like peace treaties, not margaritas.",
        dogfooding_work_23: "Mediated email war between director and showrunner with this. Less producer, more hostage negotiator.",
        dogfooding_work_24: "Wrote intern recommendation through this. AI punched it up from 'fine' to 'promising.' They'll go far. Or somewhere.",
        dogfooding_work_25: "Turned down job offer through this. AI sounded grateful, not like escaping a sinking ship.",
        dogfooding_work_26: "Analyzed meeting request to the studio head. AI cut word count by 50%. In this town, brevity is power.",
        dogfooding_work_27: "Merger announced. Drafted 'calm and confident' memo through this. Personal texts were a different story.",
        dogfooding_work_28: "Crafted thank-you to network exec. AI suggested casual sign-off. Apparently 'sincerely' is too formal for Hollywood.",
        dogfooding_work_29: "Ran Emmy campaign slogan through here. AI called it 'confident but not arrogant.' Hope voters agree.",
        dogfooding_work_30: "Drafted public apology for the lead's... 'weekend activities' through this. Unscripted drama indeed.",
        dogfooding_friends_01: "Ran 'sorry I can't make it' through this. AI suggested better excuse. They bought it. This thing is devious.",
        dogfooding_friends_02: "Checked group chat response before sending. Avoiding drama in friend groups is Olympic sport.",
        dogfooding_friends_03: "Ran 'we need to talk' through this first. Friend actually responded. Small victories.",
        dogfooding_friends_04: "Analyzed reply to friend's venting session. Tool said 'supportive, low drama.' Nailed it.",
        dogfooding_friends_05: "Friend asked to 'pick brain' on their script. AI helped set boundaries. Priceless.",
        dogfooding_friends_06: "Analyzed group chat drama about dinner location. This app should be mandatory for friend groups.",
        dogfooding_friends_07: "Declined destination wedding invite through this. AI's version was polite and vague.",
        dogfooding_friends_08: "Friend's 'we need to talk' scored 9/10 on drama scale. Used app to schedule call. At least prepared.",
        dogfooding_friends_09: "Ran 'I'm running late' through this. AI suggested specific ETA. Small things prevent big fights.",
        dogfooding_friends_10: "Mediated text fight between two friends with this. UN peacekeeper, but for brunch plans.",
        dogfooding_friends_11: "Scanned friend's vague, passive-aggressive text. AI translated it. Ah, *that's* what this is about.",
        dogfooding_friends_12: "Crafted text to friend who keeps canceling. AI's version was gentle but clear. Testing it now.",
        dogfooding_friends_13: "Checked 'no spoilers!' text before finale through this. AI confirmed 'assertive but fair.'",
        dogfooding_friends_14: "Friend's relationship drama more complex than season three story arc. This app helps keep track.",
        dogfooding_friends_15: "Using this to ensure 'too busy with work' texts sound apologetic, not braggy. Fine line.",
        dogfooding_friends_16: "Friend sent MLM pitch. AI said 'no' without ruining 10-year friendship. Producer move.",
        dogfooding_friends_17: "Analyzed text chain from drifting friend. AI confirmed the subtext. Like a table read for the end.",
        dogfooding_friends_18: "Got out of blind date setup through this. AI gave three plausible excuses. Casting is everything.",
        dogfooding_friends_19: "Crafted Venmo request for last night's dinner. AI suggested pizza emoji to soften blow.",
        dogfooding_friends_20: "Best friend's new partner is walking red flag. AI helping phrase 'concerns' diplomatically. Very diplomatically.",
        dogfooding_friends_21: "Coordinating group gift on text thread harder than managing series budget. This app is line producer.",
        dogfooding_friends_22: "Exited political argument in group chat through this. AI suggested perfectly timed GIF. Modern de-escalation.",
        dogfooding_friends_23: "Friend got pilot picked up. AI made 'congrats!' sound genuinely happy. Took three revisions.",
        dogfooding_friends_24: "Got 'you were in my neighborhood!' text. AI drafted reply apologetic and vague about schedule.",
        dogfooding_friends_25: "Ran 'can you watch my dog?' through this. AI suggested offering to pay. Right. Everyone needs motivation.",
        dogfooding_friends_26: "Analyzed friend's GoFundMe for 'art project.' AI wrote supportive message without actual donation.",
        dogfooding_friends_27: "Friend live-tweeting their breakup. Drafted 'you okay?' through this without encouraging them.",
        dogfooding_friends_28: "Getting 'yes' or 'no' on weekend plans. AI rewrote question as 'gently direct.' Testing on this character.",
        dogfooding_friends_29: "Buddy sent screenplay. AI wrote notes more 'constructive' and less 'burn this immediately.'",
        dogfooding_friends_30: "Wrote real apology text. AI suggested removing excuses. Annoying, but right note.",
        dogfooding_dating_01: "If this existed back then, could've avoided three breakups and one awkward coffee. Lucky you.",
        dogfooding_dating_02: "Used this on first date follow-up text. AI said 'low drama, good tone.' Rusty but hopeful.",
        dogfooding_dating_03: "Ran 'let's keep it casual' through here. AI confirmed 'clear and low-drama.' Still ghosted. Their loss.",
        dogfooding_dating_04: "Analyzed response to 'where is this going?' before sending. This tool is affordable therapy.",
        dogfooding_dating_05: "Used this on 'what are we?' text draft. AI rewrote from 'interrogation' to 'conversation starter.'",
        dogfooding_dating_06: "Analyzed date's follow-up text. AI detected 'low interest.' Good to know. Next.",
        dogfooding_dating_07: "This app is writer's room for dating life. Helps punch up opening lines.",
        dogfooding_dating_08: "Ran 'I had a nice time but...' through this. Found way to be honest without brutal. Public service.",
        dogfooding_dating_09: "Scanned text from ex. AI flagged as 'breadcrumb.' Deleting now. Thanks, robot.",
        dogfooding_dating_10: "Crafted message explaining chaotic schedule through this. Sounded dedicated, not disinterested.",
        dogfooding_dating_11: "Analyzed potential date's profile bio. AI flagged three clich\xE9s and red flag. More efficient than first date.",
        dogfooding_dating_12: "'Let's just be friends' texts now AI-optimized for minimum collateral damage.",
        dogfooding_dating_13: "Got 'U up?' at 2 a.m. Didn't need AI for that, but 'Maximum Drama' warning was fun.",
        dogfooding_dating_14: "AI suggested adding question to follow-up text. Like A/B testing love life.",
        dogfooding_dating_15: "Deciphered one-word 'k' reply through this. AI's analysis was short novel on passive aggression.",
        dogfooding_dating_16: "Wrote 'can I get my sweatshirt back?' through this. AI optimized for 'low drama, high retrieval success.'",
        dogfooding_dating_17: "They texted 'had a great time!' Didn't. AI drafted polite but clear series finale.",
        dogfooding_dating_18: "They're planning third date before first happened. AI helped pump brakes without harshness.",
        dogfooding_dating_19: "Got 'not ready for relationship' speech. Scanned it. AI confirmed recycled script. Moving on.",
        dogfooding_dating_20: "Drafting text to someone ghosted. AI flagging as 'risky reboot.' Not wrong.",
        dogfooding_dating_21: "Analyzing week of mixed-signal texts. AI summary: 'Inconsistent character motivation.' Story of life.",
        dogfooding_dating_22: "Got unsolicited pic. Didn't need AI to analyze, but used it to draft 'lose my number' reply.",
        dogfooding_dating_23: "Crafted witty reply to terrible pickup line. AI suggested leaning into cheese. Actually worked.",
        dogfooding_dating_24: "They replied after 18 hours. No reply. Not running through app. Okay, running it. AI said 'be patient.' Ugh.",
        dogfooding_dating_25: "Drafting 'is it too soon to meet your friends?' AI suggested casual phrasing. Like test screening.",
        dogfooding_dating_26: "Scanned date's profile after meeting. AI found 4 'continuity errors' between bio and reality.",
        dogfooding_dating_27: "Date won't stop talking about ex. Analyzing texts to find missed red flags. Spoiler: Found them.",
        dogfooding_dating_28: "Ran 'I think we should see other people' through this. AI called it 'soft launch' for breakup.",
        dogfooding_dating_29: "Analyzed incoming text for tone. AI rated 'flirty with intent.' Green light.",
        dogfooding_dating_30: "Wrote pre-date text setting expectations through this. 'Looking for something casual.' Like logline for relationship.",
        dogfooding_family_31: "Mom's text was just 'computer broken.' AI drafted a reply that didn't start with 'have you tried restarting it?'",
        dogfooding_family_32: "Cousin wants to be an extra. AI wrote a 'no openings' text that sounded regretful. The casting department is the firewall.",
        dogfooding_family_33: "Analyzed Aunt's gift of a self-help book. AI detected 'subtle judgment.' Assistant will send her a salad.",
        dogfooding_family_34: "Brother texted 'Hollywood changed you.' AI suggested a less defensive reply. Just better at giving notes now.",
        dogfooding_family_35: "Escaped that family reply-all about the potluck through this. AI crafted the perfect exit. Digital smoke bomb.",
        dogfooding_family_36: "Ran that text to stepmom through the analyzer. AI suggested a more 'inclusive' tone. Harder than a corporate merger.",
        dogfooding_family_37: "Sister's text about who gets the dog for Christmas is high-stakes negotiation. The AI is legal counsel.",
        dogfooding_family_38: "Explained 'residuals' to Dad through this. AI simplified it. He still thinks it means vacation most of the year.",
        dogfooding_family_39: "Parents are downsizing. The 'do you want this?' texts are relentless. AI said 'no thanks' to old trophies.",
        dogfooding_family_40: "Aunt keeps pitching show ideas. AI writes 'great concept!' \u2014 industry-speak for 'never going to happen.'",
        dogfooding_family_41: "Sibling chat about Dad's appointment was a mess. Used this to draft action-items. Someone has to produce.",
        dogfooding_family_42: "Family reviewed last night's episode. AI translated 'it was a little slow' to 'they hated it.'",
        dogfooding_family_43: "Asked about bringing a plus-one to the wedding through this. AI toned down the anxiety. Result: 'high-stakes ask.'",
        dogfooding_family_44: "Parents' 'we've landed' text. AI confirmed the undertone of 'why aren't you here yet?' Still in a meeting.",
        dogfooding_family_45: "Sister wants to change a holiday tradition. AI drafted something open-minded but firm. It's a series, not a reboot.",
        dogfooding_family_46: "Mom's 'feeling a little off' text. AI flagged it 'requires immediate follow-up.' Knows the subtext better than anyone.",
        dogfooding_family_47: "Missed cousin's birthday. AI drafted an apology better than 'work is crazy.' It's always crazy.",
        dogfooding_family_48: "Dad is trying GIFs now. Using AI to interpret them. Like decoding dailies from a foreign film.",
        dogfooding_family_49: "Mediated that fight about the will through this. AI suggested de-escalation language. Most dramatic writer's room yet.",
        dogfooding_family_50: "Nephew sent his school play link. AI wrote a glowing review. Sometimes you just praise the performance.",
        dogfooding_work_31: "Sent the 'your role is being eliminated' email. AI made it as humane as possible. Still feels like killing a character.",
        dogfooding_work_32: "Analyzed the 'quick sync' invite through this. AI flagged it as '90-minute unscripted monologue.' Correct.",
        dogfooding_work_33: "Brand integration notes arrived. 'Can the hero drink our soda?' AI wrote polite 'no' that won't kill the deal.",
        dogfooding_work_34: "Drafting assistant performance review. AI balanced 'needs improvement' with 'don't quit mid-season.'",
        dogfooding_work_35: "Expense report rejected. AI rewrote the appeal. Negotiating for a budget already spent.",
        dogfooding_work_36: "Defended the season finale through this. AI removed emotion, added 'strategic narrative fulfillment.' Network bought it.",
        dogfooding_work_37: "Got pitch from the dentist. AI drafted 'please submit through your agent.' Everyone has a script in this town.",
        dogfooding_work_38: "Guild sent strongly worded email. AI drafted conciliatory response without admitting fault. All politics.",
        dogfooding_work_39: "Got 'we're a family here' email from corporate after layoffs. Ran it through. Irony score off the charts.",
        dogfooding_work_40: "Negotiating credit placement. AI drafted something firm but not diva-esque. The little battles.",
        dogfooding_work_41: "Intern asked for career advice. AI wrote something more inspiring than 'run.' One good deed this week.",
        dogfooding_work_42: "Documented coworker's passive-aggressive emails with this. Like building a case for a character's exit.",
        dogfooding_work_43: "Inherited show in turnaround. AI helping draft the 'new vision' memo. Less rewrite, more exorcism.",
        dogfooding_work_44: "Wrote reference for terrible ex-employee. AI balanced honest with non-slanderous. 'Eager' is good neutral word.",
        dogfooding_work_45: "'Strategically leaked' renewal to reporter through this. AI crafted 'off the record' text. All part of the game.",
        dogfooding_work_46: "Boss wants to 'run ideas by me.' AI helped schedule for 30 minutes. Boundary setting is full-time job.",
        dogfooding_work_47: "Analyzed legal email. AI translated jargon into understandable threats. Much clearer.",
        dogfooding_work_48: "Lead wants to 'collaborate' on script. AI wrote flattering but non-committal reply. Classic move.",
        dogfooding_work_49: "Vetted team group chat for HR violations through this before big meeting. Pre-production for not getting sued.",
        dogfooding_work_50: "Coffee machine broke. Analyzed office-wide email chain. Drama score higher than the last pilot.",
        dogfooding_friends_31: "Friend got huge deal. AI checked 'congrats' text to sound genuinely happy. Took a few tries.",
        dogfooding_friends_32: "Friend's texts all about baby formulas. AI helps ask the right questions. Like learning new language.",
        dogfooding_friends_33: "Got 'looks like you had fun without me' text. AI drafted reply that de-escalated the FOMO.",
        dogfooding_friends_34: "Another 'can you get me into premiere?' text. AI wrote 'tickets are tight' excuse. Always tight for this.",
        dogfooding_friends_35: "Two friends broke up. Drafted neutral 'thinking of you' texts to both through this. Switzerland, with AI advisor.",
        dogfooding_friends_36: "Pulled into drama between two barely-known people. AI drafted 'staying out of it' text. Not the show.",
        dogfooding_friends_37: "Friend keeps one-upping work stories. AI makes replies as boring as possible. De-escalation strategy.",
        dogfooding_friends_38: "Reconnecting with college buddy. AI drafted text that wasn't awkward. 'Long time no see' is rough opening.",
        dogfooding_friends_39: "Friend's bad-idea boyfriend finally left. AI drafted supportive text instead of 'I told you so.'",
        dogfooding_friends_40: "Explained why someone wasn't invited to small dinner. AI wrote honest but kind text. Delicate rewrite.",
        dogfooding_friends_41: "The 'let's start podcast' friend. AI wrote encouraging but non-committal response. New screenplay.",
        dogfooding_friends_42: "Oldest friend has... new political views. AI helps navigate texts to keep peace. Don't talk about Season 3.",
        dogfooding_friends_43: "Best friend moving away. AI wrote text that wasn't total downer. Series finale of an era.",
        dogfooding_friends_44: "Friend's plant-watering instructions more detailed than script breakdown. AI confirmed understanding. Still don't.",
        dogfooding_friends_45: "Secret surprise party chat is minefield. AI ensures replies don't go to wrong person.",
        dogfooding_friends_46: "Friend doing cleanse won't stop texting about it. AI drafted supportive but brief reply. Muting notifications.",
        dogfooding_friends_47: "Analyzed friend's 'soft-ask' for money through this. AI confirmed subtext. Drafting 'can't help' reply now.",
        dogfooding_friends_48: "Friend wants setup with their boss. AI drafted polite 'no thanks.' Too much potential for bad story.",
        dogfooding_friends_49: "Crafting text to friend in new city. AI suggested specific questions. 'How's it going?' is dead end.",
        dogfooding_friends_50: "Friend's wedding hashtag is disaster. AI suggested three better options. Can't help it. Producer instinct.",
        dogfooding_dating_31: "The 'how should we split this?' text. AI crafted casual 'my treat' reply. Investment in potential second season.",
        dogfooding_dating_32: "Drafting 'so... are we deleting the apps?' text. AI phrasing as cool, casual question. It is not.",
        dogfooding_dating_33: "They love the show. Too much. AI steers conversation away from work. Don't want story arc talk.",
        dogfooding_dating_34: "They followed on three platforms at once. AI flagged 'moving too fast.' Data doesn't lie.",
        dogfooding_dating_35: "They texted 'you're not a cat person, right?' AI wrote 'this isn't going to work' text. Deal-breaker is deal-breaker.",
        dogfooding_dating_36: "Matched with network exec. AI analyzing texts for conflicts of interest. Could be drama or comedy.",
        dogfooding_dating_37: "Texts are... a lot. Constant compliments. AI flagged 'love bombing.' Good to have neutral second opinion.",
        dogfooding_dating_38: "They use skull emoji a lot. AI decoded generational meaning. Good thing, apparently.",
        dogfooding_dating_39: "Posting 'soft launch' photo. AI choosing one that says 'seeing someone' not 'engaged.'",
        dogfooding_dating_40: "Got 'I miss you' from ex. Ran through app. AI analysis: 'High drama, low sincerity.' Into archive.",
        dogfooding_dating_41: "Paragraph texter meets one-liner. AI helping be more concise. Like editing for different format.",
        dogfooding_dating_42: "Too soon for 'good morning' text? AI says after three dates, low-risk. Like focus group for feelings.",
        dogfooding_dating_43: "They read text an hour ago. No reply. Not running through app. Okay, running it. AI said 'be patient.' Ugh.",
        dogfooding_dating_44: "Drafting 'we should go away for weekend' text. AI making it sound spontaneous, not relationship test.",
        dogfooding_dating_45: "They revealed... surprising political opinion via text. AI crafting 'let's talk later' reply. Or never.",
        dogfooding_dating_46: "One-month anniversary. AI drafted text that's sweet but not over-the-top. Managing expectations.",
        dogfooding_dating_47: "Analyzed their profile anthem through this. AI report: 'emotionally unavailable but likes to dance.' Sounds right.",
        dogfooding_dating_48: "They want to 'hop on call.' AI drafted reply suggesting text first. Enough calls at work.",
        dogfooding_dating_49: "Got 'you're not like other people I've dated' text. AI flagged 'potential red flag.' Noted.",
        dogfooding_dating_50: "Crafted 'what are you looking for?' text through this. AI made it less interview-like. It's research.",
        conflict_subject_changing_01: "We're getting constant script rewrites in the middle of the scene. The actors can't keep up with the new dialogue.",
        conflict_sarcasm_subtext_01: "The dialogue is great, but it's all subtext. We're going to need a voiceover to explain what the characters actually mean.",
        conflict_talk_later_pickup_01: "They keep scheduling a pickup shoot for that scene, but it never makes it onto the call sheet.",
        conflict_vague_answers_01: "This dialogue feels like a first draft. It needs a polish pass for clarity and commitment.",
        conflict_dramatic_sigh_01: "Adding a big sound effect to underscore the drama. It's a choice. A loud one.",
        conflict_forgetting_continuity_01: "Major continuity error. The action from the previous scene was completely dropped. The script supervisor is furious.",
        conflict_confessional_different_01: "The on-set performance is fine, but the confessional interview is telling a completely different story.",
        conflict_busy_b_plot_01: "The lead character has been given a very convenient, all-consuming B-plot that keeps them away from the main story.",
        conflict_notes_arthouse_01: "The writers are communicating via on-screen text now. Bold. Very arthouse.",
        conflict_mean_jokes_01: "The punch-up crew was brought in to add some jokes, but they all feel a little mean-spirited. The test audience can tell.",
        conflict_resentful_fine_01: "The actor said the line, but their performance is screaming 'I'm only doing this because it's in my contract.'",
        conflict_development_hell_01: "We're stuck in development hell on this plot point. The studio can't decide which way to go.",
        conflict_audio_issues_01: "We're getting reports of audio issues on set, but only when certain topics come up. Strange.",
        conflict_blocking_opposite_01: "The blocking for this scene is interesting. The characters are always busy on opposite sides of the set.",
        conflict_no_conflict_mandate_01: "The showrunner has a strict 'no conflict' mandate. It's going to be a very boring season.",
        conflict_meme_vfx_01: "We tried to use VFX to add some levity to a dramatic scene. The tone is now completely off.",
        conflict_insincere_adr_01: "That line was delivered with the most insincere, syrupy ADR I've ever heard.",
        conflict_director_rogue_01: "The director is making major story choices on the fly without consulting the writer's room. This will not end well.",
        conflict_body_language_01: "The script says 'I'm fine,' but the actor's performance is telling a much more interesting story.",
        conflict_product_placement_01: "That's a classic product placement deal. It looks like a gift, but it's really about their brand.",
        conflict_period_drama_shift_01: "The dialogue has suddenly become incredibly formal, like a period drama. It's a weird genre shift for a contemporary piece.",
        conflict_fatigue_crutch_01: "'Fatigue' is the go-to character motivation this season. It's a bit of a writing crutch, isn't it?",
        escalation_kitchen_sink_01: "The writers are using the 'kitchen sink' approach. Every past storyline is being thrown into this one episode. It's a mess.",
        escalation_villain_edit_01: "The dialogue has devolved into pure character assassination. This is getting a villain edit for sure.",
        escalation_audio_peaking_01: "The audio mix is a disaster. Both dialogue tracks are peaking and there's no room for anyone to breathe.",
        escalation_practical_effects_01: "Adding some practical effects to heighten the drama. A bit over-budget, but it makes a statement.",
        escalation_clip_show_marathon_01: "We're now airing a marathon of clip shows from previous seasons. Is this a new fight or a 'Greatest Hits' special?",
        escalation_refusing_cut_01: "The director is refusing to call cut, even though the actors are clearly exhausted and off-script.",
        escalation_cancellation_tease_01: "Constantly teasing a series cancellation is a cheap way to create drama. The audience is getting tired of the stunt.",
        escalation_victim_competition_01: "This has turned into a reality competition show. The prize? The title of 'Biggest Victim.'",
        escalation_parody_delivery_01: "One actor has started parodying the other's line delivery. It's unprofessional and killing the scene's authenticity.",
        escalation_ultimatum_power_01: "The network has issued an ultimatum: change the story arc or face cancellation. A real power play.",
        escalation_tracking_shot_01: "Great use of a long, continuous tracking shot as the conflict moves through different locations. Very tense.",
        escalation_inciting_incident_01: "The inciting incident was minor, but the fallout is affecting the entire episode's timeline.",
        escalation_cornered_blocking_01: "The blocking in this scene feels very restrictive. One character is literally cornered on set.",
        escalation_competing_monologues_01: "This isn't a dialogue scene, it's two competing monologues edited together.",
        escalation_false_motivation_01: "The writer is assigning motivation to the character that isn't supported by the performance. It feels forced.",
        escalation_fade_to_black_01: "We just sort of... faded to black. No resolution, no character growth. The test audience is going to be confused.",
        escalation_extras_chaos_01: "Bold choice to stage the big dramatic confrontation with a bunch of extras in the shot. Makes it more chaotic.",
        escalation_running_lines_01: "You're running lines for a scene that hasn't even been written yet. That's some serious pre-production.",
        escalation_apology_rewrite_01: "That was a script rewrite mid-take. The apology was on the page, but then they ad-libbed a justification.",
        escalation_weaponized_backstory_01: "The writers are weaponizing character backstory for cheap conflict. It's effective, but it feels cruel.",
        escalation_score_overpowering_01: "The score is swelling to completely overpower the dialogue. You can't hear the character's point at all.",
        escalation_conflicting_accounts_01: "We're getting conflicting accounts in the dailies. Someone's version of the scene is going to end up on the cutting room floor.",
        escalation_text_graphics_01: "This episode is being told entirely through on-screen graphics of text messages. It's long. Very long.",
        anxious_social_stalking_01: "We're doing opposition research on the other characters. It's a bit like spying on the dailies from another set.",
        anxious_texting_pattern_01: "The lead is analyzing a single line of dialogue for subtext, convinced it signals a major plot twist.",
        anxious_are_we_okay_01: "The character keeps breaking the fourth wall to ask the director for reassurance. We need to stay in the scene.",
        anxious_perfect_text_01: "Sending the script out for notes from five different consultants. By the time it's approved, the moment will be gone.",
        anxious_disaster_plots_01: "The writer's room is just pitching disaster movie plots for this character's inner monologue.",
        anxious_day_players_jealousy_01: "We're casting a lot of attractive day players to walk through the background of their scenes. It seems to be creating the intended drama.",
        anxious_cleared_schedule_01: "The lead character cleared their entire shooting schedule on the off-chance the other lead has an opening.",
        anxious_love_interest_trope_01: "Ah, the classic 'introduce a new love interest' trope to boost ratings for a flagging storyline.",
        anxious_sorry_loop_01: "This character's dialogue is just a loop of 'I'm sorry,' even in scenes where they've done nothing wrong.",
        anxious_recast_terror_01: "The actor is terrified of getting a single note from the director, convinced they're about to be recast.",
        anxious_bottle_episode_01: "The request for a bottle episode was taken as a sign the network is cancelling the whole show.",
        anxious_market_research_01: "We're deep into market research, trying to predict audience trends instead of just reading the script.",
        anxious_lighting_dependent_01: "The lighting for this character is entirely dependent on the other character's lighting. If one is dark, they both are.",
        anxious_avoiding_conflict_01: "The writers are avoiding any real conflict because they're afraid the network will write a main character off the show.",
        anxious_repeat_lines_01: "The character has no original dialogue, they just repeat lines from the other lead. It's not a strong performance.",
        anxious_season_renewed_01: "The season has been renewed! The whole production team can finally relax. For now.",
        anxious_forensic_analysis_01: "We're running forensic analysis on the dailies, looking for clues in every glance and pause.",
        anxious_dialogue_ratio_01: "The dialogue ratio is off. One character has pages of script, the other has one-word replies.",
        anxious_character_rewrite_01: "This character is undergoing a complete rewrite to better fit the co-star's brand. Where did their original personality go?",
        anxious_tone_shift_01: "The tone of this show shifts from a lighthearted rom-com to a dark, psychological thriller with no warning.",
        anxious_live_feed_01: "We're requesting a live feed from the B-story camera crew at all times. The main character needs to know what's happening.",
        anxious_silence_tension_01: "It's the silence between lines that's creating all the tension. The sound designer is a genius. Or a sadist.",
        anxious_sizzle_reels_01: "You're watching sizzle reels from other shows and wondering why your dailies don't look as glossy.",
        anxious_too_big_performance_01: "The actor is convinced their performance is too big for the screen, so they're trying to play it smaller and smaller.",
        boundary_hijacked_episode_01: "This guest star just hijacked the episode with their own tragic backstory. We didn't have the budget for this.",
        boundary_uncredited_notes_01: "We're getting a lot of script notes from uncredited writers. Their ideas are... not helping.",
        boundary_reading_script_01: "The other character just broke the fourth wall and started reading the script. That's not allowed.",
        boundary_all_hours_01: "This supporting character's call time is supposed to be 9 to 5, but they keep showing up on set at all hours.",
        boundary_exhaustion_delivery_01: "The director is just feeding the actor the same line over and over, hoping a different delivery will emerge from pure exhaustion.",
        boundary_dangling_loan_01: "There's a subplot about a loan that was never resolved. It's a dangling plot thread that's making the budget department very nervous.",
        boundary_on_call_burnout_01: "The lead actor is now on-call 24/7. It's not in their contract, and it's leading to burnout.",
        boundary_surprise_character_01: "A surprise character has been written into the scene without any warning. The other actors have to improvise around them.",
        boundary_booking_without_checking_01: "The showrunner is booking locations and scheduling shoots without checking the lead's availability.",
        boundary_miscast_therapist_01: "You've been miscast as the on-set therapist. Your actual role is co-star.",
        boundary_pg_rating_01: "The dialogue is a little too graphic for our target demographic. We need to edit this for a PG rating.",
        boundary_day_rate_same_01: "The shooting schedule just keeps getting longer, but the day rate stays the same.",
        boundary_roast_hit_piece_01: "The script calls for roast-style humor, but it's starting to feel more like a hit piece.",
        boundary_off_camera_scenes_01: "The character is now performing their most important scenes off-camera. We're losing the whole story.",
        boundary_props_moved_01: "We've given recurring guest stars full access to the main set. They're starting to move the props around.",
        boundary_emotional_blackmail_01: "The motivation for this character's action is listed as 'emotional blackmail.' Doesn't seem very heroic.",
        boundary_cut_mid_sentence_01: "The editor is cutting off the character's lines mid-sentence. We never get to hear their full thought.",
        boundary_extreme_closeup_01: "The camera is doing an extreme close-up when the scene clearly calls for a wide shot. It's uncomfortable.",
        boundary_documentary_invasive_01: "This documentary interview is getting way too personal. The subject did not agree to these questions.",
        boundary_missing_props_01: "The props department is reporting a lot of items missing from the set after the guest star's scenes.",
        boundary_boom_mic_hovering_01: "The boom mic is always hovering, even in the most intimate scenes. There's no privacy on this set.",
        boundary_silent_observer_01: "The character's dialogue has been cut from the final act. They're just a silent observer now.",
        boundary_both_sides_dialogue_01: "One actor is now delivering both sides of the dialogue. It's an interesting performance, but not what was written.",
        avoidant_not_big_texter_01: "The character's main trait is that they don't like the primary mode of communication for this show. It's a writing challenge.",
        avoidant_vague_finale_01: "The series finale has been greenlit, but the script is just a vague outline with no specific scenes.",
        avoidant_unreachable_between_takes_01: "The performance is amazing on shoot days, but the actor is completely unreachable between takes.",
        avoidant_one_script_time_01: "The network won't commit to a full season order. They're just ordering one script at a time.",
        avoidant_pilot_never_picked_01: "This showrunner is famous for brilliant pilot episodes that never get picked up for a full series.",
        avoidant_beloved_previous_01: "They keep referencing a beloved character from a previous season, making it impossible for the new lead to measure up.",
        avoidant_less_depth_note_01: "The network sent a note: 'Less emotional depth, more action.' It's gutting the heart of the story.",
        avoidant_wide_angle_cut_01: "Every time the camera pushes in for an intimate shot, the director immediately cuts to a wide, impersonal angle.",
        avoidant_subplot_entire_show_01: "The main character's subplot has become the entire show. The romantic A-plot gets maybe five minutes of screen time.",
        avoidant_improv_oneliner_01: "We're in the most dramatic scene of the season, and the actor has started improvising one-liners.",
        avoidant_romance_to_drama_01: "The show is technically a 'romance,' but the marketing department is under strict orders to just call it a 'drama.'",
        avoidant_written_out_mystery_01: "The character was mysteriously written out of last week's episode, but now they're back with no explanation. Baffling.",
        avoidant_insignificant_details_01: "The director is getting bogged down in tiny, insignificant details of the performance to avoid shooting the actual scene.",
        avoidant_one_person_masquerade_01: "This is a one-person show, masquerading as an ensemble piece.",
        avoidant_hollow_performance_01: "The line readings are technically perfect, but there's no heart behind them. The performance feels hollow.",
        avoidant_retooled_show_01: "You're in love with the character from the pilot episode, but the show has been completely retooled since then.",
        avoidant_no_promo_joint_01: "The press release says the cast has amazing chemistry, but they refuse to do any joint promotional appearances.",
        avoidant_never_ensemble_01: "This character has never had a scene with the main ensemble cast. Are they even on the same show?",
        avoidant_exit_clause_01: "The actor has an exit clause in their contract that lets them leave the show with only one episode's notice.",
        avoidant_narrated_documentary_01: "This scene should be a heartfelt confession, but it's being delivered like a narrated documentary.",
        avoidant_cut_for_time_01: "The action sequences are incredible, but the quiet, character-driven scenes are all being cut for time.",
        avoidant_conflicting_notes_01: "We're getting conflicting notes from two different studio executives. The director has no idea what show they're supposed to be making.",
        avoidant_bottle_episode_budget_01: "We shot a big, expensive episode last week, so now the budget only allows for a single-location 'bottle episode' with one character.",
        avoidant_redacted_backstory_01: "The character's backstory is completely redacted in the script. The actor has nothing to work with.",
        avoidant_recurring_guest_01: "You've been cast as a recurring guest star, not a series regular. You're only in the episodes where the main plot needs you.",
        avoidant_walks_off_emotion_01: "The other actor just walks off set whenever their scene partner shows any genuine emotion.",
        gaslighting_overnight_rewrite_01: "Overnight rewrite. The scene was shot, but someone slipped in new pages and pretended the original never aired.",
        gaslighting_selective_crop_01: "Selective crop job. We're looking at the raw timecode; the cut they're selling trims the inconvenient beats.",
        gaslighting_genre_swap_01: "Classic genre swap\u2014turning your documentary into a melodrama to discredit the footage.",
        gaslighting_test_audience_01: "Anonymous test audience feedback? Cool story. Show the cards or cut the line.",
        gaslighting_stunt_rehearsal_01: "Rebranding a stunt as a rehearsal doesn't make it safe. The bruise is still on the dailies.",
        gaslighting_penciled_clause_01: "That contract clause isn't in the show bible. Someone penciled it in after the table read.",
        gaslighting_meters_peaked_01: "The meters peaked. You can't gaslight a soundboard.",
        gaslighting_confession_montage_01: "Clever edit\u2014turning a beat of empathy into a full confession montage.",
        gaslighting_props_continuity_01: "Continuity person on strike? Only one character's props are making it from scene to scene.",
        gaslighting_satire_punchline_01: "Don't call it satire when the punchline lands on the same character every episode.",
        gaslighting_gas_leak_01: "Gas leak on set, is it? Because the footage shows it happened in plain daylight.",
        gaslighting_offscreen_narrator_01: "Off-screen narrator suddenly claims omniscience. That's a producer note, not a fact.",
        gaslighting_check_slate_01: "Check the slate\u2014scene number, take, and date all line up. The clock isn't the liar here.",
        gaslighting_splice_points_01: "Strategic jump cuts around accountability. I see the splice points.",
        gaslighting_on_camera_stereo_01: "Funny\u2014those lines are in their mouth on camera and in stereo.",
        gaslighting_lighting_shook_01: "The lighting rigs shook. We don't get camera jitter from 'calm.'",
        gaslighting_mirror_reversed_01: "Mirror shot. The reflection is convincing\u2014until you realize it's reversed.",
        gaslighting_choreo_tripwire_01: "Reframing a scene partner's mark as a tripwire. It's choreo, not a booby trap.",
        gaslighting_choice_not_cue_01: "No actor note says 'be cruel if prompted.' That's a choice, not a cue.",
        gaslighting_ripped_spine_01: "Someone tore a page out of the show bible and hopes no one notices the ripped spine.",
        gaslighting_sweeping_generalization_01: "A sweeping generalization to avoid the specific shot list. Convenient.",
        gaslighting_commentary_missing_01: "The promised director's commentary keeps missing its release date.",
        gaslighting_press_kit_spin_01: "Public-facing brand spin. The press kit bears little resemblance to the show.",
        gaslighting_bad_dub_01: "A bad dub\u2014same lines, new menace. The lip sync betrays the swap.",
        gaslighting_wide_shot_context_01: "The wide shot shows context for days. We're not trapped in a close-up here.",
        gaslighting_details_truth_01: "Details are how we find the truth. Ask any script supervisor with a ruler and a glare.",
        codependency_craft_services_01: "One showrunner, two leads, zero autonomy. The craft services table has options\u2014pick one.",
        codependency_standby_personality_01: "Standby isn't a personality. Call time is when the story actually happens.",
        codependency_merged_bio_01: "The character bio got merged. We need separate arcs, not a shared login.",
        codependency_live_tweeting_01: "Live-tweeting your relationship isn't a plot\u2014it's a ticker.",
        codependency_solo_coverage_01: "A solo scene isn't betrayal. It's coverage.",
        codependency_two_for_one_01: "Two-for-one casting might sell posters, but it flattens performances.",
        codependency_emotional_adr_01: "Emotional ADR on loop: 'I'm sorry' as temp track under every beat.",
        codependency_sizzle_fire_01: "Polishing the sizzle reel while the set's on fire.",
        codependency_budget_spinoff_01: "Diverting the season budget to a spin-off. The flagship show suffers.",
        codependency_show_therapist_01: "Playing show therapist while your own scenes go unshot.",
        codependency_both_table_read_01: "Running both sides of the table read. Efficient, and completely unhealthy.",
        codependency_closed_set_01: "Closed set energy. No extras, no guest stars, no growth.",
        codependency_security_violations_01: "Clearing security violations because the stunt 'looked cool in rehearsal.'",
        codependency_note_cancellation_01: "If every note means cancellation, no one learns lines.",
        codependency_committee_approval_01: "Wardrobe and props approved by committee. Slow, joyless, risk-averse.",
        codependency_separation_chemistry_01: "Separation anxiety framed as 'chemistry.' The edit says otherwise.",
        codependency_fixing_post_01: "Constantly fixing it in post. Eventually, the timeline breaks.",
        codependency_echo_track_01: "Echo track engaged. Stereo, no content.",
        codependency_house_style_01: "Calling a production glitch a house style.",
        codependency_first_person_plural_01: "First person plural is great for press tours, not for inner monologues.",
        codependency_spinoff_calendar_01: "Your calendar's a spin-off of theirs. Ratings for yours are tanking.",
        codependency_solo_b_plot_terror_01: "Solo B-plot terrifies the writers' room\u2014no co-lead to prop it up.",
        codependency_group_monologue_01: "Group table read for a monologue. Some pages need a single voice.",
        codependency_hostage_thriller_01: "That's not romance\u2014that's a hostage thriller with better lighting.",
        codependency_pr_interference_01: "Running interference with PR spin while the act break falls apart.",
        codependency_no_personal_lease_01: "Shared house rules, no personal lease. Where's your key?",
        codependency_light_meter_tied_01: "Light meter tied to one face. Shadowy look when they frown.",
        power_studio_ledger_01: "One character runs the studio ledger; the other begs for petty cash to shoot scenes.",
        power_booked_hijack_01: "Booked locations, no call to the lead. That's not vision\u2014that's a hijack.",
        power_access_list_01: "Access list updated nightly. Your guest stars keep getting uninvited.",
        power_rush_golden_01: "You're on rush call; they're on golden hour. Guess who looks stunning on screen.",
        power_emotional_paywall_01: "Emotional paywall\u2014premium features locked until you accept the terms.",
        power_weaponized_jargon_01: "Weaponized jargon as a boom mic\u2014loud enough to drown out your lines.",
        power_single_signon_01: "Single sign-on with one admin user. You're browsing in guest mode.",
        power_breakout_fan_01: "PR narrative frames you as the breakout fan\u2014never the headliner.",
        power_gps_chyron_01: "Your GPS is on the chyron; theirs is redacted like a spoiler.",
        power_paternal_cut_01: "Paternal director's cut\u2014every scene trimmed to fit their thesis.",
        power_spreadsheet_locked_01: "Closed-door notes session. Your character arc lives in a spreadsheet you can't open.",
        power_pyro_budget_01: "Pyro budget spikes whenever they're questioned. It's a fear-based storyline.",
        power_sponsor_ad_01: "Awards speech cut for time; we ran a sponsor ad instead.",
        power_security_cam_01: "Security cam in the greenroom. That's not intimacy\u2014that's surveillance.",
        power_styling_erase_01: "Styling notes that erase character\u2014on-brand for them, off-brand for you.",
        power_one_hot_mic_01: "Panel with one hot mic. Everyone else is pantomime.",
        power_day_rate_entitlement_01: "Calling a standard day rate 'entitlement.' Sure, Jan.",
        power_renewal_reshoots_01: "Renewal contingent on reshoots you never agreed to.",
        power_iou_ledger_01: "IOU ledger disguised as a romance script.",
        power_intimacy_tbd_01: "Intimacy coordinator booked 'TBD' forever\u2014unless they're in the mood.",
        power_after_credits_01: "Your scenes moved to after credits\u2014if time permits.",
        power_b_roll_locations_01: "One character has the keys; the other gets dropped at B-roll locations.",
        power_expert_comic_relief_01: "On-set expert gets recut as comic relief. It's petty, not funny.",
        power_funding_yanked_01: "Funding yanked at the tech scout. You can't shoot without power.",
        power_refusing_ensemble_01: "Refusing to film with the ensemble\u2014keeps you off balance and off-book.",
        power_media_training_01: "Media training tip: let the co-star have a mic. They won't.",
        power_gravity_neutral_01: "Gravity is neutral too\u2014until you notice every ball rolls to their side of set.",
        defensiveness_tone_police_01: "Mixing critique: 'Too much treble in your truth.' Classic tone police.",
        defensiveness_closing_arguments_01: "Closing arguments over semantics while the story bleeds out.",
        defensiveness_weaponized_recap_01: "Weaponized recap\u2014previously on 'Your Mistakes,' now streaming endlessly.",
        defensiveness_hard_cut_tears_01: "Instant redemption arc inserted before the conflict resolves. Hard cut to tears.",
        defensiveness_qa_tickets_01: "Feelings aren't continuity errors. Stop filing tickets with QA.",
        defensiveness_exposition_dump_01: "Exposition dump to avoid the scene's actual beat. Audiences tune out.",
        defensiveness_unrequested_notes_01: "Unrequested director's notes in a locked cut. We didn't ask for a recut.",
        defensiveness_live_buzzer_01: "Live fact-checker with a buzzer\u2014great for quiz shows, bad for intimacy.",
        defensiveness_smoke_detector_01: "Don't blame the smoke detector for the fire.",
        defensiveness_punchup_accountability_01: "Punch-up passes can't replace a missing act break called accountability.",
        defensiveness_4k_hdr_01: "You don't need 4K HDR receipts to request basic respect.",
        defensiveness_monday_morning_01: "Monday-morning director commentary for a scene they refused to shoot.",
        defensiveness_cross_examining_01: "Cross-examining your monologue instead of listening to it.",
        defensiveness_sloppy_wipe_01: "The 'but' erases the apology like a sloppy wipe transition.",
        defensiveness_infinite_mirrors_01: "Reaction shot of a reaction shot. Infinite mirrors, zero progress.",
        defensiveness_commas_fire_01: "Arguing over commas while the scene is on fire.",
        defensiveness_blaming_clapper_01: "Calling 'action' on a check-in scene and blaming the clapper for the drama.",
        defensiveness_salt_michelin_01: "From 'pass the salt' to 'you want a Michelin star kitchen?' Wild escalation.",
        defensiveness_waveform_spikes_01: "Sensitivity isn't the problem\u2014the spikes in the waveform are.",
        defensiveness_last_season_villain_01: "Guest-starring last season's villain in this week's calm episode.",
        defensiveness_playback_clear_01: "We rolled two cameras and a boom; the playback's crystal clear.",
        defensiveness_emotion_to_spec_01: "Holding the scene hostage until the other actor performs an emotion to spec.",
        defensiveness_zero_pages_01: "Great pitch in the room, zero pages delivered.",
        defensiveness_recycling_broll_01: "Recycling B-roll to avoid shooting new material.",
        defensiveness_footage_villain_01: "The cut isn't villainizing you; the footage is.",
        defensiveness_deal_memo_01: "Signed the deal memo, ghosted the delivery date.",
        defensiveness_bible_annotations_01: "Asking for show bible annotations on a single-line note.",
        withdrawal_thousand_yard_01: "Thousand-yard stare, shallow depth of field. The subject has drifted out of focus.",
        withdrawal_grunts_missing_01: "Dialogue reduced to grunts. It's not minimalism; it's missing.",
        withdrawal_competing_screens_01: "Competing screens. Your scene's playing; their eyes are on another channel.",
        withdrawal_spontaneous_wrap_01: "Calling a spontaneous wrap because feelings walked on set.",
        withdrawal_limbo_parking_01: "Parking a storyline in limbo\u2014no pickups, no resolution.",
        withdrawal_lens_cap_01: "Every time we push in, the lens cap goes on.",
        withdrawal_cello_kazoo_01: "Tonal whiplash\u2014swapping a cello score for kazoo mid-confession.",
        withdrawal_dead_air_01: "Dead air on a live mic. The silence is louder than the show.",
        withdrawal_cold_open_01: "Cold open with no main character. Viewers notice.",
        withdrawal_crowd_scene_01: "Great extras, missing co-star. It reads as a crowd scene.",
        withdrawal_emergency_montage_01: "Emergency montage to avoid the scene everyone tuned in for.",
        withdrawal_calendar_invites_01: "Calendar invites instead of chemistry. Invite declined.",
        withdrawal_blackout_pages_01: "Blackout pages where the backstory should be.",
        withdrawal_kicking_can_01: "Kicking the can to post. Spoiler: we never got to post.",
        withdrawal_props_disappearing_01: "Key props keep disappearing. Hard to play the scene without them.",
        withdrawal_subtitles_faces_01: "Subtitles for a scene that needs faces, not fonts.",
        withdrawal_paper_cut_lockdown_01: "Full lockdown for a paper cut. The set's over-secured.",
        withdrawal_b_roll_sunsets_01: "Endless B-roll of sunsets\u2014no interviews, no insight.",
        withdrawal_marked_addressed_01: "Opened the script, skipped the scene, marked as 'addressed.'",
        withdrawal_losing_light_noon_01: "Forever 'losing the light' at noon.",
        withdrawal_statue_challenge_01: "Actor statue challenge\u2014no direction reaches them.",
        withdrawal_product_placement_shiny_01: "Swapping dialogue for product placement. Shiny, empty.",
        withdrawal_preroll_ad_01: "Emotional pre-roll ad that never ends.",
        withdrawal_mid_season_hiatuses_01: "Endless mid-season hiatuses until the audience forgets the plot.",
        withdrawal_mystery_box_01: "Mystery box with no clues. That's not suspense\u2014it's stonewalling in a tux.",
        withdrawal_driving_montage_01: "Exterior driving montage in every act. Interior scenes go unshot.",
        withdrawal_flatline_waveform_01: "Flatline on the emotional waveform. We need signal, not noise.",
        withdrawal_screen_test_empty_01: "Screen test with no subject in the chair."
      }
    };
  }
});

// src/i18n/locales/en/error_friendly.json
var require_error_friendly = __commonJS({
  "src/i18n/locales/en/error_friendly.json"(exports, module) {
    module.exports = {
      error_friendly: {
        suggestion: 'If the problem persists, tap "Need help?" below.',
        hide_help: "Hide details",
        need_help: "Need help?",
        reference: "Reference number",
        copy_for_support: "Copy for support",
        copy: "Copy"
      }
    };
  }
});

// src/i18n/locales/en/error_trace.json
var require_error_trace = __commonJS({
  "src/i18n/locales/en/error_trace.json"(exports, module) {
    module.exports = {
      error_trace: {
        toggle_details: "Toggle error details"
      }
    };
  }
});

// src/i18n/locales/en/inline_annotations.json
var require_inline_annotations = __commonJS({
  "src/i18n/locales/en/inline_annotations.json"(exports, module) {
    module.exports = {
      inline_annotations: {
        view_original: "View Original",
        view_revised: "View Revised",
        previous: "Previous",
        next: "Next",
        try_instead: "Try this instead:"
      }
    };
  }
});

// src/i18n/locales/en/mobile_app.json
var require_mobile_app = __commonJS({
  "src/i18n/locales/en/mobile_app.json"(exports, module) {
    module.exports = {
      title: "Mobile App",
      confirm_title: "Confirm Action",
      confirm_message: "Are you sure you want to proceed?",
      confirm_button: "Confirm",
      cancel: "Cancel"
    };
  }
});

// src/i18n/locales/en/historyPremiumInsights.json
var require_historyPremiumInsights = __commonJS({
  "src/i18n/locales/en/historyPremiumInsights.json"(exports, module) {
    module.exports = {
      historyPremiumInsights: {
        pattern_recognition: {
          title: "Pattern Recognition",
          insights: "Key patterns across your communication history",
          description: "Discover recurring patterns in your messages"
        }
      }
    };
  }
});

// src/i18n/locales/en/practitioner.json
var require_practitioner = __commonJS({
  "src/i18n/locales/en/practitioner.json"(exports, module) {
    module.exports = {
      header: {
        app_title: "DramaDetector",
        role_badge: "Practitioner"
      },
      greeting: {
        good_morning: "Good morning",
        good_afternoon: "Good afternoon",
        good_evening: "Good evening"
      },
      stats: {
        active_clients: "Active Clients",
        analyses_this_month: "Analyses This Month",
        earnings_this_month: "Earnings This Month",
        clients_improving: "Clients Improving",
        member_since: "Member since",
        analyses: "Analyses",
        tier: "Tier"
      },
      actions: {
        invite_client: "Invite Client",
        share_link: "Share Link",
        invite_coming_soon: "Invite flow coming soon",
        share_message: "Join my DramaDetector practice group"
      },
      sections: {
        recent_analyses: "Recent Analyses",
        view_all: "View All",
        no_analyses: "No recent analyses yet"
      },
      patterns: {
        criticism: "Criticism elevated",
        stonewalling: "Stonewalling",
        defensiveness: "Defensiveness",
        contempt: "Contempt",
        empathy: "Empathy improving"
      },
      partner: {
        header_title: "Partner Dashboard",
        go_back: "Go back",
        this_month_label: "This Month",
        this_month_earnings: "This month earnings: {{amount}}",
        total_earned_label: "Total",
        pending_label: "Pending",
        commission_label: "Commission",
        commission_rate_pill: "Founding {{rate}}%",
        referral_link_title: "Your Referral Link",
        copy_link_hint: "Tap to copy your unique referral link",
        share_email: "Email",
        share_sms: "SMS",
        share_qr: "QR Code",
        funnel_title: "Conversion Funnel",
        funnel_invited: "Invited",
        funnel_signed_up: "Signed Up",
        funnel_subscribed: "Subscribed",
        funnel_active: "Active",
        funnel_bar_a11y: "{{count}} {{stage}}, {{percent}} percent of total",
        founding_title: "Founding Partner",
        certified_since: "Certified since {{date}}",
        founding_body: "You locked in a lifetime {{rate}}% commission rate as a founding member. Share your credential to build trust with clients.",
        download_badge: "Download Badge",
        qr_title: "QR Code",
        qr_coming_soon: "QR code feature coming soon.",
        download_coming_soon: "Badge download coming soon."
      },
      client_view: {
        back: "Go back to client list",
        consent_level: "Sharing level: {{level}}",
        sharing_level_scores: "Scores & Patterns",
        sharing_level_full: "Full History"
      },
      consent: {
        scores_and_patterns: "Scores & Patterns",
        full_history: "Full History",
        original_text: "Original Text"
      },
      tier: {
        free: "Free",
        drama_plus: "Drama+",
        dramax: "DramaX"
      },
      prep_card: {
        title: "AI Session Prep Notes"
      },
      prep_note: {
        improving: "Improving",
        persistent: "Persistent",
        suggested: "Suggested"
      },
      pattern_trends: {
        title: "Pattern Trends"
      },
      pattern_bar: {
        a11y: "{{name}}: score {{score}}, {{trend}}"
      },
      trend: {
        improving: "improving",
        stable: "stable",
        worsening: "worsening"
      },
      history: {
        title: "Analysis History",
        total: "total",
        new_pattern: "new",
        pending_approval: "Pending approval",
        score: "Score"
      },
      privacy_notice: {
        message: "Original text hidden \u2014 client has not enabled sharing"
      },
      chat: {
        session_notes: "Session Notes",
        via_sendbird: "Chat via Sendbird",
        placeholder: "Add a note\u2026",
        send: "Send message",
        thread_label: "Chat thread with {{client}}"
      },
      consent_gate: {
        history: {
          title: "History access not enabled",
          body: "This client has not shared their analysis history with you. Ask them to update their sharing settings."
        }
      },
      accessibility: {
        notifications: "Notifications",
        profile: "Profile for {{name}}",
        stat_active_clients: "{{count}} active clients{{delta}}",
        stat_analyses: "{{count}} analyses this month{{delta}}",
        stat_earnings: "{{amount}} earnings this month",
        stat_improving: "{{percent}}% of clients improving",
        analysis_row: "{{client}}: {{pattern}}, {{date}}, score {{score}}",
        view_all_analyses: "View all analyses"
      }
    };
  }
});

// src/i18n/locales/en/practitioner_consent.json
var require_practitioner_consent = __commonJS({
  "src/i18n/locales/en/practitioner_consent.json"(exports, module) {
    module.exports = {
      screen: {
        title: "Practitioner Access"
      },
      explainer: {
        body: "Control what your practitioners can see. Your conversations are private by default."
      },
      card: {
        status: {
          active: "Active",
          pending: "Pending"
        },
        role_since: "{{role}} \xB7 Added {{date}}",
        role_invited: "{{role}} \xB7 Invited {{date}}"
      },
      toggle: {
        view_history: "View analysis history",
        view_history_sub: "Scores, patterns, and dates",
        view_messages: "View original messages",
        view_messages_sub: "Your conversation text",
        allow_comments: "Allow comments",
        allow_comments_sub: "Practitioner can leave session notes",
        require_approval: "Require approval per analysis",
        require_approval_sub: "Review before sharing each result",
        crisis_notifications: "Crisis notifications",
        crisis_notifications_sub: "Alert practitioner in urgent situations",
        crisis_urgency: "Crisis urgency level",
        crisis_urgency_sub: "Set alert priority",
        crisis_urgency_sub_disabled: "Enable crisis notifications first",
        crisis_contact: "Contact method",
        crisis_contact_sub: "How to reach your practitioner",
        crisis_contact_sub_disabled: "Enable crisis notifications first"
      },
      pending_banner: {
        message: "Waiting for {{name}} to accept the invitation. Permissions will be available once accepted."
      },
      revoke: {
        active_label: "Revoke Access",
        pending_label: "Cancel Invitation",
        confirm_title: "Remove practitioner?",
        confirm_body: "They will lose access to your data immediately.",
        confirm_cta: "Remove"
      },
      accordion: {
        title: "What can they see?",
        history_on: {
          label: "Analysis history ON",
          detail: "Scores, dates, and top patterns only. No text."
        },
        messages_off: {
          label: "Original messages OFF",
          detail: "Your full conversation text stays private."
        },
        messages_on: {
          label: "Original messages ON",
          detail: "Practitioner can see your conversation text."
        },
        crisis: {
          label: "Crisis notifications",
          detail: "If enabled, practitioner is alerted when a high-risk pattern is detected."
        }
      },
      empty: {
        title: "No practitioners connected",
        description: "When a practitioner invites you to their group, you can manage their access here."
      },
      error: {
        load_failed: "Could not load practitioner settings. Tap to retry.",
        retry: "Try again"
      }
    };
  }
});

// src/i18n/locales/en/messaging.json
var require_messaging = __commonJS({
  "src/i18n/locales/en/messaging.json"(exports, module) {
    module.exports = {
      bubble: {
        action_show_rewrites: "Show rewrites",
        action_copy_text: "Copy text",
        action_report: "Report",
        status_sending: "Sending",
        status_failed: "Failed to send",
        a11y_from_you: "Message from you",
        a11y_from_sender: "Message from {{sender}}",
        action_cancel: "Cancel",
        narrator_collapse: "Show less",
        narrator_expand: "Show more",
        narrator_show_less: "Show less",
        narrator_show_more: "Show more"
      },
      row: {
        untitled: "New conversation",
        empty_preview: "Say hello \u{1F44B}",
        a11y_label: "Conversation with {{title}}",
        a11y_label_unread: "Conversation with {{title}}, {{count}} unread",
        unread_badge: "{{count}} unread messages",
        time_now: "now",
        time_yesterday: "yesterday"
      },
      empty: {
        title: "No conversations yet",
        subtitle: "Start a chat to get personalized drama de-escalation guidance in real time.",
        cta: "Start your first chat"
      },
      upsell: {
        card: {
          title: "Unlock Drama+ Chats",
          subtitle: "Get real-time drama de-escalation guidance, conversation coaching, and pattern insights \u2014 all in a private chat with your DramaDetector coach.",
          feature_1: "Unlimited coaching conversations",
          feature_2: "Message rewrites on demand",
          feature_3: "Pattern-aware follow-ups",
          cta: "Upgrade to Drama+"
        },
        modal: {
          tab_tap: {
            title: "Unlock Chats",
            subtitle: "Drama+ turns DramaDetector into a private coach that remembers.",
            feature_1: "Persistent conversations with your coach",
            feature_2: "Per-message scoring and rewrites",
            feature_3: "Unlimited conversation history",
            cta_primary: "Upgrade to Drama+",
            cta_secondary: "Maybe later"
          },
          quota_exhausted: {
            title: "You're out of analyses today",
            subtitle: "Drama+ gets you 10x more every day \u2014 never get cut off mid-thread.",
            feature_1: "100 analyses per day (vs 10 on free)",
            feature_2: "Persistent chat with per-message scoring",
            feature_3: "Priority support when it matters",
            cta_primary: "Upgrade to Drama+",
            cta_secondary: "Wait until reset"
          },
          conversation_limit: {
            title: "Conversation limit reached",
            subtitle: "Drama+ removes the cap so you can keep every thread with every person.",
            feature_1: "Unlimited active conversations",
            feature_2: "Per-message scoring across all threads",
            feature_3: "Full history, forever",
            cta_primary: "Upgrade to Drama+",
            cta_secondary: "Not now"
          },
          a11y_dismiss: "Dismiss upsell"
        }
      },
      quota: {
        exhausted: "Out of analyses",
        exhausted_a11y: "Out of analyses. {{resetLabel}}. Tap to upgrade.",
        upgrade_cta: "Upgrade to Drama+",
        upgrade_short: "Upgrade",
        remaining: "{{count}} left",
        remaining_today: "{{count}} left today",
        remaining_a11y: "{{count}} analyses left today",
        remaining_full: "{{remaining}} of {{limit}} analyses left",
        remaining_full_a11y: "{{remaining}} of {{limit}} analyses left. {{resetLabel}}.",
        resets_soon: "Resets soon",
        resets_in: "Resets in {{minutes}}m",
        resets_at: "Resets at {{time}}",
        full_exhausted_body: "{{resetLabel}}. Upgrade to Drama+ for 10x more analyses every day.",
        upgrade_more_a11y: "Upgrade for more analyses",
        dramax_exhausted_title: "Analyses reset soon",
        dramax_exhausted_body: "You've used all your analyses today. They reset at {{time}}."
      },
      thread: {
        default_title: "DramaDetector Coach",
        tap_to_rename: "Tap to rename",
        empty: "Send the first message in this conversation",
        error: "Couldn't load messages",
        retry: "Retry",
        composer_placeholder: "Type a message\u2026",
        composer_placeholder_exhausted: "Quota exhausted \u2014 upgrade to continue",
        a11y_back: "Back to conversations",
        a11y_edit_title: "Edit conversation title",
        a11y_options: "Conversation options",
        a11y_send: "Send message",
        rename_title: "Rename conversation",
        rename_body: "Inline rename ships in a follow-up (MESSAGING-S2-FE7).",
        options_title: "Options",
        options_body: "Options menu ships in a follow-up (MESSAGING-S2-FE7).",
        create_stub_title: "Create conversation",
        create_stub_body: "Creating new conversations will be enabled once the messaging backend ships (MESSAGING-S2-FE5)."
      },
      list: {
        stub_footer: "Showing stub data \u2014 live conversations arrive in MESSAGING-S2-FE5",
        a11y_new_chat: "New chat"
      }
    };
  }
});

// src/i18n/locales/es/analysis.json
var require_analysis2 = __commonJS({
  "src/i18n/locales/es/analysis.json"(exports, module) {
    module.exports = {
      analysis: {
        title: "Analiza Tu Mensaje",
        drama_score_gauge: "Indicador de puntuaci\xF3n de drama mostrando {score} de 10",
        drama_score: "Puntuaci\xF3n de Drama"
      },
      feedback: {
        title: "\xBFFue \xFAtil este an\xE1lisis?",
        thumbs_up: "S\xED, \xFAtil",
        thumbs_down: "No \xFAtil",
        thank_you: "\xA1Gracias por tu comentario!"
      },
      analysis_detail_modal: {
        title: "Detalles del An\xE1lisis",
        message_label: "Mensaje",
        actions: {
          edit_and_reanalyze: "Editar y Re-analizar",
          done: "Listo"
        },
        accessibility: {
          close_modal: "Cerrar modal",
          edit_and_reanalyze: "Editar y re-analizar este mensaje"
        }
      },
      analysis_results: {
        issues_detected: "Problemas Detectados",
        suggested_improvements: "Mejoras Sugeridas",
        pattern_spotlight: "Patr\xF3n en el Spotlight",
        transformation_insights: "Insights de Transformaci\xF3n",
        accessibility: {}
      },
      score_card: {
        drama_score: "Puntuaci\xF3n de Drama",
        accessibility: {
          drama_score_value: "Puntuaci\xF3n de drama: {score} de 10, {category}"
        }
      },
      suggestions: {
        before: "Antes",
        after: "Despu\xE9s",
        copy_button: "Copiar",
        copied: "\xA1Copiado!",
        empty: {
          title: "No hay sugerencias disponibles",
          message: "\xA1Tu mensaje se ve bien as\xED como est\xE1!"
        },
        accessibility: {
          improvement_area: "\xC1rea de mejora: {area}",
          copy_to_clipboard: "Copiar al portapapeles",
          copied_to_clipboard: "Copiado al portapapeles",
          no_suggestions: "No hay sugerencias disponibles"
        }
      },
      issues: {
        position_label: "Posici\xF3n: ",
        full_snippet_label: "Fragmento completo: ",
        show_more: "Ver M\xE1s \u25BC",
        show_less: "Ver Menos \u25B2",
        empty: {
          title: "No se detectaron problemas",
          message: "\xA1Tu mensaje se ve bien!"
        },
        accessibility: {
          severity: "Severidad: {severity}",
          no_issues: "No se detectaron problemas. \xA1El mensaje se ve bien!"
        }
      },
      transformationInsightCard: {
        labels: {
          before: "Antes",
          after: "Despu\xE9s"
        },
        insights_label: "Insights Clave",
        accessibility: {
          shareTransformation: "Compartir transformaci\xF3n de {transformationType}",
          beforeText: "Mensaje original",
          afterText: "Mensaje transformado"
        }
      },
      transformation_insight: {
        communication_pattern_shift: {
          type: "Cambio de Patr\xF3n de Comunicaci\xF3n",
          before: "Tu patr\xF3n actual muestra lenguaje defensivo en contextos de alto estr\xE9s",
          after: "Abraza la autenticidad vulnerable nombrando las emociones directamente",
          insights: [
            "Observaci\xF3n sin Evaluaci\xF3n: Separa los hechos de las interpretaciones",
            "Transformaci\xF3n de alto impacto reduce la escalada de conflictos",
            "Practica nombrar emociones directamente sin encuadres defensivos"
          ]
        }
      },
      style_consistency: {
        header: "Perspectiva de Estilo de Comunicaci\xF3n",
        formality_pill: {
          consistent: "Tono consistente",
          some_variation: "Algo de variaci\xF3n de tono",
          notable_shift: "Cambio de tono notable"
        },
        punctuation_pill: {
          informal: "Puntuaci\xF3n informal",
          mixed: "Puntuaci\xF3n mixta",
          formal: "Puntuaci\xF3n formal"
        },
        length_pill: {
          brief: "Breve",
          moderate: "Moderado",
          lengthy: "Extenso"
        },
        formality_level: "Nivel de Formalidad",
        formality_description: "Qu\xE9 tan consistente es el nivel de formalidad en todo el mensaje",
        formality_desc: {
          low: "Tu tono se mantiene estable a lo largo del mensaje",
          medium: "Tu escritura alterna entre lo casual y lo formal",
          high: "Un cambio claro en tu nivel de formalidad"
        },
        vocabulary_diversity: "Diversidad de Vocabulario",
        vocabulary_description: "Proporci\xF3n de palabras significativas \xFAnicas usadas en el mensaje",
        vocabulary_desc: {
          low: "Repites palabras clave -- esto puede sentirse enf\xE1tico",
          medium: "Una mezcla natural de frases familiares y variadas",
          high: "Amplio rango de palabras -- tu expresi\xF3n es variada"
        },
        subtitle: {
          consistent: "Tu estilo de comunicaci\xF3n se siente natural y estable",
          some_variation: "Tu tono cambia en algunos puntos -- vale un segundo vistazo",
          notable_shift: "Tu estilo de escritura cambia notablemente en este mensaje"
        },
        style_flags: "Indicadores de Estilo",
        no_anomalies: "No se detectaron anomal\xEDas",
        punctuation_pattern: {
          informal: "Informal",
          mixed: "Mixto",
          formal: "Formal"
        },
        accessibility: {
          toggle_details: "Alternar detalles del estilo de comunicaci\xF3n",
          formality_value: "Cambio de formalidad: {{value}}",
          vocabulary_value: "Diversidad de vocabulario: {{value}}"
        }
      },
      ai_detection: {
        header: "Perspectiva de Patr\xF3n de Comunicaci\xF3n",
        label: {
          natural: "Escrito naturalmente",
          mixed: "Patr\xF3n de comunicaci\xF3n mixto",
          likely_assisted: "Variaci\xF3n de estilo notable detectada"
        },
        status: {
          natural: "Estilo de comunicaci\xF3n natural",
          mixed: "Variaci\xF3n en el patr\xF3n de comunicaci\xF3n detectada",
          likely_assisted: "Cambio inusual en el patr\xF3n de comunicaci\xF3n"
        },
        pattern_confidence: "Confianza del Patr\xF3n",
        contributing_signals: "Se\xF1ales Contribuyentes",
        info_note: "Esta perspectiva compara el estilo del mensaje actual con tus patrones de escritura establecidos. Las variaciones son normales y pueden reflejar diferentes contextos o estados de \xE1nimo.",
        signal_name: {
          vocabulary_markers: "Marcadores de Vocabulario",
          formality_shift: "Cambio de Formalidad",
          punctuation_patterns: "Patrones de Puntuaci\xF3n",
          sentence_structure: "Estructura de Oraciones",
          em_dash_frequency: "Estilo de Puntuaci\xF3n"
        },
        context: {
          natural: "Tu escritura coincide con tus patrones habituales",
          mixed: "Algunas partes difieren de tu estilo habitual",
          likely_assisted: "Este mensaje difiere notablemente de tu referencia"
        },
        reasons: {
          natural: "Esto es t\xEDpico -- tu voz se transmite con claridad",
          mixed: "Causas comunes: tema diferente, estr\xE9s o plantillas",
          likely_assisted: "Puede reflejar: plantillas, herramientas de edici\xF3n o nuevo contexto"
        },
        suggestion: {
          mixed: "Intenta comparar con tus otros mensajes recientes",
          likely_assisted: "Revisa si esto suena como quieres que suene"
        },
        suggestion_dynamic: {
          vocabulary: "Tus elecciones de palabras cambiaron \u2014 si usaste una plantilla, considera personalizarla",
          formality: "El cambio de tono se nota \u2014 verifica si coincide con el contexto de la conversaci\xF3n",
          punctuation: "Tus h\xE1bitos de puntuaci\xF3n cambiaron \u2014 esto sucede a menudo al copiar texto",
          structure: "El ritmo de tus oraciones difiere \u2014 intenta leerlo en voz alta para verificar",
          punctuation_style: "Tu estilo de puntuaci\xF3n cambi\xF3 \u2014 com\xFAn al editar o usar herramientas de escritura",
          multiple: "Varios patrones cambiaron a la vez \u2014 esto sucede a menudo al cambiar de contexto"
        },
        takeaway: {
          natural: "Consistente con como escribes normalmente",
          mixed: "Toca para ver qu\xE9 patrones cambiaron",
          likely_assisted: "Toca para entender las diferencias de estilo"
        },
        signal_strength: {
          strong: "Fuerte",
          moderate: "Moderado",
          minor: "Menor"
        },
        signal_desc: {
          vocabulary_markers: "Las palabras elegidas difieren de tu vocabulario habitual",
          formality_shift: "El nivel de formalidad cambi\xF3 respecto a tu norma",
          punctuation_patterns: "Los h\xE1bitos de puntuaci\xF3n lucen diferentes a lo usual",
          sentence_structure: "La longitud y ritmo de las oraciones cambi\xF3 de lo t\xEDpico",
          em_dash_frequency: "El estilo de puntuaci\xF3n difiere de tu patr\xF3n habitual"
        },
        accessibility: {
          toggle_details: "Alternar detalles del patr\xF3n de comunicaci\xF3n",
          confidence_value: "Confianza del patr\xF3n: {{value}} por ciento"
        }
      },
      progressive_disclosure: {
        building_baseline: "Construyendo tu l\xEDnea base de escritura",
        analyses_count: "{{current}}/{{required}} an\xE1lisis",
        analyses_remaining: "{{remaining}} m\xE1s para desbloquear",
        early_insight: "Perspectiva temprana",
        early_insight_tooltip: "Basado en datos limitados \u2014 la precisi\xF3n mejora con m\xE1s an\xE1lisis",
        growing_confidence: "Confianza creciente",
        full_confidence: "Confianza total",
        insight_unlocked: "{{moduleName}} est\xE1 listo",
        upgrade_to_unlock: "Actualiza a Drama+ para desbloquear"
      }
    };
  }
});

// src/i18n/locales/es/history.json
var require_history2 = __commonJS({
  "src/i18n/locales/es/history.json"(exports, module) {
    module.exports = {
      history: {
        subtitle: "Tus an\xE1lisis anteriores",
        anon: {
          empty: {
            cta_analyze: "Analizar un mensaje"
          },
          cta: {
            headline: "Reg\xEDstrate para guardar tu historial 7 d\xEDas",
            body: "Ahora mismo tus an\xE1lisis desaparecen en 24 horas. Reg\xEDstrate gratis y se conservan 7 d\xEDas.",
            button: "Reg\xEDstrate para guardar tu historial"
          }
        }
      },
      history_item: {
        category: {
          safe: "Seguro",
          caution: "Precauci\xF3n",
          high_drama: "Drama Alto",
          extreme_drama: "Drama Extremo",
          unknown: "Desconocido"
        },
        time: {
          just_now: "Justo ahora",
          minutes_ago: "Hace {count}m",
          hours_ago: "Hace {count}h",
          days_ago: "Hace {days}d"
        },
        accessibility: {
          analysis_result: "Resultado de an\xE1lisis: {category}, puntuaci\xF3n {score}"
        }
      },
      history_grouping: {
        today: "Hoy",
        yesterday: "Ayer",
        this_week: "Esta Semana",
        this_month: "Este Mes"
      },
      episode_history: {
        title: "Historial de Episodios",
        swipe_hint: "Desliza para navegar episodios como cambiar canales de TV",
        accessibility: {
          list_label: "Historial de episodios. Desliza para ver {count} episodios"
        }
      },
      history_list: {
        empty: {
          title: "Sin Historial A\xFAn",
          message: "Tus mensajes analizados aparecer\xE1n aqu\xED. \xA1Ve a la pesta\xF1a de Inicio para analizar tu primer mensaje!",
          cta: "Ir a Inicio"
        },
        end_reached: "Has llegado al final de tu historial",
        errors: {
          load_failed: "Error al Cargar el Historial",
          pull_to_retry: "Desliza hacia abajo para reintentar"
        },
        load_more: "Cargar M\xE1s"
      }
    };
  }
});

// src/i18n/locales/es/settings.json
var require_settings2 = __commonJS({
  "src/i18n/locales/es/settings.json"(exports, module) {
    module.exports = {
      subtitle: "Administra preferencias y datos",
      sections: {
        subscription: "Suscripci\xF3n",
        account: "Cuenta",
        language: "Idioma",
        retention: "Retenci\xF3n de Datos",
        data: "Gesti\xF3n de Datos",
        app_info: "Informaci\xF3n de la App"
      },
      language: {
        title: "Idioma de la App",
        description: "Elige tu idioma preferido",
        english: "English (Ingl\xE9s)",
        spanish: "Espa\xF1ol",
        change_success: "Idioma cambiado a {language}"
      },
      retention: {
        title: "Eliminaci\xF3n Autom\xE1tica",
        description: "Elige cu\xE1nto tiempo se conservan tus datos de an\xE1lisis antes de la eliminaci\xF3n autom\xE1tica",
        days_30: "30 d\xEDas",
        days_60: "60 d\xEDas",
        days_90: "90 d\xEDas (predeterminado)",
        days_180: "180 d\xEDas",
        days_365: "1 a\xF1o",
        updating: "Guardando preferencia..."
      },
      cache: {
        clear: "Limpiar Cach\xE9",
        description: "Eliminar datos almacenados localmente",
        confirm_title: "Limpiar Cach\xE9",
        confirm_message: "Esto eliminar\xE1 todos los datos de an\xE1lisis almacenados en memoria y almacenamiento. Necesitar\xE1s conexi\xF3n a internet para recargar los datos.",
        success: "Cach\xE9 limpiado exitosamente de memoria y almacenamiento",
        error: "Error al limpiar el cach\xE9: {message}"
      },
      history: {
        clear: "Limpiar Historial",
        description: "Eliminar todos los registros de an\xE1lisis de este dispositivo",
        confirm_title: "Limpiar Historial",
        confirm_message: "\xBFEst\xE1s seguro de que quieres eliminar {count, plural, one {# registro de an\xE1lisis} other {# registros de an\xE1lisis}}? Esta acci\xF3n no se puede deshacer.",
        no_history: "Tu historial de an\xE1lisis ya est\xE1 vac\xEDo.",
        success: "Se eliminaron exitosamente {count, plural, one {# registro} other {# registros}}",
        error: "Error al limpiar el historial"
      },
      delete_data: {
        title: "Eliminar Todos Mis Datos",
        description: "Borrar permanentemente todos tus datos de nuestros servidores",
        confirm_title: "\xBFEliminar Todos los Datos?",
        confirm_message: "Esto eliminar\xE1 permanentemente TODOS tus datos incluyendo historial de an\xE1lisis, enlaces compartidos, preferencias y datos en cach\xE9. Esta acci\xF3n no se puede deshacer.",
        confirm_button: "Eliminar Todo",
        requires_auth: "Debes iniciar sesi\xF3n para eliminar tus datos.",
        success_title: "Datos Eliminados",
        success_message: "Todos tus datos han sido eliminados permanentemente ({count} registros eliminados).",
        error: "Error al eliminar los datos. Int\xE9ntalo de nuevo o contacta soporte."
      },
      account_actions: {
        sign_in: "Iniciar Sesi\xF3n",
        sign_out: "Cerrar Sesi\xF3n",
        signed_in_as: "Sesi\xF3n iniciada como",
        sign_out_confirm_title: "Cerrar Sesi\xF3n",
        sign_out_confirm_message: "\xBFEst\xE1s seguro de que quieres cerrar sesi\xF3n?"
      },
      subscription_manage: {
        title: "Administrar Suscripci\xF3n",
        description: "Ver planes y facturaci\xF3n"
      },
      family_plan: {
        title: "Plan Familiar",
        admin_description: "Administra los miembros de tu familia e invitaciones",
        member_description: "Ver los detalles de tu plan familiar"
      },
      practitioner_groups: {
        title: "Grupos de Profesionales",
        description: "{count, plural, one {# grupo} other {# grupos}} a los que perteneces"
      },
      practitioner_access: {
        title: "Acceso de Profesionales",
        description: "Controla lo que tus profesionales pueden ver"
      },
      practitioner_section: {
        title: "Profesional",
        open_dashboard: "Abrir Panel del Profesional",
        stats: "{clients} clientes activos \xB7 {earnings} este mes",
        certified: "Profesional Certificado"
      },
      about: {
        title: "Acerca de",
        coming_soon: "Pr\xF3ximamente"
      },
      privacy: {
        title: "Pol\xEDtica de Privacidad"
      },
      terms: {
        title: "T\xE9rminos de Servicio"
      },
      footer: {
        version: "DramaDetector v{version}",
        powered_by: "Desarrollado por NarrativeClarity.ai \u2764\uFE0F",
        tagline: "Tu evoluci\xF3n narrativa comienza aqu\xED."
      },
      auth: {
        not_authenticated: "No autenticado"
      },
      errors: {
        network_retry: "Error de red. Por favor, int\xE9ntalo de nuevo.",
        change_billing_cycle_with_status: "Error al cambiar el ciclo de facturaci\xF3n ({{status}})"
      },
      anon: {
        section_label: "Guarda tus datos",
        cta: {
          headline: "Reg\xEDstrate para guardar tu historial 7 d\xEDas",
          body: "Tus an\xE1lisis an\xF3nimos expiran en 24 horas. Reg\xEDstrate gratis y se conservan 7 d\xEDas \u2014 adem\xE1s de 10 an\xE1lisis al d\xEDa y mensajes de 1000 caracteres.",
          button: "Reg\xEDstrate gratis"
        }
      }
    };
  }
});

// src/i18n/locales/es/share.json
var require_share2 = __commonJS({
  "src/i18n/locales/es/share.json"(exports, module) {
    module.exports = {
      share: {
        button: "Compartir puntaje + resumen",
        dialog_title: "Compartir puntaje + resumen",
        modal: {
          title: "Compartir puntaje + resumen",
          subtitle: "Elige un formato p\xFAblico para compartir el puntaje, el impacto probable y el resumen",
          select_template: "Seleccionar plantilla",
          publish_result_link_title: "Publicar puntuaci\xF3n y resumen p\xFAblicos",
          publish_result_link_disclosure: "Solo tu puntuaci\xF3n de drama y resumen ser\xE1n p\xFAblicos.",
          revoke_result_link_title: "Revocar enlace p\xFAblico",
          revoke_result_link_disclosure: "Esto hace que este enlace p\xFAblico deje de estar disponible inmediatamente."
        },
        workflow: {
          description: "Elige c\xF3mo compartir el puntaje, el impacto probable y el resumen"
        },
        link_option: {
          title: "Compartir enlace p\xFAblico",
          description: "Copia un enlace p\xFAblico con puntaje, impacto probable y resumen",
          creating: "Creando enlace...",
          label: "Copiar enlace p\xFAblico",
          copied: "\xA1Copiado!"
        },
        explicit_result: {
          title: "Resultado compartido",
          score_label: "Puntuaci\xF3n de drama",
          summary_label: "Resumen"
        },
        voice: {
          narrator: "Narrador",
          expert: "Experto en Drama"
        },
        templates: {
          episode_framing: {
            title: "Episodio de tu vida",
            description: "Comparte como el episodio dram\xE1tico de tu vida",
            text: "Alerta de Episodio: Puntuaci\xF3n de drama {score}/10 en mi vida{context} \u{1F480}\n\nAntes en Mi Vida: todo estaba tranquilo.\nAhora: El drama se desat\xF3.\n\n\xBFQu\xE9 pas\xF3? {analysis}\n\nThe Narrator dice: {narratorQuote}\n\nNivel de caos: {chaosLevel}\n\n#DramaDetector #EpisodioReal"
          },
          pattern_recognition: {
            title: "Reconocimiento de Patrones",
            description: "Comparte el patr\xF3n que detect\xF3 tu experto",
            text: 'Mi experto en drama acaba de diagnosticarme con "{pattern}" y la verdad? No est\xE1 equivocado \u{1F62D}\n\nPuntuaci\xF3n: {score}/10\n{analysis}\n\n#DramaDetector #AutoconocimientoReal'
          },
          hollywood_narrator: {
            title: "The Narrator",
            description: "Deja que The Narrator narre tu drama",
            text: 'The Narrator acaba de narrar mi drama y no me arrepiento de nada:\n\n"{narratorQuote}"\n\nPuntuaci\xF3n de drama: {score}/10\n{context}\n\n#DramaDetector #TheNarrator'
          },
          minimal: {
            title: "Minimalista",
            description: "Compartir simple y limpio",
            text: "Puntuaci\xF3n de drama: {score}/10\n\n{analysis}\n\nAnalizado con DramaDetector"
          },
          advice_wisdom: {
            title: "Sabidur\xEDa del Experto en Drama",
            description: "Comparte el consejo \xFAtil que recibiste",
            text: "\xBFPor qu\xE9 mi experto en drama da mejor consejo que mis amigos reales? \u{1F4A1}"
          },
          reality_tv_commentary: {
            title: "Comentario de Reality TV",
            description: "Comparte el meta-comentario sobre tu mensaje",
            text: "Yo: *abro mensaje a las 11:47 PM*\n\nMi narrador: Puntuaci\xF3n de drama {score}/10\n\nMe siento TAN visto \u{1F440}"
          },
          basic: {
            title: "Compartir Resultados",
            description: "Plantilla b\xE1sica para compartir",
            text: "Acabo de obtener mi puntuaci\xF3n de drama: {score}/10\n\nRevisando mis mensajes antes de enviarlos ahora..."
          }
        },
        actions: {
          copy_text: "Copiar Texto",
          save_image: "Guardar Imagen",
          share: "Compartir",
          text_copied: "Texto copiado al portapapeles",
          image_saved: "Imagen guardada en Galer\xEDa"
        },
        errors: {
          generate_failed: "Error al generar tarjeta para compartir",
          save_failed: "Error al guardar imagen"
        },
        preview: {
          title: "Vista Previa",
          generating: "Generando vista previa..."
        }
      },
      share_card: {
        watermark: "DramaDetector.app",
        narrator: {
          score_label: "Puntuaci\xF3n de Drama:",
          attribution: "Narrado por el observador de tu historia",
          section_label: "NARRADOR"
        },
        expert: {
          header: "Mi Experto en Drama dijo...",
          attribution: "Experto en Drama por DramaDetector",
          section_label: "EXPERTO EN DRAMA"
        },
        context: {
          work: "\u{1F4BC} Trabajo",
          dating: "\u{1F495} Citas",
          family: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467} Familia",
          friends: "\u{1F465} Amigos"
        }
      }
    };
  }
});

// src/i18n/locales/es/stats.json
var require_stats2 = __commonJS({
  "src/i18n/locales/es/stats.json"(exports, module) {
    module.exports = {
      stats: {
        subtitle: "Tus patrones de comunicaci\xF3n",
        category_breakdown: "Desglose por Categor\xEDa",
        category_chart: {
          empty: "A\xFAn no hay datos de categor\xEDa disponibles"
        },
        category_patterns: {
          defensive_language: "Lenguaje Defensivo",
          aggressive_tone: "Tono Agresivo",
          passive_aggressive: "Pasivo Agresivo",
          unclear_communication: "Comunicaci\xF3n Poco Clara",
          positive_communication: "Comunicaci\xF3n Positiva"
        },
        labels: {
          total_analyses: "An\xE1lisis Totales",
          average_score: "Puntuaci\xF3n Promedio"
        },
        empty: {
          title: "Sin Estad\xEDsticas A\xFAn",
          message: "\xA1Empieza a analizar mensajes para ver tus patrones de comunicaci\xF3n y estad\xEDsticas aqu\xED!"
        },
        errors: {
          load_failed: "Error al Cargar Estad\xEDsticas",
          pull_to_retry: "Desliza hacia abajo para reintentar"
        },
        insights: {
          tip_label: "Consejo",
          lower_scores: "Puntuaciones promedio m\xE1s bajas indican patrones de comunicaci\xF3n m\xE1s claros y respetuosos."
        },
        pattern_description: "Tu patr\xF3n de comunicaci\xF3n m\xE1s com\xFAn basado en el historial de an\xE1lisis",
        anon: {
          empty: {
            cta_analyze: "Analiza un mensaje"
          },
          cta: {
            headline: "Estos patrones se reinician en 24 horas",
            body: "Reg\xEDstrate gratis para conservar tus estad\xEDsticas 7 d\xEDas y empezar a comparar semana a semana.",
            button: "Reg\xEDstrate para guardar tus estad\xEDsticas"
          }
        }
      }
    };
  }
});

// src/i18n/locales/es/content.json
var require_content2 = __commonJS({
  "src/i18n/locales/es/content.json"(exports, module) {
    module.exports = {
      producer_quips: {
        anxious_social_stalking_01: "Estamos haciendo investigaci\xF3n de oposici\xF3n sobre los otros personajes. Es como espiar dailies de otro set.",
        anxious_texting_pattern_01: "El protagonista est\xE1 analizando l\xEDnea \xFAnica de di\xE1logo por subtexto, convencido de que se\xF1ala giro mayor de trama.",
        anxious_are_we_okay_01: "El personaje sigue rompiendo cuarta pared para pedir seguridad al director. Necesitamos quedarnos en escena.",
        anxious_perfect_text_01: "Enviando guion para notas de cinco consultores diferentes. Para cuando est\xE9 aprobado, el momento habr\xE1 pasado.",
        anxious_disaster_plots_01: "La sala de guionistas solo est\xE1 pitcheando tramas de pel\xEDcula de desastres para mon\xF3logo interior de este personaje.",
        anxious_day_players_jealousy_01: "Estamos casteando muchos actores de d\xEDa atractivos para caminar por fondo de sus escenas. Parece estar creando drama deseado.",
        anxious_cleared_schedule_01: "El personaje principal despej\xF3 su programa de rodaje entero por si acaso el otro principal tiene apertura.",
        anxious_love_interest_trope_01: "Ah, el tropo cl\xE1sico 'introducir nuevo inter\xE9s amoroso' para impulsar ratings de l\xEDnea narrativa decayente.",
        anxious_sorry_loop_01: "El di\xE1logo de este personaje es solo loop de 'lo siento', incluso en escenas donde no han hecho nada mal.",
        anxious_recast_terror_01: "El actor est\xE1 aterrado de recibir nota \xFAnica del director, convencido de que est\xE1n a punto de ser recasteados.",
        anxious_bottle_episode_01: "La solicitud de episodio-botella fue tomada como se\xF1al de que cadena est\xE1 cancelando show entero.",
        anxious_market_research_01: "Estamos profundo en investigaci\xF3n de mercado, intentando predecir tendencias de audiencia en lugar de solo leer guion.",
        anxious_lighting_dependent_01: "La iluminaci\xF3n para este personaje depende completamente de iluminaci\xF3n del otro personaje. Si uno est\xE1 oscuro, ambos lo est\xE1n.",
        anxious_avoiding_conflict_01: "Los guionistas est\xE1n evitando conflicto real porque tienen miedo de que cadena escriba personaje principal fuera del show.",
        anxious_repeat_lines_01: "El personaje no tiene di\xE1logo original, solo repite l\xEDneas del otro protagonista. No es desempe\xF1o fuerte.",
        anxious_season_renewed_01: "\xA1La temporada fue renovada! Todo el equipo de producci\xF3n finalmente puede relajarse. Por ahora.",
        anxious_forensic_analysis_01: "Estamos ejecutando an\xE1lisis forense en dailies, buscando pistas en cada mirada y pausa.",
        anxious_dialogue_ratio_01: "El ratio de di\xE1logo est\xE1 mal. Un personaje tiene p\xE1ginas de guion, el otro tiene respuestas de una palabra.",
        anxious_character_rewrite_01: "Este personaje est\xE1 sufriendo reescritura completa para mejor ajustarse a marca de co-estrella. \xBFD\xF3nde fue su personalidad original?",
        anxious_tone_shift_01: "El tono de este show cambia de rom-com alegre a thriller psicol\xF3gico oscuro sin aviso.",
        anxious_live_feed_01: "Estamos solicitando feed en vivo del equipo de c\xE1mara de historia-B todo el tiempo. El personaje principal necesita saber qu\xE9 est\xE1 pasando.",
        anxious_silence_tension_01: "Es el silencio entre l\xEDneas el que est\xE1 creando toda la tensi\xF3n. El dise\xF1ador de sonido es genio. O s\xE1dico.",
        anxious_sizzle_reels_01: "Est\xE1s viendo sizzle reels de otros shows y pregunt\xE1ndote por qu\xE9 tus dailies no se ven tan pulidos.",
        anxious_too_big_performance_01: "El actor est\xE1 convencido de que su desempe\xF1o es muy grande para pantalla, as\xED que intentan hacerlo cada vez m\xE1s peque\xF1o.",
        anxious_too_small_performance_01: "El actor est\xE1 convencido de que su actuaci\xF3n es demasiado peque\xF1a para la pantalla, as\xED que intenta hacerla m\xE1s y m\xE1s grande.",
        dogfooding_dating_01: "Si esto existiera en ese entonces, podr\xEDa haber evitado tres rupturas y un caf\xE9 inc\xF3modo. Qu\xE9 suerte la tuya.",
        dogfooding_dating_02: "Us\xE9 esto en el texto de seguimiento despu\xE9s de la primera cita. La IA dijo 'bajo drama, buen tono'. Oxidado pero esperanzado.",
        dogfooding_dating_03: "Pas\xE9 'manteng\xE1moslo casual' por aqu\xED. La IA confirm\xF3 'claro y bajo drama'. Igual me ghoste\xF3. Su p\xE9rdida.",
        dogfooding_dating_04: "Analic\xE9 la respuesta a '\xBFa d\xF3nde va esto?' antes de enviarlo. Esta herramienta es terapia asequible.",
        dogfooding_dating_05: "Us\xE9 esto en el borrador del texto '\xBFqu\xE9 somos?'. La IA reescribi\xF3 de 'interrogatorio' a 'inicio de conversaci\xF3n'.",
        dogfooding_dating_06: "Analic\xE9 el texto de seguimiento de la cita. La IA detect\xF3 'bajo inter\xE9s'. Bueno saberlo. Siguiente.",
        dogfooding_dating_07: "Esta app es sala de guionistas para mi vida amorosa. Ayuda a mejorar las l\xEDneas de apertura.",
        dogfooding_dating_08: "Pas\xE9 'la pas\xE9 bien pero...' por aqu\xED. Encontr\xE9 forma de ser honesto sin ser brutal. Servicio p\xFAblico.",
        dogfooding_dating_09: "Escane\xE9 texto de mi ex. La IA lo marc\xF3 como 'migaja de pan'. Elimin\xE1ndolo ahora. Gracias, robot.",
        dogfooding_dating_10: "Elabor\xE9 el mensaje explicando mi agenda ca\xF3tica con esto. Son\xF3 dedicado, no desinteresado.",
        dogfooding_dating_11: "Analic\xE9 la bio del perfil de una posible cita. La IA marc\xF3 tres clich\xE9s y una bandera roja. M\xE1s eficiente que una primera cita.",
        dogfooding_dating_12: "Los textos de 'seamos solo amigos' ahora est\xE1n optimizados por IA para da\xF1o colateral m\xEDnimo.",
        dogfooding_dating_13: "Recib\xED '\xBFdespierto?' a las 2 a.m. No necesitaba IA para eso, pero la advertencia 'M\xE1ximo Drama' fue divertida.",
        dogfooding_dating_14: "La IA sugiri\xF3 agregar una pregunta al texto de seguimiento. Como hacer pruebas A/B de mi vida amorosa.",
        dogfooding_dating_15: "Descifr\xE9 la respuesta de una palabra 'ok' con esto. El an\xE1lisis de la IA fue una novela corta sobre agresi\xF3n pasiva.",
        dogfooding_dating_16: "Escrib\xED '\xBFpuedo recuperar mi sudadera?' con esto. La IA optimiz\xF3 para 'bajo drama, alta tasa de recuperaci\xF3n exitosa'.",
        dogfooding_dating_17: "Enviaron '\xA1la pas\xE9 genial!' No la pas\xE9. La IA redact\xF3 un final de serie cort\xE9s pero claro.",
        dogfooding_dating_18: "Est\xE1n planeando la tercera cita antes de que suceda la primera. La IA ayud\xF3 a frenar sin ser duro.",
        dogfooding_dating_19: "Recib\xED el discurso de 'no estoy listo para una relaci\xF3n'. Lo escane\xE9. La IA confirm\xF3 guion reciclado. Siguiente.",
        dogfooding_dating_20: "Redactando texto para alguien que me ghoste\xF3. La IA lo marca como 'reboot riesgoso'. No est\xE1 equivocado.",
        dogfooding_dating_21: "Analizando una semana de textos de se\xF1ales mixtas. Resumen de la IA: 'Motivaci\xF3n de personaje inconsistente'. Historia de mi vida.",
        dogfooding_dating_22: "Recib\xED foto no solicitada. No necesit\xE9 IA para analizar, pero la us\xE9 para redactar la respuesta 'pierde mi n\xFAmero'.",
        dogfooding_dating_23: "Elabor\xE9 respuesta ingeniosa a l\xEDnea de ligue terrible. La IA sugiri\xF3 apoyarse en lo cursi. Funcion\xF3 realmente.",
        dogfooding_dating_24: "Respondieron despu\xE9s de 18 horas. Sin respuesta. No voy a pasarlo por la app. Ok, pas\xE1ndolo. La IA dijo 's\xE9 paciente'. Ugh.",
        dogfooding_dating_25: "Redactando texto '\xBFes muy pronto para conocer a tus amigos?' La IA sugiri\xF3 fraseo casual. Como hacer test screening.",
        dogfooding_dating_26: "Escane\xE9 perfil de la cita despu\xE9s de conocernos. La IA encontr\xF3 4 'errores de continuidad' entre bio y realidad.",
        dogfooding_dating_27: "La cita no para de hablar de su ex. Analizando textos para encontrar banderas rojas que me perd\xED. Spoiler: las encontr\xE9.",
        dogfooding_dating_28: "Pas\xE9 'creo que deber\xEDamos ver a otras personas' por aqu\xED. La IA lo llam\xF3 'soft launch' de ruptura.",
        dogfooding_dating_29: "Analic\xE9 texto entrante buscando tono. La IA lo calific\xF3 como 'coqueto con intenci\xF3n'. Luz verde.",
        dogfooding_dating_30: "Escrib\xED texto pre-cita estableciendo expectativas con esto. 'Buscando algo casual'. Como logline para relaci\xF3n.",
        dogfooding_dating_31: "El texto '\xBFc\xF3mo dividimos esto?' IA redact\xF3 respuesta casual 'yo invito'. Inversi\xF3n en segunda temporada potencial.",
        dogfooding_dating_32: "Redactando texto 'entonces... \xBFborramos las apps?' IA lo frase\xF3 como pregunta casual y cool. No lo es.",
        dogfooding_dating_33: "Les encanta el show. Demasiado. IA dirige conversaci\xF3n lejos del trabajo. No quiero hablar de arcos narrativos.",
        dogfooding_dating_34: "Siguieron en tres plataformas a la vez. IA marc\xF3 'movi\xE9ndose muy r\xE1pido'. Los datos no mienten.",
        dogfooding_dating_35: "Textearon '\xBFno eres persona de gatos, verdad?' IA escribi\xF3 texto 'esto no va a funcionar'. Trato-rompe es trato-rompe.",
        dogfooding_dating_36: "Hice match con ejecutivo de cadena. IA analizando textos por conflictos de inter\xE9s. Podr\xEDa ser drama o comedia.",
        dogfooding_dating_37: "Textos son... muchos. Cumplidos constantes. IA marc\xF3 'bombardeo de amor'. Bueno tener segunda opini\xF3n neutral.",
        dogfooding_dating_38: "Usan emoji calavera mucho. IA decodific\xF3 significado generacional. Cosa buena, aparentemente.",
        dogfooding_dating_39: "Posteando foto 'lanzamiento-suave'. IA eligiendo una que dice 'viendo a alguien' no 'comprometido'.",
        dogfooding_dating_40: "Recib\xED 'te extra\xF1o' de ex. Lo pas\xE9 por app. An\xE1lisis IA: 'Drama alto, sinceridad baja'. Al archivo.",
        dogfooding_dating_41: "Texteador-de-p\xE1rrafos conoce texteador-de-una-l\xEDnea. IA ayudando a ser m\xE1s conciso. Como editar para formato diferente.",
        dogfooding_dating_42: "\xBFMuy pronto para texto 'buenos d\xEDas'? IA dice despu\xE9s de tres citas, bajo-riesgo. Como grupo focal para sentimientos.",
        dogfooding_dating_43: "Respondieron despu\xE9s de 18 horas. Sin respuesta. No pas\xE1ndolo por app. Okay, pas\xE1ndolo. IA dijo 's\xE9 paciente'. Ugh.",
        dogfooding_dating_44: "Redactando texto 'deber\xEDamos irnos fin de semana'. IA haci\xE9ndolo sonar espont\xE1neo, no prueba de relaci\xF3n.",
        dogfooding_dating_45: "Revelaron... opini\xF3n pol\xEDtica sorprendente v\xEDa texto. IA redactando respuesta 'hablemos despu\xE9s'. O nunca.",
        dogfooding_dating_46: "Aniversario de un mes. IA redact\xF3 texto dulce pero no exagerado. Manejando expectativas.",
        dogfooding_dating_47: "Analic\xE9 su himno de perfil con esto. Reporte IA: 'emocionalmente no-disponible pero le gusta bailar'. Suena correcto.",
        dogfooding_dating_48: "Quieren 'subirse a llamada'. IA redact\xF3 respuesta sugiriendo textear primero. Suficientes llamadas en trabajo.",
        dogfooding_dating_49: "Recib\xED texto 'no eres como otras personas con las que he salido'. IA marc\xF3 'bandera roja potencial'. Notado.",
        dogfooding_dating_50: "Redact\xE9 texto '\xBFqu\xE9 est\xE1s buscando?' con esto. IA lo hizo menos tipo-entrevista. Es investigaci\xF3n.",
        dogfooding_dating_51: "Primer mensaje despu\xE9s del match. La IA convirti\xF3 'hola' en pregunta sobre su foto del perfil. Efectivo.",
        dogfooding_dating_52: "Redactando texto de 'lo siento, no hay qu\xEDmica'. La IA lo hizo amable pero firme. Est\xE1ndares de la industria.",
        dogfooding_dating_53: "Su bio dice 'no drama'. La IA detect\xF3 iron\xEDa. Cada persona que dice eso trae drama.",
        dogfooding_dating_54: "Analizando tiempo de respuesta de textos. La IA encontr\xF3 patr\xF3n: r\xE1pido cuando quiere algo, lento cuando no.",
        dogfooding_dating_55: "Elabor\xE9 texto de 'no funcion\xF3' post-primera cita. La IA sugiri\xF3 desearles suerte. Clase.",
        dogfooding_dating_56: "Recib\xED '\xBFtodav\xEDa ah\xED?' despu\xE9s de dos d\xEDas sin responder. La IA redact\xF3 salida elegante. Ghosting mutuo.",
        dogfooding_dating_57: "Redactando texto de 'me voy de la ciudad'. La IA lo hizo sonar emocionante, no como excusa.",
        dogfooding_dating_58: "Su texto de 'estoy ocupado' se volvi\xF3 constante. La IA confirm\xF3 'desvanecimiento lento'. Siguiente.",
        dogfooding_dating_59: "Analic\xE9 el texto de 'tenemos que hablar'. La IA calific\xF3 10/10 ansiedad. Prepar\xE1ndome.",
        dogfooding_dating_60: "Redactando texto de 've\xE1monos de nuevo'. La IA optimiz\xF3 para sonar interesado, no desesperado.",
        dogfooding_dating_61: "Recib\xED emoji de berenjena. La IA redact\xF3 respuesta que dice 'no' sin decir 'eres desagradable'.",
        dogfooding_dating_62: "Elabor\xE9 texto de cumplea\xF1os. La IA sugiri\xF3 casual, no rom\xE1ntico. Todav\xEDa calibrando el nivel.",
        dogfooding_dating_63: "Su perfil dice 'alma vieja'. La IA lo tradujo como 'te juzgar\xE9 por tu m\xFAsica'.",
        dogfooding_dating_64: "Redactando texto de 'no funcionamos'. La IA quit\xF3 cada 'pero' que agregu\xE9. M\xE1s limpio.",
        dogfooding_dating_65: "Analic\xE9 texto de 'podemos ser amigos'. La IA lo calific\xF3 como 'amortiguador de ego'. Pasando.",
        dogfooding_dating_66: "Elabor\xE9 pregunta de seguimiento despu\xE9s de 'k'. La IA sugiri\xF3 no enviar nada. Buena nota.",
        dogfooding_dating_67: "Recib\xED p\xE1rrafo largo sobre su d\xEDa. La IA ayud\xF3 a igualar energ\xEDa sin escribir ensayo.",
        dogfooding_dating_68: "Redactando texto de 'salgamos pronto'. La IA lo hizo espec\xEDfico. Planes vagos = sin planes.",
        dogfooding_dating_69: "Su texto de 'c\xF3mo estuvo tu d\xEDa' lleg\xF3 a medianoche. La IA detect\xF3 'booty call disfrazado'.",
        dogfooding_dating_70: "Elabor\xE9 texto rechazando segunda cita. La IA equilibr\xF3 honestidad con amabilidad. Dif\xEDcil.",
        dogfooding_dating_71: "Analic\xE9 su uso de emojis. La IA encontr\xF3 patr\xF3n: caras sonrientes cuando me ignora, corazones cuando quiere algo.",
        dogfooding_dating_72: "Redactando texto de 'lo siento por cancelar'. La IA sugiri\xF3 ofrecer nueva fecha. Responsabilidad.",
        dogfooding_dating_73: "Recib\xED 'hey extra\xF1o' despu\xE9s de semanas. La IA redact\xF3 respuesta neutral. No cayendo en eso.",
        dogfooding_dating_74: "Elabor\xE9 texto de 'me gustas'. La IA lo hizo vulnerable pero no intenso. Equilibrio delicado.",
        dogfooding_dating_75: "Su bio menciona 'aventura'. La IA lo tradujo como 'tiene pasaporte, usar\xE1 tu Netflix'.",
        dogfooding_dating_76: "Redactando texto de 'necesito espacio'. La IA lo hizo claro sin sonar como ruptura. A\xFAn.",
        dogfooding_dating_77: "Analic\xE9 texto de 'somos exclusivos, \xBFverdad?' La IA lo detect\xF3 como bandera roja de inseguridad. Notando.",
        dogfooding_dating_78: "Elabor\xE9 texto de 'conoc\xED a tus amigos, no conect\xE9'. La IA lo suaviz\xF3. Pol\xEDtica.",
        dogfooding_dating_79: "Recib\xED 'deber\xEDamos hablar de nosotros'. La IA prepar\xF3 respuestas para tres escenarios. Estrat\xE9gico.",
        dogfooding_dating_80: "Redactando texto de 'me divert\xED anoche'. La IA equilibr\xF3 inter\xE9s con misterio. Arte de juego.",
        dogfooding_dating_81: "Su patr\xF3n de texto: siempre inicia despu\xE9s de las 10pm. La IA confirm\xF3 'situationship rojo brillante'.",
        dogfooding_dating_82: "Elabor\xE9 texto de 'vamos m\xE1s lento'. La IA lo hizo sonar como preferencia, no rechazo.",
        dogfooding_dating_83: "Analic\xE9 '\xBFquieres venir?' a las 11pm. La IA redact\xF3 declive que mantiene puerta abierta.",
        dogfooding_dating_84: "Redactando texto de 'extra\xF1o pasar tiempo juntos'. La IA lo calibr\xF3: dulce, no pegajoso.",
        dogfooding_dating_85: "Recib\xED doble texto despu\xE9s de tres horas. La IA detect\xF3 'ansioso pero genuino'. D\xE1ndole chance.",
        dogfooding_dating_86: "Elabor\xE9 texto de 'no estoy listo para conocer a tus padres'. La IA lo hizo honesto pero respetuoso.",
        dogfooding_dating_87: "Su texto de 'como sea' despu\xE9s de sugerencia de plan. La IA detect\xF3 agresi\xF3n pasiva. Marcando bandera.",
        dogfooding_dating_88: "Redactando texto de 'hablemos sobre lo de anoche'. La IA sugiri\xF3 llamada en lugar de texto. Buena nota.",
        dogfooding_dating_89: "Analic\xE9 su bio actualizada. La IA not\xF3 cambio sutil dirigido a m\xED. Interesante.",
        dogfooding_dating_90: "Elabor\xE9 texto de 'no puedo esta noche'. La IA agreg\xF3 sugerencia alternativa. Considera interesado.",
        dogfooding_dating_91: "Recib\xED 'est\xE1s molesto?' sin contexto. La IA redact\xF3 respuesta calmada. Desactivaci\xF3n.",
        dogfooding_dating_92: "Redactando texto de 'me gusta a d\xF3nde va esto'. La IA lo hizo optimista pero no presionante.",
        dogfooding_dating_93: "Su texto usa muchos puntos suspensivos... La IA lo detect\xF3 como 'comunicador pasivo-agresivo'.",
        dogfooding_dating_94: "Elabor\xE9 texto de 'seamos honestos sobre lo que queremos'. La IA lo estructur\xF3 como conversaci\xF3n, no ultim\xE1tum.",
        dogfooding_dating_95: "Analic\xE9 '\xBFsalimos o qu\xE9?' La IA lo calific\xF3 como intento de DTR poco rom\xE1ntico. Pasando.",
        dogfooding_dating_96: "Redactando texto de 'disfruto nuestro tiempo'. La IA balance\xF3 afecto con mantener cool.",
        dogfooding_dating_97: "Recib\xED mensaje de voz en lugar de texto. La IA sugiri\xF3 igualar el medio. Apreciando esfuerzo.",
        dogfooding_dating_98: "Elabor\xE9 texto de 'deber\xEDamos hablar de expectativas'. La IA lo hizo maduro, no aterrador.",
        dogfooding_dating_99: "Su patr\xF3n de texto cambi\xF3 repentinamente. La IA detect\xF3 'shift de inter\xE9s'. Investigando.",
        dogfooding_dating_100: "Redactando texto de 'me gustas mucho'. La IA calibr\xF3 vulnerabilidad sin intensidad. Apostando.",
        dogfooding_family_01: "Pas\xE9 ese texto para mam\xE1 por el analizador primero. Igual me pregunt\xF3 por qu\xE9 no llamo m\xE1s seguido. Resultado: 'drama moderado'. Suena correcto.",
        dogfooding_family_02: "La respuesta para el chat grupal familiar del D\xEDa de Acci\xF3n de Gracias pas\xF3 por el filtro. Marcado como 'agresi\xF3n pasiva'. Evaluaci\xF3n justa.",
        dogfooding_family_03: "Analic\xE9 la respuesta al drama del matrimonio de mi hermana. La herramienta recomend\xF3 'mantente neutral'. Todav\xEDa lo intento.",
        dogfooding_family_04: "Ese texto de 'ah\xED estar\xE9 para la cena' pas\xF3 por el analizador primero. Pap\xE1 igual detect\xF3 excusas. Peque\xF1os avances.",
        dogfooding_family_05: "Escane\xE9 el texto de mi hermana sobre planes navide\xF1os. La IA sugiri\xF3 desescalar. Result\xF3 que 'lo que sea' es una frase detonante.",
        dogfooding_family_06: "Analic\xE9 el texto de una palabra de pap\xE1: 'Llama'. Calificaci\xF3n de IA: 'Drama M\xE1ximo'. El algoritmo entiende la din\xE1mica familiar.",
        dogfooding_family_07: "Us\xE9 el analizador en la respuesta a esa solicitud de pr\xE9stamo del primo. Reescrib\xED para ser gentil pero firme. Un script doctor de la vida real.",
        dogfooding_family_08: "El texto de mam\xE1 sobre mi vida amorosa fue marcado como 'consejo no solicitado'. La tentaci\xF3n de captura de pantalla es real.",
        dogfooding_family_09: "Ese texto de 'no puedo ir a la reuni\xF3n familiar' pas\xF3 por el analizador. La reescritura fue b\xE1sicamente un piloto de comedia de sentimientos de culpa.",
        dogfooding_family_10: "Revis\xE9 el texto de 'felicidades por el beb\xE9 nuevo' con la herramienta. La IA sugiri\xF3 agregar un emoji. M\xE1s dif\xEDcil que decisiones de casting.",
        dogfooding_family_11: "El pitch de negocios de mi hermano entr\xF3 en la app. Resultado: 'alto riesgo, baja recompensa'. Misma evaluaci\xF3n que sus \xFAltimos tres pilotos.",
        dogfooding_family_12: "El chat grupal familiar es una sala de guionistas para una telenovela. Esta app sirve como supervisora de guion.",
        dogfooding_family_13: "Analic\xE9 la disculpa del aniversario. La IA recomend\xF3 un 'gesto m\xE1s grandioso'. Las implicaciones presupuestarias son preocupantes.",
        dogfooding_family_14: "Us\xE9 la herramienta para crear una respuesta a '\xBFcu\xE1ndo van a tener hijos?' La sugerencia de la IA fue una clase magistral en deflexi\xF3n.",
        dogfooding_family_15: "Pap\xE1 cuestion\xF3 por qu\xE9 el an\xE1lisis de texto necesita una app. Le envi\xE9 el an\xE1lisis de su \xFAltimo email. Comprensi\xF3n alcanzada.",
        dogfooding_family_16: "El texto de mi suegra pas\xF3 por el analizador. La IA sugiri\xF3 agregar tres signos de exclamaci\xF3n. Requisitos de cadena diferentes.",
        dogfooding_family_17: "Analic\xE9 el discurso pol\xEDtico del t\xEDo en el chat grupal. Respuesta sugerida por IA: 'Cancelar suscripci\xF3n'. Si tan solo funcionara.",
        dogfooding_family_18: "Us\xE9 el analizador para navegar la planificaci\xF3n de vacaciones familiares. M\xE1s complicado que la log\xEDstica de grabaci\xF3n en m\xFAltiples locaciones.",
        dogfooding_family_19: "El texto del sobrino pas\xF3 por traducci\xF3n. La IA convirti\xF3 Gen Z a espa\xF1ol. Todav\xEDa poco claro, pero ahora es posible responder.",
        dogfooding_family_20: "Escrib\xED un texto de 'por favor baja esa foto' para mi t\xEDa. La IA lo hizo educado, no vanidoso. Esos dailies quedaron poco favorecedores.",
        dogfooding_family_21: "Simplifiqu\xE9 esa descripci\xF3n de trabajo para el abuelo a trav\xE9s de esto. 'Ayudar a hacer las historias de la tele'. Todav\xEDa piensa que significa camar\xF3grafo.",
        dogfooding_family_22: "Filtr\xE9 esos textos de planificaci\xF3n de fiesta sorpresa para fugas. Seguridad m\xE1s estricta que un guion de final de temporada.",
        dogfooding_family_23: "El texto de mi hermano sobre el testamento de pap\xE1 pas\xF3 por el analizador. Marcado como 'especulaci\xF3n prematura'. Eso es decirlo suavemente.",
        dogfooding_family_24: "Analic\xE9 el comentario de mam\xE1 de 'te ves cansado'. La IA sugiri\xF3 'Es la iluminaci\xF3n'. Excusa cl\xE1sica de Hollywood.",
        dogfooding_family_25: "Redact\xE9 ese texto a los hermanos sobre la salud de mam\xE1 a trav\xE9s de esto. Como co-producir el proyecto m\xE1s dif\xEDcil hasta ahora.",
        dogfooding_family_26: "El texto de mi hermana sobre el corte de pelo 'interesante' obtuvo 95% de agresi\xF3n pasiva. El algoritmo no miente.",
        dogfooding_family_27: "Pas\xE9 el texto de 'nada de trabajo en la cena' primero. Agregu\xE9 un recordatorio gentil. Establecer l\xEDmites es preproducci\xF3n para la paz.",
        dogfooding_family_28: "Us\xE9 esto para declinar ser anfitri\xF3n del D\xEDa de Acci\xF3n de Gracias. La IA cre\xF3 una excusa tan buena que casi es cre\xEDble.",
        dogfooding_family_29: "Revis\xE9 ese texto sobre el nuevo novio de mi hermana. La IA elimin\xF3 'ay no'. Buena nota, robot.",
        dogfooding_family_30: "Pap\xE1 reenviaba otra teor\xEDa de conspiraci\xF3n. La IA ayud\xF3 a escribir '\xA1cosas fascinantes!' La versi\xF3n familiar de 'paso'.",
        dogfooding_family_31: "El texto de mam\xE1 fue solo 'computadora rota'. La IA redact\xF3 una respuesta que no empezara con '\xBFintentaste reiniciarla?'",
        dogfooding_family_32: "El primo quiere ser extra. La IA escribi\xF3 un texto de 'no hay vacantes' que sonaba arrepentido. El departamento de casting es el cortafuegos.",
        dogfooding_family_33: "Analic\xE9 el regalo de mi t\xEDa de un libro de autoayuda. La IA detect\xF3 'juicio sutil'. La asistente le enviar\xE1 una ensalada.",
        dogfooding_family_34: "Mi hermano envi\xF3 'Hollywood te cambi\xF3'. La IA sugiri\xF3 una respuesta menos defensiva. Solo soy mejor dando notas ahora.",
        dogfooding_family_35: "Escap\xE9 de ese responder a todos familiar sobre el potluck a trav\xE9s de esto. La IA cre\xF3 la salida perfecta. Bomba de humo digital.",
        dogfooding_family_36: "Pas\xE9 ese texto a madrastra por el analizador. La IA sugiri\xF3 un tono m\xE1s 'inclusivo'. M\xE1s dif\xEDcil que una fusi\xF3n corporativa.",
        dogfooding_family_37: "El texto de mi hermana sobre qui\xE9n se queda con el perro en Navidad es negociaci\xF3n de alto riesgo. La IA es el asesor legal.",
        dogfooding_family_38: "Expliqu\xE9 'residuals' a pap\xE1 a trav\xE9s de esto. La IA lo simplific\xF3. Todav\xEDa piensa que significa vacaciones la mayor parte del a\xF1o.",
        dogfooding_family_39: "Los padres est\xE1n reduciendo el tama\xF1o. Los textos de '\xBFquieres esto?' son implacables. La IA dijo 'no gracias' a los viejos trofeos.",
        dogfooding_family_40: "La t\xEDa sigue haciendo pitch de ideas de shows. La IA escribe '\xA1gran concepto!' \u2014 jerga de la industria para 'nunca va a pasar'.",
        dogfooding_family_41: "El chat de hermanos sobre la cita de pap\xE1 fue un desastre. Us\xE9 esto para redactar elementos de acci\xF3n. Alguien tiene que producir.",
        dogfooding_family_42: "La familia revis\xF3 el episodio de anoche. La IA tradujo 'estuvo un poco lento' a 'lo odiaron'.",
        dogfooding_family_43: "Pregunt\xE9 sobre traer un acompa\xF1ante a la boda a trav\xE9s de esto. La IA atenu\xF3 la ansiedad. Resultado: 'solicitud de alto riesgo'.",
        dogfooding_family_44: "Texto de los padres de 'ya llegamos'. La IA confirm\xF3 el tono de '\xBFpor qu\xE9 no est\xE1s aqu\xED todav\xEDa?' Todav\xEDa en reuni\xF3n.",
        dogfooding_family_45: "Mi hermana quiere cambiar una tradici\xF3n navide\xF1a. La IA redact\xF3 algo de mente abierta pero firme. Es una serie, no un reboot.",
        dogfooding_family_46: "El texto de mam\xE1 de 'me siento un poco mal'. La IA lo marc\xF3 como 'requiere seguimiento inmediato'. Conoce el subtexto mejor que nadie.",
        dogfooding_family_47: "Olvid\xE9 el cumplea\xF1os del primo. La IA redact\xF3 una disculpa mejor que 'el trabajo est\xE1 loco'. Siempre est\xE1 loco.",
        dogfooding_family_48: "Pap\xE1 est\xE1 probando GIFs ahora. Usando IA para interpretarlos. Como decodificar dailies de una pel\xEDcula extranjera.",
        dogfooding_family_49: "Medi\xE9 esa pelea sobre el testamento a trav\xE9s de esto. La IA sugiri\xF3 lenguaje de desescalada. La sala de guionistas m\xE1s dram\xE1tica hasta ahora.",
        dogfooding_family_50: "El sobrino envi\xF3 su enlace de obra escolar. La IA escribi\xF3 una cr\xEDtica brillante. A veces solo elogias la actuaci\xF3n.",
        dogfooding_work_01: "Pas\xE9 ese email de presupuesto a la cadena por esto. Pidiendo otro mill\xF3n sin sonar desesperado.",
        dogfooding_work_02: "Us\xE9 DramaDetector en las notas al director. Revis\xE9 dos veces. Igual odiadas, pero profesionalmente.",
        dogfooding_work_03: "Dando notas mientras esta app da notas sobre las notas al showrunner. Son notas todo el camino.",
        dogfooding_work_04: "Analic\xE9 ese email sobre la situaci\xF3n del actor principal. La IA dijo 'drama alto'. Sin bromear.",
        dogfooding_work_05: "Pas\xE9 el pitch deck por aqu\xED antes de que los inversionistas lo vieran. Igual rechazado, pero sonaba confiado.",
        dogfooding_work_06: "Escane\xE9 el email del estudio sobre sobrecostos de presupuesto. La IA elimin\xF3 80% de las disculpas. La confianza es clave.",
        dogfooding_work_07: "Us\xE9 esto en notas a un guionista. Marcado como 'ambiguo'. La reescritura fue m\xE1s limpia. Buena nota.",
        dogfooding_work_08: "Analic\xE9 texto a un agente dif\xEDcil. La app sugiri\xF3 m\xE1s halagos. Hollywood funciona con eso.",
        dogfooding_work_09: "Pas\xE9 ese rechazo de pitch por el detector. Sonaba decepcionado pero no despectivo. Arte delicado.",
        dogfooding_work_10: "Esta app navega notas de cadenas. Traduce 'hazlo pop' en feedback accionable.",
        dogfooding_work_11: "Redact\xE9 'vamos en una direcci\xF3n diferente' a trav\xE9s de esto. Equivalente corporativo de 'no eres t\xFA, soy yo'.",
        dogfooding_work_12: "Pas\xE9 el memo de 'estamos atrasados en cronograma' por aqu\xED. La IA lo hizo sonar como un desaf\xEDo creativo emocionante.",
        dogfooding_work_13: "Revis\xE9 esa respuesta al email sarc\xE1stico del rival. La IA sugiri\xF3 'm\xE1talos con amabilidad'. Jugando a largo plazo.",
        dogfooding_work_14: "La asistente usa esto para filtrar mensajes entrantes. Como tener una ejecutiva de desarrollo para la vida.",
        dogfooding_work_15: "Analic\xE9 la solicitud de extensi\xF3n de fecha l\xEDmite. La reescritura de la IA sonaba estrat\xE9gica en lugar de desesperada. La tomo.",
        dogfooding_work_16: "Pas\xE9 la respuesta de RR.HH. por esto. La IA elimin\xF3 toda personalidad. Que es, por supuesto, el punto.",
        dogfooding_work_17: "Redact\xE9 'sin comentarios' sobre la fuga del guion a trav\xE9s de esto. Sonaba misterioso, no en p\xE1nico. Crisis evitada.",
        dogfooding_work_18: "Recib\xED un guion del hijo del CEO. La IA escribi\xF3 feedback alentador pero tambi\xE9n un rechazo rotundo. Caminata en la cuerda floja.",
        dogfooding_work_19: "Analic\xE9 charla motivadora al equipo despu\xE9s de 16 horas. La IA sugiri\xF3 'caf\xE9 gratis'. Conoce el camino a sus corazones.",
        dogfooding_work_20: "Analic\xE9 reacci\xF3n de Twitter sobre la elecci\xF3n de casting. La puntuaci\xF3n de drama rompi\xF3 la app. Trending, al menos.",
        dogfooding_work_21: "Pas\xE9 contraoferta por la app. Sugiri\xF3 apertura m\xE1s fuerte. Esta cosa deber\xEDa tener un agente.",
        dogfooding_work_22: "Redact\xE9 la respuesta de 'fuera de oficina' a trav\xE9s de esto. La IA lo hizo sonar como tratados de paz, no margaritas.",
        dogfooding_work_23: "Medi\xE9 una guerra de emails entre director y showrunner con esto. Menos productor, m\xE1s negociador de rehenes.",
        dogfooding_work_24: "Escrib\xED recomendaci\xF3n de pasante con esto. IA lo mejor\xF3 de 'aceptable' a 'promisorio'. Llegar\xE1n lejos. O a alg\xFAn lado.",
        dogfooding_work_25: "Rechac\xE9 oferta de trabajo con esto. IA son\xF3 agradecido, no como escapando de un barco hundi\xE9ndose.",
        dogfooding_work_26: "Analic\xE9 solicitud de reuni\xF3n con el jefe del estudio. IA redujo palabras 50%. En este negocio, la brevedad es poder.",
        dogfooding_work_27: "Fusi\xF3n anunciada. Redact\xE9 memo 'calmado y confiado' con esto. Los textos personales fueron otra historia.",
        dogfooding_work_28: "Redact\xE9 agradecimiento a ejecutivo de cadena. IA sugiri\xF3 despedida casual. Aparentemente 'atentamente' es muy formal para Hollywood.",
        dogfooding_work_29: "Pas\xE9 eslogan de campa\xF1a Emmy por aqu\xED. IA lo llam\xF3 'confiado pero no arrogante'. Espero que los votantes est\xE9n de acuerdo.",
        dogfooding_work_30: "Redact\xE9 disculpa p\xFAblica por las... 'actividades de fin de semana' del protagonista con esto. Drama sin guion de verdad.",
        dogfooding_work_31: "Envi\xE9 el email 'tu puesto est\xE1 siendo eliminado'. IA lo hizo lo m\xE1s humano posible. Igual se siente como matar a un personaje.",
        dogfooding_work_32: "Analic\xE9 la invitaci\xF3n 'reuni\xF3n r\xE1pida' con esto. IA la marc\xF3 como 'mon\xF3logo sin guion de 90 minutos'. Correcto.",
        dogfooding_work_33: "Llegaron notas de integraci\xF3n de marca. '\xBFPuede el h\xE9roe beber nuestro refresco?' IA escribi\xF3 'no' cort\xE9s que no matar\xE1 el trato.",
        dogfooding_work_34: "Redactando evaluaci\xF3n de desempe\xF1o de asistente. IA balance\xF3 'necesita mejorar' con 'no renuncies a mitad de temporada'.",
        dogfooding_work_35: "Reporte de gastos rechazado. IA reescribi\xF3 la apelaci\xF3n. Negociando presupuesto ya gastado.",
        dogfooding_work_36: "Defend\xED el final de temporada con esto. IA quit\xF3 emoci\xF3n, agreg\xF3 'cumplimiento narrativo estrat\xE9gico'. La cadena lo compr\xF3.",
        dogfooding_work_37: "Recib\xED pitch del dentista. IA redact\xF3 'por favor env\xEDalo con tu agente'. Todos tienen guion en esta ciudad.",
        dogfooding_work_38: "El gremio envi\xF3 email fuertemente redactado. IA redact\xF3 respuesta conciliadora sin admitir culpa. Pura pol\xEDtica.",
        dogfooding_work_39: "Recib\xED email 'somos una familia aqu\xED' de corporativo despu\xE9s de despidos. Lo pas\xE9 por esto. Puntaje de iron\xEDa fuera de escala.",
        dogfooding_work_40: "Negociando ubicaci\xF3n de cr\xE9ditos. IA redact\xF3 algo firme pero no diva. Las batallas peque\xF1as.",
        dogfooding_work_41: "Pasante pidi\xF3 consejo de carrera. IA escribi\xF3 algo m\xE1s inspirador que 'huye'. Una buena acci\xF3n esta semana.",
        dogfooding_work_42: "Document\xE9 emails pasivo-agresivos de colega con esto. Como construir caso para salida de personaje.",
        dogfooding_work_43: "Hered\xE9 show en turnaround. IA ayudando a redactar memo de 'nueva visi\xF3n'. Menos reescritura, m\xE1s exorcismo.",
        dogfooding_work_44: "Escrib\xED referencia para ex-empleado terrible. IA balance\xF3 honestidad con no-difamaci\xF3n. 'Entusiasta' es buena palabra neutral.",
        dogfooding_work_45: "'Filtr\xE9 estrat\xE9gicamente' renovaci\xF3n a reportero con esto. IA cre\xF3 texto 'off the record'. Parte del juego.",
        dogfooding_work_46: "Jefe quiere 'discutir ideas conmigo'. IA ayud\xF3 a programar 30 minutos. Establecer l\xEDmites es trabajo tiempo completo.",
        dogfooding_work_47: "Analic\xE9 email legal. IA tradujo jerga en amenazas comprensibles. Mucho m\xE1s claro.",
        dogfooding_work_48: "Protagonista quiere 'colaborar' en guion. IA escribi\xF3 respuesta halagadora pero no-comprometida. Movida cl\xE1sica.",
        dogfooding_work_49: "Vet\xE9 chat grupal del equipo por violaciones HR con esto antes de gran reuni\xF3n. Pre-producci\xF3n para no ser demandado.",
        dogfooding_work_50: "Cafetera se rompi\xF3. Analic\xE9 cadena de emails de toda la oficina. Puntaje de drama m\xE1s alto que el \xFAltimo piloto.",
        dogfooding_friends_01: "Pas\xE9 el 'lo siento, no puedo llegar' por esto. La IA sugiri\xF3 mejor excusa. Se la creyeron. Esta cosa es diab\xF3lica.",
        dogfooding_friends_02: "Revis\xE9 respuesta del chat grupal antes de enviar. Evitar drama en grupos de amigos es deporte ol\xEDmpico.",
        dogfooding_friends_03: "Pas\xE9 'tenemos que hablar' por esto primero. El amigo realmente respondi\xF3. Peque\xF1as victorias.",
        dogfooding_friends_04: "Analic\xE9 respuesta a sesi\xF3n de desahogo del amigo. La herramienta dijo 'solidario, drama bajo'. Lo clav\xE9.",
        dogfooding_friends_05: "El amigo pidi\xF3 'picarte el cerebro' sobre su guion. La IA ayud\xF3 a establecer l\xEDmites. No tiene precio.",
        dogfooding_friends_06: "Analic\xE9 drama del chat grupal sobre lugar de cena. Esta app deber\xEDa ser obligatoria para grupos de amigos.",
        dogfooding_friends_07: "Declin\xE9 invitaci\xF3n a boda destino a trav\xE9s de esto. La versi\xF3n de la IA fue educada y vaga.",
        dogfooding_friends_08: "El 'tenemos que hablar' del amigo obtuvo 9/10 en escala de drama. Us\xE9 app para programar llamada. Al menos preparado.",
        dogfooding_friends_09: "Pas\xE9 'voy llegando tarde' por esto. La IA sugiri\xF3 ETA espec\xEDfica. Las cosas peque\xF1as previenen grandes peleas.",
        dogfooding_friends_10: "Medi\xE9 pelea de texto entre dos amigos con esto. Pacificador de la ONU, pero para planes de brunch.",
        dogfooding_friends_11: "Escane\xE9 texto vago y agresivo pasivo del amigo. La IA lo tradujo. Ah, *eso* es de lo que se trata.",
        dogfooding_friends_12: "Redact\xE9 texto a amigo que sigue cancelando. La versi\xF3n de la IA fue gentil pero clara. Prob\xE1ndolo ahora.",
        dogfooding_friends_13: "Revis\xE9 texto de '\xA1sin spoilers!' antes del final a trav\xE9s de esto. La IA confirm\xF3 'asertivo pero justo'.",
        dogfooding_friends_14: "El drama de relaci\xF3n del amigo m\xE1s complejo que arco narrativo de tercera temporada. Esta app ayuda a llevar la cuenta.",
        dogfooding_friends_15: "Usando esto para asegurar que textos de 'muy ocupado con trabajo' suenen disculpables, no presumidos. L\xEDnea fina.",
        dogfooding_friends_16: "El amigo envi\xF3 pitch MLM. La IA dijo 'no' sin arruinar amistad de 10 a\xF1os. Movida de productor.",
        dogfooding_friends_17: "Analic\xE9 cadena de texto de amigo que se aleja. La IA confirm\xF3 el subtexto. Como lectura de mesa para el final.",
        dogfooding_friends_18: "Sal\xED de configuraci\xF3n de cita ciega a trav\xE9s de esto. La IA dio tres excusas plausibles. El casting es todo.",
        dogfooding_friends_19: "Redact\xE9 solicitud de Venmo por cena de anoche. La IA sugiri\xF3 emoji de pizza para suavizar golpe.",
        dogfooding_friends_20: "La nueva pareja del mejor amigo es bandera roja caminante. La IA ayuda a frasear 'preocupaciones' diplom\xE1ticamente. Muy diplom\xE1ticamente.",
        dogfooding_friends_21: "Coordinar regalo grupal en hilo de texto m\xE1s dif\xEDcil que manejar presupuesto de serie. Esta app es productora de l\xEDnea.",
        dogfooding_friends_22: "Sal\xED de discusi\xF3n pol\xEDtica en chat grupal a trav\xE9s de esto. La IA sugiri\xF3 GIF perfectamente temporizado. Desescalada moderna.",
        dogfooding_friends_23: "El amigo consigui\xF3 trato enorme. La IA hizo '\xA1felicidades!' sonar genuinamente feliz. Tom\xF3 tres revisiones.",
        dogfooding_friends_24: "Recib\xED texto de '\xA1estabas en mi vecindario!' La IA redact\xF3 respuesta disculpable y vaga sobre horario.",
        dogfooding_friends_25: "Pas\xE9 '\xBFpuedes cuidar mi perro?' por esto. La IA sugiri\xF3 ofrecer pagar. Claro. Todos necesitan motivaci\xF3n.",
        dogfooding_friends_26: "Analic\xE9 GoFundMe del amigo para 'proyecto de arte'. La IA escribi\xF3 mensaje solidario sin donaci\xF3n real.",
        dogfooding_friends_27: "El amigo tuiteando en vivo su ruptura. Redact\xE9 '\xBFest\xE1s bien?' a trav\xE9s de esto sin alentarlos.",
        dogfooding_friends_28: "Consiguiendo 's\xED' o 'no' en planes de fin de semana. La IA reescribi\xF3 pregunta como 'gentilmente directa'. Probando en este personaje.",
        dogfooding_friends_29: "El amigo envi\xF3 guion. La IA escribi\xF3 notas m\xE1s 'constructivas' y menos 'quema esto inmediatamente'.",
        dogfooding_friends_30: "Escrib\xED disculpa real. La IA sugiri\xF3 eliminar excusas. Molesto, pero nota correcta.",
        dogfooding_friends_31: "Amigo consigui\xF3 trato enorme. IA revis\xF3 texto 'felicidades' para sonar genuinamente feliz. Tom\xF3 tres revisiones.",
        dogfooding_friends_32: "Textos de amigo todo sobre f\xF3rmulas de beb\xE9. IA ayuda a hacer preguntas correctas. Como aprender idioma nuevo.",
        dogfooding_friends_33: "Recib\xED texto 'se ve que te divertiste sin m\xED'. IA redact\xF3 respuesta que des-escal\xF3 el FOMO.",
        dogfooding_friends_34: "Otro texto '\xBFme puedes meter a estreno?' IA escribi\xF3 excusa 'boletos apretados'. Siempre apretados para esto.",
        dogfooding_friends_35: "Dos amigos terminaron. Redact\xE9 textos neutrales 'pensando en ti' para ambos con esto. Suiza, con asesor IA.",
        dogfooding_friends_36: "Me jalaron a drama entre dos personas apenas-conocidas. IA redact\xF3 texto 'me mantengo al margen'. No es mi show.",
        dogfooding_friends_37: "Amigo sigue compitiendo historias de trabajo. IA hace respuestas lo m\xE1s aburridas posible. Estrategia de des-escalamiento.",
        dogfooding_friends_38: "Reconectando con amigo de universidad. IA redact\xF3 texto que no fue inc\xF3modo. 'Hace tiempo sin vernos' es apertura dif\xEDcil.",
        dogfooding_friends_39: "Novio mala-idea de amiga finalmente se fue. IA redact\xF3 texto de apoyo en lugar de 'te lo dije'.",
        dogfooding_friends_40: "Expliqu\xE9 por qu\xE9 alguien no fue invitado a cena peque\xF1a. IA escribi\xF3 texto honesto pero amable. Reescritura delicada.",
        dogfooding_friends_41: "El amigo 'empecemos podcast'. IA escribi\xF3 respuesta alentadora pero no-comprometida. Nuevo guion.",
        dogfooding_friends_42: "Amigo m\xE1s viejo tiene... nuevas opiniones pol\xEDticas. IA ayuda a navegar textos para mantener paz. No hablar de Temporada 3.",
        dogfooding_friends_43: "Mejor amigo se muda lejos. IA escribi\xF3 texto que no fue total baj\xF3n. Final de serie de una era.",
        dogfooding_friends_44: "Instrucciones de riego de planta de amigo m\xE1s detalladas que desglose de guion. IA confirm\xF3 entendimiento. A\xFAn no entiendo.",
        dogfooding_friends_45: "Chat de fiesta sorpresa secreta es campo minado. IA asegura que respuestas no vayan a persona equivocada.",
        dogfooding_friends_46: "Amigo haciendo limpieza no deja de textear sobre ello. IA redact\xF3 respuesta de apoyo pero breve. Silenciando notificaciones.",
        dogfooding_friends_47: "Analic\xE9 'pregunta-suave' de amigo por dinero con esto. IA confirm\xF3 subtexto. Redactando respuesta 'no puedo ayudar' ahora.",
        dogfooding_friends_48: "Amigo quiere conectarme con su jefe. IA redact\xF3 cort\xE9s 'no gracias'. Mucho potencial para mala historia.",
        dogfooding_friends_49: "Redactando texto a amigo en ciudad nueva. IA sugiri\xF3 preguntas espec\xEDficas. '\xBFC\xF3mo va todo?' es callej\xF3n sin salida.",
        dogfooding_friends_50: "Hashtag de boda de amigo es desastre. IA sugiri\xF3 tres opciones mejores. No puedo evitarlo. Instinto de productor.",
        conflict_subject_changing_01: "Estamos recibiendo reescrituras constantes de guion en medio de escena. Los actores no pueden seguir el di\xE1logo nuevo.",
        conflict_sarcasm_subtext_01: "El di\xE1logo est\xE1 genial, pero es todo subtexto. Vamos a necesitar voz en off para explicar qu\xE9 significan realmente los personajes.",
        conflict_talk_later_pickup_01: "Siguen programando toma de pickup para esa escena, pero nunca llega a la hoja de llamado.",
        conflict_vague_answers_01: "Este di\xE1logo se siente como primer borrador. Necesita pasada de pulido para claridad y compromiso.",
        conflict_dramatic_sigh_01: "Agregando gran efecto de sonido para subrayar el drama. Es una elecci\xF3n. Bien ruidosa.",
        conflict_forgetting_continuity_01: "Error de continuidad mayor. La acci\xF3n de escena previa fue completamente abandonada. La supervisora de guion est\xE1 furiosa.",
        conflict_confessional_different_01: "El desempe\xF1o en set est\xE1 bien, pero la entrevista confesional est\xE1 contando historia completamente diferente.",
        conflict_busy_b_plot_01: "Al personaje principal le dieron trama-B muy conveniente y absorbente que lo mantiene lejos de historia principal.",
        conflict_notes_arthouse_01: "Los guionistas est\xE1n comunic\xE1ndose v\xEDa texto en pantalla ahora. Audaz. Muy arthouse.",
        conflict_mean_jokes_01: "El equipo de punch-up vino a agregar chistes, pero todos se sienten poco mal-intencionados. La audiencia de prueba puede notarlo.",
        conflict_resentful_fine_01: "El actor dijo la l\xEDnea, pero su desempe\xF1o est\xE1 gritando 'solo hago esto porque est\xE1 en mi contrato'.",
        conflict_development_hell_01: "Estamos atorados en infierno de desarrollo en este punto de trama. El estudio no puede decidir qu\xE9 direcci\xF3n tomar.",
        conflict_audio_issues_01: "Estamos recibiendo reportes de problemas de audio en set, pero solo cuando ciertos temas surgen. Extra\xF1o.",
        conflict_blocking_opposite_01: "El blocking para esta escena es interesante. Los personajes siempre est\xE1n ocupados en lados opuestos del set.",
        conflict_no_conflict_mandate_01: "El showrunner tiene mandato estricto 'sin conflicto'. Va a ser temporada muy aburrida.",
        conflict_meme_vfx_01: "Intentamos usar VFX para agregar algo de ligereza a escena dram\xE1tica. El tono ahora est\xE1 completamente mal.",
        conflict_insincere_adr_01: "Esa l\xEDnea fue entregada con el ADR m\xE1s poco-sincero y almibarado que he escuchado.",
        conflict_director_rogue_01: "El director est\xE1 tomando decisiones mayores de historia al vuelo sin consultar sala de guionistas. Esto no terminar\xE1 bien.",
        conflict_body_language_01: "El guion dice 'estoy bien', pero el desempe\xF1o del actor est\xE1 contando historia mucho m\xE1s interesante.",
        conflict_product_placement_01: "Ese es trato cl\xE1sico de product placement. Parece regalo, pero realmente es sobre su marca.",
        conflict_period_drama_shift_01: "El di\xE1logo de repente se volvi\xF3 incre\xEDblemente formal, como drama de \xE9poca. Es cambio de g\xE9nero raro para pieza contempor\xE1nea.",
        conflict_fatigue_crutch_01: "'Fatiga' es la motivaci\xF3n de personaje recurrente esta temporada. Es un poco muleta de guion, \xBFno?",
        escalation_kitchen_sink_01: "Los guionistas est\xE1n usando enfoque 'fregadero de cocina'. Cada l\xEDnea narrativa pasada est\xE1 siendo tirada a este episodio. Es desastre.",
        escalation_villain_edit_01: "El di\xE1logo ha degenerado en asesinato puro de personaje. Esto va a recibir edici\xF3n de villano seguro.",
        escalation_audio_peaking_01: "La mezcla de audio es desastre. Ambas pistas de di\xE1logo est\xE1n peaking y no hay espacio para que nadie respire.",
        escalation_practical_effects_01: "Agregando efectos pr\xE1cticos para aumentar el drama. Poco sobre-presupuesto, pero hace declaraci\xF3n.",
        escalation_clip_show_marathon_01: "Ahora estamos transmitiendo marat\xF3n de shows de clips de temporadas previas. \xBFEs pelea nueva o especial 'Grandes \xC9xitos'?",
        escalation_refusing_cut_01: "El director se reh\xFAsa a gritar corte, aunque actores est\xE1n claramente exhaustos y fuera de guion.",
        escalation_cancellation_tease_01: "Constantemente insinuando cancelaci\xF3n de serie es forma barata de crear drama. La audiencia se est\xE1 cansando del truco.",
        escalation_victim_competition_01: "Esto se convirti\xF3 en show de competencia de reality. \xBFEl premio? El t\xEDtulo de 'V\xEDctima M\xE1s Grande'.",
        escalation_parody_delivery_01: "Un actor empez\xF3 a parodiar la entrega de l\xEDneas del otro. Es poco profesional y matando autenticidad de escena.",
        escalation_ultimatum_power_01: "La cadena emiti\xF3 ultim\xE1tum: cambiar arco narrativo o enfrentar cancelaci\xF3n. Jugada de poder real.",
        escalation_tracking_shot_01: "Gran uso de toma tracking larga y continua mientras conflicto se mueve por diferentes locaciones. Muy tenso.",
        escalation_inciting_incident_01: "El incidente incitador fue menor, pero las consecuencias est\xE1n afectando l\xEDnea de tiempo del episodio entero.",
        escalation_cornered_blocking_01: "El blocking en esta escena se siente muy restrictivo. Un personaje est\xE1 literalmente arrinconado en set.",
        escalation_competing_monologues_01: "Esta no es escena de di\xE1logo, son dos mon\xF3logos compitiendo editados juntos.",
        escalation_false_motivation_01: "El guionista est\xE1 asignando motivaci\xF3n al personaje que no est\xE1 respaldada por desempe\xF1o. Se siente forzado.",
        escalation_fade_to_black_01: "Solo como que... fundimos a negro. Sin resoluci\xF3n, sin crecimiento de personaje. La audiencia de prueba va a estar confundida.",
        escalation_extras_chaos_01: "Elecci\xF3n audaz de montar gran confrontaci\xF3n dram\xE1tica con mont\xF3n de extras en toma. Lo hace m\xE1s ca\xF3tico.",
        escalation_running_lines_01: "Est\xE1s repasando l\xEDneas para escena que ni siquiera ha sido escrita todav\xEDa. Eso es pre-producci\xF3n seria.",
        escalation_apology_rewrite_01: "Esa fue reescritura de guion en medio de toma. La disculpa estaba en p\xE1gina, pero luego improvisaron justificaci\xF3n.",
        escalation_weaponized_backstory_01: "Los guionistas est\xE1n armamentizando historia de fondo de personaje para conflicto barato. Es efectivo, pero se siente cruel.",
        escalation_score_overpowering_01: "La m\xFAsica est\xE1 hinch\xE1ndose para sobrepasar completamente el di\xE1logo. No puedes escuchar el punto del personaje para nada.",
        escalation_conflicting_accounts_01: "Estamos recibiendo versiones conflictivas en dailies. La versi\xF3n de escena de alguien va a terminar en piso de sala de edici\xF3n.",
        escalation_text_graphics_01: "Este episodio est\xE1 siendo contado completamente a trav\xE9s de gr\xE1ficos en pantalla de mensajes de texto. Es largo. Muy largo.",
        boundary_hijacked_episode_01: "Esta estrella invitada acaba de secuestrar episodio con su propia historia de fondo tr\xE1gica. No ten\xEDamos presupuesto para esto.",
        boundary_uncredited_notes_01: "Estamos recibiendo muchas notas de guion de guionistas sin cr\xE9dito. Sus ideas... no est\xE1n ayudando.",
        boundary_reading_script_01: "El otro personaje acaba de romper cuarta pared y empez\xF3 a leer guion. Eso no est\xE1 permitido.",
        boundary_all_hours_01: "El tiempo de llamado de este personaje de apoyo se supone que es 9 a 5, pero siguen apareciendo en set a todas horas.",
        boundary_exhaustion_delivery_01: "El director solo est\xE1 alimentando al actor la misma l\xEDnea una y otra vez, esperando que entrega diferente emerja de puro agotamiento.",
        boundary_dangling_loan_01: "Hay subtrama sobre pr\xE9stamo que nunca fue resuelta. Es hilo de trama colgante que est\xE1 poniendo al departamento de presupuesto muy nervioso.",
        boundary_on_call_burnout_01: "El actor principal ahora est\xE1 de guardia 24/7. No est\xE1 en su contrato, y est\xE1 llevando a agotamiento.",
        boundary_surprise_character_01: "Un personaje sorpresa fue escrito en escena sin aviso. Los otros actores tienen que improvisar alrededor de ellos.",
        boundary_booking_without_checking_01: "El showrunner est\xE1 reservando locaciones y programando rodajes sin revisar disponibilidad del protagonista.",
        boundary_miscast_therapist_01: "Fuiste mal-casteado como terapeuta en set. Tu rol real es co-estrella.",
        boundary_pg_rating_01: "El di\xE1logo es poco demasiado gr\xE1fico para nuestra demograf\xEDa objetivo. Necesitamos editar esto para clasificaci\xF3n PG.",
        boundary_day_rate_same_01: "El programa de rodaje sigue haci\xE9ndose m\xE1s largo, pero tarifa diaria permanece igual.",
        boundary_roast_hit_piece_01: "El guion pide humor estilo roast, pero est\xE1 empezando a sentirse m\xE1s como pieza de ataque.",
        boundary_off_camera_scenes_01: "El personaje ahora est\xE1 desempe\xF1ando sus escenas m\xE1s importantes fuera de c\xE1mara. Estamos perdiendo historia completa.",
        boundary_props_moved_01: "Hemos dado a estrellas invitadas recurrentes acceso completo al set principal. Est\xE1n empezando a mover utiler\xEDa.",
        boundary_emotional_blackmail_01: "La motivaci\xF3n para acci\xF3n de este personaje est\xE1 listada como 'chantaje emocional'. No parece muy heroico.",
        boundary_cut_mid_sentence_01: "El editor est\xE1 cortando l\xEDneas del personaje a mitad de oraci\xF3n. Nunca llegamos a escuchar su pensamiento completo.",
        boundary_extreme_closeup_01: "La c\xE1mara est\xE1 haciendo close-up extremo cuando escena claramente pide toma amplia. Es inc\xF3modo.",
        boundary_documentary_invasive_01: "Esta entrevista documental se est\xE1 poniendo demasiado personal. El sujeto no acord\xF3 estas preguntas.",
        boundary_missing_props_01: "El departamento de utiler\xEDa est\xE1 reportando muchos art\xEDculos faltantes del set despu\xE9s de escenas de estrella invitada.",
        boundary_boom_mic_hovering_01: "El boom mic siempre est\xE1 flotando, incluso en escenas m\xE1s \xEDntimas. No hay privacidad en este set.",
        boundary_silent_observer_01: "El di\xE1logo del personaje fue cortado del acto final. Solo son observador silencioso ahora.",
        boundary_both_sides_dialogue_01: "Un actor ahora est\xE1 entregando ambos lados del di\xE1logo. Es desempe\xF1o interesante, pero no lo que fue escrito.",
        avoidant_not_big_texter_01: "El rasgo principal del personaje es que no les gusta modo primario de comunicaci\xF3n para este show. Es desaf\xEDo de guion.",
        avoidant_vague_finale_01: "El final de serie ha sido aprobado, pero guion es solo bosquejo vago sin escenas espec\xEDficas.",
        avoidant_unreachable_between_takes_01: "El desempe\xF1o es incre\xEDble en d\xEDas de rodaje, pero actor es completamente inalcanzable entre tomas.",
        avoidant_one_script_time_01: "La cadena no se comprometer\xE1 a orden de temporada completa. Solo est\xE1n ordenando guion a la vez.",
        avoidant_pilot_never_picked_01: "Este showrunner es famoso por episodios piloto brillantes que nunca son recogidos para serie completa.",
        avoidant_beloved_previous_01: "Siguen referenciando personaje amado de temporada previa, haciendo imposible que nuevo protagonista est\xE9 a la altura.",
        avoidant_less_depth_note_01: "La cadena envi\xF3 nota: 'Menos profundidad emocional, m\xE1s acci\xF3n'. Est\xE1 destripando coraz\xF3n de historia.",
        avoidant_wide_angle_cut_01: "Cada vez que c\xE1mara empuja para toma \xEDntima, director inmediatamente corta a \xE1ngulo amplio e impersonal.",
        avoidant_subplot_entire_show_01: "La subtrama del personaje principal se convirti\xF3 en show entero. La trama-A rom\xE1ntica recibe quiz\xE1 cinco minutos de tiempo en pantalla.",
        avoidant_improv_oneliner_01: "Estamos en escena m\xE1s dram\xE1tica de temporada, y actor empez\xF3 a improvisar one-liners.",
        avoidant_romance_to_drama_01: "El show es t\xE9cnicamente 'romance', pero departamento de marketing est\xE1 bajo \xF3rdenes estrictas de solo llamarlo 'drama'.",
        avoidant_written_out_mystery_01: "El personaje fue misteriosamente escrito fuera del episodio de semana pasada, pero ahora est\xE1n de vuelta sin explicaci\xF3n. Desconcertante.",
        avoidant_insignificant_details_01: "El director se est\xE1 atascando en detalles diminutos e insignificantes del desempe\xF1o para evitar rodar escena real.",
        avoidant_one_person_masquerade_01: "Este es show de una persona, disfraz\xE1ndose como pieza de conjunto.",
        avoidant_hollow_performance_01: "Las lecturas de l\xEDnea son t\xE9cnicamente perfectas, pero no hay coraz\xF3n detr\xE1s de ellas. El desempe\xF1o se siente vac\xEDo.",
        avoidant_retooled_show_01: "Est\xE1s enamorado del personaje del episodio piloto, pero show ha sido completamente retrabajado desde entonces.",
        avoidant_no_promo_joint_01: "El comunicado de prensa dice que elenco tiene qu\xEDmica incre\xEDble, pero reh\xFAsan hacer apariciones promocionales conjuntas.",
        avoidant_never_ensemble_01: "Este personaje nunca ha tenido escena con elenco principal de conjunto. \xBFSiquiera est\xE1n en mismo show?",
        avoidant_exit_clause_01: "El actor tiene cl\xE1usula de salida en contrato que les permite dejar show con solo aviso de un episodio.",
        avoidant_narrated_documentary_01: "Esta escena deber\xEDa ser confesi\xF3n sincera, pero est\xE1 siendo entregada como documental narrado.",
        avoidant_cut_for_time_01: "Las secuencias de acci\xF3n son incre\xEDbles, pero escenas tranquilas impulsadas-por-personaje est\xE1n todas siendo cortadas por tiempo.",
        avoidant_conflicting_notes_01: "Estamos recibiendo notas conflictivas de dos ejecutivos de estudio diferentes. El director no tiene idea qu\xE9 show se supone que est\xE1 haciendo.",
        avoidant_bottle_episode_budget_01: "Rodamos episodio grande y caro semana pasada, as\xED que ahora presupuesto solo permite 'episodio-botella' de locaci\xF3n-\xFAnica con un personaje.",
        avoidant_redacted_backstory_01: "La historia de fondo del personaje est\xE1 completamente redactada en guion. El actor no tiene nada con qu\xE9 trabajar.",
        avoidant_recurring_guest_01: "Fuiste casteado como estrella invitada recurrente, no regular de serie. Solo est\xE1s en episodios donde trama principal te necesita.",
        avoidant_walks_off_emotion_01: "El otro actor solo se va del set cuando su compa\xF1ero de escena muestra emoci\xF3n genuina.",
        gaslighting_overnight_rewrite_01: "Reescritura de noche a ma\xF1ana. Escena fue rodada, pero alguien meti\xF3 p\xE1ginas nuevas y pretendi\xF3 que original nunca sali\xF3 al aire.",
        gaslighting_selective_crop_01: "Trabajo de recorte selectivo. Estamos mirando timecode crudo; corte que venden recorta beats inconvenientes.",
        gaslighting_genre_swap_01: "Swap de g\xE9nero cl\xE1sico\u2014convirtiendo tu documental en melodrama para desacreditar filmaci\xF3n.",
        gaslighting_test_audience_01: "\xBFRetroalimentaci\xF3n an\xF3nima de audiencia de prueba? Linda historia. Muestra tarjetas o corta l\xEDnea.",
        gaslighting_stunt_rehearsal_01: "Re-marcar truco como ensayo no lo hace seguro. El moret\xF3n sigue en dailies.",
        gaslighting_penciled_clause_01: "Esa cl\xE1usula de contrato no est\xE1 en biblia del show. Alguien la escribi\xF3 a l\xE1piz despu\xE9s de table read.",
        gaslighting_meters_peaked_01: "Los medidores peakearon. No puedes gaslight una consola de sonido.",
        gaslighting_confession_montage_01: "Edici\xF3n inteligente\u2014convertir beat de empat\xEDa en montaje de confesi\xF3n completo.",
        gaslighting_props_continuity_01: "\xBFPersona de continuidad en huelga? Solo utiler\xEDa de un personaje est\xE1 llegando de escena a escena.",
        gaslighting_satire_punchline_01: "No lo llames s\xE1tira cuando punchline cae sobre mismo personaje cada episodio.",
        gaslighting_gas_leak_01: "\xBFFuga de gas en set, es? Porque filmaci\xF3n muestra que pas\xF3 a plena luz del d\xEDa.",
        gaslighting_offscreen_narrator_01: "Narrador fuera-de-pantalla repentinamente afirma omnisciencia. Esa es nota de productor, no hecho.",
        gaslighting_check_slate_01: "Revisa slate\u2014n\xFAmero de escena, toma y fecha todos coinciden. El reloj no es mentiroso aqu\xED.",
        gaslighting_splice_points_01: "Jump cuts estrat\xE9gicos alrededor de responsabilidad. Veo puntos de empalme.",
        gaslighting_on_camera_stereo_01: "Gracioso\u2014esas l\xEDneas est\xE1n en su boca en c\xE1mara y en est\xE9reo.",
        gaslighting_lighting_shook_01: "Los rigs de iluminaci\xF3n temblaron. No obtenemos jitter de c\xE1mara de 'calma'.",
        gaslighting_mirror_reversed_01: "Toma de espejo. El reflejo es convincente\u2014hasta que te das cuenta que est\xE1 invertido.",
        gaslighting_choreo_tripwire_01: "Re-enmarcar marca de compa\xF1ero de escena como trampa. Es coreograf\xEDa, no trampa explosiva.",
        gaslighting_choice_not_cue_01: "Ninguna nota de actor dice 's\xE9 cruel si provocado'. Esa es elecci\xF3n, no cue.",
        gaslighting_ripped_spine_01: "Alguien arranc\xF3 p\xE1gina de biblia del show y espera que nadie note lomo rasgado.",
        gaslighting_sweeping_generalization_01: "Generalizaci\xF3n arrasadora para evitar lista de tomas espec\xEDfica. Conveniente.",
        gaslighting_commentary_missing_01: "El comentario prometido del director sigue faltando fecha de lanzamiento.",
        gaslighting_press_kit_spin_01: "Spin de marca cara-al-p\xFAblico. El kit de prensa apenas se parece al show.",
        gaslighting_bad_dub_01: "Doblaje malo\u2014mismas l\xEDneas, nueva amenaza. Sincronizaci\xF3n de labios delata swap.",
        gaslighting_wide_shot_context_01: "La toma amplia muestra contexto por d\xEDas. No estamos atrapados en close-up aqu\xED.",
        gaslighting_details_truth_01: "Los detalles son c\xF3mo encontramos verdad. Pregunta a cualquier supervisora de guion con regla y mirada fulminante.",
        codependency_craft_services_01: "Un showrunner, dos protagonistas, cero autonom\xEDa. La mesa de craft services tiene opciones\u2014elige una.",
        codependency_standby_personality_01: "Standby no es personalidad. Tiempo de llamado es cuando historia realmente pasa.",
        codependency_merged_bio_01: "La bio de personaje se fusion\xF3. Necesitamos arcos separados, no login compartido.",
        codependency_live_tweeting_01: "Tweeteando en vivo tu relaci\xF3n no es trama\u2014es ticker.",
        codependency_solo_coverage_01: "Escena solo no es traici\xF3n. Es cobertura.",
        codependency_two_for_one_01: "Casteo dos-por-uno quiz\xE1 venda p\xF3sters, pero aplana desempe\xF1os.",
        codependency_emotional_adr_01: "ADR emocional en loop: 'lo siento' como pista temp bajo cada beat.",
        codependency_sizzle_fire_01: "Puliendo sizzle reel mientras set est\xE1 en fuego.",
        codependency_budget_spinoff_01: "Desviando presupuesto de temporada a spin-off. El show insignia sufre.",
        codependency_show_therapist_01: "Jugando terapeuta de show mientras tus propias escenas no se ruedan.",
        codependency_both_table_read_01: "Ejecutando ambos lados del table read. Eficiente, y completamente poco-saludable.",
        codependency_closed_set_01: "Energ\xEDa de set cerrado. Sin extras, sin estrellas invitadas, sin crecimiento.",
        codependency_security_violations_01: "Aprobando violaciones de seguridad porque truco 'se ve\xEDa cool en ensayo'.",
        codependency_note_cancellation_01: "Si cada nota significa cancelaci\xF3n, nadie aprende l\xEDneas.",
        codependency_committee_approval_01: "Vestuario y utiler\xEDa aprobados por comit\xE9. Lento, sin alegr\xEDa, adverso-al-riesgo.",
        codependency_separation_chemistry_01: "Ansiedad de separaci\xF3n enmarcada como 'qu\xEDmica'. La edici\xF3n dice otra cosa.",
        codependency_fixing_post_01: "Constantemente arregl\xE1ndolo en post. Eventualmente, l\xEDnea de tiempo se rompe.",
        codependency_echo_track_01: "Pista de eco activada. Est\xE9reo, sin contenido.",
        codependency_house_style_01: "Llamar falla de producci\xF3n estilo de casa.",
        codependency_first_person_plural_01: "Primera persona plural es genial para tours de prensa, no para mon\xF3logos interiores.",
        codependency_spinoff_calendar_01: "Tu calendario es spin-off del de ellos. Ratings para tuyo est\xE1n cayendo.",
        codependency_solo_b_plot_terror_01: "Trama-B solo aterroriza sala de guionistas\u2014sin co-protagonista para sostenerla.",
        codependency_group_monologue_01: "Table read grupal para mon\xF3logo. Algunas p\xE1ginas necesitan voz \xFAnica.",
        codependency_hostage_thriller_01: "Eso no es romance\u2014es thriller de rehenes con mejor iluminaci\xF3n.",
        codependency_pr_interference_01: "Ejecutando interferencia con spin de PR mientras break de acto se cae a pedazos.",
        codependency_no_personal_lease_01: "Reglas de casa compartidas, sin contrato personal. \xBFD\xF3nde est\xE1 tu llave?",
        codependency_light_meter_tied_01: "Medidor de luz atado a una cara. Look sombreado cuando fruncen ce\xF1o.",
        power_studio_ledger_01: "Un personaje ejecuta libro mayor de estudio; el otro ruega por caja chica para rodar escenas.",
        power_booked_hijack_01: "Locaciones reservadas, sin llamada al protagonista. Eso no es visi\xF3n\u2014es secuestro.",
        power_access_list_01: "Lista de acceso actualizada nocturnamente. Tus estrellas invitadas siguen siendo des-invitadas.",
        power_rush_golden_01: "Est\xE1s en llamado rush; ellos en hora dorada. Adivina qui\xE9n se ve impresionante en pantalla.",
        power_emotional_paywall_01: "Paywall emocional\u2014caracter\xEDsticas premium bloqueadas hasta que aceptes t\xE9rminos.",
        power_weaponized_jargon_01: "Jerga armamentizada como boom mic\u2014suficientemente ruidosa para ahogar tus l\xEDneas.",
        power_single_signon_01: "Sign-on \xFAnico con usuario admin \xFAnico. Est\xE1s navegando en modo invitado.",
        power_breakout_fan_01: "Narrativa de PR te enmarca como fan breakout\u2014nunca titular.",
        power_gps_chyron_01: "Tu GPS est\xE1 en chyron; el de ellos est\xE1 redactado como spoiler.",
        power_paternal_cut_01: "Corte paternal de director\u2014cada escena recortada para ajustar su tesis.",
        power_spreadsheet_locked_01: "Sesi\xF3n de notas a puerta cerrada. Tu arco de personaje vive en hoja de c\xE1lculo que no puedes abrir.",
        power_pyro_budget_01: "Presupuesto de pirotecnia pica cada vez que son cuestionados. Es l\xEDnea narrativa basada-en-miedo.",
        power_sponsor_ad_01: "Discurso de premios cortado por tiempo; ejecutamos anuncio de patrocinador en su lugar.",
        power_security_cam_01: "C\xE1mara de seguridad en greenroom. Eso no es intimidad\u2014es vigilancia.",
        power_styling_erase_01: "Notas de styling que borran personaje\u2014on-brand para ellos, off-brand para ti.",
        power_one_hot_mic_01: "Panel con un hot mic. Todos los dem\xE1s son pantomima.",
        power_day_rate_entitlement_01: "Llamar tarifa diaria est\xE1ndar 'derecho'. Claro, Jan.",
        power_renewal_reshoots_01: "Renovaci\xF3n contingente en reshoots que nunca acordaste.",
        power_iou_ledger_01: "Libro mayor de pagar\xE9s disfrazado como guion de romance.",
        power_intimacy_tbd_01: "Coordinador de intimidad reservado 'TBD' para siempre\u2014a menos que est\xE9n de humor.",
        power_after_credits_01: "Tus escenas movidas a despu\xE9s de cr\xE9ditos\u2014si tiempo permite.",
        power_b_roll_locations_01: "Un personaje tiene llaves; otro es dejado en locaciones de B-roll.",
        power_expert_comic_relief_01: "Experto en set es re-cortado como alivio c\xF3mico. Es mezquino, no gracioso.",
        power_funding_yanked_01: "Financiamiento retirado en tech scout. No puedes rodar sin poder.",
        power_refusing_ensemble_01: "Rehusando filmar con conjunto\u2014te mantiene fuera-de-balance y fuera-de-guion.",
        power_media_training_01: "Tip de entrenamiento de medios: deja que co-estrella tenga mic. No lo har\xE1n.",
        power_gravity_neutral_01: "Gravedad es neutral tambi\xE9n\u2014hasta que notas que cada pelota rueda a su lado del set.",
        defensiveness_tone_police_01: "Mezclando cr\xEDtica: 'Demasiado agudo en tu verdad'. Polic\xEDa de tono cl\xE1sica.",
        defensiveness_closing_arguments_01: "Argumentos de cierre sobre sem\xE1ntica mientras historia se desangra.",
        defensiveness_weaponized_recap_01: "Recap armamentizado\u2014previamente en 'Tus Errores', ahora transmitiendo sin fin.",
        defensiveness_hard_cut_tears_01: "Arco de redenci\xF3n instant\xE1neo insertado antes de que conflicto se resuelva. Hard cut a l\xE1grimas.",
        defensiveness_qa_tickets_01: "Sentimientos no son errores de continuidad. Deja de llenar tickets con QA.",
        defensiveness_exposition_dump_01: "Dump de exposici\xF3n para evitar beat real de escena. Audiencias desconectan.",
        defensiveness_unrequested_notes_01: "Notas de director no-solicitadas en corte bloqueado. No pedimos re-corte.",
        defensiveness_live_buzzer_01: "Fact-checker en vivo con buzzer\u2014genial para shows de quiz, malo para intimidad.",
        defensiveness_smoke_detector_01: "No culpes al detector de humo por el fuego.",
        defensiveness_punchup_accountability_01: "Pasadas de punch-up no pueden reemplazar break de acto faltante llamado responsabilidad.",
        defensiveness_4k_hdr_01: "No necesitas recibos 4K HDR para solicitar respeto b\xE1sico.",
        defensiveness_monday_morning_01: "Comentario de director de lunes-en-ma\xF1ana para escena que rehusaron rodar.",
        defensiveness_cross_examining_01: "Interrogando tu mon\xF3logo en lugar de escucharlo.",
        defensiveness_sloppy_wipe_01: "El 'pero' borra disculpa como transici\xF3n de wipe descuidada.",
        defensiveness_infinite_mirrors_01: "Toma de reacci\xF3n de toma de reacci\xF3n. Espejos infinitos, cero progreso.",
        defensiveness_commas_fire_01: "Discutiendo sobre comas mientras escena est\xE1 en fuego.",
        defensiveness_blaming_clapper_01: "Gritando 'acci\xF3n' en escena de check-in y culpando al clapper por drama.",
        defensiveness_salt_michelin_01: "De 'pasa la sal' a '\xBFquieres cocina estrella Michelin?' Escalamiento salvaje.",
        defensiveness_waveform_spikes_01: "Sensibilidad no es problema\u2014los picos en forma de onda lo son.",
        defensiveness_last_season_villain_01: "Villano de \xFAltima temporada protagonizando episodio calmado de esta semana.",
        defensiveness_playback_clear_01: "Rodamos dos c\xE1maras y boom; playback est\xE1 cristalino.",
        defensiveness_emotion_to_spec_01: "Reteniendo escena de reh\xE9n hasta que otro actor desempe\xF1e emoci\xF3n seg\xFAn especificaci\xF3n.",
        defensiveness_zero_pages_01: "Gran pitch en sala, cero p\xE1ginas entregadas.",
        defensiveness_recycling_broll_01: "Reciclando B-roll para evitar rodar material nuevo.",
        defensiveness_footage_villain_01: "El corte no te est\xE1 villainizando; la filmaci\xF3n lo est\xE1.",
        defensiveness_deal_memo_01: "Firm\xF3 memo de trato, ghoste\xF3 fecha de entrega.",
        defensiveness_bible_annotations_01: "Pidiendo anotaciones de biblia de show en nota de l\xEDnea-\xFAnica.",
        withdrawal_thousand_yard_01: "Mirada de mil yardas, profundidad de campo superficial. El sujeto ha derivado fuera de foco.",
        withdrawal_grunts_missing_01: "Di\xE1logo reducido a gru\xF1idos. No es minimalismo; est\xE1 faltando.",
        withdrawal_competing_screens_01: "Pantallas compitiendo. Tu escena est\xE1 tocando; sus ojos est\xE1n en otro canal.",
        withdrawal_spontaneous_wrap_01: "Gritando wrap espont\xE1neo porque sentimientos caminaron a set.",
        withdrawal_limbo_parking_01: "Estacionando l\xEDnea narrativa en limbo\u2014sin pickups, sin resoluci\xF3n.",
        withdrawal_lens_cap_01: "Cada vez que empujamos, tapa de lente se pone.",
        withdrawal_cello_kazoo_01: "Whiplash tonal\u2014swapeando partitura de cello por kazoo a mitad-de-confesi\xF3n.",
        withdrawal_dead_air_01: "Aire muerto en mic en vivo. El silencio es m\xE1s ruidoso que show.",
        withdrawal_cold_open_01: "Cold open sin personaje principal. Espectadores lo notan.",
        withdrawal_crowd_scene_01: "Grandes extras, co-estrella faltante. Se lee como escena de multitud.",
        withdrawal_emergency_montage_01: "Montaje de emergencia para evitar escena por la que todos sintonizaron.",
        withdrawal_calendar_invites_01: "Invitaciones de calendario en lugar de qu\xEDmica. Invitaci\xF3n declinada.",
        withdrawal_blackout_pages_01: "P\xE1ginas en negro donde historia de fondo deber\xEDa estar.",
        withdrawal_kicking_can_01: "Pateando lata a post. Spoiler: nunca llegamos a post.",
        withdrawal_props_disappearing_01: "Utiler\xEDa clave sigue desapareciendo. Dif\xEDcil jugar escena sin ellas.",
        withdrawal_subtitles_faces_01: "Subt\xEDtulos para escena que necesita caras, no fuentes.",
        withdrawal_paper_cut_lockdown_01: "Lockdown completo por corte de papel. Set est\xE1 sobre-asegurado.",
        withdrawal_b_roll_sunsets_01: "B-roll sin fin de puestas de sol\u2014sin entrevistas, sin insight.",
        withdrawal_marked_addressed_01: "Abri\xF3 guion, salt\xF3 escena, marc\xF3 como 'dirigido'.",
        withdrawal_losing_light_noon_01: "Siempre 'perdiendo luz' a mediod\xEDa.",
        withdrawal_statue_challenge_01: "Desaf\xEDo de estatua de actor\u2014ninguna direcci\xF3n los alcanza.",
        withdrawal_product_placement_shiny_01: "Swapeando di\xE1logo por product placement. Brillante, vac\xEDo.",
        withdrawal_preroll_ad_01: "Anuncio pre-roll emocional que nunca termina.",
        withdrawal_mid_season_hiatuses_01: "Hiatuses de media-temporada sin fin hasta que audiencia olvida trama.",
        withdrawal_mystery_box_01: "Caja misteriosa sin pistas. Eso no es suspenso\u2014es silencio en esmoquin.",
        withdrawal_driving_montage_01: "Montaje de conducci\xF3n exterior en cada acto. Escenas interiores no se ruedan.",
        withdrawal_flatline_waveform_01: "L\xEDnea plana en forma de onda emocional. Necesitamos se\xF1al, no ruido.",
        withdrawal_screen_test_empty_01: "Prueba de pantalla sin sujeto en silla.",
        pitching_01: "Analizando el pitch. Uno similar fue rechazado recientemente por un ejecutivo en sudadera.",
        pitching_02: "Esta historia tiene potencial. Ahora viene la parte donde doce ejecutivos liman las aristas lentamente.",
        pitching_03: "Procesando... Peores ideas han sido presentadas a Netflix. Compraron dos de ellas.",
        pitching_04: "Una nota cl\xE1sica: les encant\xF3 el pitch, pero quieren reescritura. Y un personaje diferente. Y una nueva trama.",
        pitching_05: "Evaluando la premisa. \xBFEs 'valiente' o 'limitante para la carrera'? Veamos.",
        pitching_06: "Espera, llama un agente. El 'proyecto de pasi\xF3n' ahora es 'gran descuento fiscal.'",
        pitching_07: "Actualmente en la versi\xF3n 14 del guion. El escritor original renunci\xF3 en la versi\xF3n 6. Buena se\xF1al.",
        pitching_08: "El feedback fue 'demasiado original'. Lo que usualmente significa que es hora de volver a los zombies.",
        pitching_09: "Esta es la parte del episodio donde una gran estrella se suma, solo para retirarse antes del rodaje.",
        pitching_10: "Lleg\xF3 el resultado del pitch: quieren 'Gladiador', pero con influencers, por menos dinero.",
        network_01: "El estudio quiere 'm\xE1s riesgo'. El h\xE9roe ya salv\xF3 el mundo. Dos veces.",
        network_02: "Nota de la cadena: '\xBFPuede el detective tener un perro peculiar y simp\xE1tico?' Por supuesto.",
        network_03: "Analizando feedback. La audiencia de prueba sinti\xF3 que el final era 'demasiado realista.'",
        network_04: "El mandato: 'Hazlo m\xE1s oscuro. Pero tambi\xE9n m\xE1s divertido. Y para audiencia m\xE1s joven. Pero conserva la crudeza.'",
        network_05: "Llega una nueva nota: 'Amamos el di\xE1logo, pero \xBFpueden hablar menos y textear m\xE1s?'",
        network_06: "El estudio quiere que el villano sea m\xE1s comprensivo. Este villano particular patea cachorros por diversi\xF3n.",
        network_07: "Por favor espera. Legal est\xE1 verificando si se puede usar el color azul en el episodio tres.",
        network_08: "Quieren cortar la escena m\xE1s cara. Que casualmente es la trama completa.",
        network_09: "Lleg\xF3 el feedback: '\xBFEsto podr\xEDa ser en el espacio? El espacio est\xE1 testeando bien este trimestre.'",
        network_10: "'Amamos al personaje, pero \xBFtiene que ser tan... competente?' S\xED, esa fue una nota real.",
        budget_01: "Una visi\xF3n \xE9pica para esta escena y un presupuesto que cubre el alquiler de un scooter.",
        budget_02: "Esa explosi\xF3n deb\xEDa ser m\xE1s grande. Tambi\xE9n el financiamiento.",
        budget_03: "Analizando el mensaje mientras intento hacer que tres extras parezcan un ej\xE9rcito romano.",
        budget_04: "El guion pide una mansi\xF3n. El presupuesto permite un cobertizo bien mantenido. Hora de soluciones creativas.",
        budget_05: "En producci\xF3n, 10% del d\xEDa es para el arte, 90% para discutir el precio del caf\xE9.",
        budget_06: "Y aqu\xED observamos un actor de clase mundial comiendo un burrito de gasolinera en una silla plegable. La magia del cine.",
        budget_07: "Bienvenido al cine: donde la mitad del trabajo es rogar por m\xE1s tiempo o m\xE1s dinero.",
        budget_08: "La escena final necesita un \xE1guila majestuosa. El presupuesto permite una paloma bien entrenada.",
        budget_09: "El equipo 'de \xFAltima generaci\xF3n' se sostiene con cinta americana y pura esperanza.",
        budget_10: "'No te preocupes, lo arreglaremos en post.' Una frase responsable de millones en sobrecostos.",
        talent_01: "En llamada con un agente. Est\xE1n asegurando que su cliente es perfecto para el papel.",
        talent_02: "El actor principal decidi\xF3 que el personaje ahora debe tener una cojera misteriosa. Espont\xE1neo.",
        talent_03: "Procesando... El director quiere filmar al amanecer. El equipo quiere dormir. Un enfrentamiento cl\xE1sico.",
        talent_04: "Por favor espera. Mediando una disputa entre la estrella y un pavo real de apoyo emocional.",
        talent_05: "El coordinador de acrobacias y el agente de seguros tienen una... discusi\xF3n acalorada.",
        talent_06: "Analizando el drama. En otro lugar, un showrunner acaba de renunciar v\xEDa mensaje cr\xEDptico.",
        talent_07: "El escritor est\xE1 en el set. Con... opiniones. Esto ser\xE1 divertido.",
        talent_08: "La estrella no saldr\xE1 del tr\xE1iler hasta localizar una marca espec\xEDfica de kombucha artesanal.",
        talent_09: "Haciendo malabares con tres llamadas mientras alguien necesita aprobaci\xF3n de un tono espec\xEDfico de beige. Bienvenido al set.",
        talent_10: "Los departamentos de peinado y vestuario no se hablan. Otra vez.",
        trends_01: "\xBFTiene esto potencial de franquicia? El algoritmo y la junta necesitan saber.",
        trends_02: "Verificando los datos... \xBFse alinea esta historia con los h\xE1bitos de visualizaci\xF3n del grupo demogr\xE1fico clave?",
        trends_03: "Esto es genial, pero \xBFpuede convertirse en un universo cinem\xE1tico de seis partes?",
        trends_04: "Analizando... La directiva es hacer esto 'm\xE1s viral' y 'menos historia.'",
        trends_05: "\xBFEs esto un reboot, un remake o una reimaginaci\xF3n? La respuesta afecta la estructura de bonos.",
        trends_06: "Marketing pregunta si su nueva bebida energ\xE9tica puede a\xF1adirse a la escena final.",
        trends_07: "El estudio acaba de comprar un juego de mesa. El guion vence en tres d\xEDas.",
        trends_08: "El pedido es una versi\xF3n cruda y realista de un amado personaje de caricatura. \xBFQu\xE9 podr\xEDa salir mal?",
        trends_09: "Todos quieren lo pr\xF3ximo grande, siempre que sea exactamente como lo \xFAltimo grande.",
        trends_10: "Veamos... \xBFtiene este drama una fanbase integrada? \xBFNo? Entonces \xBFcu\xE1l es el punto?",
        meta_01: "Analizando este drama. Tiene que ser mejor que los 200 emails sin leer sobre catering.",
        meta_02: "Dicen que entras a este negocio para crear arte. Terminas aprobando hojas de c\xE1lculo.",
        meta_03: "Analizando este conflicto mientras, en otro lugar, un tercer acto se desmorona completamente.",
        meta_04: "Los terapeutas recomiendan menos conflicto. Este analizador difiere.",
        meta_05: "\xBFEs esto un incidente incitador convincente? \xBFO solo otra reuni\xF3n de producci\xF3n? Analizando...",
        meta_06: "El objetivo es detectar drama, incluso cuando la producci\xF3n misma es un largo giro argumental irresoluble.",
        meta_07: "Procesando la historia. El material original es tragedia, pero el objetivo es dramedia.",
        meta_08: "El trabajo: resolver problemas ficticios para escapar de los muy reales y log\xEDsticos.",
        meta_09: "La iron\xEDa de usar un detector de drama cuando el calendario de producci\xF3n es una obra maestra ca\xF3tica.",
        meta_10: "Analizando la estructura de esta historia. Es menos ca\xF3tica que una serie de llamadas fren\xE9ticas. Esperemos.",
        user_focused_01: "Analizando lo que tienes. El \xFAltimo mensaje as\xED llev\xF3 a una cena muy inc\xF3moda.",
        user_focused_02: "Revisando este mensaje mientras producci\xF3n hace malabares con tres llamadas y crisis presupuestaria. Martes normal.",
        user_focused_03: "Analizando el texto. La bandeja de producci\xF3n tiene 200 mensajes sin leer, as\xED que sin presi\xF3n.",
        user_focused_04: "Verificando este mensaje en busca de drama. El calendario de producci\xF3n tiene suficiente para serie limitada.",
        user_focused_05: "Revisando este. La \xFAltima presentaci\xF3n ten\xEDa m\xE1s giros que un thriller de prestigio.",
        user_focused_06: "Evaluando el mensaje mientras asistentes recuerdan cuatro reuniones en diez minutos.",
        user_focused_07: "Analizando... El \xFAltimo texto revisado fue clase magistral en diplomacia. El anterior necesitaba reescritura.",
        user_focused_08: "Probando si pasa la prueba de drama. Toda gran l\xEDnea necesita un poco de pulido.",
        user_focused_09: "Revisando la presentaci\xF3n. Los terapeutas recomiendan ver menos conflicto. Esta herramienta difiere.",
        user_focused_10: "Verificando el mensaje en busca de se\xF1ales rojas. Un segundo par de ojos nunca hace da\xF1o.",
        user_focused_11: "Analizando mientras los tel\xE9fonos de producci\xF3n suenan sin parar. Otro d\xEDa, otra crisis.",
        user_focused_12: "Revisando este. La industria ha aprobado peores ideas que de alguna forma hicieron millones.",
        user_focused_13: "Evaluando el mensaje. El \xFAltimo revisado llev\xF3 a debate de tres horas. Esperemos algo mejor.",
        user_focused_14: "Analizando... El trabajo es detectar una chispa peque\xF1a antes de que se convierta en incendio forestal.",
        user_focused_15: "Revisando el texto mientras producci\xF3n aprueba \xF3rdenes de almuerzo simult\xE1neamente.",
        user_focused_16: "Analizando este mensaje. Tras revisar miles, est\xE1 claro que una gran historia puede venir de cualquier parte.",
        user_focused_17: "Verificando drama mientras el calendario de producci\xF3n colapsa. Solo otro lunes.",
        user_focused_18: "Analizando la presentaci\xF3n. Los riesgos se sienten altos. Hora de asegurar que esto aterrice perfectamente.",
        user_focused_19: "Revisando el mensaje. El \xFAltimo feedback fue llamado 'directo pero justo'. Veamos qu\xE9 necesita este.",
        user_focused_20: "Verificando este borrador. El genio se ha encontrado en los borradores m\xE1s bruscos antes."
      }
    };
  }
});

// src/i18n/locales/es/error_friendly.json
var require_error_friendly2 = __commonJS({
  "src/i18n/locales/es/error_friendly.json"(exports, module) {
    module.exports = {
      error_friendly: {
        suggestion: 'Si el problema persiste, toca "\xBFNecesitas ayuda?" a continuaci\xF3n.',
        hide_help: "Ocultar detalles",
        need_help: "\xBFNecesitas ayuda?",
        reference: "N\xFAmero de referencia",
        copy_for_support: "Copiar para soporte",
        copy: "Copiar"
      }
    };
  }
});

// src/i18n/locales/es/error_trace.json
var require_error_trace2 = __commonJS({
  "src/i18n/locales/es/error_trace.json"(exports, module) {
    module.exports = {
      error_trace: {
        toggle_details: "Alternar detalles del error"
      }
    };
  }
});

// src/i18n/locales/es/inline_annotations.json
var require_inline_annotations2 = __commonJS({
  "src/i18n/locales/es/inline_annotations.json"(exports, module) {
    module.exports = {
      inline_annotations: {
        view_original: "Ver Original",
        view_revised: "Ver Revisado",
        previous: "Anterior",
        next: "Siguiente",
        try_instead: "Prueba esto en su lugar:"
      }
    };
  }
});

// src/i18n/locales/es/mobile_app.json
var require_mobile_app2 = __commonJS({
  "src/i18n/locales/es/mobile_app.json"(exports, module) {
    module.exports = {
      title: "Aplicaci\xF3n M\xF3vil",
      confirm_title: "Confirmar Acci\xF3n",
      confirm_message: "\xBFEst\xE1s seguro de que quieres continuar?",
      confirm_button: "Confirmar",
      cancel: "Cancelar"
    };
  }
});

// src/i18n/locales/es/historyPremiumInsights.json
var require_historyPremiumInsights2 = __commonJS({
  "src/i18n/locales/es/historyPremiumInsights.json"(exports, module) {
    module.exports = {
      historyPremiumInsights: {
        pattern_recognition: {
          title: "Reconocimiento de Patrones",
          insights: "Patrones clave en tu historial de comunicaci\xF3n",
          description: "Descubre patrones recurrentes en tus mensajes"
        }
      }
    };
  }
});

// src/i18n/locales/es/practitioner.json
var require_practitioner2 = __commonJS({
  "src/i18n/locales/es/practitioner.json"(exports, module) {
    module.exports = {
      header: {
        app_title: "DramaDetector",
        role_badge: "Profesional"
      },
      greeting: {
        good_morning: "Buenos d\xEDas",
        good_afternoon: "Buenas tardes",
        good_evening: "Buenas noches"
      },
      stats: {
        active_clients: "Clientes Activos",
        analyses_this_month: "An\xE1lisis Este Mes",
        earnings_this_month: "Ganancias Este Mes",
        clients_improving: "Clientes Mejorando",
        member_since: "Miembro desde",
        analyses: "An\xE1lisis",
        tier: "Plan"
      },
      actions: {
        invite_client: "Invitar Cliente",
        share_link: "Compartir Enlace",
        invite_coming_soon: "Funci\xF3n de invitaci\xF3n pr\xF3ximamente",
        share_message: "\xDAnete a mi grupo de pr\xE1ctica de DramaDetector"
      },
      sections: {
        recent_analyses: "An\xE1lisis Recientes",
        view_all: "Ver Todo",
        no_analyses: "A\xFAn no hay an\xE1lisis recientes"
      },
      patterns: {
        criticism: "Cr\xEDtica elevada",
        stonewalling: "Bloqueo emocional",
        defensiveness: "Defensividad",
        contempt: "Desprecio",
        empathy: "Empat\xEDa mejorando"
      },
      partner: {
        header_title: "Panel de Socios",
        go_back: "Volver",
        this_month_label: "Este Mes",
        this_month_earnings: "Ganancias de este mes: {{amount}}",
        total_earned_label: "Total",
        pending_label: "Pendiente",
        commission_label: "Comisi\xF3n",
        commission_rate_pill: "Fundador {{rate}}%",
        referral_link_title: "Tu Enlace de Referido",
        copy_link_hint: "Toca para copiar tu enlace \xFAnico de referido",
        share_email: "Correo",
        share_sms: "SMS",
        share_qr: "C\xF3digo QR",
        funnel_title: "Embudo de Conversi\xF3n",
        funnel_invited: "Invitados",
        funnel_signed_up: "Registrados",
        funnel_subscribed: "Suscritos",
        funnel_active: "Activos",
        funnel_bar_a11y: "{{count}} {{stage}}, {{percent}} por ciento del total",
        founding_title: "Socio Fundador",
        certified_since: "Certificado desde {{date}}",
        founding_body: "Aseguraste una tasa de comisi\xF3n vitalicia del {{rate}}% como miembro fundador. Comparte tu credencial para generar confianza con los clientes.",
        download_badge: "Descargar Insignia",
        qr_title: "C\xF3digo QR",
        qr_coming_soon: "La funci\xF3n de c\xF3digo QR estar\xE1 disponible pr\xF3ximamente.",
        download_coming_soon: "La descarga de insignia estar\xE1 disponible pr\xF3ximamente."
      },
      client_view: {
        back: "Volver a la lista de clientes",
        consent_level: "Nivel de acceso: {{level}}",
        sharing_level_scores: "Puntuaciones y Patrones",
        sharing_level_full: "Historial Completo"
      },
      consent: {
        scores_and_patterns: "Puntuaciones y Patrones",
        full_history: "Historial Completo",
        original_text: "Texto Original"
      },
      tier: {
        free: "Gratuito",
        drama_plus: "Drama+",
        dramax: "DramaX"
      },
      prep_card: {
        title: "Notas de Preparaci\xF3n de Sesi\xF3n (IA)"
      },
      prep_note: {
        improving: "Mejorando",
        persistent: "Persistente",
        suggested: "Sugerido"
      },
      pattern_trends: {
        title: "Tendencias de Patrones"
      },
      pattern_bar: {
        a11y: "{{name}}: puntuaci\xF3n {{score}}, {{trend}}"
      },
      trend: {
        improving: "mejorando",
        stable: "estable",
        worsening: "empeorando"
      },
      history: {
        title: "Historial de An\xE1lisis",
        total: "total",
        new_pattern: "nuevo",
        pending_approval: "Pendiente de aprobaci\xF3n",
        score: "Puntuaci\xF3n"
      },
      privacy_notice: {
        message: "Texto original oculto \u2014 el cliente no ha habilitado el acceso"
      },
      chat: {
        session_notes: "Notas de Sesi\xF3n",
        via_sendbird: "Chat v\xEDa Sendbird",
        placeholder: "Agregar una nota\u2026",
        send: "Enviar mensaje",
        thread_label: "Hilo de chat con {{client}}"
      },
      consent_gate: {
        history: {
          title: "Acceso al historial no habilitado",
          body: "Este cliente no ha compartido su historial de an\xE1lisis contigo. P\xEDdele que actualice su configuraci\xF3n de acceso."
        }
      },
      accessibility: {
        notifications: "Notificaciones",
        profile: "Perfil de {{name}}",
        stat_active_clients: "{{count}} clientes activos{{delta}}",
        stat_analyses: "{{count}} an\xE1lisis este mes{{delta}}",
        stat_earnings: "{{amount}} ganancias este mes",
        stat_improving: "{{percent}}% de clientes mejorando",
        analysis_row: "{{client}}: {{pattern}}, {{date}}, puntuaci\xF3n {{score}}",
        view_all_analyses: "Ver todos los an\xE1lisis"
      }
    };
  }
});

// src/i18n/locales/es/practitioner_consent.json
var require_practitioner_consent2 = __commonJS({
  "src/i18n/locales/es/practitioner_consent.json"(exports, module) {
    module.exports = {
      screen: {
        title: "Acceso de Profesionales"
      },
      explainer: {
        body: "Controla lo que tus profesionales pueden ver. Tus conversaciones son privadas por defecto."
      },
      card: {
        status: {
          active: "Activo",
          pending: "Pendiente"
        },
        role_since: "{{role}} \xB7 A\xF1adido {{date}}",
        role_invited: "{{role}} \xB7 Invitado {{date}}"
      },
      toggle: {
        view_history: "Ver historial de an\xE1lisis",
        view_history_sub: "Puntuaciones, patrones y fechas",
        view_messages: "Ver mensajes originales",
        view_messages_sub: "El texto de tu conversaci\xF3n",
        allow_comments: "Permitir comentarios",
        allow_comments_sub: "El profesional puede dejar notas de sesi\xF3n",
        require_approval: "Requerir aprobaci\xF3n por an\xE1lisis",
        require_approval_sub: "Revisar antes de compartir cada resultado",
        crisis_notifications: "Notificaciones de crisis",
        crisis_notifications_sub: "Alertar al profesional en situaciones urgentes",
        crisis_urgency: "Nivel de urgencia en crisis",
        crisis_urgency_sub: "Establecer prioridad de alerta",
        crisis_urgency_sub_disabled: "Activa primero las notificaciones de crisis",
        crisis_contact: "M\xE9todo de contacto",
        crisis_contact_sub: "C\xF3mo contactar a tu profesional",
        crisis_contact_sub_disabled: "Activa primero las notificaciones de crisis"
      },
      pending_banner: {
        message: "Esperando que {{name}} acepte la invitaci\xF3n. Los permisos estar\xE1n disponibles una vez aceptada."
      },
      revoke: {
        active_label: "Revocar Acceso",
        pending_label: "Cancelar Invitaci\xF3n",
        confirm_title: "\xBFEliminar profesional?",
        confirm_body: "Perder\xE1n acceso a tus datos inmediatamente.",
        confirm_cta: "Eliminar"
      },
      accordion: {
        title: "\xBFQu\xE9 pueden ver?",
        history_on: {
          label: "Historial de an\xE1lisis ACTIVADO",
          detail: "Solo puntuaciones, fechas y patrones principales. Sin texto."
        },
        messages_off: {
          label: "Mensajes originales DESACTIVADOS",
          detail: "El texto completo de tu conversaci\xF3n permanece privado."
        },
        messages_on: {
          label: "Mensajes originales ACTIVADOS",
          detail: "El profesional puede ver el texto de tu conversaci\xF3n."
        },
        crisis: {
          label: "Notificaciones de crisis",
          detail: "Si est\xE1 activado, el profesional recibe una alerta cuando se detecta un patr\xF3n de alto riesgo."
        }
      },
      empty: {
        title: "No hay profesionales conectados",
        description: "Cuando un profesional te invite a su grupo, podr\xE1s gestionar su acceso aqu\xED."
      },
      error: {
        load_failed: "No se pudo cargar la configuraci\xF3n del profesional. Toca para reintentar.",
        retry: "Intentar de nuevo"
      }
    };
  }
});

// src/i18n/locales/es/messaging.json
var require_messaging2 = __commonJS({
  "src/i18n/locales/es/messaging.json"(exports, module) {
    module.exports = {
      bubble: {
        action_show_rewrites: "Show rewrites",
        action_copy_text: "Copy text",
        action_report: "Report",
        status_sending: "Sending",
        status_failed: "Failed to send",
        a11y_from_you: "Message from you",
        a11y_from_sender: "Message from {{sender}}",
        action_cancel: "Cancel",
        narrator_collapse: "Show less",
        narrator_expand: "Show more",
        narrator_show_less: "Show less",
        narrator_show_more: "Show more"
      },
      row: {
        untitled: "New conversation",
        empty_preview: "Say hello \u{1F44B}",
        a11y_label: "Conversation with {{title}}",
        a11y_label_unread: "Conversation with {{title}}, {{count}} unread",
        unread_badge: "{{count}} unread messages",
        time_now: "now",
        time_yesterday: "yesterday"
      },
      empty: {
        title: "No conversations yet",
        subtitle: "Start a chat to get personalized drama de-escalation guidance in real time.",
        cta: "Start your first chat"
      },
      upsell: {
        card: {
          title: "Unlock Drama+ Chats",
          subtitle: "Get real-time drama de-escalation guidance, conversation coaching, and pattern insights \u2014 all in a private chat with your DramaDetector coach.",
          feature_1: "Unlimited coaching conversations",
          feature_2: "Message rewrites on demand",
          feature_3: "Pattern-aware follow-ups",
          cta: "Upgrade to Drama+"
        },
        modal: {
          tab_tap: {
            title: "Unlock Chats",
            subtitle: "Drama+ turns DramaDetector into a private coach that remembers.",
            feature_1: "Persistent conversations with your coach",
            feature_2: "Per-message scoring and rewrites",
            feature_3: "Unlimited conversation history",
            cta_primary: "Upgrade to Drama+",
            cta_secondary: "Maybe later"
          },
          quota_exhausted: {
            title: "You're out of analyses today",
            subtitle: "Drama+ gets you 10x more every day \u2014 never get cut off mid-thread.",
            feature_1: "100 analyses per day (vs 10 on free)",
            feature_2: "Persistent chat with per-message scoring",
            feature_3: "Priority support when it matters",
            cta_primary: "Upgrade to Drama+",
            cta_secondary: "Wait until reset"
          },
          conversation_limit: {
            title: "Conversation limit reached",
            subtitle: "Drama+ removes the cap so you can keep every thread with every person.",
            feature_1: "Unlimited active conversations",
            feature_2: "Per-message scoring across all threads",
            feature_3: "Full history, forever",
            cta_primary: "Upgrade to Drama+",
            cta_secondary: "Not now"
          },
          a11y_dismiss: "Dismiss upsell"
        }
      },
      quota: {
        exhausted: "Out of analyses",
        exhausted_a11y: "Out of analyses. {{resetLabel}}. Tap to upgrade.",
        upgrade_cta: "Upgrade to Drama+",
        upgrade_short: "Upgrade",
        remaining: "{{count}} left",
        remaining_today: "{{count}} left today",
        remaining_a11y: "{{count}} analyses left today",
        remaining_full: "{{remaining}} of {{limit}} analyses left",
        remaining_full_a11y: "{{remaining}} of {{limit}} analyses left. {{resetLabel}}.",
        resets_soon: "Resets soon",
        resets_in: "Resets in {{minutes}}m",
        resets_at: "Resets at {{time}}",
        full_exhausted_body: "{{resetLabel}}. Upgrade to Drama+ for 10x more analyses every day.",
        upgrade_more_a11y: "Upgrade for more analyses",
        dramax_exhausted_title: "Analyses reset soon",
        dramax_exhausted_body: "You've used all your analyses today. They reset at {{time}}."
      },
      thread: {
        default_title: "DramaDetector Coach",
        tap_to_rename: "Tap to rename",
        empty: "Send the first message in this conversation",
        error: "Couldn't load messages",
        retry: "Retry",
        composer_placeholder: "Type a message\u2026",
        composer_placeholder_exhausted: "Quota exhausted \u2014 upgrade to continue",
        a11y_back: "Back to conversations",
        a11y_edit_title: "Edit conversation title",
        a11y_options: "Conversation options",
        a11y_send: "Send message",
        rename_title: "Rename conversation",
        rename_body: "Inline rename ships in a follow-up (MESSAGING-S2-FE7).",
        options_title: "Options",
        options_body: "Options menu ships in a follow-up (MESSAGING-S2-FE7).",
        create_stub_title: "Create conversation",
        create_stub_body: "Creating new conversations will be enabled once the messaging backend ships (MESSAGING-S2-FE5)."
      },
      list: {
        stub_footer: "Showing stub data \u2014 live conversations arrive in MESSAGING-S2-FE5",
        a11y_new_chat: "New chat"
      }
    };
  }
});

// src/types/content-manifest.ts
import { z } from "zod";
var ContentManifestSchema = z.object({
  /** LLM-generated narrator intro (replaces default from analyze-drama) */
  narratorOverride: z.string().max(500).optional(),
  /** Overall emphasis level based on drama severity */
  emphasisLevel: z.enum(["normal", "high", "critical"]).optional(),
  /** LLM-generated contextual commentary/insights */
  customInsights: z.array(z.string().max(300)).max(3).optional()
}).strict();

// src/utils/text.ts
function truncate(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3) + "...";
}
function sanitize(text) {
  return text.replace(/[<>]/g, "").replace(/[^\S\r\n]+/g, " ").trim();
}
function wordCount(text) {
  const words = text.trim().split(/\s+/);
  return words.length === 1 && words[0] === "" ? 0 : words.length;
}
function charCount(text, excludeWhitespace = false) {
  if (excludeWhitespace) {
    return text.replace(/\s/g, "").length;
  }
  return text.length;
}
function capitalize(text) {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
}
function titleCase(text) {
  if (!text) return text ?? "";
  return text.toLowerCase().split(" ").map((word) => capitalize(word)).join(" ");
}
function extractSnippet(text, startIndex, endIndex, contextChars = 20) {
  const snippetStart = Math.max(0, startIndex - contextChars);
  const snippetEnd = Math.min(text.length, endIndex + contextChars);
  let snippet = text.slice(snippetStart, snippetEnd);
  if (snippetStart > 0) snippet = "..." + snippet;
  if (snippetEnd < text.length) snippet = snippet + "...";
  return snippet;
}
function containsKeywords(text, keywords) {
  if (!text || !keywords?.length) return false;
  const lowerText = text.toLowerCase();
  return keywords.some((keyword) => keyword && lowerText.includes(keyword.toLowerCase()));
}
function normalizeWhitespace(text) {
  return text.replace(/\r\n/g, "\n").replace(/[ \t]+/g, " ").replace(/\n{3,}/g, "\n\n").trim();
}
function splitSentences(text) {
  return text.split(/[.!?]+/).map((s) => s.trim()).filter((s) => s.length > 0);
}
function readingTime(text, wordsPerMinute = 200) {
  const words = wordCount(text);
  return Math.ceil(words / wordsPerMinute);
}

// src/utils/format.ts
function formatScore(score) {
  return score.toFixed(1);
}
function getCategoryColor(category) {
  const colors = {
    safe: "#22c55e",
    // green-500 (0-2)
    caution: "#f59e0b",
    // amber-500 (2.1-5)
    high_drama: "#f97316",
    // orange-500 (5.1-7)
    extreme_drama: "#ef4444"
    // red-500 (7.1-10)
  };
  return colors[category];
}
function getCategoryEmoji(category) {
  const emojis = {
    safe: "\u2705",
    caution: "\u26A0\uFE0F",
    high_drama: "\u{1F525}",
    extreme_drama: "\u{1F6A8}"
  };
  return emojis[category];
}
function getCategoryLabel(category) {
  const labels = {
    safe: "Safe",
    caution: "Caution",
    high_drama: "High Drama",
    extreme_drama: "Extreme Drama"
  };
  return labels[category];
}
function formatRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = /* @__PURE__ */ new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSecs = Math.floor(diffMs / 1e3);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  if (diffSecs < 60) return "just now";
  if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? "s" : ""} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
  return formatDate(dateString);
}
function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function formatDateTime(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
}
function formatLatency(ms) {
  if (ms < 1e3) return `${Math.round(ms)}ms`;
  return `${(ms / 1e3).toFixed(2)}s`;
}
function formatCost(usd) {
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(4)}`;
}
function formatNumber(num) {
  return num.toLocaleString("en-US");
}
function formatPercentage(value, decimals = 1) {
  return `${(value * 100).toFixed(decimals)}%`;
}
function pluralize(count, singular, plural) {
  if (count === 1) return `${count} ${singular}`;
  return `${count} ${plural || singular + "s"}`;
}

// src/constants/app.ts
var APP_NAME = "DramaDetector";
var APP_VERSION = "0.2.0";
var APP_DESCRIPTION = "AI-powered communication analysis to detect and reduce drama";
var API_VERSION = "v1";
var API_TIMEOUT_MS = 3e4;
var MIN_MESSAGE_LENGTH = 3;
var MAX_MESSAGE_LENGTH = 5e3;
var MAX_MESSAGE_LENGTH_FREE = 1e3;
var USAGE_LIMITS = {
  free: {
    dailyAnalysisLimit: 10,
    monthlyAnalysisLimit: 100,
    historyRetentionDays: 7,
    advancedFeatures: false
  },
  drama_plus: {
    dailyAnalysisLimit: 100,
    monthlyAnalysisLimit: -1,
    // unlimited
    historyRetentionDays: 365,
    advancedFeatures: true
  },
  dramax: {
    dailyAnalysisLimit: 200,
    monthlyAnalysisLimit: -1,
    // unlimited
    historyRetentionDays: -1,
    // unlimited
    advancedFeatures: true
  }
};
var CACHE_TTL_SECONDS = 3600;
var CACHE_MAX_SIZE = 1e3;
var RATE_LIMIT_REQUESTS_PER_MINUTE = 60;
var RATE_LIMIT_REQUESTS_PER_HOUR = 1e3;
var FEATURES = {
  SOCIAL_SHARING: true,
  ANALYTICS: true,
  PUSH_NOTIFICATIONS: false,
  ADVANCED_REWRITES: true,
  BULK_ANALYSIS: false
};
var MESSAGE_CONTEXTS = [
  "family",
  "work",
  "friends",
  "dating",
  "social",
  "other"
];
var LLM_PROVIDERS = {
  GROQ: "groq",
  OPENAI: "openai",
  ANTHROPIC: "anthropic"
};
var ERROR_CODES = {
  INVALID_INPUT: "INVALID_INPUT",
  RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED",
  UNAUTHORIZED: "UNAUTHORIZED",
  PAYMENT_REQUIRED: "PAYMENT_REQUIRED",
  SERVER_ERROR: "SERVER_ERROR",
  SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE"
};

// src/i18n/types.ts
import "i18next";

// src/i18n/config.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import ICU from "i18next-icu";

// src/i18n/hooks.ts
import { useEffect, useState } from "react";
function getDeviceLocale() {
  try {
    if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
      const Localization = __require("expo-localization");
      const locale = Localization.getLocales()[0]?.languageCode;
      return locale || "en";
    }
    if (typeof navigator !== "undefined") {
      const browserLocale = navigator.language || navigator.userLanguage;
      return browserLocale?.split("-")[0] || "en";
    }
    return "en";
  } catch (error) {
    console.warn("[i18n] Failed to detect device locale:", error);
    return "en";
  }
}
function useDeviceLocale() {
  const [locale, setLocale] = useState(() => getDeviceLocale());
  useEffect(() => {
    let isMounted = true;
    const detectedLocale = getDeviceLocale();
    if (isMounted && detectedLocale !== locale) {
      setLocale(detectedLocale);
    }
    return () => {
      isMounted = false;
    };
  }, [locale]);
  return locale;
}

// src/i18n/config.ts
var import_common = __toESM(require_common());
var import_auth = __toESM(require_auth());
var import_home = __toESM(require_home());
var import_loading = __toESM(require_loading());
var import_subscription = __toESM(require_subscription());
var import_features = __toESM(require_features());
var import_safety = __toESM(require_safety());
var import_common2 = __toESM(require_common2());
var import_auth2 = __toESM(require_auth2());
var import_home2 = __toESM(require_home2());
var import_loading2 = __toESM(require_loading2());
var import_subscription2 = __toESM(require_subscription2());
var import_features2 = __toESM(require_features2());
var import_safety2 = __toESM(require_safety2());
var preloadedResources = {
  en: {
    common: import_common.default,
    auth: import_auth.default,
    home: import_home.default,
    // Home screen is critical path (always loads first)
    loading: import_loading.default,
    // Loading states prevent flicker during analysis
    subscription: import_subscription.default,
    // Quota warnings, family plans (prevents raw key fallback)
    features: import_features.default,
    // Trial modals (IpLimitModal, QuotaExhaustedModal - critical UX)
    safety: import_safety.default
    // Crisis resources, moderation (must be available immediately)
  },
  es: {
    common: import_common2.default,
    auth: import_auth2.default,
    home: import_home2.default,
    loading: import_loading2.default,
    subscription: import_subscription2.default,
    features: import_features2.default,
    // Trial modals Spanish translations
    safety: import_safety2.default
    // Crisis resources Spanish translations
  }
};
var supportedLocales = ["en", "es"];
var getStoredLocaleSyncWeb = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  try {
    return window.localStorage.getItem("user_locale");
  } catch (error) {
    console.warn("[i18n] Failed to read stored locale (sync):", error);
    return null;
  }
};
var getInitialLocale = () => {
  if (typeof window !== "undefined" && window.location) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLocale = urlParams.get("locale");
    if (urlLocale && supportedLocales.includes(urlLocale)) {
      return urlLocale;
    }
  }
  const storedLocale = getStoredLocaleSyncWeb();
  if (storedLocale && supportedLocales.includes(storedLocale)) {
    return storedLocale;
  }
  const deviceLocale = getDeviceLocale();
  return supportedLocales.includes(deviceLocale) ? deviceLocale : "en";
};
var initialLocale = getInitialLocale();
var getLoadPath = () => {
  if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
    const namespaceMap = {
      en: {
        common: require_common(),
        auth: require_auth(),
        // All namespaces (complete list for language switching)
        analysis: require_analysis(),
        features: require_features(),
        history: require_history(),
        home: require_home(),
        loading: require_loading(),
        settings: require_settings(),
        share: require_share(),
        stats: require_stats(),
        subscription: require_subscription(),
        content: require_content(),
        safety: require_safety(),
        error_friendly: require_error_friendly(),
        error_trace: require_error_trace(),
        inline_annotations: require_inline_annotations(),
        mobile_app: require_mobile_app(),
        historyPremiumInsights: require_historyPremiumInsights(),
        practitioner: require_practitioner(),
        practitioner_consent: require_practitioner_consent(),
        messaging: require_messaging()
      },
      es: {
        common: require_common2(),
        auth: require_auth2(),
        // Spanish namespaces (Week 40 - AI translated, complete list)
        analysis: require_analysis2(),
        features: require_features2(),
        history: require_history2(),
        home: require_home2(),
        loading: require_loading2(),
        settings: require_settings2(),
        share: require_share2(),
        stats: require_stats2(),
        subscription: require_subscription2(),
        content: require_content2(),
        safety: require_safety2(),
        error_friendly: require_error_friendly2(),
        error_trace: require_error_trace2(),
        inline_annotations: require_inline_annotations2(),
        mobile_app: require_mobile_app2(),
        historyPremiumInsights: require_historyPremiumInsights2(),
        practitioner: require_practitioner2(),
        practitioner_consent: require_practitioner_consent2(),
        messaging: require_messaging2()
      }
    };
    return (lng, ns) => {
      try {
        const resource = namespaceMap[lng]?.[ns];
        if (!resource) {
          console.warn(`[i18n] No resource found for ${lng}/${ns}.json`);
          return {};
        }
        return resource;
      } catch (e) {
        console.warn(`[i18n] Failed to load ${lng}/${ns}.json`, e);
        return {};
      }
    };
  }
  return "/locales/{{lng}}/{{ns}}.json";
};
var isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
if (isReactNative) {
  i18n.use(resourcesToBackend(getLoadPath()));
} else {
  i18n.use(HttpApi);
}
i18n.use(ICU).use(initReactI18next).init({
  compatibilityJSON: "v4",
  // i18next v4 format
  resources: preloadedResources,
  // Preload common + auth for sync initialization
  lng: initialLocale,
  // Auto-detect device locale, fallback to English
  fallbackLng: "en",
  backend: {
    loadPath: getLoadPath(),
    // Lazy load namespaces not in preloadedResources
    allowMultiLoading: true,
    // ✅ Phase 2 Fix: Enable parallel namespace loading (GPT-5-Pro recommendation)
    crossDomain: false
  },
  interpolation: {
    escapeValue: false
    // React already escapes
  },
  react: {
    useSuspense: true,
    // Phase 1.1: Enable Suspense for lazy loading
    bindI18n: "languageChanged loaded",
    // Bind to language change + namespace loaded events
    bindI18nStore: "added",
    // Bind to namespace added events
    transEmptyNodeValue: "",
    // Return empty string for empty nodes
    transSupportBasicHtmlNodes: true,
    // Support basic HTML in translations
    transKeepBasicHtmlNodesFor: ["br", "strong", "i"]
    // Whitelist HTML tags
  },
  // Namespace separation for better organization
  // Phase 1: Preload essential, lazy load others
  // IMPORTANT: Only include defaultNS here - preloaded namespaces in 'resources' are already available
  // Including preloaded namespaces triggers redundant HTTP requests that can overwrite static imports
  ns: ["common"],
  // Only specify default namespace
  defaultNS: "common",
  // Default to common namespace
  fallbackNS: ["common", "features"],
  // ✅ Phase 2 Fix: Transitional fallback to prevent regressions during migration (GPT-5-Pro critical finding)
  // Partition loading strategy: Load namespaces on-demand
  partialBundledLanguages: true,
  // Missing key handler for development
  saveMissing: true,
  missingKeyHandler: (lngs, ns, key, _fallbackValue) => {
    if (process.env.NODE_ENV === "development") {
      console.warn(`[i18n] Missing translation key: ${ns}:${key} for languages: ${lngs.join(", ")}`);
    }
  },
  // CRITICAL: Initialize synchronously to prevent React Context null errors
  // i18next v26 renamed initImmediate to initAsync.
  initAsync: false
  // Force synchronous initialization
});
if (!i18n.isInitialized) {
  console.error("[i18n] Failed to initialize synchronously");
}
var config_default = i18n;

// src/i18n/index.ts
import { useTranslation as useTranslation2 } from "react-i18next";

// src/i18n/useLocale.ts
import { useState as useState2, useCallback, useEffect as useEffect2 } from "react";
import { useTranslation } from "react-i18next";

// src/i18n/storage.ts
var LOCALE_STORAGE_KEY = "user_locale";
async function getStoredLocale() {
  try {
    const AsyncStorage = await import("@react-native-async-storage/async-storage");
    const locale = await AsyncStorage.default.getItem(LOCALE_STORAGE_KEY);
    return locale;
  } catch (error) {
    console.warn("[i18n] Failed to get stored locale:", error);
    return null;
  }
}
async function setStoredLocale(locale) {
  try {
    const AsyncStorage = await import("@react-native-async-storage/async-storage");
    await AsyncStorage.default.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (error) {
    console.warn("[i18n] Failed to set stored locale:", error);
  }
}
async function clearStoredLocale() {
  try {
    const AsyncStorage = await import("@react-native-async-storage/async-storage");
    await AsyncStorage.default.removeItem(LOCALE_STORAGE_KEY);
  } catch (error) {
    console.warn("[i18n] Failed to clear stored locale:", error);
  }
}

// src/i18n/useLocale.ts
function useLocale() {
  const { i18n: i18n2 } = useTranslation();
  const [locale, setLocale] = useState2(i18n2.language || "en");
  useEffect2(() => {
    const handleLanguageChange = (lng) => setLocale(lng || "en");
    i18n2.on("languageChanged", handleLanguageChange);
    return () => {
      i18n2.off("languageChanged", handleLanguageChange);
    };
  }, [i18n2]);
  const changeLocale = useCallback(
    async (newLocale) => {
      try {
        await i18n2.changeLanguage(newLocale);
        await setStoredLocale(newLocale);
        setLocale(newLocale);
      } catch (error) {
        console.error("[i18n] Failed to change locale:", error);
      }
    },
    [i18n2]
  );
  return {
    locale,
    changeLocale,
    supportedLocales: ["en", "es"]
  };
}

// src/i18n/index.ts
import { I18nextProvider } from "react-i18next";

// src/design/tokens.ts
var tokens_exports = {};
__export(tokens_exports, {
  CATEGORY_COLORS: () => CATEGORY_COLORS2,
  CATEGORY_LABELS: () => CATEGORY_LABELS2,
  DRAMA_THRESHOLDS: () => DRAMA_THRESHOLDS2,
  agentCatalog: () => agentCatalog,
  cssVars: () => cssVars,
  drama: () => drama,
  primitive: () => primitive,
  semantic: () => semantic,
  tierStyles: () => tierStyles,
  tiers: () => tiers
});
var primitive = {
  // ── Color Palette ──────────────────────────────────────────────────────
  color: {
    white: "#ffffff",
    black: "#000000",
    // Neutral scale (gray)
    gray: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
      950: "#030712"
    },
    // Brand palette
    brand: {
      50: "#EFF6FF",
      100: "#DBEAFE",
      200: "#BFDBFE",
      300: "#93C5FD",
      400: "#60A5FA",
      500: "#3B82F6",
      600: "#2563EB",
      700: "#1D4ED8",
      800: "#1E40AF",
      900: "#1E3A8A"
    },
    // Drama category colors (authoritative)
    dramaSafe: "#22c55e",
    // Green — score 0-2
    dramaCaution: "#f59e0b",
    // Amber — score 2.1-5
    dramaHigh: "#f97316",
    // Orange — score 5.1-7
    dramaExtreme: "#ef4444",
    // Red — score 7.1-10
    // Tier accents
    accentGold: "#f59e0b",
    accentBlush: "#ec4899",
    // UI component accents (switch, toggle)
    accentViolet: "#A78BFA",
    accentVioletDark: "#8B5CF6",
    // Status colors
    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444"
  },
  // ── Typography Scale ───────────────────────────────────────────────────
  fontSize: {
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    "2xl": 24,
    "3xl": 30,
    "4xl": 36
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800
  },
  // ── Spacing Scale ──────────────────────────────────────────────────────
  space: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    8: 32,
    10: 40,
    12: 48,
    16: 64,
    20: 80
  },
  // ── Border Radius ──────────────────────────────────────────────────────
  radius: {
    none: 0,
    sm: 4,
    base: 8,
    md: 12,
    lg: 16,
    xl: 24,
    full: 9999
  },
  // ── Motion ─────────────────────────────────────────────────────────────
  motion: {
    duration: {
      fast: 150,
      normal: 300,
      slow: 500,
      reveal: 700
    },
    easing: {
      ease: "ease-in-out",
      spring: "cubic-bezier(0.34, 1.56, 0.64, 1)",
      linear: "linear"
    }
  }
};
var semantic = {
  // ── Text Colors ────────────────────────────────────────────────────────
  text: {
    primary: primitive.color.gray[900],
    secondary: primitive.color.gray[700],
    tertiary: primitive.color.gray[500],
    inverse: primitive.color.white,
    brand: primitive.color.brand[500],
    link: primitive.color.brand[600]
  },
  // ── Background Colors ──────────────────────────────────────────────────
  bg: {
    surface: primitive.color.white,
    elevated: primitive.color.gray[50],
    muted: primitive.color.gray[100],
    brand: primitive.color.brand[50],
    brandSubtle: primitive.color.brand[100]
  },
  // ── Border Colors ──────────────────────────────────────────────────────
  border: {
    subtle: primitive.color.gray[200],
    default: primitive.color.gray[300],
    strong: primitive.color.gray[400],
    brand: primitive.color.brand[200]
  },
  // ── Status / Feedback ──────────────────────────────────────────────────
  status: {
    success: primitive.color.success,
    warning: primitive.color.warning,
    error: primitive.color.error,
    info: primitive.color.brand[500]
  },
  // ── Info/Alert (used in EmailSettings, etc.) ───────────────────────────
  info: {
    bg: primitive.color.brand[50],
    text: primitive.color.brand[700],
    border: primitive.color.brand[200]
  }
};
var drama = {
  // ── Category Colors (authoritative source) ─────────────────────────────
  category: {
    safe: primitive.color.dramaSafe,
    caution: primitive.color.dramaCaution,
    highDrama: primitive.color.dramaHigh,
    extremeDrama: primitive.color.dramaExtreme
  },
  // ── Category Labels ────────────────────────────────────────────────────
  categoryLabel: {
    safe: "Safe",
    caution: "Caution",
    highDrama: "High Drama",
    extremeDrama: "Extreme Drama"
  },
  // ── Score Thresholds (logical, no color) ───────────────────────────────
  thresholds: {
    safeMax: 2,
    cautionMin: 2.1,
    cautionMax: 5,
    highDramaMin: 5.1,
    highDramaMax: 7,
    extremeDramaMin: 7.1
  },
  // ── OG Image Category Colors (RGB values for templates) ────────────────
  ogCategory: {
    safe: { bg: "#F0FDF4", text: "#166534", accent: "#22C55E" },
    caution: { bg: "#FFFBEB", text: "#92400E", accent: "#F59E0B" },
    highDrama: { bg: "#FEF2F2", text: "#991B1B", accent: "#EF4444" },
    extremeDrama: { bg: "#FEF2F2", text: "#7F1D1D", accent: "#DC2626" }
  },
  // ── Share Image Dimensions ─────────────────────────────────────────────
  shareFormat: {
    horizontal: { width: 1200, height: 630 },
    square: { width: 1080, height: 1080 },
    portrait: { width: 1080, height: 1350 },
    reel: { width: 1080, height: 1920 }
  }
};
var tiers = {
  free: {
    label: "Free",
    accent: primitive.color.brand[500],
    premium: false
  },
  dramaPlus: {
    label: "Drama+",
    accent: primitive.color.accentGold,
    premium: true
  },
  dramaX: {
    label: "DramaX",
    accent: primitive.color.accentBlush,
    premium: true
  }
};
var tierStyles = {
  free: {
    cardBg: "#FFFFFF",
    cardBorder: "#E5E7EB",
    badgeBg: "#F3F4F6",
    badgeText: "#374151",
    accent: primitive.color.brand[500]
  },
  dramaPlus: {
    cardBg: "#1F2937",
    cardBorder: "#374151",
    badgeBg: "#F59E0B20",
    badgeText: "#F59E0B",
    accent: primitive.color.accentGold
  },
  dramaX: {
    cardBg: "#0F172A",
    cardBorder: "#1E293B",
    badgeBg: "#EC489920",
    badgeText: "#EC4899",
    accent: primitive.color.accentBlush
  }
};
var cssVars = {
  // Colors
  "color-primary-rgb": "138 43 226",
  "color-safe-rgb": "34 197 94",
  // #22C55E — matches primitive
  "color-caution-rgb": "245 158 11",
  // #F59E0B
  "color-danger-rgb": "239 68 68",
  // #EF4444
  "color-brand-rgb": "59 130 246",
  // #3B82F6
  // Typography
  "font-display": "'Inter', sans-serif",
  "font-body": "'Inter', sans-serif",
  "font-narrator": "'Playfair Display', serif",
  // Spacing (CSS rem scale — tier-invariant)
  "space-1": "0.25rem",
  "space-2": "0.5rem",
  "space-3": "0.75rem",
  "space-4": "1rem",
  "space-6": "1.5rem",
  "space-8": "2rem",
  "space-10": "2.5rem",
  "space-12": "3rem",
  // Border radius
  "radius": "0.5rem",
  "radius-sm": "0.25rem",
  "radius-lg": "1rem",
  // Motion
  "motion-duration": "300ms",
  "motion-duration-reveal": "700ms",
  "motion-timing": "ease-in-out",
  "motion-spring": "cubic-bezier(0.34, 1.56, 0.64, 1)"
};
var agentCatalog = {
  name: "dramadetector-design-tokens",
  version: "1.0.0",
  layers: ["primitive", "semantic", "drama", "tiers"],
  dramaCategories: Object.keys(drama.category),
  dramaThresholds: drama.thresholds,
  shareFormats: Object.keys(drama.shareFormat),
  tierIds: Object.keys(tiers),
  semanticTextColors: Object.keys(semantic.text),
  semanticBgColors: Object.keys(semantic.bg)
};
var CATEGORY_COLORS2 = {
  safe: drama.ogCategory.safe,
  caution: drama.ogCategory.caution,
  high_drama: drama.ogCategory.highDrama,
  extreme_drama: drama.ogCategory.extremeDrama
};
var CATEGORY_LABELS2 = drama.categoryLabel;
var DRAMA_THRESHOLDS2 = {
  SAFE_MAX: drama.thresholds.safeMax,
  CAUTION_MIN: drama.thresholds.cautionMin,
  CAUTION_MAX: drama.thresholds.cautionMax,
  HIGH_DRAMA_MIN: drama.thresholds.highDramaMin,
  HIGH_DRAMA_MAX: drama.thresholds.highDramaMax,
  EXTREME_DRAMA_MIN: drama.thresholds.extremeDramaMin
};

// src/screen-experience/useHomeExperiencePolicy.ts
function assertHomeSurface(inputs) {
  if (inputs.surface !== "home") {
    throw new Error(
      `useHomeExperiencePolicy expected surface "home", received "${inputs.surface}"`
    );
  }
}
function getHomeExperiencePolicy(inputs) {
  assertHomeSurface(inputs);
  const isAnonymousTrialPending = inputs.auth.isAnonymous && (!inputs.trial.isLoaded || inputs.trial.visitState === "unknown");
  const isFirstSessionAnonymous = inputs.auth.isAnonymous && inputs.trial.visitState === "new";
  const shouldHideExperience = isAnonymousTrialPending || isFirstSessionAnonymous;
  const experienceVisibility = shouldHideExperience ? "hidden" : "selector";
  return {
    surface: "home",
    experienceVisibility,
    shellClassification: "foundation",
    shareTreatment: "secondary",
    shouldUseLocalFallback: true,
    showModeSelector: experienceVisibility === "selector",
    inputPlaceholderKey: shouldHideExperience ? "message_before_send" : "default",
    showSoftSignupPrompt: inputs.auth.isAnonymous && inputs.trial.isLoaded && inputs.trial.visitState === "returning",
    showAdvancedControls: !shouldHideExperience
  };
}
function useHomeExperiencePolicy(inputs) {
  return getHomeExperiencePolicy(inputs);
}

// src/screen-experience/resultsModuleRegistry.ts
var RESULTS_MODULE_REGISTRY = {
  score: {
    key: "score",
    description: "Core score / category framing at the top of results.",
    ownership: "shell_owned",
    visibility: "always",
    sduiEligible: false,
    allowedSurfaces: ["results", "shared_link", "share_artifact"]
  },
  likely_impact: {
    key: "likely_impact",
    description: "Plain-English likely impact framing paired with the score.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results", "shared_link", "share_artifact"]
  },
  summary: {
    key: "summary",
    description: "Primary summary / verdict block for the analysis.",
    ownership: "shell_owned",
    visibility: "always",
    sduiEligible: false,
    allowedSurfaces: ["results", "shared_link", "share_artifact"]
  },
  primary_rewrite: {
    key: "primary_rewrite",
    description: "Best rewrite candidate surfaced early in the flow.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results", "shared_link"]
  },
  narrator: {
    key: "narrator",
    description: "Narrator-style explanation / tone commentary.",
    ownership: "shell_owned",
    visibility: "always",
    sduiEligible: false,
    allowedSurfaces: ["results", "shared_link"]
  },
  patterns: {
    key: "patterns",
    description: "Detected conversational patterns or red flags.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results", "shared_link"]
  },
  transformations: {
    key: "transformations",
    description: "Expanded rewrite / transformation breakdowns.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results"]
  },
  feedback: {
    key: "feedback",
    description: "Feedback or response collection module.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results", "shared_link"]
  },
  share: {
    key: "share",
    description: "Built-in share controls for private results surfaces.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results"]
  },
  upgrade_teaser: {
    key: "upgrade_teaser",
    description: "Upgrade/teaser block for preview-tier result states.",
    ownership: "policy_controlled",
    visibility: "optional",
    sduiEligible: true,
    allowedSurfaces: ["results"]
  }
};
var BASE_RESULTS_MODULE_ORDER = {
  preview: [
    "score",
    "likely_impact",
    "summary",
    "primary_rewrite",
    "narrator",
    "patterns",
    "feedback",
    "share",
    "upgrade_teaser"
  ],
  full: [
    "score",
    "likely_impact",
    "summary",
    "primary_rewrite",
    "narrator",
    "patterns",
    "transformations",
    "feedback",
    "share"
  ],
  generative: [
    "score",
    "likely_impact",
    "summary",
    "primary_rewrite",
    "narrator",
    "patterns",
    "transformations",
    "feedback",
    "share"
  ]
};
var SHARE_ARTIFACT_MODULE_ORDER = [
  "score",
  "likely_impact",
  "summary"
];
var SHARED_LINK_PRIVACY_MODULE_FILTERS = {
  hide_message: [],
  hide_score: ["score", "likely_impact"],
  hide_summary: ["summary"],
  hide_narrator: ["narrator"],
  hide_snippets: ["patterns"],
  hide_rewrites: ["primary_rewrite", "transformations"]
};
function getBaseResultsModuleOrder(renderVariant) {
  return [...BASE_RESULTS_MODULE_ORDER[renderVariant]];
}
function getAllowedModulesForSurface(surface, renderVariant) {
  const sourceModules = renderVariant ? getBaseResultsModuleOrder(renderVariant) : Object.keys(RESULTS_MODULE_REGISTRY);
  return sourceModules.filter(
    (moduleKey) => RESULTS_MODULE_REGISTRY[moduleKey].allowedSurfaces.includes(surface)
  );
}
function getShareArtifactModuleOrder() {
  return SHARE_ARTIFACT_MODULE_ORDER.filter(
    (moduleKey) => RESULTS_MODULE_REGISTRY[moduleKey].allowedSurfaces.includes(
      "share_artifact"
    )
  );
}
function applySharedLinkPrivacyToModuleOrder(moduleOrder, privacySettings) {
  if (!privacySettings) return [...moduleOrder];
  const hiddenModules = /* @__PURE__ */ new Set();
  for (const [privacyKey, modules] of Object.entries(
    SHARED_LINK_PRIVACY_MODULE_FILTERS
  )) {
    if (privacySettings[privacyKey]) {
      for (const moduleKey of modules) hiddenModules.add(moduleKey);
    }
  }
  return moduleOrder.filter((moduleKey) => !hiddenModules.has(moduleKey));
}
function isSduiEligibleResultsModule(key) {
  return RESULTS_MODULE_REGISTRY[key].sduiEligible;
}

// src/screen-experience/useResultsExperiencePolicy.ts
function assertResultsSurface(inputs) {
  if (inputs.surface !== "results" && inputs.surface !== "shared_link") {
    throw new Error(
      `useResultsExperiencePolicy expected surface "results" or "shared_link", received "${inputs.surface}"`
    );
  }
}
function getLikelyImpactLabel(category) {
  switch (category) {
    case "safe":
      return "Calm";
    case "caution":
      return "Tense";
    case "high_drama":
      return "Defensive / tense";
    case "extreme_drama":
      return "Escalating";
    default:
      return null;
  }
}
function buildModuleOrder(renderVariant, showLikelyImpact, showPrimaryRewriteCard, shareTreatment, showUpgradePrompt, hasPatterns, hasTransformations, includeFeedback) {
  return getBaseResultsModuleOrder(renderVariant).filter((moduleKey) => {
    switch (moduleKey) {
      case "likely_impact":
        return showLikelyImpact;
      case "primary_rewrite":
        return showPrimaryRewriteCard;
      case "patterns":
        return hasPatterns;
      case "transformations":
        return renderVariant !== "preview" && hasTransformations;
      case "feedback":
        return includeFeedback;
      case "share":
        return shareTreatment !== "hidden";
      case "upgrade_teaser":
        return showUpgradePrompt;
      default:
        return true;
    }
  });
}
function getResultsRenderVariant(inputs) {
  const isPreviewTier = inputs.entitlements.tierLevel <= 1;
  if (isPreviewTier) return "preview";
  if (inputs.surface === "results" && inputs.features.generativeResultsEnabled) {
    return "generative";
  }
  return "full";
}
function getResultsExperiencePolicy(inputs) {
  assertResultsSurface(inputs);
  const renderVariant = getResultsRenderVariant(inputs);
  const showLikelyImpact = inputs.result.hasDisplayableAnalysis && !inputs.result.isCircuitBreakerResponse;
  const showPrimaryRewriteCard = inputs.features.rewritesEnabled && inputs.result.hasDisplayableAnalysis && inputs.result.hasRewrites;
  const shareTreatment = inputs.surface === "shared_link" || !inputs.features.sharedLinksEnabled ? "hidden" : "primary";
  const showUpgradePrompt = inputs.surface === "results" && renderVariant === "preview" && Boolean(inputs.features.conversionUxEnabled);
  const primaryActionTreatment = inputs.surface === "results" ? "copy_use_primary" : "legacy";
  const moduleOrder = buildModuleOrder(
    renderVariant,
    showLikelyImpact,
    showPrimaryRewriteCard,
    shareTreatment,
    showUpgradePrompt,
    inputs.result.hasPatterns,
    inputs.result.hasTransformations,
    !inputs.result.isCircuitBreakerResponse
  );
  if (inputs.surface === "shared_link") {
    return {
      surface: "shared_link",
      shellClassification: "foundation",
      renderVariant: renderVariant === "preview" ? "preview" : "full",
      showLikelyImpact,
      showPrimaryRewriteCard,
      primaryActionTreatment,
      showUpgradePrompt: false,
      shareTreatment,
      shouldUseLocalFallback: true,
      moduleOrder
    };
  }
  return {
    surface: "results",
    shellClassification: "foundation",
    renderVariant,
    showLikelyImpact,
    showPrimaryRewriteCard,
    primaryActionTreatment,
    showUpgradePrompt: Boolean(showUpgradePrompt),
    shareTreatment,
    shouldUseLocalFallback: renderVariant !== "generative",
    moduleOrder
  };
}
function useResultsExperiencePolicy(inputs) {
  return getResultsExperiencePolicy(inputs);
}

// src/sdui/guardrails.ts
var SDUI_SCHEMA_VERSION = 1;
var SDUI_SURFACE_KEYS = [
  "blur-teaser",
  "score-delta",
  "consent-modal",
  "referral-share",
  "subscription-page",
  "og-image",
  "share-modal-config",
  "habit-engine",
  "dramacards"
];
var SDUI_FORBIDDEN_CONTROL_AREAS = [
  "auth_enforcement",
  "quota_enforcement",
  "navigation_semantics",
  "safety_enforcement",
  "pricing_contract",
  "tier_entitlements",
  "arbitrary_condition_execution"
];
var DEFAULT_FORBIDDEN_CONTROL = [
  "auth_enforcement",
  "quota_enforcement",
  "navigation_semantics",
  "safety_enforcement",
  "arbitrary_condition_execution"
];
var SDUI_SURFACE_GUARDRAILS = {
  "blur-teaser": {
    surfaceKey: "blur-teaser",
    allowedControl: ["visibility", "copy", "thresholds"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: [
      "May tune teaser thresholds and copy, but cannot change paywall mechanics."
    ]
  },
  "score-delta": {
    surfaceKey: "score-delta",
    allowedControl: ["formatting"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: ["Formatting only; cannot redefine scoring semantics."]
  },
  "consent-modal": {
    surfaceKey: "consent-modal",
    allowedControl: ["visibility", "thresholds", "copy"],
    forbiddenControl: [...DEFAULT_FORBIDDEN_CONTROL, "tier_entitlements"],
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: [
      "Can tune prompt cadence, but core consent/auth flows remain code-owned."
    ]
  },
  "referral-share": {
    surfaceKey: "referral-share",
    allowedControl: ["copy", "formatting"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: ["Share footer and CTA copy only."]
  },
  "subscription-page": {
    surfaceKey: "subscription-page",
    allowedControl: ["plan_visibility", "checkout_availability"],
    forbiddenControl: [
      ...DEFAULT_FORBIDDEN_CONTROL,
      "pricing_contract",
      "tier_entitlements"
    ],
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "local_render",
    notes: [
      "May toggle plan-family visibility and checkout availability only.",
      "Must not control price values, entitlement logic, or route/navigation ownership."
    ]
  },
  "og-image": {
    surfaceKey: "og-image",
    allowedControl: ["public_artifact_fields", "copy"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: [
      "Public artifact field visibility only; privacy rules still come from share settings."
    ]
  },
  "share-modal-config": {
    surfaceKey: "share-modal-config",
    allowedControl: ["share_modal_options", "copy", "template_ordering"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: [
      "Can order formats and hints, but cannot alter share permission mechanics."
    ]
  },
  "habit-engine": {
    surfaceKey: "habit-engine",
    allowedControl: ["thresholds", "formatting"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: ["Cadence tuning only."]
  },
  dramacards: {
    surfaceKey: "dramacards",
    allowedControl: ["thresholds", "visibility", "formatting"],
    forbiddenControl: DEFAULT_FORBIDDEN_CONTROL,
    requiresDefaults: true,
    versioned: true,
    fallbackBehavior: "defaults_only",
    notes: [
      "Session tuning only; unlock rules still must remain bounded and typed."
    ]
  }
};
function isKnownSduiSurfaceKey(value) {
  return SDUI_SURFACE_KEYS.includes(value);
}
function getSduiSurfaceGuardrail(surfaceKey) {
  return SDUI_SURFACE_GUARDRAILS[surfaceKey];
}
function assertSupportedSduiSchemaVersion(schemaVersion) {
  if (schemaVersion !== SDUI_SCHEMA_VERSION) {
    throw new Error(
      `Unsupported SDUI schemaVersion ${String(schemaVersion)}; expected ${SDUI_SCHEMA_VERSION}`
    );
  }
}

// src/training-data/transformations.ts
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function asArray(value) {
  return Array.isArray(value) ? value : [];
}
function parseMaybeJson(value) {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
async function hashInputPii(input, hashText) {
  const result = {};
  for (const [key, value] of Object.entries(input)) {
    if (key === "message" || key === "context") {
      result[key] = typeof value === "string" && value.length > 0 ? await hashText(value) : null;
    } else {
      result[key] = value;
    }
  }
  return result;
}
async function hashOutputPii(output, hashText) {
  const result = { ...output };
  if (Array.isArray(result.issues)) {
    const hashedIssues = [];
    for (const issue of result.issues) {
      const hashedIssue = { ...issue };
      if (typeof hashedIssue.snippet === "string" && hashedIssue.snippet.length > 0) {
        hashedIssue.snippet = await hashText(hashedIssue.snippet);
      }
      if (typeof hashedIssue.replacement === "string" && hashedIssue.replacement.length > 0) {
        hashedIssue.replacement = await hashText(hashedIssue.replacement);
      }
      hashedIssues.push(hashedIssue);
    }
    result.issues = hashedIssues;
  }
  if (Array.isArray(result.rewrites)) {
    const hashedRewrites = [];
    for (const rewrite of result.rewrites) {
      const hashedRewrite = { ...rewrite };
      if (typeof hashedRewrite.original === "string" && hashedRewrite.original.length > 0) {
        hashedRewrite.original = await hashText(hashedRewrite.original);
      }
      if (typeof hashedRewrite.improved === "string" && hashedRewrite.improved.length > 0) {
        hashedRewrite.improved = await hashText(hashedRewrite.improved);
      }
      hashedRewrites.push(hashedRewrite);
    }
    result.rewrites = hashedRewrites;
  }
  return result;
}
async function sanitizeSignalMetadata(value, hashText) {
  const parsed = parseMaybeJson(value);
  if (!isRecord(parsed)) return parsed;
  const sanitized = { ...parsed };
  if (isRecord(sanitized.baseline)) {
    const baseline = { ...sanitized.baseline };
    baseline.snippet_hash = await hashText(typeof baseline.snippet === "string" ? baseline.snippet : null);
    baseline.replacement_hash = await hashText(
      typeof baseline.replacement === "string" ? baseline.replacement : null
    );
    delete baseline.snippet;
    delete baseline.replacement;
    sanitized.baseline = baseline;
  }
  if (isRecord(sanitized.decision_payload)) {
    const decisionPayload = { ...sanitized.decision_payload };
    decisionPayload.user_modified_text_hash = await hashText(
      typeof decisionPayload.user_modified_text === "string" ? decisionPayload.user_modified_text : null
    );
    delete decisionPayload.user_modified_text;
    sanitized.decision_payload = decisionPayload;
  }
  return sanitized;
}
async function buildHashedFeedback(rows, hashedUserId, options) {
  const hashedFeedback = [];
  for (const row of rows) {
    const input = isRecord(row.input) ? await hashInputPii(row.input, options.hashText) : {};
    const output = isRecord(row.output) ? await hashOutputPii(row.output, options.hashText) : row.output;
    const feedback = isRecord(row.feedback) ? row.feedback : {};
    const metadata = isRecord(row.metadata) ? row.metadata : {};
    const issues = isRecord(output) ? asArray(output.issues) : [];
    const labels = {
      feedback_type: feedback.type ?? null,
      category: isRecord(output) ? output.category ?? null : null,
      score: isRecord(output) ? output.score ?? null : null,
      issue_types: issues.map((issue) => isRecord(issue) ? issue.type : null).filter((value) => typeof value === "string")
    };
    const consentSnapshot = isRecord(metadata.consent_snapshot) ? metadata.consent_snapshot : null;
    const eligibleForTraining = consentSnapshot?.granted === true && (feedback.type === "positive" || feedback.type === "approved");
    hashedFeedback.push({
      id: row.id,
      user_id_hash: hashedUserId,
      input,
      output,
      feedback,
      metadata,
      labels,
      contract: options.buildFeedbackContract({
        sourceRecordId: row.id,
        analysisId: typeof input.analysis_id === "string" ? input.analysis_id : void 0,
        feedbackType: feedback.type ?? null,
        provider: metadata.provider ?? null,
        model: metadata.model ?? null,
        analysisSchemaVersion: metadata.analysis_schema_version ?? null,
        promptVersion: metadata.prompt_version ?? null,
        agentExecutionId: typeof metadata.agent_execution_id === "string" ? metadata.agent_execution_id : null,
        eligibleForTraining
      }),
      created_at: row.created_at
    });
  }
  return hashedFeedback;
}
function buildSftExamples(feedbackRows, options) {
  return feedbackRows.map((row) => {
    const metadata = isRecord(row.metadata) ? row.metadata : {};
    const consentSnapshot = isRecord(metadata.consent_snapshot) ? metadata.consent_snapshot : null;
    const feedback = isRecord(row.feedback) ? row.feedback : {};
    const eligibleForTraining = consentSnapshot?.granted === true && (feedback.type === "positive" || feedback.type === "approved");
    return {
      id: `feedback:${row.id}`,
      user_id_hash: row.user_id_hash,
      source: "analysis_feedback",
      task: "scoring",
      eligible_for_training: eligibleForTraining,
      input: row.input,
      output: row.output,
      signal_types: isRecord(row.output) ? options.extractCanonicalIssueTypes(row.output.issues) : [],
      feedback: row.feedback,
      labels: row.labels,
      metadata: row.metadata,
      contract: options.buildFeedbackContract({
        sourceRecordId: row.id,
        analysisId: typeof row.input.analysis_id === "string" ? row.input.analysis_id : void 0,
        feedbackType: feedback.type ?? null,
        provider: metadata.provider ?? null,
        model: metadata.model ?? null,
        analysisSchemaVersion: metadata.analysis_schema_version ?? null,
        promptVersion: metadata.prompt_version ?? null,
        agentExecutionId: typeof metadata.agent_execution_id === "string" ? metadata.agent_execution_id : null,
        eligibleForTraining
      }),
      created_at: row.created_at
    };
  });
}
function buildCompatibilityTrainingExamples(sftExamples, options) {
  return sftExamples.filter((row) => row.eligible_for_training).map((row) => ({
    id: row.id,
    user_id_hash: row.user_id_hash,
    input: row.input,
    labels: row.labels,
    signal_types: row.signal_types,
    confidence: 0.8,
    source: "analysis_feedback_compat",
    tags: ["compatibility-derived", "analysis_feedback"],
    contract: options.buildFeedbackContract({
      sourceRecordId: row.id,
      analysisId: typeof row.input.analysis_id === "string" ? row.input.analysis_id : void 0,
      feedbackType: isRecord(row.feedback) && typeof row.feedback.type === "string" ? row.feedback.type : null,
      compatibilityProjection: true,
      eligibleForTraining: row.eligible_for_training
    }),
    created_at: row.created_at
  }));
}
async function buildPreferenceExamples(revisions, events, hashedUserId, options) {
  const revisionsById = new Map(revisions.map((row) => [row.id, row]));
  const preferenceExamples = [];
  for (const event of events) {
    const revision = revisionsById.get(event.revision_id);
    if (!revision) continue;
    const baselineReplacementHash = await options.hashText(event.replacement);
    const selectedText = event.decision === "modified" ? event.user_modified_text : event.decision === "accepted" ? event.replacement : null;
    const parsedOriginalIssues = parseMaybeJson(revision.original_issues);
    const parsedRevisedIssues = parseMaybeJson(revision.revised_issues);
    const hashedOriginalIssues = Array.isArray(parsedOriginalIssues) ? await hashOutputPii({ issues: parsedOriginalIssues }, options.hashText) : { issues: [] };
    const hashedRevisedIssues = Array.isArray(parsedRevisedIssues) ? await hashOutputPii({ issues: parsedRevisedIssues }, options.hashText) : { issues: [] };
    preferenceExamples.push({
      id: event.id,
      user_id_hash: hashedUserId,
      source: "analysis_rewrite_event",
      revision_id: revision.id,
      analysis_id: revision.analysis_id,
      decision: event.decision,
      signal_type: event.signal_type ?? null,
      signal_strength: event.signal_strength ?? null,
      baseline: {
        issue_id: event.issue_id,
        issue_type: event.issue_type,
        severity: event.severity,
        snippet_hash: await options.hashText(event.snippet),
        replacement_hash: baselineReplacementHash
      },
      choice: {
        selected_text_hash: await options.hashText(selectedText),
        user_modified_text_hash: await options.hashText(event.user_modified_text),
        decision_latency_ms: event.decision_latency_ms
      },
      outcome: {
        original_message_hash: await options.hashText(revision.original_message),
        revised_message_hash: await options.hashText(revision.revised_message),
        original_score: revision.original_score,
        revised_score: revision.revised_score,
        original_category: revision.original_category,
        revised_category: revision.revised_category,
        score_delta: revision.score_delta,
        issues_resolved: revision.issues_resolved,
        issues_total: revision.issues_total,
        status: revision.status,
        original_issues: hashedOriginalIssues.issues,
        revised_issues: hashedRevisedIssues.issues
      },
      metadata: {
        prompt_version: revision.prompt_version,
        scoring_version: revision.scoring_version,
        model_id: revision.model_id,
        agent_execution_id: revision.agent_execution_id,
        suggestion_provider: event.suggestion_provider,
        suggestion_model: event.suggestion_model,
        suggestion_tokens: event.suggestion_tokens,
        suggestion_cost_usd: event.suggestion_cost_usd,
        signal_metadata: await sanitizeSignalMetadata(event.signal_metadata, options.hashText)
      },
      contract: options.buildRewritePreferenceContract({
        sourceRecordId: event.id,
        analysisId: revision.analysis_id,
        revisionId: revision.id,
        signalType: event.signal_type ?? null,
        signalStrength: event.signal_strength ?? null,
        promptVersion: revision.prompt_version,
        scoringVersion: revision.scoring_version,
        modelId: revision.model_id,
        agentExecutionId: revision.agent_execution_id,
        suggestionProvider: event.suggestion_provider,
        suggestionModel: event.suggestion_model
      }),
      created_at: event.created_at,
      completed_at: revision.completed_at
    });
  }
  return preferenceExamples;
}
async function buildEvalExamples(revisions, hashedUserId, options) {
  const evalExamples = [];
  for (const revision of revisions) {
    if (revision.status !== "completed") continue;
    const parsedOriginalIssues = parseMaybeJson(revision.original_issues);
    const parsedRevisedIssues = parseMaybeJson(revision.revised_issues);
    const hashedOriginalIssues = Array.isArray(parsedOriginalIssues) ? await hashOutputPii({ issues: parsedOriginalIssues }, options.hashText) : { issues: [] };
    const hashedRevisedIssues = Array.isArray(parsedRevisedIssues) ? await hashOutputPii({ issues: parsedRevisedIssues }, options.hashText) : { issues: [] };
    evalExamples.push({
      id: revision.id,
      user_id_hash: hashedUserId,
      source: "analysis_revision_eval",
      analysis_id: revision.analysis_id,
      revision_id: revision.id,
      input: {
        original_message_hash: await options.hashText(revision.original_message),
        revised_message_hash: await options.hashText(revision.revised_message)
      },
      expected: {
        original_score: revision.original_score,
        original_category: revision.original_category,
        original_issues: hashedOriginalIssues.issues,
        revised_score: revision.revised_score,
        revised_category: revision.revised_category,
        revised_issues: hashedRevisedIssues.issues,
        issues_resolved: revision.issues_resolved,
        issues_total: revision.issues_total,
        score_delta: revision.score_delta
      },
      metadata: {
        prompt_version: revision.prompt_version,
        scoring_version: revision.scoring_version,
        model_id: revision.model_id,
        agent_execution_id: revision.agent_execution_id,
        completed_at: revision.completed_at
      },
      contract: options.buildRevisionEvalContract({
        sourceRecordId: revision.id,
        analysisId: revision.analysis_id,
        revisionId: revision.id,
        promptVersion: revision.prompt_version,
        scoringVersion: revision.scoring_version,
        modelId: revision.model_id,
        agentExecutionId: revision.agent_execution_id
      }),
      created_at: revision.created_at
    });
  }
  return evalExamples;
}

// src/training-data/sft-export.ts
var LEARNING_LOOP_CONTRACT_VERSION = "v1";
var TRAINING_LABEL_PROVENANCE = "deterministic_canonicalization";
function mapTrainingSplit(split) {
  if (split === "gold") return "train";
  if (split === "production_holdout") return "validation";
  return null;
}
function buildSftRowMetadata(input) {
  return {
    example_id: input.exampleId,
    source_type: "synthetic_reviewed",
    source_ref: input.sourceRef,
    review_status: "approved",
    signal_types: input.signalTypes,
    context: input.context,
    split: input.split,
    label_provenance: TRAINING_LABEL_PROVENANCE,
    prompt_version: input.promptVersion,
    benchmark_model: input.benchmarkModel,
    learning_contract_version: LEARNING_LOOP_CONTRACT_VERSION,
    content_hash: input.contentHash
  };
}
function buildSftManifestEntry(input) {
  return {
    example_id: input.exampleId,
    dataset_version: input.datasetVersion,
    source_type: "synthetic_reviewed",
    source_ref: input.sourceRef,
    review_status: "approved",
    reviewer: "automated_pilot",
    benchmark_model_seen: input.benchmarkModel,
    taxonomy_labels: input.taxonomyLabels,
    split: input.split,
    label_provenance: TRAINING_LABEL_PROVENANCE,
    learning_contract_version: LEARNING_LOOP_CONTRACT_VERSION,
    content_hash: input.contentHash,
    notes: "Pilot corpus: golden prompt fixture with benchmark model output + safe canonicalization"
  };
}
export {
  API_TIMEOUT_MS,
  API_VERSION,
  APP_DESCRIPTION,
  APP_NAME,
  APP_VERSION,
  AcceptTosResultDto,
  AgentExecutionEntryDto,
  AgentExecutionStatusEnum,
  AnalysisDto,
  AnalysisFeedbackSourceEnum,
  AnalysisHistoryEntryDto,
  AnalysisHistoryPageDto,
  AnalysisProviderEnum,
  AnalysisRecordCategoryEnum,
  AnalysisRecordProviderEnum,
  AnalysisRevisionDto,
  AnalysisRevisionStatusEnum,
  AnalysisStatsDto,
  AnonymousQuotaDto,
  BASE_RESULTS_MODULE_ORDER,
  CACHE_MAX_SIZE,
  CACHE_TTL_SECONDS,
  CATEGORY_COLORS,
  CATEGORY_LABELS,
  CATEGORY_RECOMMENDATIONS,
  CONTEXT_MULTIPLIERS,
  CancelSubscriptionResultDto,
  CertificationStatusEnum,
  ClaimAnonymousDataResultDto,
  ClearAnalysisResultDto,
  CommunicationPatternDto,
  ConfirmAnalysisReceiptResultDto,
  ContentManifestSchema,
  ConversationDto,
  ConversationLastMessagePreviewDto,
  ConversationListEntryDto,
  ConversationStatusEnum,
  CreateConversationResultDto,
  CreateSharedLinkResultDto,
  CrisisAssistanceRequestResultDto,
  CrisisAssistanceRespondResultDto,
  CrisisContactMethodEnum,
  CrisisFeedbackSubmitResultDto,
  CrisisUrgencyLevelEnum,
  CrisisUrgencyPreferenceEnum,
  CryptoShreddingInfoDto,
  CustomerPortalSessionResultDto,
  CustomerReferralDto,
  DEFAULT_OG_CARD_CONFIG,
  DEFAULT_SHARE_FORMAT,
  DRAMA_KEYWORDS,
  DRAMA_THRESHOLDS,
  DeleteAnalysisResultDto,
  DeleteUserDataCountsDto,
  DeleteUserDataResultDto,
  DramaAnalysisRequestSchema,
  DramaCategoryEnum,
  E2ESharedLinkFixtureResultDto,
  ENTITLEMENTS_MANIFEST,
  ERROR_CODES,
  EntitlementsDto,
  ExplicitSharedResultDto,
  FEATURES,
  FamilyAcceptResultDto,
  FamilyCancelInviteResultDto,
  FamilyInviteBillingIntervalEnum,
  FamilyInviteDetailsDto,
  FamilyInviteDto,
  FamilyInviteResultDto,
  FamilyInviteStatusEnum,
  FamilyMemberDto,
  FamilyPlanDetailsDto,
  FamilyPlanDto,
  FamilyPlanTierDtoEnum,
  FamilyQuotaDto,
  FamilyRemoveResultDto,
  FeedbackEntryDto,
  FeedbackSubmitResultDto,
  FeedbackTypeEnum,
  GeneratedContentResultDto,
  GetFeedbackResultDto,
  GetMessagesPageDto,
  I18nextProvider,
  ISSUE_DESCRIPTIONS,
  LEARNING_LOOP_CONTRACT_VERSION,
  LLM_PROVIDERS,
  ListConversationsPageDto,
  MAX_MESSAGE_LENGTH,
  MAX_MESSAGE_LENGTH_FREE,
  MESSAGE_CONTEXTS,
  MIN_MESSAGE_LENGTH,
  MarkMessagesReadResultDto,
  MessageContextEnum,
  MessageContextSchema,
  MessageDto,
  OnboardingStatusDto,
  PartnerCertificationDto,
  PartnerCertificationTypeEnum,
  PartnerDashboardResultDto,
  PartnerFunnelStepDto,
  PartnerTypeEnum,
  PatternArchiveResultDto,
  PatternCreateResultDto,
  PatternDetailDto,
  PatternListDto,
  PatternPublishResultDto,
  PatternStatusDtoEnum,
  PatternTypeDtoEnum,
  PatternUpdateResultDto,
  PracticeTypeEnum,
  PractitionerAcceptResultDto,
  PractitionerConsentListDto,
  PractitionerConsentRecordDto,
  PractitionerConsentRevokeResultDto,
  PractitionerConsentUpdateResultDto,
  PractitionerDashboardDto,
  PractitionerInviteResultDto,
  PractitionerProfileDto,
  PractitionerRemoveResultDto,
  PractitionerStatusEnum,
  PublicSharedAnalysisDto,
  QuotaPolicyDto,
  QuotaRefundResultDto,
  QuotaUsageDto,
  RATE_LIMIT_REQUESTS_PER_HOUR,
  RATE_LIMIT_REQUESTS_PER_MINUTE,
  RESULTS_MODULE_REGISTRY,
  ReferralCodeResultDto,
  ReferralRowDto,
  ReferralStatusEnum,
  RetentionDaysEnum,
  RevokeSharedLinkResultDto,
  RewriteDecisionEnum,
  RewriteEventDto,
  RewriteIssueSeverityEnum,
  SDUI_FORBIDDEN_CONTROL_AREAS,
  SDUI_SCHEMA_VERSION,
  SDUI_SURFACE_GUARDRAILS,
  SDUI_SURFACE_KEYS,
  SEVERITY_WEIGHTS,
  SHARED_LINK_PRIVACY_MODULE_FILTERS,
  SHARE_ARTIFACT_MODULE_ORDER,
  SHARE_FORMAT_DIMENSIONS,
  SendMessageCompletedDto,
  SendMessagePendingDto,
  SendMessageResultDto,
  SessionPrepPatternItemDto,
  SessionPrepResponseDto,
  SharedAnalysisDto,
  SharedLinkPrivacySettingsDto,
  SharedLinkTypeEnum,
  SubmitConcernResultDto,
  SubscriptionStatusDto,
  SubscriptionStatusEnum,
  SubscriptionTierEnum,
  TRAINING_LABEL_PROVENANCE,
  TierDto,
  TierIdEnum,
  TierSourceEnum,
  USAGE_LIMITS,
  UpdateLastActiveResultDto,
  UpdateOnboardingResultDto,
  UpdatePreferencesResultDto,
  UpdateSubscriptionActionEnum,
  UpdateSubscriptionResultDto,
  UserPreferencesDto,
  UserStatsDto,
  UserStatsRowDto,
  VisualLayerEnum,
  applySharedLinkPrivacyToModuleOrder,
  asArray,
  assertSupportedSduiSchemaVersion,
  buildCompatibilityTrainingExamples,
  buildEvalExamples,
  buildGenerationCoreOutput,
  buildHashedFeedback,
  buildPreferenceExamples,
  buildSftExamples,
  buildSftManifestEntry,
  buildSftRowMetadata,
  capitalize,
  charCount,
  clearStoredLocale,
  computeFallbackWeights,
  containsKeywords,
  createGenerationRegistry,
  extractSnippet,
  formatCost,
  formatDate,
  formatDateTime,
  formatLatency,
  formatNumber,
  formatPercentage,
  formatRelativeTime,
  formatScore,
  getAllowedModulesForSurface,
  getBaseResultsModuleOrder,
  getCategoryColor,
  getCategoryEmoji,
  getCategoryLabel,
  getDeviceLocale,
  getDramaCategory,
  getEmailDomain,
  getFeatureValue,
  getHomeExperiencePolicy,
  getLikelyImpactLabel,
  getLimit,
  getResultsExperiencePolicy,
  getSduiSurfaceGuardrail,
  getShareArtifactModuleOrder,
  getStoredLocale,
  hasFeatureBoolean,
  hashInputPii,
  hashOutputPii,
  config_default as i18n,
  isDefined,
  isFreeEmailProvider,
  isKnownSduiSurfaceKey,
  isNonEmptyString,
  isRecord,
  isSduiEligibleResultsModule,
  mapTrainingSplit,
  normalizeWhitespace,
  parseMaybeJson,
  pluralize,
  readingTime,
  resolveGenerationContent,
  sanitize,
  sanitizeEmail,
  sanitizeInput,
  sanitizeSignalMetadata,
  selectGenerationCandidate,
  setStoredLocale,
  splitSentences,
  titleCase,
  tokens_exports as tokens,
  truncate,
  useDeviceLocale,
  useHomeExperiencePolicy,
  useLocale,
  useResultsExperiencePolicy,
  useTranslation2 as useTranslation,
  validateAndSanitizeEmail,
  validateContext,
  validateEmail,
  validateMessage,
  validateScore,
  validateUuid,
  wordCount
};
